
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cA8mQ", function(module, exports) {

$parcel$export(module.exports, "init", () => $928f566aa50bb77a$export$2cd8252107eb640b);

var $hi47i = parcelRequire("hi47i");
var $fW1oP = parcelRequire("fW1oP");
var $aNMJx = parcelRequire("aNMJx");
var $kGYVh = parcelRequire("kGYVh");
var $lBLPp = parcelRequire("lBLPp");
var $hA6iJ = parcelRequire("hA6iJ");
var $1dwxw = parcelRequire("1dwxw");
var $8TZGP = parcelRequire("8TZGP");
var $diSl5 = parcelRequire("diSl5");
var $kQ0sT = parcelRequire("kQ0sT");
var $5v1oS = parcelRequire("5v1oS");
var $aW7Vg = parcelRequire("aW7Vg");

var $9Rc92 = parcelRequire("9Rc92");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");

var $bXMYE = parcelRequire("bXMYE");

var $6HdUS = parcelRequire("6HdUS");

var $bSsXc = parcelRequire("bSsXc");

var $4U4Fy = parcelRequire("4U4Fy");

var $jXkOO = parcelRequire("jXkOO");

var $a13dx = parcelRequire("a13dx");

var $jjJIz = parcelRequire("jjJIz");

var $3yu4Q = parcelRequire("3yu4Q");
/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $8TZGP.inboundFiltersIntegration)(),
        (0, $aNMJx.functionToStringIntegration)(),
        (0, $6HdUS.browserApiErrorsIntegration)(),
        (0, $bXMYE.breadcrumbsIntegration)(),
        (0, $4U4Fy.globalHandlersIntegration)(),
        (0, $a13dx.linkedErrorsIntegration)(),
        (0, $fW1oP.dedupeIntegration)(),
        (0, $jXkOO.httpContextIntegration)(),
        (0, $bSsXc.browserSessionIntegration)()
    ];
}
/** Exported only for tests. */ function $928f566aa50bb77a$export$4e107b20a7f977(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $csQk2.WINDOW).SENTRY_RELEASE?.id,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...$928f566aa50bb77a$var$dropTopLevelUndefinedKeys(optionsArg)
    };
}
/**
 * In contrast to the regular `dropUndefinedKeys` method,
 * this one does not deep-drop keys, but only on the top level.
 */ function $928f566aa50bb77a$var$dropTopLevelUndefinedKeys(obj) {
    const mutatetedObj = {};
    for (const k of Object.getOwnPropertyNames(obj)){
        const key = k;
        if (obj[key] !== undefined) mutatetedObj[key] = obj[key];
    }
    return mutatetedObj;
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $csQk2.WINDOW).window !== "undefined" && (0, $csQk2.WINDOW);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject?.runtime?.id;
    const href = (0, $hA6iJ.getLocationHref)() || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $csQk2.WINDOW) === (0, $csQk2.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$export$4e107b20a7f977(browserOptions);
    if (!options.skipBrowserExtensionCheck && $928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        if (0, $aBCC8.DEBUG_BUILD) (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if ((0, $aBCC8.DEBUG_BUILD) && !(0, $aW7Vg.supportsFetch)()) (0, $hi47i.logger).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    const clientOptions = {
        ...options,
        stackParser: (0, $5v1oS.stackParserFromStackParserOptions)(options.stackParser || (0, $jjJIz.defaultStackParser)),
        integrations: (0, $lBLPp.getIntegrationsToSetup)(options),
        transport: options.transport || (0, $3yu4Q.makeFetchTransport)
    };
    return (0, $diSl5.initAndBind)((0, $9Rc92.BrowserClient), clientOptions);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $csQk2.WINDOW).document) {
        (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $kGYVh.getCurrentScope)();
    const client = scope.getClient();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $kQ0sT.lastEventId)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $csQk2.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $1dwxw.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $csQk2.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $csQk2.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $csQk2.WINDOW).document.head || (0, $csQk2.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("hi47i", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $c9674f9e04798056$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $c9674f9e04798056$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $c9674f9e04798056$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $c9674f9e04798056$export$af88d00dbe7f521);

var $iNK7c = parcelRequire("iNK7c");

var $24aKj = parcelRequire("24aKj");

var $2fKhD = parcelRequire("2fKhD");
/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = "Sentry Logger ";
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $2fKhD.GLOBAL_OBJ))) return callback();
    const console = (0, $2fKhD.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $24aKj.DEBUG_BUILD) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $2fKhD.GLOBAL_OBJ).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $iNK7c.getGlobalSingleton)("logger", $c9674f9e04798056$var$makeLogger);

});
parcelRegister("iNK7c", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $db00931c27c5ec41$export$19eade501500c6c1);
$parcel$export(module.exports, "getSentryCarrier", () => $db00931c27c5ec41$export$c8bfa33e4e8ae492);
$parcel$export(module.exports, "getGlobalSingleton", () => $db00931c27c5ec41$export$7e223ec222791509);

var $faPnA = parcelRequire("faPnA");

var $2fKhD = parcelRequire("2fKhD");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $2fKhD.GLOBAL_OBJ));
    return 0, $2fKhD.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $faPnA.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $faPnA.SDK_VERSION] = __SENTRY__[0, $faPnA.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $db00931c27c5ec41$export$7e223ec222791509(name, creator, obj = (0, $2fKhD.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $faPnA.SDK_VERSION] = __SENTRY__[0, $faPnA.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("faPnA", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $b0bfa51115099518$export$31499a9cd224b78c);
// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "9.1.0";

});

parcelRegister("2fKhD", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("24aKj", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $18144a665bc8acf7$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $18144a665bc8acf7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("fW1oP", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", () => $b99d5bb3db344fdd$export$6d39aa44cd0c7567);

var $lBLPp = parcelRequire("lBLPp");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");

var $5v1oS = parcelRequire("5v1oS");
const $b99d5bb3db344fdd$var$INTEGRATION_NAME = "Dedupe";
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $lBLPp.defineIntegration)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $5v1oS.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $5v1oS.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}

});
parcelRegister("lBLPp", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", () => $fbb22756c9507e85$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $fbb22756c9507e85$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $fbb22756c9507e85$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $fbb22756c9507e85$export$35abcfd71227c6ca);
$parcel$export(module.exports, "defineIntegration", () => $fbb22756c9507e85$export$2323046b9414659f);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $fbb22756c9507e85$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $kGYVh.getClient)();
    if (!client) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}

});
parcelRegister("kGYVh", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", () => $f106fce27ec076f7$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getIsolationScope", () => $f106fce27ec076f7$export$68f3af03034c9e90);
$parcel$export(module.exports, "getGlobalScope", () => $f106fce27ec076f7$export$aa55d5ab8e05984f);
$parcel$export(module.exports, "withScope", () => $f106fce27ec076f7$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $f106fce27ec076f7$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "getClient", () => $f106fce27ec076f7$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getTraceContextFromScope", () => $f106fce27ec076f7$export$1e83db7ee4876dc4);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $4rxjU = parcelRequire("4rxjU");



var $l1oVX = parcelRequire("l1oVX");



var $iWfxY = parcelRequire("iWfxY");
/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $iNK7c.getGlobalSingleton)("globalScope", ()=>new (0, $4rxjU.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $f106fce27ec076f7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = (0, $l1oVX.dropUndefinedKeys)({
        trace_id: traceId,
        span_id: propagationSpanId || (0, $iWfxY.generateSpanId)(),
        parent_span_id: parentSpanId
    });
    return traceContext;
}

});
parcelRegister("7YCyf", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", () => $5cec0a7bd2540b32$export$f639b0c2752203be);

var $iNK7c = parcelRequire("iNK7c");

var $eGYpZ = parcelRequire("eGYpZ");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $iNK7c.getMainCarrier)();
    const sentry = (0, $iNK7c.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $iNK7c.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $eGYpZ.getStackAsyncContextStrategy)();
}

});
parcelRegister("eGYpZ", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", () => $ab23dab597a507b7$export$329d4d4d54e42710);

var $5MoSi = parcelRequire("5MoSi");

var $4rxjU = parcelRequire("4rxjU");

var $dfMsQ = parcelRequire("dfMsQ");

var $iNK7c = parcelRequire("iNK7c");
/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $4rxjU.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $4rxjU.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $dfMsQ.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $iNK7c.getMainCarrier)();
    const sentry = (0, $iNK7c.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $5MoSi.getDefaultCurrentScope)(), (0, $5MoSi.getDefaultIsolationScope)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("5MoSi", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", () => $4354bb0fac58a6e0$export$6f1b9191db9c4d5);
$parcel$export(module.exports, "getDefaultIsolationScope", () => $4354bb0fac58a6e0$export$de9862929b76bf57);

var $iNK7c = parcelRequire("iNK7c");

var $4rxjU = parcelRequire("4rxjU");
/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $iNK7c.getGlobalSingleton)("defaultCurrentScope", ()=>new (0, $4rxjU.Scope)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $iNK7c.getGlobalSingleton)("defaultIsolationScope", ()=>new (0, $4rxjU.Scope)());
}

});
parcelRegister("4rxjU", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $33c387bb26fe522d$export$775b6bb06e53a214);

var $kkdRz = parcelRequire("kkdRz");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $iWfxY = parcelRequire("iWfxY");

var $6OKHc = parcelRequire("6OKHc");

var $vNNF0 = parcelRequire("vNNF0");

var $dc48k = parcelRequire("dc48k");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $33c387bb26fe522d$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $iWfxY.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $33c387bb26fe522d$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $dc48k._setSpanForScope)(newScope, (0, $dc48k._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $kkdRz.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $dfMsQ.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $dc48k._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $iWfxY.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $6OKHc.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $dc48k._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $vNNF0.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("kkdRz", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $ecc06dd71ed8ff5f$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $ecc06dd71ed8ff5f$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $ecc06dd71ed8ff5f$export$56521d9ba90f62ee);



var $l1oVX = parcelRequire("l1oVX");

var $6OKHc = parcelRequire("6OKHc");

var $6OhB9 = parcelRequire("6OhB9");

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $6OKHc.timestampInSeconds)();
    const session = {
        sid: (0, $6OhB9.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $6OKHc.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $6OhB9.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return (0, $l1oVX.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});
parcelRegister("l1oVX", function(module, exports) {

$parcel$export(module.exports, "fill", () => $f4dd084fe83374eb$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $f4dd084fe83374eb$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $f4dd084fe83374eb$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $f4dd084fe83374eb$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "convertToPlainObject", () => $f4dd084fe83374eb$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $f4dd084fe83374eb$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $f4dd084fe83374eb$export$d25f2688db1bb433);

var $hA6iJ = parcelRequire("hA6iJ");

var $24aKj = parcelRequire("24aKj");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $hLnp0 = parcelRequire("hLnp0");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $dfMsQ.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $dfMsQ.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $dfMsQ.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $dfMsQ.isElement)(target) ? (0, $hA6iJ.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $hLnp0.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hLnp0.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    if (!(0, $dfMsQ.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch  {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $dfMsQ.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("hA6iJ", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $cccaafc2216668b2$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $cccaafc2216668b2$export$1cfafeee2987818b);
$parcel$export(module.exports, "getComponentName", () => $cccaafc2216668b2$export$26727cfcc4d7e0fc);

var $dfMsQ = parcelRequire("dfMsQ");

var $2fKhD = parcelRequire("2fKhD");
const $cccaafc2216668b2$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $dfMsQ.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("dfMsQ", function(module, exports) {

$parcel$export(module.exports, "isError", () => $9a62450b4f3c2c3b$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $9a62450b4f3c2c3b$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $9a62450b4f3c2c3b$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $9a62450b4f3c2c3b$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $9a62450b4f3c2c3b$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $9a62450b4f3c2c3b$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $9a62450b4f3c2c3b$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $9a62450b4f3c2c3b$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $9a62450b4f3c2c3b$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $9a62450b4f3c2c3b$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $9a62450b4f3c2c3b$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $9a62450b4f3c2c3b$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $9a62450b4f3c2c3b$export$bc2894c7158efbac);
$parcel$export(module.exports, "isVueViewModel", () => $9a62450b4f3c2c3b$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});


parcelRegister("hLnp0", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $cee8faa76567523a$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $cee8faa76567523a$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $cee8faa76567523a$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $cee8faa76567523a$export$a7a5ec66062ea5d);

var $dfMsQ = parcelRequire("dfMsQ");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $dfMsQ.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $dfMsQ.isString)(value)) return false;
    if ((0, $dfMsQ.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $dfMsQ.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});


parcelRegister("6OKHc", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $4f6ba265374890ec$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $4f6ba265374890ec$export$ee52dced521e3e18);

var $2fKhD = parcelRequire("2fKhD");
const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $2fKhD.GLOBAL_OBJ);
    if (!performance?.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $4f6ba265374890ec$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $4f6ba265374890ec$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $2fKhD.GLOBAL_OBJ);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $4f6ba265374890ec$export$baf075a948ffc0bf() {
    if (!$4f6ba265374890ec$var$cachedTimeOrigin) $4f6ba265374890ec$var$cachedTimeOrigin = $4f6ba265374890ec$var$getBrowserTimeOrigin();
    return $4f6ba265374890ec$var$cachedTimeOrigin[0];
}

});

parcelRegister("6OhB9", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $4f55103f4332a5b0$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $4f55103f4332a5b0$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $4f55103f4332a5b0$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $4f55103f4332a5b0$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $4f55103f4332a5b0$export$6de4ffac6a2f1098);

var $l1oVX = parcelRequire("l1oVX");

var $hLnp0 = parcelRequire("hLnp0");

var $2fKhD = parcelRequire("2fKhD");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496() {
    const gbl = (0, $2fKhD.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $hLnp0.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $hLnp0.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $hLnp0.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    if ($4f55103f4332a5b0$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $l1oVX.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4f55103f4332a5b0$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});


parcelRegister("iWfxY", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", () => $dc99b4184ec29e47$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "generateSpanId", () => $dc99b4184ec29e47$export$295213bc4d0c54ad);

var $6OhB9 = parcelRequire("6OhB9");
/**
 * Generate a random, valid trace ID.
 */ function $dc99b4184ec29e47$export$dc6d7ea554bcce10() {
    return (0, $6OhB9.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $dc99b4184ec29e47$export$295213bc4d0c54ad() {
    return (0, $6OhB9.uuid4)().substring(16);
}

});

parcelRegister("vNNF0", function(module, exports) {

$parcel$export(module.exports, "merge", () => $05f9869a4b646370$export$4950aa0f605343fb);
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("dc48k", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", () => $99af9a2b040631ba$export$3f25fa50c18e20ca);
$parcel$export(module.exports, "_getSpanForScope", () => $99af9a2b040631ba$export$91f063ebb8eff307);

var $l1oVX = parcelRequire("l1oVX");
const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $l1oVX.addNonEnumerableProperty)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}

});






parcelRegister("fKzCQ", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $b776c95debaa4af0$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("5v1oS", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", () => $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
$parcel$export(module.exports, "createStackParser", () => $4010ef0d9b3761f9$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $4010ef0d9b3761f9$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $4010ef0d9b3761f9$export$aad197c7121a6651);
$parcel$export(module.exports, "getFramesFromEvent", () => $4010ef0d9b3761f9$export$91d8ca51bd9f6a47);
const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});


parcelRegister("aNMJx", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", () => $7dd448759c7f5e18$export$7918117e9202e4fb);

var $kGYVh = parcelRequire("kGYVh");

var $lBLPp = parcelRequire("lBLPp");

var $l1oVX = parcelRequire("l1oVX");
let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = "FunctionToString";
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $l1oVX.getOriginalFunction)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $kGYVh.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $lBLPp.defineIntegration)($7dd448759c7f5e18$var$_functionToStringIntegration);

});

parcelRegister("1dwxw", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $0e303f054920e2b1$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $0e303f054920e2b1$export$671c7ed8e40a7a57);

var $cucnP = parcelRequire("cucnP");
const $0e303f054920e2b1$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $cucnP.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $cucnP.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("cucnP", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $9171e4713e443b9b$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $9171e4713e443b9b$export$128827c3562ec0cb);

var $24aKj = parcelRequire("24aKj");

var $hi47i = parcelRequire("hi47i");
/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $24aKj.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $hi47i.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("8TZGP", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", () => $67b350191b117f2b$export$cb3c5c2ceb9818ba);

var $fKzCQ = parcelRequire("fKzCQ");

var $lBLPp = parcelRequire("lBLPp");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $hLnp0 = parcelRequire("hLnp0");

var $jHXCX = parcelRequire("jHXCX");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $67b350191b117f2b$var$INTEGRATION_NAME = "InboundFilters";
const $67b350191b117f2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $67b350191b117f2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $67b350191b117f2b$var$_mergeOptions(options, clientOptions);
            return $67b350191b117f2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $67b350191b117f2b$export$cb3c5c2ceb9818ba = (0, $lBLPp.defineIntegration)($67b350191b117f2b$var$_inboundFiltersIntegration);
function $67b350191b117f2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $67b350191b117f2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $67b350191b117f2b$var$_isSentryError(event)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isUselessError(event)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$67b350191b117f2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $67b350191b117f2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return (0, $jHXCX.getPossibleEventMessages)(event).some((message)=>(0, $hLnp0.stringMatchesSomePattern)(message, ignoreErrors));
}
function $67b350191b117f2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $hLnp0.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $67b350191b117f2b$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $hLnp0.stringMatchesSomePattern)(url, denyUrls);
}
function $67b350191b117f2b$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $hLnp0.stringMatchesSomePattern)(url, allowUrls);
}
function $67b350191b117f2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $67b350191b117f2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $67b350191b117f2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $67b350191b117f2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error(`Cannot extract url for event ${(0, $6OhB9.getEventDescription)(event)}`);
        return null;
    }
}
function $67b350191b117f2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}

});
parcelRegister("jHXCX", function(module, exports) {

$parcel$export(module.exports, "getPossibleEventMessages", () => $e5904939f3a5a4e3$export$d55a97c329cacfcc);
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $e5904939f3a5a4e3$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("diSl5", function(module, exports) {

$parcel$export(module.exports, "initAndBind", () => $9af71b6a24a126c8$export$5333c3f1c58d9bc1);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $fKzCQ.DEBUG_BUILD) (0, $hi47i.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $kGYVh.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $kGYVh.getCurrentScope)().setClient(client);
}

});

parcelRegister("kQ0sT", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $f2b90654edf2c0a1$export$f5282963edea4a68);
$parcel$export(module.exports, "captureEvent", () => $f2b90654edf2c0a1$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "lastEventId", () => $f2b90654edf2c0a1$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "startSession", () => $f2b90654edf2c0a1$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $f2b90654edf2c0a1$export$667e7b4d445d566b);

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $kkdRz = parcelRequire("kkdRz");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $6OKHc = parcelRequire("6OKHc");

var $2fKhD = parcelRequire("2fKhD");

var $g1WRa = parcelRequire("g1WRa");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(exception, hint) {
    return (0, $kGYVh.getCurrentScope)().captureException(exception, (0, $g1WRa.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $kGYVh.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $kGYVh.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $kGYVh.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $kGYVh.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $kGYVh.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $kGYVh.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $kGYVh.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $kGYVh.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $kGYVh.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $kGYVh.getCurrentScope)();
    const client = (0, $kGYVh.getClient)();
    if (!client) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $6OhB9.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $6OKHc.timestampInSeconds)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $6OKHc.timestampInSeconds)() - now
        });
    }
    return (0, $kGYVh.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $dfMsQ.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $kGYVh.getClient)();
    if (client) return client.flush(timeout);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $kGYVh.getClient)();
    if (client) return client.close(timeout);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $kGYVh.getClient)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $kGYVh.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $kGYVh.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const currentScope = (0, $kGYVh.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $2fKhD.GLOBAL_OBJ).navigator || {};
    const session = (0, $kkdRz.makeSession)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $kkdRz.updateSession)(currentSession, {
        status: "exited"
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const currentScope = (0, $kGYVh.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $kkdRz.closeSession)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const client = (0, $kGYVh.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}

});
parcelRegister("g1WRa", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $baba650ac852ba0c$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $baba650ac852ba0c$export$76b5f966996d1653);

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $luMZm = parcelRequire("luMZm");

var $4rxjU = parcelRequire("4rxjU");

var $1pGI9 = parcelRequire("1pGI9");

var $6OhB9 = parcelRequire("6OhB9");

var $886wr = parcelRequire("886wr");

var $hLnp0 = parcelRequire("hLnp0");

var $6OKHc = parcelRequire("6OKHc");

var $3zNRu = parcelRequire("3zNRu");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $6OhB9.uuid4)(),
        timestamp: event.timestamp || (0, $6OKHc.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$export$d7e04067a6fbc882(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $6OhB9.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $kGYVh.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $3zNRu.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $3zNRu.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $3zNRu.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $luMZm.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $4Baka.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $hLnp0.truncate)(event.message, maxValueLength);
    const exception = event.exception?.values?.[0];
    if (exception?.value) exception.value = (0, $hLnp0.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request?.url) request.url = (0, $hLnp0.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $1pGI9.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $886wr.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $886wr.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $886wr.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $886wr.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $886wr.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $886wr.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $886wr.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $4rxjU.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $4rxjU.Scope) || typeof hint === "function";
}
const $baba650ac852ba0c$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}

});
parcelRegister("4Baka", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $3592a0510b526070$export$849dbeeeda01ae98);
const $3592a0510b526070$export$849dbeeeda01ae98 = "production";

});

parcelRegister("luMZm", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", () => $fa62667502ab5c7a$export$bf2a096c3e883e79);

var $fKzCQ = parcelRequire("fKzCQ");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $di9R8 = parcelRequire("di9R8");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $di9R8.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $fKzCQ.DEBUG_BUILD) && processor.id && result === null && (0, $hi47i.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $dfMsQ.isThenable)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("di9R8", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $9ad49a0639c06d33$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $9ad49a0639c06d33$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $9ad49a0639c06d33$export$78e43115b553f358);

var $dfMsQ = parcelRequire("dfMsQ");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $dfMsQ.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("1pGI9", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", () => $107941ce73c7a34f$export$e069fee9c632ed00);

var $2fKhD = parcelRequire("2fKhD");
let $107941ce73c7a34f$var$parsedStackResults;
let $107941ce73c7a34f$var$lastKeysCount;
let $107941ce73c7a34f$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $2fKhD.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($107941ce73c7a34f$var$cachedFilenameDebugIds && debugIdKeys.length === $107941ce73c7a34f$var$lastKeysCount) return $107941ce73c7a34f$var$cachedFilenameDebugIds;
    $107941ce73c7a34f$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $107941ce73c7a34f$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$107941ce73c7a34f$var$parsedStackResults) $107941ce73c7a34f$var$parsedStackResults = {};
        const result = $107941ce73c7a34f$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $107941ce73c7a34f$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $107941ce73c7a34f$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("886wr", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $5eb42146e0d2c9ef$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $5eb42146e0d2c9ef$export$23fbbb20bed71033);

var $dfMsQ = parcelRequire("dfMsQ");

var $l1oVX = parcelRequire("l1oVX");

var $5v1oS = parcelRequire("5v1oS");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $5eb42146e0d2c9ef$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $l1oVX.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $dfMsQ.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $dfMsQ.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $5v1oS.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function $5eb42146e0d2c9ef$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("3zNRu", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $29ab5181ea4a2c1b$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $29ab5181ea4a2c1b$export$25ac7e259a513db4);

var $jdzJv = parcelRequire("jdzJv");

var $l1oVX = parcelRequire("l1oVX");

var $vNNF0 = parcelRequire("vNNF0");

var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "extra", extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "tags", tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "user", user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $vNNF0.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $vNNF0.merge)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $l1oVX.dropUndefinedKeys)(extra);
    if (Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $l1oVX.dropUndefinedKeys)(tags);
    if (Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $l1oVX.dropUndefinedKeys)(user);
    if (Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $l1oVX.dropUndefinedKeys)(contexts);
    if (Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4H7Y8.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $jdzJv.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const transactionName = (0, $4H7Y8.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("jdzJv", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromScope", () => $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $dfdaf30e5fcd5fd9$export$a117f995597e25df);

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $yQUXg = parcelRequire("yQUXg");

var $gdhAa = parcelRequire("gdhAa");

var $l1oVX = parcelRequire("l1oVX");

var $4XLci = parcelRequire("4XLci");

var $4H7Y8 = parcelRequire("4H7Y8");

var $5VulJ = parcelRequire("5VulJ");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $l1oVX.addNonEnumerableProperty)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $l1oVX.dropUndefinedKeys)({
        environment: options.environment || (0, $4Baka.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $dfdaf30e5fcd5fd9$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return {};
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const rootSpanJson = (0, $4H7Y8.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $gdhAa.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $4XLci.hasSpansEnabled)()) {
        dsc.sampled = String((0, $4H7Y8.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $5VulJ.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $gdhAa.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("yQUXg", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $068c396dceb690a1$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $068c396dceb690a1$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $068c396dceb690a1$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $068c396dceb690a1$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", () => $068c396dceb690a1$export$165ce9a229f6f050);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $068c396dceb690a1$export$1efec95406bbe327);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", () => $068c396dceb690a1$export$fea48ba9f4550879);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $068c396dceb690a1$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = "sentry.profile_id";
const $068c396dceb690a1$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $068c396dceb690a1$export$b016f89ac1066ec = "cache.hit";
const $068c396dceb690a1$export$3110e4c3f4386399 = "cache.key";
const $068c396dceb690a1$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = "http.request.method";
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = "url.full";

});

parcelRegister("gdhAa", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $bcdb7fb6cf7e08bf$export$56766feef403f365);

var $24aKj = parcelRequire("24aKj");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");
const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = "sentry-";
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $dfMsQ.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});

parcelRegister("4XLci", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", () => $39d14882dc0612d9$export$1f70765132c3c225);

var $kGYVh = parcelRequire("kGYVh");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $39d14882dc0612d9$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $kGYVh.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $39d14882dc0612d9$export$5008da00b1b6dee6 = $39d14882dc0612d9$export$1f70765132c3c225;

});

parcelRegister("4H7Y8", function(module, exports) {

$parcel$export(module.exports, "spanToJSON", () => $36b15c0d755e29f6$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceContext", () => $36b15c0d755e29f6$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanIsSampled", () => $36b15c0d755e29f6$export$5caecac1caaf3a71);
$parcel$export(module.exports, "getRootSpan", () => $36b15c0d755e29f6$export$c4c6a79b1260ca1b);
$parcel$export(module.exports, "showSpanDropWarning", () => $36b15c0d755e29f6$export$d11691ff45a3e535);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $kGYVh = parcelRequire("kGYVh");

var $yQUXg = parcelRequire("yQUXg");

var $02dIh = parcelRequire("02dIh");

var $5VulJ = parcelRequire("5VulJ");

var $hi47i = parcelRequire("hi47i");

var $l1oVX = parcelRequire("l1oVX");

var $iWfxY = parcelRequire("iWfxY");

var $6OKHc = parcelRequire("6OKHc");

var $AIi6N = parcelRequire("AIi6N");

var $dc48k = parcelRequire("dc48k");
// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
let $36b15c0d755e29f6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $l1oVX.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $36b15c0d755e29f6$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $5VulJ.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $iWfxY.generateSpanId)() : spanId;
    return (0, $l1oVX.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $AIi6N.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $36b15c0d755e29f6$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $6OKHc.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
        return (0, $l1oVX.dropUndefinedKeys)({
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
            status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
            op: attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]
        });
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $02dIh.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $02dIh.SPAN_STATUS_OK)) return "ok";
    return status.message || "unknown_error";
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $l1oVX.addNonEnumerableProperty)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $l1oVX.addNonEnumerableProperty)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $dc48k._getSpanForScope)((0, $kGYVh.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $36b15c0d755e29f6$export$d11691ff45a3e535() {
    if (!$36b15c0d755e29f6$var$hasShownSpanDropWarning) {
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.");
        });
        $36b15c0d755e29f6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $36b15c0d755e29f6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom",
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("02dIh", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", () => $006ad32cdaebe09b$export$136e25984ba4a383);
$parcel$export(module.exports, "SPAN_STATUS_OK", () => $006ad32cdaebe09b$export$58f7963109c806fc);
const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}

});

parcelRegister("5VulJ", function(module, exports) {

$parcel$export(module.exports, "getCapturedScopesOnSpan", () => $4509d165411fd11c$export$c08fbc656a245d03);

var $l1oVX = parcelRequire("l1oVX");
const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $l1oVX.addNonEnumerableProperty)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $l1oVX.addNonEnumerableProperty)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("AIi6N", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", () => $06e5b8314e290bf2$export$f35d907436da45cf);

var $1oUdV = parcelRequire("1oUdV");

var $gdhAa = parcelRequire("gdhAa");

var $iWfxY = parcelRequire("iWfxY");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $gdhAa.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $iWfxY.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $iWfxY.generateTraceId)(), spanId = (0, $iWfxY.generateSpanId)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $1oUdV.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $1oUdV.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("1oUdV", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", () => $1053a52e7802e64c$export$a5bd2d81656d9546);
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});







parcelRegister("aW7Vg", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", () => $020e060e3b422828$export$67fc34576016d6ec);
$parcel$export(module.exports, "supportsFetch", () => $020e060e3b422828$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFunction", () => $020e060e3b422828$export$d5f608b368e73f38);
$parcel$export(module.exports, "supportsNativeFetch", () => $020e060e3b422828$export$c82d238e23c40b21);

var $24aKj = parcelRequire("24aKj");

var $hi47i = parcelRequire("hi47i");

var $2fKhD = parcelRequire("2fKhD");
const $020e060e3b422828$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$67fc34576016d6ec() {
    return "history" in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return "ReportingObserver" in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("9Rc92", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $72d27c0252bb80ff$export$1df9218a526d318d);

var $3Qq0w = parcelRequire("3Qq0w");
var $8gINE = parcelRequire("8gINE");
var $acs5H = parcelRequire("acs5H");
var $2wKOZ = parcelRequire("2wKOZ");

var $34UVT = parcelRequire("34UVT");

var $csQk2 = parcelRequire("csQk2");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $acs5H.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $csQk2.WINDOW).SENTRY_SDK_SOURCE || (0, $2wKOZ.getSDKSource)();
        (0, $8gINE.applySdkMetadata)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $csQk2.WINDOW).document) (0, $csQk2.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $csQk2.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
        if (this._options.sendDefaultPii) {
            this.on("postprocessEvent", (0, $3Qq0w.addAutoIpAddressToUser));
            this.on("beforeSendSession", (0, $3Qq0w.addAutoIpAddressToSession));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $34UVT.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $34UVT.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}

});
parcelRegister("3Qq0w", function(module, exports) {

$parcel$export(module.exports, "addAutoIpAddressToUser", () => $2cca66f9c5e6f810$export$3e12ad68afa434ac);
$parcel$export(module.exports, "addAutoIpAddressToSession", () => $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c);
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === undefined) session.ipAddress = "{{auto}}";
}

});

parcelRegister("8gINE", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", () => $605291aa308d4b89$export$b9f95b027256052c);

var $faPnA = parcelRequire("faPnA");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $faPnA.SDK_VERSION)
            })),
        version: (0, $faPnA.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("acs5H", function(module, exports) {

$parcel$export(module.exports, "Client", () => $76d0d0aa71b7be3b$export$1f2bb630327ac4b6);

var $1dwxw = parcelRequire("1dwxw");

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $fQDlp = parcelRequire("fQDlp");

var $lBLPp = parcelRequire("lBLPp");

var $kkdRz = parcelRequire("kkdRz");

var $jdzJv = parcelRequire("jdzJv");

var $g8eDs = parcelRequire("g8eDs");

var $cucnP = parcelRequire("cucnP");

var $l4iiL = parcelRequire("l4iiL");

var $9M9Rd = parcelRequire("9M9Rd");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $di9R8 = parcelRequire("di9R8");

var $jHXCX = parcelRequire("jHXCX");

var $vNNF0 = parcelRequire("vNNF0");

var $1oUdV = parcelRequire("1oUdV");

var $g1WRa = parcelRequire("g1WRa");

var $4H7Y8 = parcelRequire("4H7Y8");

var $lFsLg = parcelRequire("lFsLg");
const $76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $76d0d0aa71b7be3b$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $cucnP.makeDsn)(options.dsn);
        else (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $1dwxw.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $6OhB9.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $6OhB9.checkOrSetAlreadyCaught)(exception)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $6OhB9.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $dfMsQ.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $dfMsQ.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $6OhB9.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $6OhB9.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $kkdRz.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $di9R8.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $lBLPp.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $lBLPp.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $fQDlp.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $l4iiL.addItemToEnvelope)(env, (0, $l4iiL.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $4Baka.DEFAULT_ENVIRONMENT) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $fQDlp.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook oin this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error("Error while sending envelope:", reason);
            return reason;
        });
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error("Transport disabled");
        return (0, $di9R8.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $lBLPp.setupIntegrations)(this, integrations);
        (0, $lBLPp.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $kkdRz.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $di9R8.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $g1WRa.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: (0, $kGYVh.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $jdzJv.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $kGYVh.getCurrentScope)(), isolationScope = (0, $kGYVh.getIsolationScope)()) {
        if ((0, $fKzCQ.DEBUG_BUILD) && $76d0d0aa71b7be3b$var$isErrorEvent(event)) (0, $hi47i.logger).log(`Captured error event \`${(0, $jHXCX.getPossibleEventMessages)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $fKzCQ.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                if (reason instanceof (0, $9M9Rd.SentryError) && reason.logLevel === "log") (0, $hi47i.logger).log(reason.message);
                else (0, $hi47i.logger).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $76d0d0aa71b7be3b$var$isTransactionEvent(event);
        const isError = $76d0d0aa71b7be3b$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $1oUdV.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return (0, $di9R8.rejectedSyncPromise)(new (0, $9M9Rd.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw new (0, $9M9Rd.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $76d0d0aa71b7be3b$var$processBeforeSend(this, options, prepared, hint);
            return $76d0d0aa71b7be3b$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $9M9Rd.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $9M9Rd.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $9M9Rd.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $g8eDs.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $cucnP.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $76d0d0aa71b7be3b$export$4f22f74eddb7716a = $76d0d0aa71b7be3b$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $76d0d0aa71b7be3b$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $dfMsQ.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $dfMsQ.isPlainObject)(event) && event !== null) throw new (0, $9M9Rd.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $9M9Rd.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $dfMsQ.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $9M9Rd.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $76d0d0aa71b7be3b$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($76d0d0aa71b7be3b$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($76d0d0aa71b7be3b$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $lFsLg.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $4H7Y8.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $vNNF0.merge)(event, (0, $lFsLg.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $4H7Y8.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $76d0d0aa71b7be3b$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $76d0d0aa71b7be3b$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

});
parcelRegister("fQDlp", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $b89a3b4f1056006b$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $b89a3b4f1056006b$export$c31057337a18010f);

var $jdzJv = parcelRequire("jdzJv");

var $cucnP = parcelRequire("cucnP");

var $l4iiL = parcelRequire("l4iiL");



var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $l4iiL.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cucnP.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $l4iiL.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $l4iiL.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $l4iiL.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $l4iiL.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $jdzJv.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cucnP.dsnToString)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $4H7Y8.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $4H7Y8.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $4H7Y8.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $l4iiL.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $l4iiL.createEnvelope)(headers, items);
}

});
parcelRegister("l4iiL", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $f5682b06913d5b03$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $f5682b06913d5b03$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $f5682b06913d5b03$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $f5682b06913d5b03$export$32f9b428425aac85);
$parcel$export(module.exports, "createSpanEnvelopeItem", () => $f5682b06913d5b03$export$655cf139bc8b8afd);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $f5682b06913d5b03$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $f5682b06913d5b03$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $f5682b06913d5b03$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $f5682b06913d5b03$export$92b6093782fe661b);

var $iNK7c = parcelRequire("iNK7c");

var $cucnP = parcelRequire("cucnP");

var $886wr = parcelRequire("886wr");

var $l1oVX = parcelRequire("l1oVX");

var $2fKhD = parcelRequire("2fKhD");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    const carrier = (0, $iNK7c.getSentryCarrier)((0, $2fKhD.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    const carrier = (0, $iNK7c.getSentryCarrier)((0, $2fKhD.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $886wr.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $l1oVX.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    raw_security: "security"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cucnP.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $l1oVX.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});


parcelRegister("g8eDs", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $bbe8beff1aee2812$export$f3b9ed77c03eeb00);

var $l4iiL = parcelRequire("l4iiL");

var $6OKHc = parcelRequire("6OKHc");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $6OKHc.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $l4iiL.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("9M9Rd", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $71e03e2f84576ceb$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $71e03e2f84576ceb$export$5949942ba2a7c0e2 extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}

});

parcelRegister("lFsLg", function(module, exports) {

$parcel$export(module.exports, "convertTransactionEventToSpanJson", () => $fc63bcb83eb88e73$export$d9c6b2464b0a687e);
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", () => $fc63bcb83eb88e73$export$f2d8fce5ae150e92);

var $yQUXg = parcelRequire("yQUXg");



var $l1oVX = parcelRequire("l1oVX");


/**
 * Converts a transaction event to a span JSON object.
 */ function $fc63bcb83eb88e73$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return (0, $l1oVX.dropUndefinedKeys)({
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[0, $yQUXg.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    });
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $fc63bcb83eb88e73$export$f2d8fce5ae150e92(span) {
    const event = {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
    return (0, $l1oVX.dropUndefinedKeys)(event);
}

});


parcelRegister("2wKOZ", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", () => $1d72e3a9e632bed3$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}

});

parcelRegister("34UVT", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $23dde874fe12fd4c$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $23dde874fe12fd4c$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $23dde874fe12fd4c$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $23dde874fe12fd4c$export$5425b53185d13d6c);

var $6OhB9 = parcelRequire("6OhB9");
var $l1oVX = parcelRequire("l1oVX");
var $kGYVh = parcelRequire("kGYVh");
var $dfMsQ = parcelRequire("dfMsQ");
var $886wr = parcelRequire("886wr");
var $di9R8 = parcelRequire("di9R8");
/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $kGYVh.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $886wr.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $dfMsQ.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6OhB9.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $di9R8.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $di9R8.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $dfMsQ.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $dfMsQ.isDOMError)(exception) || (0, $dfMsQ.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $dfMsQ.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $6OhB9.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $dfMsQ.isError)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $dfMsQ.isPlainObject)(exception) || (0, $dfMsQ.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $6OhB9.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6OhB9.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $6OhB9.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $6OhB9.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $dfMsQ.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $l1oVX.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $dfMsQ.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $dfMsQ.isEvent)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});

parcelRegister("csQk2", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $9130afac94f0b7c9$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $9130afac94f0b7c9$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $9130afac94f0b7c9$export$4997ffc0176396a6);

var $6OhB9 = parcelRequire("6OhB9");
var $l1oVX = parcelRequire("l1oVX");
var $kQ0sT = parcelRequire("kQ0sT");
var $2fKhD = parcelRequire("2fKhD");
var $kGYVh = parcelRequire("kGYVh");
const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $2fKhD.GLOBAL_OBJ);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $l1oVX.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $kGYVh.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $6OhB9.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $6OhB9.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $kQ0sT.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $l1oVX.markFunctionWrapped)(sentryWrapped, fn);
    (0, $l1oVX.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}

});


parcelRegister("aBCC8", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $7b8b500cb80621bc$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("bXMYE", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", () => $8b5b3242e956e79f$export$c079d904b326663a);

var $h8vIJ = parcelRequire("h8vIJ");
var $5hw2H = parcelRequire("5hw2H");
var $8zIFF = parcelRequire("8zIFF");

var $6El1G = parcelRequire("6El1G");
var $1XAcA = parcelRequire("1XAcA");
var $iKmMF = parcelRequire("iKmMF");
var $lBLPp = parcelRequire("lBLPp");
var $36svk = parcelRequire("36svk");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $6OhB9 = parcelRequire("6OhB9");
var $hi47i = parcelRequire("hi47i");
var $3M05P = parcelRequire("3M05P");
var $hLnp0 = parcelRequire("hLnp0");
var $2bC2j = parcelRequire("2bC2j");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = "Breadcrumbs";
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $1XAcA.addConsoleInstrumentationHandler)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $h8vIJ.addClickKeypressInstrumentationHandler)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $8zIFF.addXhrInstrumentationHandler)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $iKmMF.addFetchInstrumentationHandler)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $5hw2H.addHistoryInstrumentationHandler)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $lBLPp.defineIntegration)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $kGYVh.getClient)() !== client) return;
        (0, $6El1G.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $6OhB9.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $hA6iJ.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $hA6iJ.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $6El1G.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $2bC2j.severityLevelFromString)(handlerData.level),
            message: (0, $hLnp0.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $hLnp0.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $6El1G.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $8zIFF.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $36svk.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $6El1G.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $6El1G.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $36svk.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $6El1G.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $3M05P.parseUrl)((0, $csQk2.WINDOW).location.href);
        let parsedFrom = from ? (0, $3M05P.parseUrl)(from) : undefined;
        const parsedTo = (0, $3M05P.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $6El1G.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("h8vIJ", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $c79bca128681c716$export$5aeffd3db2cf9df7);

var $kE1Yf = parcelRequire("kE1Yf");
var $l1oVX = parcelRequire("l1oVX");
var $6OhB9 = parcelRequire("6OhB9");

var $cOSHO = parcelRequire("cOSHO");
const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $cOSHO.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $kE1Yf.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $cOSHO.WINDOW).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $cOSHO.WINDOW).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $cOSHO.WINDOW);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $l1oVX.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $l1oVX.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $l1oVX.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $l1oVX.addNonEnumerableProperty)(target, "_sentryId", (0, $6OhB9.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $cOSHO.WINDOW).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});
parcelRegister("kE1Yf", function(module, exports) {

$parcel$export(module.exports, "addHandler", () => $f079126c500c7ea2$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $f079126c500c7ea2$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $f079126c500c7ea2$export$b18c893e424d3127);

var $24aKj = parcelRequire("24aKj");

var $hi47i = parcelRequire("hi47i");

var $5v1oS = parcelRequire("5v1oS");
// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $5v1oS.getFunctionName)(handler)}\nError:`, e);
    }
}

});

parcelRegister("cOSHO", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $955496f5d3029976$export$56d8a8a25bd48b81);

var $2fKhD = parcelRequire("2fKhD");
const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $2fKhD.GLOBAL_OBJ);

});


parcelRegister("5hw2H", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $3d87653da885c31c$export$3f18c56c58114e75);

var $kE1Yf = parcelRequire("kE1Yf");
var $l1oVX = parcelRequire("l1oVX");
var $aW7Vg = parcelRequire("aW7Vg");

var $cOSHO = parcelRequire("cOSHO");
let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $3d87653da885c31c$var$instrumentHistory);
}
function $3d87653da885c31c$var$instrumentHistory() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $cOSHO.WINDOW).addEventListener("popstate", ()=>{
        const to = (0, $cOSHO.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $kE1Yf.triggerHandlers)("history", handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $aW7Vg.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                if (from === to) return;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $kE1Yf.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $l1oVX.fill)((0, $cOSHO.WINDOW).history, "pushState", historyReplacementFunction);
    (0, $l1oVX.fill)((0, $cOSHO.WINDOW).history, "replaceState", historyReplacementFunction);
}

});

parcelRegister("8zIFF", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $63e43e59b4196dc4$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $63e43e59b4196dc4$export$26ace48dd54c9aea);

var $kE1Yf = parcelRequire("kE1Yf");
var $dfMsQ = parcelRequire("dfMsQ");
var $6OKHc = parcelRequire("6OKHc");

var $cOSHO = parcelRequire("cOSHO");
const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $cOSHO.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $6OKHc.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $dfMsQ.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $kE1Yf.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $dfMsQ.isString)(header) && (0, $dfMsQ.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $kE1Yf.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $63e43e59b4196dc4$var$parseUrl(url) {
    if ((0, $dfMsQ.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("6El1G", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", () => $4d76c9d78abc3a9e$export$efda9a273d7a036d);

var $kGYVh = parcelRequire("kGYVh");

var $hi47i = parcelRequire("hi47i");

var $6OKHc = parcelRequire("6OKHc");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $kGYVh.getClient)();
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $6OKHc.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $hi47i.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});

parcelRegister("1XAcA", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $16d762171e064dbd$export$1d6e0d073f9e6723);

var $hi47i = parcelRequire("hi47i");

var $l1oVX = parcelRequire("l1oVX");

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!("console" in (0, $2fKhD.GLOBAL_OBJ))) return;
    (0, $hi47i.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $2fKhD.GLOBAL_OBJ).console)) return;
        (0, $l1oVX.fill)((0, $2fKhD.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $hi47i.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $kE1Yf.triggerHandlers)("console", handlerData);
                const log = (0, $hi47i.originalConsoleMethods)[level];
                log?.apply((0, $2fKhD.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("iKmMF", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $da5e32477400e3c6$export$f75d3c772c923df0);

var $dfMsQ = parcelRequire("dfMsQ");

var $l1oVX = parcelRequire("l1oVX");

var $aW7Vg = parcelRequire("aW7Vg");

var $6OKHc = parcelRequire("6OKHc");

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $aW7Vg.supportsNativeFetch)()) return;
    (0, $l1oVX.fill)((0, $2fKhD.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $kE1Yf.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $2fKhD.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $kE1Yf.triggerHandlers)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $kE1Yf.triggerHandlers)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $dfMsQ.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $l1oVX.addNonEnumerableProperty)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $kE1Yf.triggerHandlers)("fetch-body-resolved", {
            endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($da5e32477400e3c6$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});

parcelRegister("36svk", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", () => $24280af9d15f06bf$export$b8cfcc4175694bcc);
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}

});

parcelRegister("3M05P", function(module, exports) {

$parcel$export(module.exports, "parseUrl", () => $2bf5ed435a4428b5$export$7a5253c0f62e0150);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});

parcelRegister("2bC2j", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", () => $197a1d16f7c0faf5$export$d771ef054122c30a);
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}

});


parcelRegister("6HdUS", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", () => $4e018dbe28beb052$export$59bfe9f1c76150e);

var $lBLPp = parcelRequire("lBLPp");
var $l1oVX = parcelRequire("l1oVX");
var $5v1oS = parcelRequire("5v1oS");

var $csQk2 = parcelRequire("csQk2");
const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = "BrowserApiErrors";
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $l1oVX.fill)((0, $csQk2.WINDOW), "setTimeout", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $l1oVX.fill)((0, $csQk2.WINDOW), "setInterval", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $l1oVX.fill)((0, $csQk2.WINDOW), "requestAnimationFrame", $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $csQk2.WINDOW)) (0, $l1oVX.fill)(XMLHttpRequest.prototype, "send", $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $lBLPp.defineIntegration)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $csQk2.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $5v1oS.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $csQk2.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $5v1oS.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $l1oVX.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $5v1oS.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $l1oVX.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $5v1oS.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $csQk2.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    const globalObject = (0, $csQk2.WINDOW);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $l1oVX.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4e018dbe28beb052$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $csQk2.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $5v1oS.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $csQk2.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $5v1oS.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $l1oVX.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4e018dbe28beb052$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}

});

parcelRegister("bSsXc", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", () => $8a5b32760c0daa50$export$1baa7880e357371c);

var $5hw2H = parcelRequire("5hw2H");

var $kQ0sT = parcelRequire("kQ0sT");
var $lBLPp = parcelRequire("lBLPp");
var $hi47i = parcelRequire("hi47i");

var $aBCC8 = parcelRequire("aBCC8");

var $csQk2 = parcelRequire("csQk2");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8a5b32760c0daa50$export$1baa7880e357371c = (0, $lBLPp.defineIntegration)(()=>{
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $csQk2.WINDOW).document === "undefined") {
                (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $kQ0sT.startSession)({
                ignoreDuration: true
            });
            (0, $kQ0sT.captureSession)();
            // We want to create a session for every navigation as well
            (0, $5hw2H.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $kQ0sT.startSession)({
                        ignoreDuration: true
                    });
                    (0, $kQ0sT.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("4U4Fy", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", () => $3920039f2d643754$export$66acc70e8cf2b71a);

var $6El2X = parcelRequire("6El2X");
var $alg0v = parcelRequire("alg0v");
var $kQ0sT = parcelRequire("kQ0sT");
var $lBLPp = parcelRequire("lBLPp");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $dfMsQ = parcelRequire("dfMsQ");
var $hi47i = parcelRequire("hi47i");
var $5v1oS = parcelRequire("5v1oS");

var $aBCC8 = parcelRequire("aBCC8");

var $34UVT = parcelRequire("34UVT");

var $csQk2 = parcelRequire("csQk2");
const $3920039f2d643754$var$INTEGRATION_NAME = "GlobalHandlers";
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $lBLPp.defineIntegration)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $6El2X.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $kGYVh.getClient)() !== client || (0, $csQk2.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $34UVT.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $kQ0sT.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $alg0v.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $kGYVh.getClient)() !== client || (0, $csQk2.shouldIgnoreOnError)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $dfMsQ.isPrimitive)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $34UVT.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $kQ0sT.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $dfMsQ.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $dfMsQ.isString)(url) && url.length > 0 ? url : (0, $hA6iJ.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $5v1oS.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $aBCC8.DEBUG_BUILD) && (0, $hi47i.logger).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $kGYVh.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("6El2X", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $4d76cdf59d4d2156$export$55b5c3ba2194f0c6);

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $2fKhD.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $2fKhD.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $kE1Yf.triggerHandlers)("error", handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $2fKhD.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("alg0v", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $7878483f8a9932cd$export$8bf4fc6858821a4e);

var $2fKhD = parcelRequire("2fKhD");

var $kE1Yf = parcelRequire("kE1Yf");
let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $kE1Yf.addHandler)(type, handler);
    (0, $kE1Yf.maybeInstrument)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $kE1Yf.triggerHandlers)("unhandledrejection", handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("jXkOO", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", () => $e873ad23f512125c$export$1378794447170364);

var $lBLPp = parcelRequire("lBLPp");
var $hA6iJ = parcelRequire("hA6iJ");

var $csQk2 = parcelRequire("csQk2");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $lBLPp.defineIntegration)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $csQk2.WINDOW).navigator && !(0, $csQk2.WINDOW).location && !(0, $csQk2.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request?.url || (0, $hA6iJ.getLocationHref)();
            const { referrer: referrer } = (0, $csQk2.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $csQk2.WINDOW).navigator || {};
            const headers = {
                ...event.request?.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});

});

parcelRegister("a13dx", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", () => $74ac7e452f6a0785$export$ebabb00eb7f3a395);

var $9L0Km = parcelRequire("9L0Km");
var $lBLPp = parcelRequire("lBLPp");

var $34UVT = parcelRequire("34UVT");
const $74ac7e452f6a0785$var$DEFAULT_KEY = "cause";
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = "LinkedErrors";
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9L0Km.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $34UVT.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $lBLPp.defineIntegration)($74ac7e452f6a0785$var$_linkedErrorsIntegration);

});
parcelRegister("9L0Km", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $71a9151fcd5ea774$export$b91c38ed7d8ae9b2);

var $dfMsQ = parcelRequire("dfMsQ");

var $hLnp0 = parcelRequire("hLnp0");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $dfMsQ.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$truncateAggregateExceptions($71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $dfMsQ.isInstanceOf)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $dfMsQ.isInstanceOf)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $71a9151fcd5ea774$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $hLnp0.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("jjJIz", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", () => $e103414b28380d9b$export$2b2b997d81bf3907);

var $5v1oS = parcelRequire("5v1oS");
// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $5v1oS.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $5v1oS.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $5v1oS.createStackParser)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $5v1oS.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("3yu4Q", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", () => $296be0c65ac1edb3$export$b2311068c46d7cc8);

var $hUuVt = parcelRequire("hUuVt");

var $kqMGl = parcelRequire("kqMGl");
var $di9R8 = parcelRequire("di9R8");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $hUuVt.getNativeImplementation)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $hUuVt.clearCachedImplementation)("fetch");
            return (0, $di9R8.rejectedSyncPromise)("No fetch implementation available");
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $hUuVt.clearCachedImplementation)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $di9R8.rejectedSyncPromise)(e);
        }
    }
    return (0, $kqMGl.createTransport)(options, makeRequest);
}

});
parcelRegister("hUuVt", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", () => $d09fa7e5070984b9$export$e464f4a514ac28a8);
$parcel$export(module.exports, "clearCachedImplementation", () => $d09fa7e5070984b9$export$8aa36702e8c8978);

var $aW7Vg = parcelRequire("aW7Vg");
var $hi47i = parcelRequire("hi47i");

var $jioJL = parcelRequire("jioJL");

var $cOSHO = parcelRequire("cOSHO");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $cOSHO.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $aW7Vg.isNativeFunction)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $cOSHO.WINDOW));
    const document = (0, $cOSHO.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $jioJL.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $cOSHO.WINDOW));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("setTimeout")(...rest);
}

});
parcelRegister("jioJL", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $e0c2e3106e46caa2$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("kqMGl", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $edfbff9038a67171$export$d09f50d9ab7f7b69);

var $fKzCQ = parcelRequire("fKzCQ");

var $l4iiL = parcelRequire("l4iiL");

var $9M9Rd = parcelRequire("9M9Rd");

var $hi47i = parcelRequire("hi47i");

var $kVISx = parcelRequire("kVISx");

var $78AZl = parcelRequire("78AZl");

var $di9R8 = parcelRequire("di9R8");
const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $kVISx.makePromiseBuffer)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $l4iiL.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $l4iiL.envelopeItemTypeToDataCategory)(type);
            if ((0, $78AZl.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $di9R8.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $l4iiL.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $l4iiL.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $l4iiL.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $l4iiL.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $78AZl.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $9M9Rd.SentryError)) {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $di9R8.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("kVISx", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $f3cbf180d3404fe0$export$85a4f67f852183e6);

var $9M9Rd = parcelRequire("9M9Rd");

var $di9R8 = parcelRequire("di9R8");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $di9R8.rejectedSyncPromise)(new (0, $9M9Rd.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $di9R8.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $di9R8.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("78AZl", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", () => $5325f8e04d3d0467$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $5325f8e04d3d0467$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});




parcelRegister("8Nbse", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

parcelRegister("jW3HH", function(module, exports) {

$parcel$export(module.exports, "setLoggerContext", () => $e8364e9fc530379c$export$a4f9dc99be407671);
$parcel$export(module.exports, "default", () => $e8364e9fc530379c$export$2e2bcd8739ae039);

var $4Ra9g = parcelRequire("4Ra9g");

var $1SXIy = parcelRequire("1SXIy");

var $01O3F = parcelRequire("01O3F");
var $e8364e9fc530379c$var$__assign = undefined && undefined.__assign || function() {
    $e8364e9fc530379c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8364e9fc530379c$var$__assign.apply(this, arguments);
};
var $e8364e9fc530379c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $e8364e9fc530379c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $e8364e9fc530379c$var$_a, $e8364e9fc530379c$var$_b;
var $e8364e9fc530379c$var$logtailKey = {
    production: "keyAcZRGmo8z7tzNJrHeqvwy",
    staging: "siDe8z8pRcpMPj8Gp93CmCe4"
}[($e8364e9fc530379c$var$_a = "production", $e8364e9fc530379c$var$_a !== void 0) ? $e8364e9fc530379c$var$_a : "development"];
var $e8364e9fc530379c$var$logtailEndpoint = {
    production: "https://log-intake.upscope.io/",
    staging: "https://log-intake.upscope.xyz/"
}[($e8364e9fc530379c$var$_b = "production", $e8364e9fc530379c$var$_b !== void 0) ? $e8364e9fc530379c$var$_b : "development"];
var $e8364e9fc530379c$var$pageviewId = (0, $01O3F.uuid)();
var $e8364e9fc530379c$var$context = {
    release: "2025.6.4",
    pageviewId: $e8364e9fc530379c$var$pageviewId
};
var $e8364e9fc530379c$var$logtail = $e8364e9fc530379c$var$logtailKey ? new (0, $4Ra9g.Browser)($e8364e9fc530379c$var$logtailKey, {
    endpoint: $e8364e9fc530379c$var$logtailEndpoint,
    syncMax: 1,
    burstProtectionMax: 250,
    burstProtectionMilliseconds: 5000
}) : null;
function $e8364e9fc530379c$export$a4f9dc99be407671(newContext) {
    $e8364e9fc530379c$var$context = $e8364e9fc530379c$var$__assign($e8364e9fc530379c$var$__assign({}, $e8364e9fc530379c$var$context), newContext);
}
function $e8364e9fc530379c$export$2e2bcd8739ae039(namespace, throttle) {
    if (throttle === void 0) throttle = {
        max: 30,
        seconds: 5
    };
    var debug = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))("upscope:".concat(namespace));
    var debugWarning = (0, (/*@__PURE__*/$parcel$interopDefault($1SXIy)))("upscope:".concat(namespace, ":warn"));
    var currentThrottle = 0;
    function isThrottled() {
        if (currentThrottle === 0) setTimeout(function() {
            if (currentThrottle > throttle.max) $e8364e9fc530379c$var$logtail === null || $e8364e9fc530379c$var$logtail === void 0 || $e8364e9fc530379c$var$logtail.warn("Dropped ".concat(currentThrottle - throttle.max, " logs due to throttle"), $e8364e9fc530379c$var$__assign($e8364e9fc530379c$var$__assign({}, $e8364e9fc530379c$var$context), {
                namespace: namespace
            }));
            currentThrottle = 0;
        }, throttle.seconds * 1000);
        return currentThrottle++ > throttle.max;
    }
    var safeJsonStringify = function(obj) {
        if (Array.isArray(obj)) return "[ ".concat(obj.map(safeJsonStringify).join(" , "), " ]");
        if (!(0, $01O3F.isPlainObject)(obj)) return String(obj);
        try {
            return JSON.stringify(obj);
        } catch (e) {
            return "Unserializable object: ".concat(e);
        }
    };
    var func = function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        debug.apply(void 0, $e8364e9fc530379c$var$__spreadArray([
            message
        ], $e8364e9fc530379c$var$__read(args), false));
        if (window.baa === true) return;
        if (isThrottled()) return;
        args = args.map(function(arg) {
            return safeJsonStringify(arg).slice(0, 1000);
        });
        var logArgs = args.slice();
        $e8364e9fc530379c$var$logtail === null || $e8364e9fc530379c$var$logtail === void 0 || $e8364e9fc530379c$var$logtail.info(message.replace(/%[sodO]/g, function() {
            return logArgs.shift().slice(0, 30);
        }), $e8364e9fc530379c$var$__assign({
            arguments: args,
            namespace: namespace
        }, $e8364e9fc530379c$var$context));
    };
    func.local = function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        debug.apply(void 0, $e8364e9fc530379c$var$__spreadArray([
            message
        ], $e8364e9fc530379c$var$__read(args), false));
    };
    func.warning = function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        debugWarning.apply(void 0, $e8364e9fc530379c$var$__spreadArray([
            message
        ], $e8364e9fc530379c$var$__read(args), false));
        if (window.baa === true) return;
        if (isThrottled()) return;
        args = args.map(function(arg) {
            return safeJsonStringify(arg).slice(0, 200);
        });
        var logArgs = args.slice();
        $e8364e9fc530379c$var$logtail === null || $e8364e9fc530379c$var$logtail === void 0 || $e8364e9fc530379c$var$logtail.warn(message.replace(/%[sodO]/g, function() {
            return logArgs.shift().slice(0, 30);
        }), $e8364e9fc530379c$var$__assign({
            arguments: args,
            namespace: "".concat(namespace, ":warn")
        }, $e8364e9fc530379c$var$context));
    };
    return func;
}

});
parcelRegister("4Ra9g", function(module, exports) {

$parcel$export(module.exports, "Browser", () => $3893fbe85fb0b74e$export$5fefc2586e00a689);
parcelRequire("5IiP3");

var $gT3WU = parcelRequire("gT3WU");
class $3893fbe85fb0b74e$export$5fefc2586e00a689 extends (0, $gT3WU.default) {
    constructor(sourceToken, options){
        // After reaching 48KiB, the batch will get flushed automatically to avoid 64KiB body limit for keepalive requests
        super(sourceToken, Object.assign({
            batchSizeKiB: 48
        }, options));
        // Sync function
        const sync = async (logs)=>{
            const res = await fetch(this._options.endpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${this._sourceToken}`
                },
                body: JSON.stringify(logs),
                keepalive: true
            });
            if (res.ok) return logs;
            /**
             * TODO: if status is 50x throw custom ServerError
             * to be used in retry logic
             */ throw new Error(res.statusText);
        };
        // Set the throttled sync function
        this.setSync(sync);
        this.configureFlushOnPageLeave();
    }
    /**
     * Override `Base` log to add browser-specific context
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Log context for passing structured data
     * @returns Promise<ILogtailLog> after syncing
     */ async log(message, level, context = {}) {
        // Wrap context in an object, if it's not already
        if (typeof context !== "object") {
            const wrappedContext = {
                extra: context
            };
            context = wrappedContext;
        }
        if (context instanceof Error) {
            const wrappedContext = {
                error: context
            };
            context = wrappedContext;
        }
        context = Object.assign(Object.assign({}, this.getCurrentContext()), context);
        return super.log(message, level, context);
    }
    getCurrentContext() {
        var _a, _b, _c;
        const context = {};
        if (typeof window !== "undefined") {
            context.url = (_a = window.location) === null || _a === void 0 ? void 0 : _a.href;
            context.device_pixel_ratio = window.devicePixelRatio;
            context.screen_width = (_b = window.screen) === null || _b === void 0 ? void 0 : _b.width;
            context.screen_height = (_c = window.screen) === null || _c === void 0 ? void 0 : _c.height;
            context.window_width = window.innerWidth;
            context.window_height = window.innerHeight;
        }
        if (typeof navigator !== "undefined") {
            context.user_locale = navigator.userLanguage || navigator.language;
            context.user_agent = navigator.userAgent;
        }
        return context;
    }
    configureFlushOnPageLeave() {
        if (typeof document === "undefined") return;
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "hidden") this.flush();
        });
    }
}

});
parcelRegister("5IiP3", function(module, exports) {
(function(self1) {
    var irrelevant = function(exports) {
        var global = typeof globalThis !== "undefined" && globalThis || typeof self1 !== "undefined" && self1 || typeof global !== "undefined" && global;
        var support = {
            searchParams: "URLSearchParams" in global,
            iterable: "Symbol" in global && "iterator" in Symbol,
            blob: "FileReader" in global && "Blob" in global && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in global,
            arrayBuffer: "ArrayBuffer" in global
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports.DOMException = global.DOMException;
        try {
            new exports.DOMException();
        } catch (err) {
            exports.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports.DOMException.prototype = Object.create(Error.prototype);
            exports.DOMException.prototype.constructor = exports.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && global.location.href ? global.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer && request.headers.get("Content-Type") && request.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!global.fetch) {
            global.fetch = fetch;
            global.Headers = Headers;
            global.Request = Request;
            global.Response = Response;
        }
        exports.Headers = Headers;
        exports.Request = Request;
        exports.Response = Response;
        exports.fetch = fetch;
        return exports;
    }({});
})(typeof self !== "undefined" ? self : module.exports);

});

parcelRegister("gT3WU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b4d89d21673730$export$2e2bcd8739ae039);

var $3SwG2 = parcelRequire("3SwG2");

var $1deeM = parcelRequire("1deeM");
var $bXM5b = parcelRequire("bXM5b");
var $bWB46 = parcelRequire("bWB46");

var $1ErbZ = parcelRequire("1ErbZ");
// Set default options for Logtail
const $c4b4d89d21673730$var$defaultOptions = {
    // Default sync endpoint (protocol + domain)
    endpoint: "https://in.logs.betterstack.com",
    // Maximum number of logs to sync in a single request to Better Stack
    batchSize: 1000,
    // Size of logs (in KiB) to trigger sync to Better Stack (0 to disable)
    batchSizeKiB: 0,
    // Max interval (in milliseconds) before a batch of logs proceeds to syncing
    batchInterval: 1000,
    // Maximum number of times to retry a failed sync request
    retryCount: 3,
    // Minimum number of milliseconds to wait before retrying a failed sync request
    retryBackoff: 100,
    // Maximum number of sync requests to make concurrently
    syncMax: 5,
    // Length of the checked window for logs burst protection in milliseconds (0 to disable)
    burstProtectionMilliseconds: 5000,
    // Maximum number of accepted logs in the specified time window (0 to disable)
    burstProtectionMax: 10000,
    // If true, errors when sending logs will be ignored
    // Has precedence over throwExceptions
    ignoreExceptions: false,
    // If true, errors when sending logs will result in a thrown exception
    throwExceptions: false,
    // Maximum depth (number of attribute levels) of a context object
    contextObjectMaxDepth: 50,
    // Produce a warn log when context object max depth is reached
    contextObjectMaxDepthWarn: true,
    // Produce a warning when circular reference is found in context object
    contextObjectCircularRefWarn: true,
    // If true, all logs will be sent to standard console output functions (console.info, console.warn, ...)
    sendLogsToConsoleOutput: false,
    // If true, all logs will be sent to Better Stack
    sendLogsToBetterStack: true,
    // Function to be used to calculate size of logs in bytes (to evaluate batchSizeLimitKiB)
    calculateLogSizeBytes: (0, $1deeM.calculateJsonLogSizeBytes)
};
/**
 * Logtail core class for logging to the Better Stack service
 */ class $c4b4d89d21673730$var$Logtail {
    /* CONSTRUCTOR */ /**
     * Initializes a new Logtail instance
     *
     * @param sourceToken: string - Private source token for logging to Better Stack
     * @param options?: ILogtailOptions - Optionally specify Logtail options
     */ constructor(sourceToken, options){
        // Middleware
        this._middleware = [];
        // Number of logs logged
        this._countLogged = 0;
        // Number of logs successfully synced with Logtail
        this._countSynced = 0;
        // Number of logs that failed to be synced to Logtail
        this._countDropped = 0;
        // First, check we have a valid source token
        if (typeof sourceToken !== "string" || sourceToken === "") throw new Error("Logtail source token missing");
        // Store the source token, to use for syncing with Better Stack
        this._sourceToken = sourceToken;
        // Merge default and user options
        this._options = Object.assign(Object.assign({}, $c4b4d89d21673730$var$defaultOptions), options);
        // Create a throttler, for sync operations
        const throttle = (0, $bWB46.default)(this._options.syncMax);
        // Sync after throttling
        const throttler = throttle((logs)=>{
            return this._sync(logs);
        });
        // Burst protection for logging
        this._logBurstProtection = (0, $bXM5b.default)(this._options.burstProtectionMilliseconds, this._options.burstProtectionMax, "Logging");
        this.log = this._logBurstProtection(this.log.bind(this));
        // Create a batcher, for aggregating logs by buffer size/interval
        const batcher = (0, $1deeM.default)(this._options.batchSize, this._options.batchInterval, this._options.retryCount, this._options.retryBackoff, this._options.batchSizeKiB * 1024, this._options.calculateLogSizeBytes);
        this._batch = batcher.initPusher((logs)=>{
            return throttler(logs);
        });
        this._flush = batcher.flush;
    }
    /* PUBLIC METHODS */ /**
     * Flush batched logs to Logtail
     */ async flush() {
        return this._flush();
    }
    /**
     * Number of entries logged
     *
     * @returns number
     */ get logged() {
        return this._countLogged;
    }
    /**
     * Number of log entries synced with Better Stack
     *
     * @returns number
     */ get synced() {
        return this._countSynced;
    }
    /**
     * Number of entries dropped
     *
     * @returns number
     */ get dropped() {
        return this._countDropped;
    }
    /**
     * Log an entry, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param level (LogLevel) - Level to log at (debug|info|warn|error)
     * @param context: (Context) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async log(message, level = (0, $3SwG2.LogLevel).Info, context = {}) {
        // Wrap context in an object, if it's not already
        if (typeof context !== "object") {
            const wrappedContext = {
                extra: context
            };
            context = wrappedContext;
        }
        if (context instanceof Error) {
            const wrappedContext = {
                error: context
            };
            context = wrappedContext;
        }
        if (this._options.sendLogsToConsoleOutput) switch(level){
            case "debug":
                console.debug(message, context);
                break;
            case "info":
                console.info(message, context);
                break;
            case "warn":
                console.warn(message, context);
                break;
            case "error":
                console.error(message, context);
                break;
            default:
                console.log(`[${level.toUpperCase()}]`, message, context);
                break;
        }
        // Check that we have a sync function
        if (typeof this._sync !== "function") throw new Error("No Logtail logger sync function provided");
        // Increment log count
        this._countLogged++;
        // Start building the log message
        let log = Object.assign(Object.assign({
            // Implicit date timestamp
            dt: new Date(),
            level: // Explicit level
            level
        }, context), message instanceof Error ? (0, $1ErbZ.serializeError)(message) : {
            message: message
        });
        let transformedLog = log;
        for (const middleware of this._middleware){
            let newTransformedLog = await middleware(transformedLog);
            if (newTransformedLog == null) // Don't push the log if it was filtered out in a middleware
            return transformedLog;
            transformedLog = newTransformedLog;
        }
        // Manually serialize the log data
        transformedLog = this.serialize(transformedLog, this._options.contextObjectMaxDepth);
        if (!this._options.sendLogsToBetterStack) // Return the resulting log before sending it
        return transformedLog;
        try {
            // Push the log through the batcher, and sync
            await this._batch(transformedLog);
            // Increment sync count
            this._countSynced++;
        } catch (e) {
            // Increment dropped count
            this._countDropped++;
            // Catch any errors - re-throw if `ignoreExceptions` == false
            if (!this._options.ignoreExceptions) {
                if (this._options.throwExceptions) throw e;
                else // Output to console
                console.error(e);
            }
        }
        // Return the resulting log
        return transformedLog;
    }
    serialize(value, maxDepth, visitedObjects = new WeakSet()) {
        if (value === null || typeof value === "boolean" || typeof value === "number" || typeof value === "string") return value;
        else if (value instanceof Date) {
            // Date instances can be invalid & toISOString() will fail
            if (isNaN(value.getTime())) return value.toString();
            return value.toISOString();
        } else if (value instanceof Error) return (0, $1ErbZ.serializeError)(value);
        else if ((typeof value === "object" || Array.isArray(value)) && (maxDepth < 1 || visitedObjects.has(value))) {
            if (visitedObjects.has(value)) {
                if (this._options.contextObjectCircularRefWarn) console.warn(`[Logtail] Found a circular reference when serializing logs. Please do not use circular references in your logs.`);
                return "<omitted circular reference>";
            }
            if (this._options.contextObjectMaxDepthWarn) console.warn(`[Logtail] Max depth of ${this._options.contextObjectMaxDepth} reached when serializing logs. Please do not use excessive object depth in your logs.`);
            return `<omitted context beyond configured max depth: ${this._options.contextObjectMaxDepth}>`;
        } else if (Array.isArray(value)) {
            visitedObjects.add(value);
            const serializedArray = value.map((item)=>this.serialize(item, maxDepth - 1, visitedObjects));
            visitedObjects.delete(value);
            return serializedArray;
        } else if (typeof value === "object") {
            const serializedObject = {};
            visitedObjects.add(value);
            Object.entries(value).forEach((item)=>{
                const key = item[0];
                const value = item[1];
                const serializedValue = this.serialize(value, maxDepth - 1, visitedObjects);
                if (serializedValue !== undefined) serializedObject[key] = serializedValue;
            });
            visitedObjects.delete(value);
            return serializedObject;
        } else if (typeof value === "undefined") return undefined;
        else return `<omitted unserializable ${typeof value}>`;
    }
    /**
     *
     * Debug level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async debug(message, context = {}) {
        return this.log(message, (0, $3SwG2.LogLevel).Debug, context);
    }
    /**
     *
     * Info level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async info(message, context = {}) {
        return this.log(message, (0, $3SwG2.LogLevel).Info, context);
    }
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async warn(message, context = {}) {
        return this.log(message, (0, $3SwG2.LogLevel).Warn, context);
    }
    /**
     *
     * Warning level log, to be synced with Better Stack
     *
     * @param message: string - Log message
     * @param context: (Pick<ILogtailLog, "context">) - Context (optional)
     * @returns Promise<ILogtailLog> after syncing
     */ async error(message, context = {}) {
        return this.log(message, (0, $3SwG2.LogLevel).Error, context);
    }
    /**
     * Sets the sync method - i.e. the final step in the pipeline to get logs
     * over to Better Stack
     *
     * @param fn - Pipeline function to use as sync method
     */ setSync(fn) {
        this._sync = fn;
    }
    /**
     * Add a middleware function to the logging pipeline
     *
     * @param fn - Function to add to the log pipeline
     * @returns void
     */ use(fn) {
        this._middleware.push(fn);
    }
    /**
     * Remove a function from the pipeline
     *
     * @param fn - Pipeline function
     * @returns void
     */ remove(fn) {
        this._middleware = this._middleware.filter((p)=>p !== fn);
    }
}
class $c4b4d89d21673730$export$2e2bcd8739ae039 extends $c4b4d89d21673730$var$Logtail {
    async log(message, level = (0, $3SwG2.LogLevel).Info, context = {}) {
        return super.log(message, level, context);
    }
}

});
parcelRegister("3SwG2", function(module, exports) {

$parcel$export(module.exports, "LogLevel", () => $2d2fc333d51f9cb0$export$243e62d78d3b544d);
/**
 * Logtail library options
 */ var $2d2fc333d51f9cb0$export$243e62d78d3b544d;
(function(LogLevel) {
    // core log levels - available as functions
    LogLevel["Error"] = "error";
    LogLevel["Warn"] = "warn";
    LogLevel["Info"] = "info";
    LogLevel["Debug"] = "debug";
    // extra log levels - recognized when passed from logging frameworks
    LogLevel["Fatal"] = "fatal";
    LogLevel["Http"] = "http";
    LogLevel["Verbose"] = "verbose";
    LogLevel["Silly"] = "silly";
    LogLevel["Trace"] = "trace";
})($2d2fc333d51f9cb0$export$243e62d78d3b544d || ($2d2fc333d51f9cb0$export$243e62d78d3b544d = {}));

});

parcelRegister("1deeM", function(module, exports) {

$parcel$export(module.exports, "calculateJsonLogSizeBytes", () => $0e220c9286e17f06$export$a8bbed3c2f27a07);
$parcel$export(module.exports, "default", () => $0e220c9286e17f06$export$2e2bcd8739ae039);
/*
 * Default buffer size
 */ const $0e220c9286e17f06$var$DEFAULT_BUFFER_SIZE = 1000;
/*
 * Default flush timeout
 */ const $0e220c9286e17f06$var$DEFAULT_FLUSH_TIMEOUT = 1000;
/*
 * Default retry count
 */ const $0e220c9286e17f06$var$DEFAULT_RETRY_COUNT = 3;
/*
 * Default retry backoff
 */ const $0e220c9286e17f06$var$DEFAULT_RETRY_BACKOFF = 100;
const $0e220c9286e17f06$export$a8bbed3c2f27a07 = (log)=>JSON.stringify(log).length + 1;
function $0e220c9286e17f06$export$2e2bcd8739ae039(size = $0e220c9286e17f06$var$DEFAULT_BUFFER_SIZE, flushTimeout = $0e220c9286e17f06$var$DEFAULT_FLUSH_TIMEOUT, retryCount = $0e220c9286e17f06$var$DEFAULT_RETRY_COUNT, retryBackoff = $0e220c9286e17f06$var$DEFAULT_RETRY_BACKOFF, sizeBytes = 0, calculateLogSizeBytes = $0e220c9286e17f06$export$a8bbed3c2f27a07) {
    let timeout;
    let cb;
    let buffer = [];
    let bufferSizeBytes = 0;
    let retry = 0;
    // Wait until the minimum retry backoff time has passed before retrying
    let minRetryBackoff = 0;
    /*
     * Process then flush the list
     */ async function flush() {
        if (timeout) clearTimeout(timeout);
        timeout = null;
        const currentBuffer = buffer;
        const currentBufferSizeKB = bufferSizeBytes;
        buffer = [];
        bufferSizeBytes = 0;
        try {
            await cb(currentBuffer.map((d)=>d.log));
            currentBuffer.forEach((d)=>d.resolve(d.log));
            retry = 0;
        } catch (e) {
            if (retry < retryCount) {
                retry++;
                minRetryBackoff = Date.now() + retryBackoff;
                buffer = buffer.concat(currentBuffer);
                bufferSizeBytes += currentBufferSizeKB;
                await setupTimeout();
                return;
            }
            currentBuffer.map((d)=>d.reject(e));
            retry = 0;
        }
    }
    /*
     * Start timeout to flush
     */ async function setupTimeout() {
        if (timeout) return;
        return new Promise((resolve)=>{
            timeout = setTimeout(async function() {
                await flush();
                resolve();
            }, flushTimeout);
        });
    }
    /*
     * Batcher which takes a process function
     * @param fn - Any function to process list
     */ return {
        initPusher: function(fn) {
            cb = fn;
            /*
             * Pushes each log into list
             * @param log: ILogtailLog - Any object to push into list
             */ return async function(log) {
                return new Promise(async (resolve, reject)=>{
                    buffer.push({
                        log: log,
                        resolve: resolve,
                        reject: reject
                    });
                    // We can skip log size calculation if there is no max size set
                    if (sizeBytes > 0) bufferSizeBytes += calculateLogSizeBytes(log);
                    // If the buffer is full enough, flush it
                    // Unless we're still waiting for the minimum retry backoff time
                    const isBufferFullEnough = buffer.length >= size || sizeBytes > 0 && bufferSizeBytes >= sizeBytes;
                    if (isBufferFullEnough && Date.now() > minRetryBackoff) await flush();
                    else await setupTimeout();
                    return resolve;
                });
            };
        },
        flush: flush
    };
}

});

parcelRegister("bXM5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b5a80a01b5ca14c$export$2e2bcd8739ae039);
const $8b5a80a01b5ca14c$var$RESOLUTION = 64;
function $8b5a80a01b5ca14c$export$2e2bcd8739ae039(milliseconds, max, functionName = "The function") {
    if (milliseconds <= 0 || max <= 0) return (fn)=>fn;
    let callCounts = [
        0
    ];
    let lastErrorOutput = 0;
    let lastIntervalTime = Date.now();
    function updateCallCounts() {
        const now = Date.now();
        const intervalLength = milliseconds / $8b5a80a01b5ca14c$var$RESOLUTION;
        if (now < lastIntervalTime + intervalLength) return;
        // Prepend callCounts with correct number of zeroes and keep its length to RESOLUTION at max
        const intervalCountSinceLast = Math.floor((now - lastIntervalTime) / intervalLength);
        callCounts = Array(Math.min(intervalCountSinceLast, $8b5a80a01b5ca14c$var$RESOLUTION)).fill(0).concat(callCounts).slice(0, $8b5a80a01b5ca14c$var$RESOLUTION);
        lastIntervalTime += intervalCountSinceLast * intervalLength;
    }
    function getTotalCallCount() {
        return callCounts.reduce((total, item)=>total + item);
    }
    function incrementCallCount() {
        callCounts[0]++;
    }
    return (fn)=>{
        return async (...args)=>{
            updateCallCounts();
            if (getTotalCallCount() < max) {
                incrementCallCount();
                return await fn(...args);
            }
            const now = Date.now();
            if (lastErrorOutput < now - milliseconds) {
                lastErrorOutput = now;
                console.error(`${functionName} was called more than ${max} times during last ${milliseconds}ms. Ignoring.`);
            }
        };
    };
}

});

parcelRegister("bWB46", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b21dcdce0c48444$export$2e2bcd8739ae039);

var $agusq = parcelRequire("agusq");
function $8b21dcdce0c48444$export$2e2bcd8739ae039(max) {
    // Current iteration cycle
    let current = 0;
    // Create a FIFO queue
    const queue = new (0, $agusq.default)();
    /**
     * Throttle function that throttles the passed func according to `max`
     * @param fn - async function to resolve
     */ function throttle(fn) {
        return async (...args)=>{
            return new Promise((resolve, reject)=>{
                /**
                 * Handler for resolving the Promise chain
                 */ async function handler() {
                    // Only resolve if the `max` hasn't been exhausted
                    if (current < max) {
                        // Increment the available slot size
                        current++;
                        try {
                            // Await the passed function here first, to determine if any
                            // errors are thrown, so they can be handled by our outside `reject`
                            resolve(await fn(...args));
                        } catch (e) {
                            reject(e);
                        }
                        // Since this has now resolved, make the slot available again
                        current--;
                        // If there are items waiting in the queue, resolve the next
                        // Promise
                        if (queue.length > 0) queue.shift()();
                    } else // The `max` has been exceeded - push onto the queue to wait
                    queue.push(handler);
                }
                // Return the async handler
                return handler();
            });
        };
    }
    // Return the throttle function
    return throttle;
}

});
parcelRegister("agusq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7793063ff00ed5a1$export$2e2bcd8739ae039);
/**
 * Queue, for FIFO access to arbitrary objects. Intended to be a faster
 * replacement for a Javascript array.
 */ class $7793063ff00ed5a1$export$2e2bcd8739ae039 {
    constructor(){
        /**
         * First node in the tree
         */ /**
         * Number of items in the queue
         */ this.length = 0;
    }
    /**
     * Pushes a value into the queue.
     * @param value - Any object to push into the queue
     */ push(value) {
        const node = {
            value: value
        };
        this.last = this.last ? this.last.next = node : this.first = node;
        this.length++;
    }
    /**
     * Remove a value from the start of the queue (FIFO) and return it
     */ shift() {
        if (this.first) {
            const { value: value } = this.first;
            this.first = this.first.next;
            if (!--this.length) this.last = undefined;
            return value;
        }
    }
}

});


parcelRegister("1ErbZ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $133e9eb0e92e3331$require$Buffer = $6ZWSX.Buffer;
"use strict";
class $133e9eb0e92e3331$var$NonError extends Error {
    constructor(message){
        super($133e9eb0e92e3331$var$NonError._prepareSuperMessage(message));
        Object.defineProperty(this, "name", {
            value: "NonError",
            configurable: true,
            writable: true
        });
        if (Error.captureStackTrace) Error.captureStackTrace(this, $133e9eb0e92e3331$var$NonError);
    }
    static _prepareSuperMessage(message) {
        try {
            return JSON.stringify(message);
        } catch  {
            return String(message);
        }
    }
}
const $133e9eb0e92e3331$var$commonProperties = [
    {
        property: "name",
        enumerable: false
    },
    {
        property: "message",
        enumerable: false
    },
    {
        property: "stack",
        enumerable: false
    },
    {
        property: "code",
        enumerable: true
    }
];
const $133e9eb0e92e3331$var$isCalled = Symbol(".toJSON called");
const $133e9eb0e92e3331$var$toJSON = (from)=>{
    from[$133e9eb0e92e3331$var$isCalled] = true;
    const json = from.toJSON();
    delete from[$133e9eb0e92e3331$var$isCalled];
    return json;
};
const $133e9eb0e92e3331$var$destroyCircular = ({ from: from, seen: seen, to_: to_, forceEnumerable: forceEnumerable, maxDepth: maxDepth, depth: depth })=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    if (depth >= maxDepth) return to;
    if (typeof from.toJSON === "function" && from[$133e9eb0e92e3331$var$isCalled] !== true) return $133e9eb0e92e3331$var$toJSON(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof $133e9eb0e92e3331$require$Buffer === "function" && $133e9eb0e92e3331$require$Buffer.isBuffer(value)) {
            to[key] = "[object Buffer]";
            continue;
        }
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            depth++;
            to[key] = $133e9eb0e92e3331$var$destroyCircular({
                from: from[key],
                seen: seen.slice(),
                forceEnumerable: forceEnumerable,
                maxDepth: maxDepth,
                depth: depth
            });
            continue;
        }
        to[key] = "[Circular]";
    }
    for (const { property: property, enumerable: enumerable } of $133e9eb0e92e3331$var$commonProperties)if (typeof from[property] === "string") Object.defineProperty(to, property, {
        value: from[property],
        enumerable: forceEnumerable ? true : enumerable,
        configurable: true,
        writable: true
    });
    return to;
};
const $133e9eb0e92e3331$var$serializeError = (value, options = {})=>{
    const { maxDepth: maxDepth = Number.POSITIVE_INFINITY } = options;
    if (typeof value === "object" && value !== null) return $133e9eb0e92e3331$var$destroyCircular({
        from: value,
        seen: [],
        forceEnumerable: true,
        maxDepth: maxDepth,
        depth: 0
    });
    // People sometimes throw things besides Error objects…
    if (typeof value === "function") // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
const $133e9eb0e92e3331$var$deserializeError = (value, options = {})=>{
    const { maxDepth: maxDepth = Number.POSITIVE_INFINITY } = options;
    if (value instanceof Error) return value;
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const newError = new Error(); // eslint-disable-line unicorn/error-message
        $133e9eb0e92e3331$var$destroyCircular({
            from: value,
            seen: [],
            to_: newError,
            maxDepth: maxDepth,
            depth: 0
        });
        return newError;
    }
    return new $133e9eb0e92e3331$var$NonError(value);
};
module.exports = {
    serializeError: $133e9eb0e92e3331$var$serializeError,
    deserializeError: $133e9eb0e92e3331$var$deserializeError
};

});



parcelRegister("1SXIy", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $hPtJY = parcelRequire("hPtJY");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    let m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $hPtJY !== "undefined" && "env" in $hPtJY) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("7kBR8"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("7kBR8", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $5567c417bf6247fd$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("3pRq5"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $5567c417bf6247fd$var$setup;

});
parcelRegister("3pRq5", function(module, exports) {
/**
 * Helpers.
 */ var $27cd24efd2f930b8$var$s = 1000;
var $27cd24efd2f930b8$var$m = $27cd24efd2f930b8$var$s * 60;
var $27cd24efd2f930b8$var$h = $27cd24efd2f930b8$var$m * 60;
var $27cd24efd2f930b8$var$d = $27cd24efd2f930b8$var$h * 24;
var $27cd24efd2f930b8$var$w = $27cd24efd2f930b8$var$d * 7;
var $27cd24efd2f930b8$var$y = $27cd24efd2f930b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $27cd24efd2f930b8$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $27cd24efd2f930b8$var$fmtLong(val) : $27cd24efd2f930b8$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $27cd24efd2f930b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $27cd24efd2f930b8$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $27cd24efd2f930b8$var$w;
        case "days":
        case "day":
        case "d":
            return n * $27cd24efd2f930b8$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $27cd24efd2f930b8$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $27cd24efd2f930b8$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $27cd24efd2f930b8$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return Math.round(ms / $27cd24efd2f930b8$var$d) + "d";
    if (msAbs >= $27cd24efd2f930b8$var$h) return Math.round(ms / $27cd24efd2f930b8$var$h) + "h";
    if (msAbs >= $27cd24efd2f930b8$var$m) return Math.round(ms / $27cd24efd2f930b8$var$m) + "m";
    if (msAbs >= $27cd24efd2f930b8$var$s) return Math.round(ms / $27cd24efd2f930b8$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$d, "day");
    if (msAbs >= $27cd24efd2f930b8$var$h) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$h, "hour");
    if (msAbs >= $27cd24efd2f930b8$var$m) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$m, "minute");
    if (msAbs >= $27cd24efd2f930b8$var$s) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $27cd24efd2f930b8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});




parcelRegister("ebuIP", function(module, exports) {

$parcel$export(module.exports, "useApiCache", () => $a539ec897ac047de$export$5ddcc8bff7cbd7f2);
$parcel$export(module.exports, "makeNewVersionAvailableEvent", () => $a539ec897ac047de$export$db66e6e89448a14c);
$parcel$export(module.exports, "default", () => $a539ec897ac047de$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $jW3HH = parcelRequire("jW3HH");
var $a539ec897ac047de$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $a539ec897ac047de$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $a539ec897ac047de$var$debug = (0, $jW3HH.default)("apiCcache");
var $a539ec897ac047de$var$ApiCacheContext = /*#__PURE__*/ (0, $acw62.createContext)({
    setCache: function(key, data, value) {},
    forgetCache: function(key, immediate) {
        if (immediate === void 0) immediate = false;
    },
    invalidateCache: function(cutoff, ids) {},
    getCache: function(key, data) {
        throw new Error("Cache not initialized");
    },
    newVersionAvailable: false
});
function $a539ec897ac047de$export$5ddcc8bff7cbd7f2() {
    return (0, $acw62.useContext)($a539ec897ac047de$var$ApiCacheContext);
}
function $a539ec897ac047de$export$db66e6e89448a14c() {
    return new CustomEvent("new_version_available");
}
var $a539ec897ac047de$var$EIGHT_HOURS = 28800000;
function $a539ec897ac047de$export$2e2bcd8739ae039(_a) {
    var children = _a.children;
    var _b = $a539ec897ac047de$var$__read((0, $acw62.useState)(new Map()), 2), apiCache = _b[0], setApiCache = _b[1];
    var _c = $a539ec897ac047de$var$__read((0, $acw62.useState)(false), 2), newVersionAvailable = _c[0], setNewVersionAvailable = _c[1];
    var _d = $a539ec897ac047de$var$__read((0, $acw62.useState)(Date.now()), 2), lastActivityAt = _d[0], setLastActivityAt = _d[1];
    var _e = $a539ec897ac047de$var$__read((0, $acw62.useState)(Date.now()), 2), previousActivityAt = _e[0], setPreviousActivityAt = _e[1];
    (0, $acw62.useEffect)(function() {
        var listener = function(event) {
            setNewVersionAvailable(true);
        };
        document.addEventListener("new_version_available", listener);
        return function() {
            document.removeEventListener("new_version_available", listener);
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        var listener = function() {
            if (Date.now() - lastActivityAt < 60000) return;
            setPreviousActivityAt(lastActivityAt);
            setLastActivityAt(Date.now());
        };
        document.addEventListener("mousemove", listener);
        return function() {
            document.removeEventListener("mousemove", listener);
        };
    }, [
        lastActivityAt
    ]);
    (0, $acw62.useEffect)(function() {
        if (newVersionAvailable && Date.now() - previousActivityAt > $a539ec897ac047de$var$EIGHT_HOURS) window.reload();
    }, [
        previousActivityAt,
        newVersionAvailable
    ]);
    var forgetCache = (0, $acw62.useCallback)(function(key, immediate) {
        if (immediate === void 0) immediate = false;
        setApiCache(function(cache) {
            var e_1, _a;
            if (immediate) cache.delete(key);
            else {
                var keyCache = cache.get(key);
                try {
                    for(var _b = $a539ec897ac047de$var$__values(keyCache.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var _d = $a539ec897ac047de$var$__read(_c.value, 2), dataKey = _d[0], _e = $a539ec897ac047de$var$__read(_d[1], 2), date = _e[0], cachedValue = _e[1];
                        keyCache.set(dataKey, [
                            new Date(0),
                            cachedValue
                        ]);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
            return new Map(cache);
        });
    }, []);
    var setCache = (0, $acw62.useCallback)(function(key, data, value) {
        setApiCache(function(cache) {
            var _a;
            var keyCache = (_a = cache.get(key)) !== null && _a !== void 0 ? _a : new Map();
            keyCache.set(JSON.stringify(data !== null && data !== void 0 ? data : "-"), [
                new Date(),
                value
            ]);
            cache.set(key, keyCache);
            if (cache.size > 100) cache.delete(cache.keys().next().value);
            return new Map(cache);
        });
    }, []);
    // Returns [isFresh: boolean, data: ApiRequests[T] | undefined]
    var getCache = (0, $acw62.useCallback)(function(key, data) {
        var _a;
        var cached = (_a = apiCache.get(key)) === null || _a === void 0 ? void 0 : _a.get(JSON.stringify(data !== null && data !== void 0 ? data : "-"));
        if (cached) {
            var _b = $a539ec897ac047de$var$__read(cached, 2), date = _b[0], value = _b[1];
            return [
                new Date().getTime() - date.getTime() < 60000,
                value
            ];
        }
        return [
            false,
            undefined
        ];
    }, [
        apiCache
    ]);
    var invalidateCache = (0, $acw62.useCallback)(function(cutoff, ids) {
        $a539ec897ac047de$var$debug("Invalidating cache by %O", ids);
        setApiCache(function(apiCache) {
            var e_2, _a, e_3, _b;
            try {
                for(var _c = $a539ec897ac047de$var$__values(apiCache.keys()), _d = _c.next(); !_d.done; _d = _c.next()){
                    var endpoint = _d.value;
                    var _loop_1 = function(dataKey, date, cacheValue) {
                        if (date > cutoff) return "continue";
                        if (ids.every(function(id) {
                            return $a539ec897ac047de$var$deepExists(cacheValue, id);
                        })) {
                            $a539ec897ac047de$var$debug("Invalidating cache %s / %s", endpoint, dataKey);
                            var keyCache = apiCache.get(endpoint);
                            keyCache.set(dataKey, [
                                new Date(0),
                                cacheValue
                            ]);
                        }
                    };
                    try {
                        for(var _e = (e_3 = void 0, $a539ec897ac047de$var$__values(apiCache.get(endpoint).entries())), _f = _e.next(); !_f.done; _f = _e.next()){
                            var _g = $a539ec897ac047de$var$__read(_f.value, 2), dataKey = _g[0], _h = $a539ec897ac047de$var$__read(_g[1], 2), date = _h[0], cacheValue = _h[1];
                            _loop_1(dataKey, date, cacheValue);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            return new Map(apiCache);
        });
    }, []);
    return (0, $ayMG0.jsx)($a539ec897ac047de$var$ApiCacheContext.Provider, {
        value: {
            setCache: setCache,
            getCache: getCache,
            forgetCache: forgetCache,
            newVersionAvailable: newVersionAvailable,
            invalidateCache: invalidateCache
        },
        children: children
    });
}
var $a539ec897ac047de$var$deepExists = function(obj, query) {
    return Object.values(obj).some(function(v) {
        return typeof v === "object" && v !== null ? $a539ec897ac047de$var$deepExists(v, query) : v === query;
    });
};

});

parcelRegister("iCMjC", function(module, exports) {

$parcel$export(module.exports, "useAuthentication", () => $d8f1410551c2b4e3$export$1c4696175a160501);
$parcel$export(module.exports, "default", () => $d8f1410551c2b4e3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $bn01X = parcelRequire("bn01X");

var $8Nbse = parcelRequire("8Nbse");

var $acw62 = parcelRequire("acw62");

var $6yrIz = parcelRequire("6yrIz");

var $gU1vo = parcelRequire("gU1vo");

var $jFdmN = parcelRequire("jFdmN");

var $jW3HH = parcelRequire("jW3HH");

var $hmJ39 = parcelRequire("hmJ39");

var $9HNzc = parcelRequire("9HNzc");

var $fbNBg = parcelRequire("fbNBg");

var $01O3F = parcelRequire("01O3F");

var $lID51 = parcelRequire("lID51");

var $3gpVc = parcelRequire("3gpVc");
var $d8f1410551c2b4e3$var$__assign = undefined && undefined.__assign || function() {
    $d8f1410551c2b4e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d8f1410551c2b4e3$var$__assign.apply(this, arguments);
};
var $d8f1410551c2b4e3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8f1410551c2b4e3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d8f1410551c2b4e3$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d8f1410551c2b4e3$var$AuthenticationContext = /*#__PURE__*/ (0, $acw62.createContext)({
    user: null,
    teams: null,
    teamMemberships: null,
    impersonating: null,
    promptForPassword: false,
    promptForMfa: false,
    adminRoles: [],
    refresh: function() {
        return $d8f1410551c2b4e3$var$__awaiter(void 0, void 0, void 0, function() {
            return $d8f1410551c2b4e3$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    },
    logout: function() {
        return $d8f1410551c2b4e3$var$__awaiter(void 0, void 0, void 0, function() {
            return $d8f1410551c2b4e3$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    },
    stopImpersonation: function() {
        return $d8f1410551c2b4e3$var$__awaiter(void 0, void 0, void 0, function() {
            return $d8f1410551c2b4e3$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    }
});
function $d8f1410551c2b4e3$export$1c4696175a160501() {
    return (0, $acw62.useContext)($d8f1410551c2b4e3$var$AuthenticationContext);
}
function $d8f1410551c2b4e3$export$2e2bcd8739ae039(_a) {
    var _this = this;
    var _b;
    var children = _a.children;
    var _c = $d8f1410551c2b4e3$var$__read((0, $acw62.useState)(false), 2), fetched = _c[0], setFetched = _c[1];
    var _d = $d8f1410551c2b4e3$var$__read((0, $acw62.useState)(false), 2), promptForPassword = _d[0], setPromptForPassword = _d[1];
    var _e = $d8f1410551c2b4e3$var$__read((0, $acw62.useState)(false), 2), promptForMfa = _e[0], setPromptForMfa = _e[1];
    var _f = $d8f1410551c2b4e3$var$__read((0, $9HNzc.useCachedState)(null), 2), user = _f[0], setUser = _f[1];
    var _g = $d8f1410551c2b4e3$var$__read((0, $9HNzc.useCachedState)(null), 2), teams = _g[0], setTeams = _g[1];
    var _h = $d8f1410551c2b4e3$var$__read((0, $acw62.useState)(null), 2), impersonating = _h[0], setImpersonating = _h[1];
    var _j = $d8f1410551c2b4e3$var$__read((0, $9HNzc.useCachedState)(null), 2), teamMemberships = _j[0], setTeamMemberships = _j[1];
    var _k = $d8f1410551c2b4e3$var$__read((0, $acw62.useState)([]), 2), adminRoles = _k[0], setAdminRoles = _k[1];
    var _l = $d8f1410551c2b4e3$var$__read((0, $acw62.useState)(null), 2), baa = _l[0], setBaa = _l[1];
    var isIdle = (0, $6yrIz.default)(60000);
    (0, $3gpVc.default)({
        enable: fetched && !impersonating && !(user === null || user === void 0 ? void 0 : user.isAdmin),
        email: user === null || user === void 0 ? void 0 : user.email,
        name: user === null || user === void 0 ? void 0 : user.name,
        hashedEmail: (0, $01O3F.presence)(user === null || user === void 0 ? void 0 : user.intercomHashedEmail)
    });
    (0, $lID51.useGoogleTagManager)({
        enable: fetched && !impersonating && !(user === null || user === void 0 ? void 0 : user.isAdmin),
        userId: user === null || user === void 0 ? void 0 : user.id,
        baa: baa
    });
    (0, $fbNBg.default)();
    var refresh = (0, $acw62.useCallback)(function() {
        return $d8f1410551c2b4e3$var$__awaiter(_this, void 0, void 0, function() {
            var auth, originalCookie;
            return $d8f1410551c2b4e3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $gU1vo.default)("auth.status.show")
                        ];
                    case 1:
                        auth = _a.sent().auth;
                        setFetched(true);
                        if (auth) {
                            originalCookie = (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get("upscope_locale");
                            if (typeof auth.language === "string" && originalCookie !== auth.language) {
                                (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).set("upscope_locale", auth.language, {
                                    expires: 365
                                });
                                if ((0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get("upscope_locale") === auth.language) // Will not get saved if cookies are disabled in embedded version
                                window.reload();
                            }
                            setUser(auth.user);
                            setTeams(auth.teams);
                            setImpersonating(auth.impersonating);
                            setTeamMemberships(auth.teamMemberships);
                            setPromptForPassword(auth.promptForPassword);
                            setPromptForMfa(auth.promptForMfa);
                            setBaa(auth.baa);
                            setAdminRoles(auth.adminRoles);
                        } else {
                            setUser(null);
                            setTeams(null);
                            setTeamMemberships(null);
                            setImpersonating(false);
                            setAdminRoles([]);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        setTeamMemberships,
        setTeams,
        setUser
    ]);
    var teamMembershipsWithTeam = (0, $acw62.useMemo)(function() {
        return (teamMemberships === null || teamMemberships === void 0 ? void 0 : teamMemberships.map(function(membership) {
            var m = $d8f1410551c2b4e3$var$__assign({}, membership);
            m.team = teams.find(function(t) {
                return t.id === membership.teamId;
            });
            return m;
        })) || null;
    }, [
        teams,
        teamMemberships
    ]);
    var logout = (0, $acw62.useCallback)(function() {
        return $d8f1410551c2b4e3$var$__awaiter(_this, void 0, void 0, function() {
            return $d8f1410551c2b4e3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $gU1vo.default)("auth.sessions.terminate")
                        ];
                    case 1:
                        _a.sent();
                        setUser(null);
                        setTeams(null);
                        setTeamMemberships(null);
                        location.href = (0, $hmJ39.path)("up.root", {}); // Cannot  use navigate because this happens outside of the router
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        setTeamMemberships,
        setTeams,
        setUser
    ]);
    var stopImpersonation = (0, $acw62.useCallback)(function() {
        return $d8f1410551c2b4e3$var$__awaiter(_this, void 0, void 0, function() {
            var redirectUrl;
            return $d8f1410551c2b4e3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $gU1vo.default)("global.impersonation.stop")
                        ];
                    case 1:
                        redirectUrl = _a.sent().redirectUrl;
                        location.href = redirectUrl;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, []);
    (0, $acw62.useEffect)(function() {
        if (isIdle) return;
        refresh();
    }, [
        refresh,
        isIdle
    ]);
    (0, $acw62.useEffect)(function() {
        var _a;
        (0, $jW3HH.setLoggerContext)({
            user: (_a = user === null || user === void 0 ? void 0 : user.id) !== null && _a !== void 0 ? _a : "unauthenticated",
            admin: user === null || user === void 0 ? void 0 : user.isAdmin
        });
    }, [
        user
    ]);
    if (!fetched) return (0, $ayMG0.jsx)((0, $jFdmN.default), {});
    return (0, $ayMG0.jsx)($d8f1410551c2b4e3$var$AuthenticationContext.Provider, {
        value: {
            user: user,
            teams: teams,
            teamMemberships: teamMembershipsWithTeam,
            impersonating: impersonating,
            refresh: refresh,
            logout: logout,
            promptForPassword: promptForPassword,
            promptForMfa: promptForMfa,
            adminRoles: adminRoles,
            stopImpersonation: stopImpersonation
        },
        children: (0, $ayMG0.jsx)((0, $bn01X.UpscopeProvider), {
            apiKey: "N1ZaRHmZcJbuJdMK6TmyF8My",
            enabled: !impersonating && !(user === null || user === void 0 ? void 0 : user.isAdmin),
            uniqueId: user === null || user === void 0 ? void 0 : user.id,
            identities: [
                user === null || user === void 0 ? void 0 : user.name,
                user === null || user === void 0 ? void 0 : user.email,
                (_b = teams === null || teams === void 0 ? void 0 : teams[0]) === null || _b === void 0 ? void 0 : _b.domain
            ].filter(Boolean),
            children: children
        })
    });
}

});
parcelRegister("bn01X", function(module, exports) {

$parcel$export(module.exports, "UpscopeProvider", () => $8471ddc32c25e7d5$export$baf8ac8861935692);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iIAws = parcelRequire("iIAws");
function $8471ddc32c25e7d5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8471ddc32c25e7d5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8471ddc32c25e7d5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $8471ddc32c25e7d5$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $8471ddc32c25e7d5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $8471ddc32c25e7d5$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $8471ddc32c25e7d5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8471ddc32c25e7d5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8471ddc32c25e7d5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8471ddc32c25e7d5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8471ddc32c25e7d5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8471ddc32c25e7d5$var$_slicedToArray(arr, i) {
    return $8471ddc32c25e7d5$var$_arrayWithHoles(arr) || $8471ddc32c25e7d5$var$_iterableToArrayLimit(arr, i) || $8471ddc32c25e7d5$var$_unsupportedIterableToArray(arr, i) || $8471ddc32c25e7d5$var$_nonIterableRest();
}
function $8471ddc32c25e7d5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8471ddc32c25e7d5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8471ddc32c25e7d5$var$_arrayLikeToArray(o, minLen);
}
var $8471ddc32c25e7d5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8471ddc32c25e7d5$var$UpscopeContext = (0, $acw62.createContext)({
    Upscope: undefined,
    shortId: undefined,
    getLookupCode: function getLookupCode() {
        return $8471ddc32c25e7d5$var$_asyncToGenerator(function() {
            return $8471ddc32c25e7d5$var$__generator(this, function(_state) {
                return [
                    2,
                    ""
                ];
            });
        })();
    },
    listen: function(event, callback) {},
    reset: function() {},
    isSharing: false
});
function $8471ddc32c25e7d5$export$6ecd112e9bce2c42() {
    return (0, $acw62.useContext)($8471ddc32c25e7d5$var$UpscopeContext);
}
function $8471ddc32c25e7d5$export$baf8ac8861935692(_param) {
    var getLookupCode = function getLookupCode() {
        return new Promise(function(resolve) {
            if (!loaded || !enabled) return resolve(undefined);
            (0, $iIAws.default)("getLookupCode", function(lookupCode) {
                resolve(lookupCode);
            });
        });
    };
    var listen = function listen(event, callback) {
        (0, $iIAws.default)("on", event, callback);
    };
    var reset = function reset() {
        (0, $iIAws.default)("reset", true);
    };
    var children = _param.children, enabled = _param.enabled, config = $8471ddc32c25e7d5$var$_objectWithoutProperties(_param, [
        "children",
        "enabled"
    ]);
    var _useState = $8471ddc32c25e7d5$var$_slicedToArray((0, $acw62.useState)(false), 2), loaded = _useState[0], setLoaded = _useState[1];
    var _useState1 = $8471ddc32c25e7d5$var$_slicedToArray((0, $acw62.useState)(false), 2), sharing = _useState1[0], setSharing = _useState1[1];
    var _useState2 = $8471ddc32c25e7d5$var$_slicedToArray((0, $acw62.useState)(undefined), 2), shortId = _useState2[0], setShortId = _useState2[1];
    enabled !== null && enabled !== void 0 ? enabled : enabled = true;
    (0, $acw62.useEffect)(function() {
        if (enabled && !loaded) {
            setLoaded(true);
            (0, $iIAws.default)("init", config);
        } else if (!enabled && loaded) {
            (0, $iIAws.default)("reset", false);
            setShortId(undefined);
        }
    }, [
        enabled,
        loaded,
        config
    ]);
    (0, $acw62.useEffect)(function() {
        if (enabled && loaded) {
            (0, $iIAws.default)("updateConnection", config);
            (0, $iIAws.default)("getShortId", function(shortId) {
                setShortId(shortId);
            });
        }
    }, [
        enabled,
        loaded,
        config
    ]);
    (0, $acw62.useEffect)(function() {
        if (loaded) {
            (0, $iIAws.default)("on", "sessionStart", function() {
                setSharing(true);
            });
            (0, $iIAws.default)("on", "sessionContinue", function() {
                setSharing(true);
            });
            (0, $iIAws.default)("on", "sessionEnd", function() {
                setSharing(false);
            });
        }
    }, [
        loaded
    ]);
    return (0, $ayMG0.jsx)($8471ddc32c25e7d5$var$UpscopeContext.Provider, {
        value: {
            Upscope: (0, $iIAws.default),
            shortId: shortId,
            getLookupCode: getLookupCode,
            listen: listen,
            reset: reset,
            isSharing: sharing
        },
        children: children
    });
}
function $8471ddc32c25e7d5$export$598fc71206495231(param) {
    var children = param.children;
    var beforeRef = (0, $acw62.useRef)(null);
    var afterRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (beforeRef.current && afterRef.current) {
            var nextSibling = beforeRef.current.nextSibling;
            while(nextSibling && nextSibling !== afterRef.current){
                nextSibling.dataset.upscopeMasked = true;
                nextSibling = nextSibling.nextSibling;
            }
        }
    }, [
        beforeRef,
        afterRef,
        children
    ]);
    return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsx)("script", {
                ref: beforeRef
            }),
            children,
            (0, $ayMG0.jsx)("script", {
                ref: afterRef
            })
        ]
    });
}
function $8471ddc32c25e7d5$export$94b669dd66270e53(param) {
    var children = param.children;
    var beforeRef = (0, $acw62.useRef)(null);
    var afterRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (beforeRef.current && afterRef.current) {
            var nextSibling = beforeRef.current.nextSibling;
            while(nextSibling && nextSibling !== afterRef.current){
                nextSibling.dataset.upscopeNoRemoteControl = true;
                nextSibling = nextSibling.nextSibling;
            }
        }
    }, [
        beforeRef,
        afterRef,
        children
    ]);
    return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsx)("script", {
                ref: beforeRef
            }),
            children,
            (0, $ayMG0.jsx)("script", {
                ref: afterRef
            })
        ]
    });
}

});
parcelRegister("iIAws", function(module, exports) {

$parcel$export(module.exports, "default", () => $da08aaa7179d6fda$export$2e2bcd8739ae039);
function $da08aaa7179d6fda$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $da08aaa7179d6fda$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $da08aaa7179d6fda$var$_arrayLikeToArray(arr);
}
function $da08aaa7179d6fda$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $da08aaa7179d6fda$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $da08aaa7179d6fda$var$_toConsumableArray(arr) {
    return $da08aaa7179d6fda$var$_arrayWithoutHoles(arr) || $da08aaa7179d6fda$var$_iterableToArray(arr) || $da08aaa7179d6fda$var$_unsupportedIterableToArray(arr) || $da08aaa7179d6fda$var$_nonIterableSpread();
}
function $da08aaa7179d6fda$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $da08aaa7179d6fda$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $da08aaa7179d6fda$var$_arrayLikeToArray(o, minLen);
}
var $da08aaa7179d6fda$var$loaded = false;
function $da08aaa7179d6fda$var$loadSDK(apiKey) {
    if (typeof window.Upscope !== "undefined") {
        $da08aaa7179d6fda$var$loaded = true;
        return;
    }
    var i = function i1() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        i.q.push(args);
    };
    i.q = [];
    // The real Upscope implementation is loaded below
    window.Upscope = i;
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://code.upscope.io/".concat(apiKey, ".js");
    document.head.appendChild(s);
    $da08aaa7179d6fda$var$loaded = true;
}
var $da08aaa7179d6fda$var$_Upscope = function _Upscope() {
    for(var _len = arguments.length, instruction = new Array(_len), _key = 0; _key < _len; _key++)instruction[_key] = arguments[_key];
    var _window;
    if (!$da08aaa7179d6fda$var$loaded) {
        if (instruction[0] === "init") {
            var config = instruction[1];
            if (!(config === null || config === void 0 ? void 0 : config.apiKey)) throw new Error("API key not specified");
            $da08aaa7179d6fda$var$loadSDK(config.apiKey);
        } else throw new Error("Upscope is not loaded");
    }
    return (_window = window).Upscope.apply(_window, $da08aaa7179d6fda$var$_toConsumableArray(instruction));
};
var $da08aaa7179d6fda$export$2e2bcd8739ae039 = $da08aaa7179d6fda$var$_Upscope;

});


parcelRegister("6yrIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c5b6b41ad951e8c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $80Dm5 = parcelRequire("80Dm5");

var $iG64q = parcelRequire("iG64q");
var $4c5b6b41ad951e8c$var$defaultEvents = [
    "mousemove",
    "mousedown",
    "resize",
    "keydown",
    "touchstart",
    "wheel"
];
var $4c5b6b41ad951e8c$var$oneMinute = 60e3;
var $4c5b6b41ad951e8c$var$useIdle = function(ms, initialState, events) {
    if (ms === void 0) ms = $4c5b6b41ad951e8c$var$oneMinute;
    if (initialState === void 0) initialState = false;
    if (events === void 0) events = $4c5b6b41ad951e8c$var$defaultEvents;
    var _a = (0, $acw62.useState)(initialState), state = _a[0], setState = _a[1];
    (0, $acw62.useEffect)(function() {
        var mounted = true;
        var timeout;
        var localState = state;
        var set = function(newState) {
            if (mounted) {
                localState = newState;
                setState(newState);
            }
        };
        var onEvent = (0, $80Dm5.throttle)(50, function() {
            if (localState) set(false);
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                return set(true);
            }, ms);
        });
        var onVisibility = function() {
            if (!document.hidden) onEvent();
        };
        for(var i = 0; i < events.length; i++)(0, $iG64q.on)(window, events[i], onEvent);
        (0, $iG64q.on)(document, "visibilitychange", onVisibility);
        timeout = setTimeout(function() {
            return set(true);
        }, ms);
        return function() {
            mounted = false;
            for(var i = 0; i < events.length; i++)(0, $iG64q.off)(window, events[i], onEvent);
            (0, $iG64q.off)(document, "visibilitychange", onVisibility);
        };
    }, [
        ms,
        events
    ]);
    return state;
};
var $4c5b6b41ad951e8c$export$2e2bcd8739ae039 = $4c5b6b41ad951e8c$var$useIdle;

});
parcelRegister("80Dm5", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $5d4cd9f8bc92bd41$export$de363e709c412c8a);
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */ function $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== "boolean") {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */ function $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0(delay, atBegin, callback) {
    return callback === undefined ? $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, atBegin, false) : $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, atBegin !== false);
}

});


parcelRegister("gU1vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e30b35fcc9bd2b$export$2e2bcd8739ae039);

var $kQ0sT = parcelRequire("kQ0sT");
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");

var $xLhiG = parcelRequire("xLhiG");

var $eyQyi = parcelRequire("eyQyi");

var $aRPX9 = parcelRequire("aRPX9");

var $hmJ39 = parcelRequire("hmJ39");

var $ebuIP = parcelRequire("ebuIP");

var $01O3F = parcelRequire("01O3F");

var $gz8iO = parcelRequire("gz8iO");
var $c4e30b35fcc9bd2b$var$__assign = undefined && undefined.__assign || function() {
    $c4e30b35fcc9bd2b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c4e30b35fcc9bd2b$var$__assign.apply(this, arguments);
};
var $c4e30b35fcc9bd2b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4e30b35fcc9bd2b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c4e30b35fcc9bd2b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $c4e30b35fcc9bd2b$var$failingSince = undefined, $c4e30b35fcc9bd2b$var$mfaCode = undefined, $c4e30b35fcc9bd2b$var$mfaCodePromise = undefined;
var $c4e30b35fcc9bd2b$var$authenticationToken = location.pathname.startsWith("/embed") ? localStorage.getItem("upscope:authentication-token") : null;
var $c4e30b35fcc9bd2b$var$verbKeywords = {
    get: [
        "get",
        "show",
        "index",
        "list",
        "stats",
        "verify",
        "search",
        "download",
        "info",
        "setup",
        "stop"
    ],
    put: [
        "update",
        "transfer",
        "publish",
        "toggle",
        "add",
        "on",
        "off"
    ],
    post: [
        "create",
        "perform",
        "upload",
        "report",
        "refetch",
        "share",
        "submit",
        "join",
        "merge",
        "send",
        "start"
    ],
    delete: [
        "delete",
        "unlink",
        "remove",
        "terminate",
        "disable"
    ]
};
var $c4e30b35fcc9bd2b$var$rateLimitErrors = [
    429,
    502,
    503,
    504
];
var $c4e30b35fcc9bd2b$var$getVerbKeywordsCheck = true;
var $c4e30b35fcc9bd2b$var$postVerbKeywordsCheck = true;
var $c4e30b35fcc9bd2b$var$putVerbKeywordsCheck = true;
var $c4e30b35fcc9bd2b$var$deleteVerbKeywordsCheck = true;
var $c4e30b35fcc9bd2b$var$serverPrefixes = {
    up: "up",
    hq: "hq",
    ld: "ld",
    uv: "uv",
    hs: "hs",
    co: "co",
    auth: "*",
    global: "*"
};
var $c4e30b35fcc9bd2b$export$f77d6386ad0c2c62 = [
    "permission:denied",
    "auth:logged_in",
    "auth:not_logged_in",
    "auth:mfa_setup_required",
    "admin:not_admin",
    "admin:impersonating",
    "admin:wrong_role",
    "billing:subscription_needed",
    "billing:missing_feature",
    "billing:change_not_allowed",
    "team_status:baa",
    "team_status:banned",
    "team_status:on_premise",
    "team_status:not_on_premise",
    "admin:mfa_required"
];
var $c4e30b35fcc9bd2b$var$railsAxiosClient = (0, $xLhiG.default)((0, $7we3r.default).create({
    baseURL: "/",
    headers: {
        "Content-Type": "application/json",
        "X-Integration-Authentication-Token": $c4e30b35fcc9bd2b$var$authenticationToken,
        "Accept": "application/json",
        "X-Version": "2025.6.4"
    },
    validateStatus: function(status) {
        return status < 501 || !$c4e30b35fcc9bd2b$var$failingForTooLong() && $c4e30b35fcc9bd2b$var$rateLimitErrors.includes(status);
    }
}));
var $c4e30b35fcc9bd2b$var$axiosClient = (0, $7we3r.default).create({
    baseURL: "/",
    headers: {
        "Content-Type": "application/json",
        "X-Integration-Authentication-Token": $c4e30b35fcc9bd2b$var$authenticationToken,
        "Accept": "application/json",
        "X-Version": "2025.6.4",
        "X-Client-Timezone": $c4e30b35fcc9bd2b$var$timezone()
    },
    validateStatus: function(status) {
        return status < 501 || !$c4e30b35fcc9bd2b$var$failingForTooLong() && $c4e30b35fcc9bd2b$var$rateLimitErrors.includes(status);
    }
});
function $c4e30b35fcc9bd2b$export$2e2bcd8739ae039(endpoint, data) {
    return $c4e30b35fcc9bd2b$var$__awaiter(this, void 0, Promise, function() {
        return $c4e30b35fcc9bd2b$var$__generator(this, function(_a) {
            if (endpoint in (0, $aRPX9.apiEndpoints)) // Legacy endpoints
            return [
                2 /*return*/ ,
                $c4e30b35fcc9bd2b$var$railsRequest(endpoint, data)
            ];
            return [
                2 /*return*/ ,
                $c4e30b35fcc9bd2b$var$apiRequest(endpoint, data)
            ];
        });
    });
}
function $c4e30b35fcc9bd2b$var$railsRequest(endpoint, data) {
    return $c4e30b35fcc9bd2b$var$__awaiter(this, void 0, Promise, function() {
        var func, _a, domain, method, url, expectedHostname, headers, response, _b, version, status, responseData, validation, error;
        var _c;
        return $c4e30b35fcc9bd2b$var$__generator(this, function(_d) {
            switch(_d.label){
                case 0:
                    data !== null && data !== void 0 ? data : data = {};
                    func = (0, $aRPX9.apiEndpoints)[endpoint];
                    _a = $c4e30b35fcc9bd2b$var$__read(func(data), 3), domain = _a[0], method = _a[1], url = _a[2];
                    if (domain !== "*") {
                        expectedHostname = (0, $hmJ39.getRouteBaseHostname)("".concat(domain, ".root"));
                        if (location.hostname !== expectedHostname && !location.hostname.endsWith(".".concat(expectedHostname))) throw new Error("Endpoint ".concat(endpoint, " is not allowed to be called from ").concat(location.origin));
                    }
                    headers = {
                        "X-Mfa-Code": $c4e30b35fcc9bd2b$var$mfaCode
                    };
                    if ((0, $01O3F.containsFile)(data)) headers["Content-Type"] = "multipart/form-data";
                    return [
                        4 /*yield*/ ,
                        $c4e30b35fcc9bd2b$var$railsAxiosClient.request((_c = {
                            method: method,
                            url: url
                        }, _c[method === "get" ? "params" : "data"] = data, _c.headers = headers, _c))
                    ];
                case 1:
                    response = _d.sent();
                    _b = $c4e30b35fcc9bd2b$var$__read([
                        response.headers["x-app-version"],
                        response.status,
                        response.data
                    ], 3), version = _b[0], status = _b[1], responseData = _b[2];
                    if (status === 401 && $c4e30b35fcc9bd2b$export$f77d6386ad0c2c62.includes(responseData.error)) return [
                        2 /*return*/ ,
                        $c4e30b35fcc9bd2b$var$handleRailsUnauthorizedResponse(endpoint, data, responseData.error)
                    ];
                    if ($c4e30b35fcc9bd2b$var$rateLimitErrors.includes(status)) return [
                        2 /*return*/ ,
                        $c4e30b35fcc9bd2b$var$handleRateLimitResponse(endpoint, data)
                    ];
                    if (status === 500) return [
                        2 /*return*/ ,
                        $c4e30b35fcc9bd2b$var$handleServerError(endpoint, data)
                    ];
                    $c4e30b35fcc9bd2b$var$failingSince = undefined;
                    validation = (0, $aRPX9.apiResponses)[endpoint].safeParse(responseData);
                    if (!validation.success) {
                        if ("2025.6.4" !== version) window.reload();
                        else {
                            error = new Error("API response for ".concat(endpoint, " is not valid. Response: ").concat(JSON.stringify((0, $01O3F.trimStrings)(responseData))));
                            console.error(error);
                            console.log(validation.error.issues);
                            $kQ0sT.captureException(error);
                        }
                    }
                    return [
                        2 /*return*/ ,
                        "data" in validation ? validation.data : responseData
                    ];
            }
        });
    });
}
function $c4e30b35fcc9bd2b$var$apiRequest(endpoint, data) {
    return $c4e30b35fcc9bd2b$var$__awaiter(this, void 0, Promise, function() {
        var parts, prefix, verb, requestId, method, expectedHostname, headers, encodedData, response, _a, version, status, responseData;
        var _b;
        var _c, _d;
        return $c4e30b35fcc9bd2b$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    parts = endpoint.split(".");
                    prefix = parts[0];
                    verb = parts[parts.length - 1];
                    requestId = (0, $01O3F.uuid)();
                    data !== null && data !== void 0 ? data : data = {};
                    method = (_c = Object.entries($c4e30b35fcc9bd2b$var$verbKeywords).find(function(_a) {
                        var _b = $c4e30b35fcc9bd2b$var$__read(_a, 2), _ = _b[0], keywords = _b[1];
                        return keywords.includes(verb);
                    })) === null || _c === void 0 ? void 0 : _c[0];
                    if ($c4e30b35fcc9bd2b$var$serverPrefixes[prefix] !== "*") {
                        expectedHostname = (0, $hmJ39.getRouteBaseHostname)("".concat($c4e30b35fcc9bd2b$var$serverPrefixes[prefix], ".root"));
                        if (location.hostname !== expectedHostname && !location.hostname.endsWith(".".concat(expectedHostname))) throw new Error("Endpoint ".concat(endpoint, " is not allowed to be called from ").concat(location.origin));
                    }
                    headers = {
                        "X-Mfa-Code": $c4e30b35fcc9bd2b$var$mfaCode,
                        "X-Request-Id": requestId
                    };
                    encodedData = $c4e30b35fcc9bd2b$export$9f8a32dca75c5393(data);
                    if ((0, $01O3F.containsFile)(data)) {
                        headers["Content-Type"] = "multipart/form-data";
                        encodedData = $c4e30b35fcc9bd2b$export$3b2a6bb46c2b0cee(encodedData);
                    }
                    return [
                        4 /*yield*/ ,
                        $c4e30b35fcc9bd2b$var$axiosClient.request((_b = {
                            method: method,
                            url: "/api/call/".concat(endpoint)
                        }, _b[method === "get" ? "params" : "data"] = encodedData, _b.headers = headers, _b))
                    ];
                case 1:
                    response = _e.sent();
                    _a = $c4e30b35fcc9bd2b$var$__read([
                        response.headers["x-app-version"],
                        response.status,
                        response.data
                    ], 3), version = _a[0], status = _a[1], responseData = _a[2];
                    if (status === 401 && responseData.error === "admin:mfa_required") return [
                        2 /*return*/ ,
                        $c4e30b35fcc9bd2b$var$handleMfaUnauthorizedResponse(endpoint, data)
                    ];
                    if (status === 403) {
                        $c4e30b35fcc9bd2b$var$handleUnauthorizedResponse(responseData.requiredRole);
                        return [
                            2 /*return*/ ,
                            $c4e30b35fcc9bd2b$var$waitForever()
                        ];
                    }
                    if (status === 402) {
                        $c4e30b35fcc9bd2b$var$handlePaymentRequiredResponse(responseData.subscriptionIssues, data && "teamId" in data ? data.teamId : undefined);
                        return [
                            2 /*return*/ ,
                            $c4e30b35fcc9bd2b$var$waitForever()
                        ];
                    }
                    if ($c4e30b35fcc9bd2b$var$rateLimitErrors.includes(status)) return [
                        2 /*return*/ ,
                        $c4e30b35fcc9bd2b$var$handleRateLimitResponse(endpoint, data, responseData)
                    ];
                    if (status === 500) return [
                        2 /*return*/ ,
                        $c4e30b35fcc9bd2b$var$handleServerError(endpoint, data)
                    ];
                    if (status === 413) {
                        $kQ0sT.captureException(new Error("Size too large for request to ".concat(endpoint, ".")));
                        document.dispatchEvent((0, $eyQyi.makeApiErrorEvent)("request_too_large"));
                        return [
                            2 /*return*/ ,
                            $c4e30b35fcc9bd2b$var$waitForever()
                        ];
                    }
                    $c4e30b35fcc9bd2b$var$failingSince = undefined;
                    if ("2025.6.4" !== version && ((_d = "2025.6.4", _d === void 0) ? void 0 : _d.localeCompare(version, undefined, {
                        numeric: true,
                        sensitivity: "base"
                    })) === -1) document.dispatchEvent((0, $ebuIP.makeNewVersionAvailableEvent)());
                    if (status === 400 && responseData.status === "unexpected_error") {
                        $kQ0sT.captureException(new Error("Unexpected response to ".concat(endpoint, ": ").concat(responseData.error)));
                        document.dispatchEvent((0, $eyQyi.makeApiErrorEvent)("unexpected"));
                        return [
                            2 /*return*/ ,
                            $c4e30b35fcc9bd2b$var$waitForever()
                        ];
                    }
                    return [
                        2 /*return*/ ,
                        $c4e30b35fcc9bd2b$var$ensureErrorChecked(endpoint, $c4e30b35fcc9bd2b$export$a0f1734e2f86df6a(responseData))
                    ];
            }
        });
    });
}
function $c4e30b35fcc9bd2b$var$failingForTooLong() {
    return $c4e30b35fcc9bd2b$var$failingSince !== undefined && Date.now() - $c4e30b35fcc9bd2b$var$failingSince.getTime() > 60000;
}
function $c4e30b35fcc9bd2b$var$waitForever() {
    return new Promise(function() {});
}
function $c4e30b35fcc9bd2b$var$ensureErrorChecked(endpoint, response) {
    if (response.success) return response;
    var errorChecked = false;
    var handler = {
        get: function(target, prop, receiver) {
            if ([
                "status",
                "success",
                "error"
            ].includes(prop)) errorChecked = true;
            return Reflect.get(target, prop, receiver);
        },
        has: function(target, prop) {
            // catches `"error" in response`
            if (prop === "error") errorChecked = true;
            return Reflect.has(target, prop);
        }
    };
    setTimeout(function() {
        if (!errorChecked) {
            var error = "Bad Request error not checked in ".concat(endpoint, ": error is ").concat(response.error);
            $kQ0sT.captureException(new Error(error));
        }
    }, 1000);
    return new Proxy(response, handler);
}
function $c4e30b35fcc9bd2b$var$handleRailsUnauthorizedResponse(endpoint, data, reason) {
    if (reason === "admin:mfa_required") {
        $c4e30b35fcc9bd2b$var$mfaCode = undefined;
        $c4e30b35fcc9bd2b$var$mfaCodePromise !== null && $c4e30b35fcc9bd2b$var$mfaCodePromise !== void 0 ? $c4e30b35fcc9bd2b$var$mfaCodePromise : $c4e30b35fcc9bd2b$var$mfaCodePromise = new Promise(function(resolve) {
            while(!$c4e30b35fcc9bd2b$var$mfaCode)$c4e30b35fcc9bd2b$var$mfaCode = (0, $01O3F.presence)(prompt("Enter MFA code"));
            resolve();
            $c4e30b35fcc9bd2b$var$mfaCodePromise = undefined;
        });
        return $c4e30b35fcc9bd2b$var$mfaCodePromise.then(function() {
            return $c4e30b35fcc9bd2b$export$2e2bcd8739ae039(endpoint, data);
        });
    }
    document.dispatchEvent((0, $eyQyi.makeRailsErrorEvent)(reason));
    return $c4e30b35fcc9bd2b$var$waitForever();
}
function $c4e30b35fcc9bd2b$var$handleUnauthorizedResponse(requiredRole) {
    document.dispatchEvent((0, $eyQyi.makeApiErrorEvent)({
        auth: requiredRole
    }));
}
function $c4e30b35fcc9bd2b$var$handleMfaUnauthorizedResponse(endpoint, data) {
    $c4e30b35fcc9bd2b$var$mfaCode = undefined;
    $c4e30b35fcc9bd2b$var$mfaCodePromise !== null && $c4e30b35fcc9bd2b$var$mfaCodePromise !== void 0 ? $c4e30b35fcc9bd2b$var$mfaCodePromise : $c4e30b35fcc9bd2b$var$mfaCodePromise = new Promise(function(resolve) {
        while(!$c4e30b35fcc9bd2b$var$mfaCode)$c4e30b35fcc9bd2b$var$mfaCode = (0, $01O3F.presence)(prompt("Enter MFA code"));
        resolve();
        $c4e30b35fcc9bd2b$var$mfaCodePromise = undefined;
    });
    return $c4e30b35fcc9bd2b$var$mfaCodePromise.then(function() {
        return $c4e30b35fcc9bd2b$export$2e2bcd8739ae039(endpoint, data);
    });
}
function $c4e30b35fcc9bd2b$var$handlePaymentRequiredResponse(subscriptionIssues, teamId) {
    document.dispatchEvent((0, $eyQyi.makeApiErrorEvent)({
        subscriptionIssues: subscriptionIssues,
        teamId: teamId
    }));
}
function $c4e30b35fcc9bd2b$var$handleRateLimitResponse(endpoint, data, response) {
    var retryIn = 5000;
    $c4e30b35fcc9bd2b$var$failingSince !== null && $c4e30b35fcc9bd2b$var$failingSince !== void 0 ? $c4e30b35fcc9bd2b$var$failingSince : $c4e30b35fcc9bd2b$var$failingSince = new Date();
    if (typeof response === "object" && response !== null && "resetsInMs" in response) retryIn = response.resetsInMs;
    console.log("Hit rate limit, retrying in ".concat(retryIn.toLocaleString(), "ms"));
    return (0, $01O3F.sleep)(retryIn).then(function() {
        return $c4e30b35fcc9bd2b$export$2e2bcd8739ae039(endpoint, data);
    });
}
function $c4e30b35fcc9bd2b$var$handleServerError(endpoint, data) {
    var retryIn = 5000;
    $c4e30b35fcc9bd2b$var$failingSince !== null && $c4e30b35fcc9bd2b$var$failingSince !== void 0 ? $c4e30b35fcc9bd2b$var$failingSince : $c4e30b35fcc9bd2b$var$failingSince = new Date();
    if (Date.now() - $c4e30b35fcc9bd2b$var$failingSince.getTime() > 30000) {
        $kQ0sT.captureException(new Error("Unexpected server 500 at ".concat(endpoint, ".")));
        document.dispatchEvent((0, $eyQyi.makeApiErrorEvent)("unexpected"));
        return $c4e30b35fcc9bd2b$var$waitForever();
    }
    console.log("Got server error, retrying in ".concat(retryIn.toLocaleString(), "ms"));
    return (0, $01O3F.sleep)(retryIn).then(function() {
        return $c4e30b35fcc9bd2b$export$2e2bcd8739ae039(endpoint, data);
    });
}
function $c4e30b35fcc9bd2b$export$3b2a6bb46c2b0cee(input) {
    if (typeof input === "string") return JSON.stringify(input);
    else if (Array.isArray(input)) return input.map(function(element) {
        return $c4e30b35fcc9bd2b$export$3b2a6bb46c2b0cee(element);
    });
    else if (typeof input === "object" && input !== null) {
        if (!(0, $01O3F.isPlainObject)(input)) return input;
        var transformedObj = {};
        for(var key in input)if (Object.prototype.hasOwnProperty.call(input, key)) transformedObj[key] = $c4e30b35fcc9bd2b$export$3b2a6bb46c2b0cee(input[key]);
        return transformedObj;
    } else if (input === null || typeof input === "number" || typeof input === "boolean") return JSON.stringify(input);
}
function $c4e30b35fcc9bd2b$export$9f8a32dca75c5393(object) {
    if (!(0, $01O3F.isPlainObject)(object)) return object;
    var objectCopy = $c4e30b35fcc9bd2b$var$__assign({}, object);
    for(var key in objectCopy){
        if (objectCopy[key] instanceof Date) objectCopy[key] = {
            __date__: objectCopy[key].toISOString()
        };
        else if (objectCopy[key] instanceof (0, $gz8iO.default)) objectCopy[key] = {
            __day__: objectCopy[key].toString()
        };
        else if (Array.isArray(objectCopy[key])) objectCopy[key] = objectCopy[key].map(function(item) {
            if (typeof item === "object") return $c4e30b35fcc9bd2b$export$9f8a32dca75c5393(item);
            return item;
        });
        else if (typeof objectCopy[key] === "object" && objectCopy[key] !== null) objectCopy[key] = $c4e30b35fcc9bd2b$export$9f8a32dca75c5393(objectCopy[key]);
    }
    return objectCopy;
}
function $c4e30b35fcc9bd2b$export$a0f1734e2f86df6a(object) {
    if (!(0, $01O3F.isPlainObject)(object)) return object;
    var objectCopy = $c4e30b35fcc9bd2b$var$__assign({}, object);
    for(var key in objectCopy){
        if (Array.isArray(objectCopy[key])) objectCopy[key] = objectCopy[key].map(function(item) {
            if (typeof item === "object") return $c4e30b35fcc9bd2b$export$a0f1734e2f86df6a(item);
            return item;
        });
        else if (typeof objectCopy[key] === "object" && objectCopy[key] !== null) {
            if (objectCopy[key].__day__ !== undefined) objectCopy[key] = new (0, $gz8iO.default)(objectCopy[key].__day__);
            else if (objectCopy[key].__date__ !== undefined) objectCopy[key] = new Date(objectCopy[key].__date__);
            else objectCopy[key] = $c4e30b35fcc9bd2b$export$a0f1734e2f86df6a(objectCopy[key]);
        }
    }
    return objectCopy;
}
function $c4e30b35fcc9bd2b$var$timezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (_a) {
        return null;
    }
}

});
parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $jJbMR.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : typeof $hPtJY !== "undefined" && $hPtJY.nextTick || $c319b2c832c2914a$var$_setImmediate;
var // *********************
$c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling("baseURL"),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $gKvUL.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $gKvUL.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $gKvUL.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, "[]")) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $gKvUL.default).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $gKvUL.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $gKvUL.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});

parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});




parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $lcuqa.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $gKvUL.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});


parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");
"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6HVMZ.default).call(this, message == null ? "canceled" : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $gKvUL.default).inherits($9fd0919e266b4fda$var$CanceledError, (0, $6HVMZ.default), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: (0, $jFSbX.default)
};
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)("Request aborted", (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6HVMZ.default)("Network Error", (0, $6HVMZ.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $gKvUL.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && (0, $g65xr.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6HVMZ.default)("Unsupported protocol " + protocol + ":", (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)("Request failed with status code " + response.status, [
        (0, $6HVMZ.default).ERR_BAD_REQUEST,
        (0, $6HVMZ.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $gKvUL.default).asap(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $cbIsf = parcelRequire("cbIsf");
var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $lk5EI.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $gKvUL.default).isFormData(data)) {
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $gKvUL.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $889er.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $gKvUL.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $gKvUL.default).isString(path) && cookie.push("path=" + path);
        (0, $gKvUL.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $ckHwb.default)(requestedURL)) return (0, $fE4ul.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e52be20a9fc15e96$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");
const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $g65xr.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response("").body));
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $gKvUL.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $gKvUL.default).isBlob(body)) return body.size;
    if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $g65xr.default).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + "";
    if ((0, $gKvUL.default).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $eHGD2.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $dLozx.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress)));
                data = (0, $hhnAb.trackStream)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $gKvUL.default).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $gKvUL.default).findKey($e52be20a9fc15e96$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $kk0E9.default)(resolve, reject, {
                data: responseData,
                headers: (0, $bxxyx.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $6HVMZ.default)("Network Error", (0, $6HVMZ.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $6HVMZ.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $6HVMZ.default)(`timeout ${timeout} of ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $6HVMZ.default)("options must be an object", (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)("option " + opt + " must be " + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)("Unknown option " + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});
parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.7.9";

});



parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});



parcelRegister("xLhiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0657c19d7ff1d328$export$2e2bcd8739ae039);

var $cAmfc = parcelRequire("cAmfc");

var $0657c19d7ff1d328$export$2e2bcd8739ae039 = (0, $cAmfc.applyCaseMiddleware);

});
parcelRegister("cAmfc", function(module, exports) {

$parcel$export(module.exports, "applyCaseMiddleware", () => $929a1a086784ec1c$export$78d71c3d5ee2668d);

var $7WQrb = parcelRequire("7WQrb");

var $iLVWc = parcelRequire("iLVWc");

var $RX9Av = parcelRequire("RX9Av");
var $929a1a086784ec1c$export$d51f4b842a2c3daf = function(options) {
    var snake = (0, $iLVWc.createObjectTransformers)(options === null || options === void 0 ? void 0 : options.caseFunctions).snake;
    return function(config) {
        if (config.params) config.params = snake(config.params, options);
        return config;
    };
};
var $929a1a086784ec1c$export$bed98a71bbb0e689 = function(options) {
    var _a = (0, $iLVWc.createObjectTransformers)(options === null || options === void 0 ? void 0 : options.caseFunctions), snake = _a.snake, header = _a.header;
    return function(data, headers) {
        $929a1a086784ec1c$var$overwriteHeadersOrNoop(headers, header, options, [
            "common",
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch"
        ]);
        return snake(data, options);
    };
};
var $929a1a086784ec1c$export$46de618e0e305c2f = function(options) {
    var camel = (0, $iLVWc.createObjectTransformers)(options === null || options === void 0 ? void 0 : options.caseFunctions).camel;
    return function(data, headers) {
        $929a1a086784ec1c$var$overwriteHeadersOrNoop(headers, camel, options);
        return camel(data, options);
    };
};
var $929a1a086784ec1c$var$overwriteHeadersOrNoop = function(headers, fn, options, excludedKeys) {
    var e_1, _a, _b, _c;
    if ((options === null || options === void 0 ? void 0 : options.ignoreHeaders) || !(0, $RX9Av.isPlainObject)(headers) && !(0, $RX9Av.isAxiosHeaders)(headers)) return;
    try {
        for(var _d = (0, $7WQrb.__values)(Object.entries(headers)), _e = _d.next(); !_e.done; _e = _d.next()){
            var _f = (0, $7WQrb.__read)(_e.value, 2), key = _f[0], value = _f[1];
            fn(value, (0, $7WQrb.__assign)({
                overwrite: true
            }, options));
            if ((excludedKeys || []).includes(key)) continue;
            if ((0, $RX9Av.isAxiosHeaders)(headers)) {
                headers.delete(key);
                headers.set(Object.keys(fn((_b = {}, _b[key] = null, _b), options))[0], value, true);
            } else {
                delete headers[key];
                headers[Object.keys(fn((_c = {}, _c[key] = null, _c), options))[0]] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
};
var $929a1a086784ec1c$export$78d71c3d5ee2668d = function(axios, options) {
    var _a, _b, _c;
    axios.defaults.transformRequest = (0, $7WQrb.__spreadArray)([
        ((_a = options === null || options === void 0 ? void 0 : options.caseMiddleware) === null || _a === void 0 ? void 0 : _a.requestTransformer) || $929a1a086784ec1c$export$bed98a71bbb0e689(options)
    ], (0, $7WQrb.__read)(Array.isArray(axios.defaults.transformRequest) ? axios.defaults.transformRequest : axios.defaults.transformRequest !== undefined ? [
        axios.defaults.transformRequest
    ] : []), false);
    axios.defaults.transformResponse = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(Array.isArray(axios.defaults.transformResponse) ? axios.defaults.transformResponse : axios.defaults.transformResponse !== undefined ? [
        axios.defaults.transformResponse
    ] : []), false), [
        ((_b = options === null || options === void 0 ? void 0 : options.caseMiddleware) === null || _b === void 0 ? void 0 : _b.responseTransformer) || $929a1a086784ec1c$export$46de618e0e305c2f(options)
    ], false);
    axios.interceptors.request.use(((_c = options === null || options === void 0 ? void 0 : options.caseMiddleware) === null || _c === void 0 ? void 0 : _c.requestInterceptor) || $929a1a086784ec1c$export$d51f4b842a2c3daf(options));
    return axios;
};

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__values", () => $5c96a02c592fcff1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};

});

parcelRegister("iLVWc", function(module, exports) {

$parcel$export(module.exports, "createObjectTransformers", () => $daa98efb4aa9b74b$export$77d66088b81e2043);

var $7WQrb = parcelRequire("7WQrb");

var $63CkK = parcelRequire("63CkK");

var $7TbM9 = parcelRequire("7TbM9");

var $43qU8 = parcelRequire("43qU8");

var $9BmFa = parcelRequire("9BmFa");

var $RX9Av = parcelRequire("RX9Av");
var $daa98efb4aa9b74b$var$caseFunctions = {
    snake: (0, $7TbM9.snakeCase),
    camel: (0, $63CkK.camelCase),
    header: (0, $43qU8.headerCase)
};
var $daa98efb4aa9b74b$var$transformObjectUsingCallbackRecursive = function(data, fn, overwrite) {
    var e_1, _a, e_2, _b, e_3, _c;
    if (!(0, $RX9Av.isTransformable)(data)) return data;
    /* eslint-disable no-console */ // Check FormData/URLSearchParams compatibility
    if (((0, $RX9Av.isFormData)(data) || (0, $RX9Av.isURLSearchParams)(data)) && (!data.entries || overwrite && !data.delete)) {
        var type = (0, $RX9Av.isFormData)(data) ? "FormData" : "URLSearchParams";
        var polyfill = (0, $RX9Av.isFormData)(data) ? "https://github.com/jimmywarting/FormData" : "https://github.com/jerrybendy/url-search-params-polyfill";
        if (typeof navigator !== "undefined" && navigator.product === "ReactNative") // You cannot transform FormData/URLSearchParams on React Native
        console.warn("Be careful that ".concat(type, " cannot be transformed on React Native. If you intentionally implemented, ignore this kind of warning: https://facebook.github.io/react-native/docs/debugging.html"));
        else {
            if (!data.entries) // You need to polyfill `entries` method
            console.warn("You must use polyfill of ".concat(type, ".prototype.entries() on Internet Explorer or Safari: ").concat(polyfill));
            if (overwrite && !data.delete) // You need to polyfill `delete` method for overwriting
            console.warn("You must use polyfill of ".concat(type, ".prototype.delete() on Internet Explorer or Safari: ").concat(polyfill));
        }
        return data;
    }
    /* eslint-enable no-console */ var prototype = Object.getPrototypeOf(data);
    // Storage of new values.
    // New instances are created when overwriting is disabled.
    var store = overwrite ? data : !prototype ? Object.create(null) : new prototype.constructor();
    // We need to clean up all entries before overwriting.
    var series;
    if ((0, $RX9Av.isFormData)(data) || (0, $RX9Av.isURLSearchParams)(data)) {
        // Create native iterator from FormData/URLSearchParams
        series = data.entries();
        if (overwrite) {
            // When overwriting, native iterator needs to be copied as array.
            series = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(series), false);
            try {
                for(var series_1 = (0, $7WQrb.__values)(series), series_1_1 = series_1.next(); !series_1_1.done; series_1_1 = series_1.next()){
                    var _d = (0, $7WQrb.__read)(series_1_1.value, 1), key = _d[0];
                    data.delete(key);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (series_1_1 && !series_1_1.done && (_a = series_1.return)) _a.call(series_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
    } else {
        // Create array from objects
        series = Object.entries(data);
        // Array keys never change, so we don't need to clean up
        if (overwrite && !Array.isArray(data)) try {
            for(var series_2 = (0, $7WQrb.__values)(series), series_2_1 = series_2.next(); !series_2_1.done; series_2_1 = series_2.next()){
                var _e = (0, $7WQrb.__read)(series_2_1.value, 1), key = _e[0];
                delete data[key];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (series_2_1 && !series_2_1.done && (_b = series_2.return)) _b.call(series_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    }
    try {
        for(var series_3 = (0, $7WQrb.__values)(series), series_3_1 = series_3.next(); !series_3_1.done; series_3_1 = series_3.next()){
            var _f = (0, $7WQrb.__read)(series_3_1.value, 2), key = _f[0], value = _f[1];
            if ((0, $RX9Av.isFormData)(store) || (0, $RX9Av.isURLSearchParams)(store)) store.append(fn(key), value);
            else if (key !== "__proto__") store[fn(typeof key === "string" ? key : "".concat(key))] = $daa98efb4aa9b74b$var$transformObjectUsingCallbackRecursive(value, fn, overwrite);
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (series_3_1 && !series_3_1.done && (_c = series_3.return)) _c.call(series_3);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return store;
};
var $daa98efb4aa9b74b$var$transformObjectUsingCallback = function(data, fn, options) {
    fn = (0, $9BmFa.applyCaseOptions)(fn, (0, $7WQrb.__assign)({
        stripRegexp: /[^A-Z0-9[\]]+/gi
    }, options === null || options === void 0 ? void 0 : options.caseOptions));
    if (options === null || options === void 0 ? void 0 : options.preservedKeys) fn = (0, $9BmFa.preserveSpecificKeys)(fn, options.preservedKeys);
    return $daa98efb4aa9b74b$var$transformObjectUsingCallbackRecursive(data, fn, (options === null || options === void 0 ? void 0 : options.overwrite) || false);
};
var $daa98efb4aa9b74b$export$f3d4a8207a9d907f = function(fn) {
    return function(data, options) {
        return $daa98efb4aa9b74b$var$transformObjectUsingCallback(data, fn, options);
    };
};
var $daa98efb4aa9b74b$export$5ae7c60bdb7b8217 = function(functionName, options) {
    return $daa98efb4aa9b74b$export$f3d4a8207a9d907f((options === null || options === void 0 ? void 0 : options[functionName]) || $daa98efb4aa9b74b$var$caseFunctions[functionName]);
};
var $daa98efb4aa9b74b$export$77d66088b81e2043 = function(options) {
    var e_4, _a;
    var functionNames = Object.keys($daa98efb4aa9b74b$var$caseFunctions);
    var objectTransformers = {};
    try {
        for(var functionNames_1 = (0, $7WQrb.__values)(functionNames), functionNames_1_1 = functionNames_1.next(); !functionNames_1_1.done; functionNames_1_1 = functionNames_1.next()){
            var functionName = functionNames_1_1.value;
            objectTransformers[functionName] = $daa98efb4aa9b74b$export$5ae7c60bdb7b8217(functionName, options);
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (functionNames_1_1 && !functionNames_1_1.done && (_a = functionNames_1.return)) _a.call(functionNames_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return objectTransformers;
};

});
parcelRegister("63CkK", function(module, exports) {

$parcel$export(module.exports, "camelCase", () => $4690c22a3f79a44e$export$8a7688a96d852767);

var $7WQrb = parcelRequire("7WQrb");

var $2pnsO = parcelRequire("2pnsO");
function $4690c22a3f79a44e$export$1c6885769b2bad6f(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $2pnsO.pascalCaseTransform)(input, index);
}
function $4690c22a3f79a44e$export$f3c8e8146a7dbf93(input, index) {
    if (index === 0) return input.toLowerCase();
    return (0, $2pnsO.pascalCaseTransformMerge)(input);
}
function $4690c22a3f79a44e$export$8a7688a96d852767(input, options) {
    if (options === void 0) options = {};
    return (0, $2pnsO.pascalCase)(input, (0, $7WQrb.__assign)({
        transform: $4690c22a3f79a44e$export$1c6885769b2bad6f
    }, options));
}

});
parcelRegister("2pnsO", function(module, exports) {

$parcel$export(module.exports, "pascalCaseTransform", () => $1c101dfc925f9f17$export$66a4dfea2695736);
$parcel$export(module.exports, "pascalCaseTransformMerge", () => $1c101dfc925f9f17$export$c27cf446dc44c0b9);
$parcel$export(module.exports, "pascalCase", () => $1c101dfc925f9f17$export$26c6f48841fe1a8a);

var $7WQrb = parcelRequire("7WQrb");

var $g68gv = parcelRequire("g68gv");
function $1c101dfc925f9f17$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $1c101dfc925f9f17$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $1c101dfc925f9f17$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $g68gv.noCase)(input, (0, $7WQrb.__assign)({
        delimiter: "",
        transform: $1c101dfc925f9f17$export$66a4dfea2695736
    }, options));
}

});
parcelRegister("g68gv", function(module, exports) {

$parcel$export(module.exports, "noCase", () => $bb839e30d903d5e0$export$a596972587f860c8);

var $6A52n = parcelRequire("6A52n");
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $bb839e30d903d5e0$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $bb839e30d903d5e0$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $bb839e30d903d5e0$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $bb839e30d903d5e0$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $bb839e30d903d5e0$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $6A52n.lowerCase) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $bb839e30d903d5e0$var$replace($bb839e30d903d5e0$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $bb839e30d903d5e0$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}

});
parcelRegister("6A52n", function(module, exports) {

$parcel$export(module.exports, "lowerCase", () => $4caa032c183be831$export$61d6efbc6547e8eb);
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $4caa032c183be831$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "i",
            I: "\u0131",
            I\u0307: "i"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "i\u0307",
            J: "j\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "i\u0307\u0300",
            "\xcd": "i\u0307\u0301",
            \u0128: "i\u0307\u0303"
        }
    }
};
function $4caa032c183be831$export$206cd6ecad4fcdde(str, locale) {
    var lang = $4caa032c183be831$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $4caa032c183be831$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $4caa032c183be831$export$61d6efbc6547e8eb(str);
}
function $4caa032c183be831$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}

});




parcelRegister("7TbM9", function(module, exports) {

$parcel$export(module.exports, "snakeCase", () => $5be6cdd8e661e6b8$export$feae9a740c003485);

var $7WQrb = parcelRequire("7WQrb");

var $5NKGO = parcelRequire("5NKGO");
function $5be6cdd8e661e6b8$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $5NKGO.dotCase)(input, (0, $7WQrb.__assign)({
        delimiter: "_"
    }, options));
}

});
parcelRegister("5NKGO", function(module, exports) {

$parcel$export(module.exports, "dotCase", () => $4395beeb50d15822$export$e1b697368b9a68f5);

var $7WQrb = parcelRequire("7WQrb");

var $g68gv = parcelRequire("g68gv");
function $4395beeb50d15822$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $g68gv.noCase)(input, (0, $7WQrb.__assign)({
        delimiter: "."
    }, options));
}

});


parcelRegister("43qU8", function(module, exports) {

$parcel$export(module.exports, "headerCase", () => $2f3c4fe4c074edda$export$e434c8e1873659bf);

var $7WQrb = parcelRequire("7WQrb");

var $4FSoA = parcelRequire("4FSoA");
function $2f3c4fe4c074edda$export$e434c8e1873659bf(input, options) {
    if (options === void 0) options = {};
    return (0, $4FSoA.capitalCase)(input, (0, $7WQrb.__assign)({
        delimiter: "-"
    }, options));
}

});
parcelRegister("4FSoA", function(module, exports) {

$parcel$export(module.exports, "capitalCase", () => $36752f95a16f3884$export$7fed55d4315c6715);

var $7WQrb = parcelRequire("7WQrb");

var $g68gv = parcelRequire("g68gv");

var $jIiXM = parcelRequire("jIiXM");
function $36752f95a16f3884$export$2a6bd1f4c244c979(input) {
    return (0, $jIiXM.upperCaseFirst)(input.toLowerCase());
}
function $36752f95a16f3884$export$7fed55d4315c6715(input, options) {
    if (options === void 0) options = {};
    return (0, $g68gv.noCase)(input, (0, $7WQrb.__assign)({
        delimiter: " ",
        transform: $36752f95a16f3884$export$2a6bd1f4c244c979
    }, options));
}

});
parcelRegister("jIiXM", function(module, exports) {

$parcel$export(module.exports, "upperCaseFirst", () => $e5a0d60d66157baf$export$688230ca06b60d9d);
/**
 * Upper case the first character of an input string.
 */ function $e5a0d60d66157baf$export$688230ca06b60d9d(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}

});



parcelRegister("9BmFa", function(module, exports) {

$parcel$export(module.exports, "applyCaseOptions", () => $6fd92628a2703180$export$51ccaea2cf5bc496);
$parcel$export(module.exports, "preserveSpecificKeys", () => $6fd92628a2703180$export$8961a37e2dfcc26a);

var $7WQrb = parcelRequire("7WQrb");
var $6fd92628a2703180$export$51ccaea2cf5bc496 = function(fn, defaultOptions) {
    return function(input, options) {
        return fn(input, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, defaultOptions), options));
    };
};
var $6fd92628a2703180$export$8961a37e2dfcc26a = function(fn, keys) {
    var condition = typeof keys === "function" ? keys : function(input) {
        return keys.includes(input);
    };
    return function(input, options) {
        return condition(input, options) ? input : fn(input, options);
    };
};

});

parcelRegister("RX9Av", function(module, exports) {

$parcel$export(module.exports, "isURLSearchParams", () => $0a22d60859547151$export$7002c8248e07507e);
$parcel$export(module.exports, "isFormData", () => $0a22d60859547151$export$67a42df2b7ab73bc);
$parcel$export(module.exports, "isPlainObject", () => $0a22d60859547151$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isTransformable", () => $0a22d60859547151$export$96052cdc881032e3);
$parcel$export(module.exports, "isAxiosHeaders", () => $0a22d60859547151$export$3cd7424ed9295cd4);
var $0a22d60859547151$export$7002c8248e07507e = function(value) {
    return typeof URLSearchParams !== "undefined" && value instanceof URLSearchParams;
};
var $0a22d60859547151$export$67a42df2b7ab73bc = function(value) {
    return typeof FormData !== "undefined" && value instanceof FormData;
};
var $0a22d60859547151$export$53b83ca8eaab0383 = function(value) {
    if (value == null) return false;
    var proto = Object.getPrototypeOf(value);
    return proto === null || proto === Object.prototype;
};
var $0a22d60859547151$export$96052cdc881032e3 = function(value) {
    return Array.isArray(value) || $0a22d60859547151$export$53b83ca8eaab0383(value) || $0a22d60859547151$export$67a42df2b7ab73bc(value) || $0a22d60859547151$export$7002c8248e07507e(value);
};
var $0a22d60859547151$export$3cd7424ed9295cd4 = function(value) {
    var _a, _b;
    if (value == null) return false;
    return ((_b = (_a = Object.getPrototypeOf(value)) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name) === "AxiosHeaders";
};

});




parcelRegister("eyQyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a99d016c4549cd0c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "makeRailsErrorEvent", () => $a99d016c4549cd0c$export$80879e05828f7af8);
$parcel$export(module.exports, "makeApiErrorEvent", () => $a99d016c4549cd0c$export$62a314f66a2f4e30);

var $acw62 = parcelRequire("acw62");

var $4Q1tF = parcelRequire("4Q1tF");

var $dtKoB = parcelRequire("dtKoB");

var $iCMjC = parcelRequire("iCMjC");

var $5aE2v = parcelRequire("5aE2v");

var $hNovL = parcelRequire("hNovL");

var $7xuAh = parcelRequire("7xuAh");
var $a99d016c4549cd0c$var$requiredRoleDescriptions = {
    "public": "NA",
    "user_any_team": "You must be logged in to perform this action.",
    "admin": "You must be an admin to perform this action.",
    "guest": "You are already logged in. Please log out to perform this action.",
    "member": "You must be a member of this team to perform this action.",
    "owner": "You must be the owner of this team to perform this action.",
    "member:canAccessSettings": "Please ask your admin for settings access to continue.",
    "member:canManageBilling": "Please ask your admin for billing access to continue.",
    "member:canUse": "Please ask your admin for access to continue.",
    "member:canManageContent": "Please ask your admin for content management access to continue.",
    "member:canViewReporting": "Please ask your admin for reporting access to continue.",
    "member:canManageUsers": "Please ask your admin for user management access to continue.",
    "admin:accounts_view": "Please ask the tech team for accounts view access to continue.",
    "admin:accounts_write": "Please ask the tech team for accounts write access to continue.",
    "admin:sales_lead_target": "Please ask the tech team for sales lead target access to continue.",
    "admin:customer_success": "Only Customer Success Managers can perform this action.",
    "admin:product_helloscreen": "You are a helloscreen admin.",
    "admin:product_userview": "You are a userview admin.",
    "admin:product_cobrowsingapi": "You are a cobrowsingapi admin.",
    "admin:product_livedocument": "You are a livedocument admin.",
    "admin:impersonate": "Please ask the tech team for impersonation access to continue.",
    "admin:sales_exec": "Only Sales Executives can perform this action.",
    "admin:sales_manager": "Only Sales Managers can perform this action.",
    "admin:sales_view": "Please ask the tech team for sales view access to continue.",
    "admin:sales_write": "Please ask the tech team for sales write access to continue.",
    "admin:devops": "Please ask the tech team for Devops access to continue.",
    "admin:superuser": "Only super admins can perform this action."
};
var $a99d016c4549cd0c$var$subscriptionStatusDescriptions = {
    "active": "Your subscription is currently inactive. Please reach out to your account manager to reactivate your subscription.",
    "active:subscribed": "You can only perform this action if you have an active subscription.",
    "active:trial": "You can only perform this action if you are on trial.",
    "inactive": "You already have an active subscription."
};
function $a99d016c4549cd0c$export$2e2bcd8739ae039(_a) {
    var children = _a.children;
    var addModal = (0, $5aE2v.useModal)().addModal;
    var redirect = (0, $7xuAh.default)();
    var teams = (0, $iCMjC.useAuthentication)().teams;
    var getSupport = (0, $hNovL.default)().getSupport;
    (0, $acw62.useEffect)(function() {
        var listener = function(event) {
            switch(event.detail.reason){
                case "permission:denied":
                    addModal({
                        title: "Permission denied",
                        content: "You do not have permission to perform this action."
                    });
                    break;
                case "auth:not_logged_in":
                    addModal({
                        title: "Not logged in",
                        content: "You must be logged in to perform this action.",
                        onClick: function() {
                            window.reload();
                        }
                    });
                    break;
                case "auth:logged_in":
                    addModal({
                        title: "Already logged in",
                        content: "You are already logged in.",
                        onClick: function() {
                            window.reload();
                        }
                    });
                    break;
                case "auth:mfa_setup_required":
                    addModal({
                        title: "MFA setup required",
                        content: "Please set up your MFA before continuing.",
                        onClick: function() {
                            redirect([
                                "up.auth.mfa.enable"
                            ]);
                        }
                    });
                    break;
                case "admin:not_admin":
                    addModal({
                        title: "Not an admin",
                        content: "You must be an admin to perform this action."
                    });
                    break;
                case "admin:impersonating":
                    addModal({
                        title: "Impersonating",
                        content: "You cannot perform this action while impersonating another  user."
                    });
                    break;
                case "admin:wrong_role":
                    addModal({
                        title: "Please contact your manager",
                        content: "Your manager's permission is required for you to perform this action."
                    });
                    break;
                case "billing:subscription_needed":
                    addModal({
                        title: "Please subscribe",
                        content: "You must have a subscription to perform this action.",
                        onClick: function() {
                            redirect([
                                "up.shortCuts.purchase"
                            ]);
                        }
                    });
                    break;
                case "billing:missing_feature":
                    addModal({
                        title: "Upgrade required",
                        content: "Your subscription does not currently have access to this feature. Please reach out to your account manager to upgrade your account."
                    });
                    break;
                case "billing:change_not_allowed":
                    addModal({
                        title: "Please contact us",
                        content: "Please reach out to your account manager to make changes to your subscription."
                    });
                    break;
                case "team_status:baa":
                    addModal({
                        title: "BAA protected",
                        content: "Because this team has BAA protections activated, some features are not available."
                    });
                    break;
                case "team_status:banned":
                    addModal({
                        title: "Please contact us",
                        content: "We have tried reaching out to you about your account. Please contact us to resolve this issue.",
                        onClick: function() {
                            redirect([
                                "up.root",
                                {}
                            ]);
                        }
                    });
                    break;
                case "team_status:on_premise":
                    addModal({
                        title: "On premise",
                        content: "Some features are not available because your account is configured to be hosted on-premise."
                    });
                    break;
                case "team_status:not_on_premise":
                    addModal({
                        title: "Not on premise",
                        content: "Please contact us if you wish to host your account on-premise."
                    });
                    break;
                case "unexpected":
                    addModal({
                        title: "Unexpected error",
                        content: "An unexpected error has occurred. Please try again later."
                    });
                    break;
            }
        };
        document.addEventListener("railserror", listener);
        return function() {
            document.removeEventListener("railserror", listener);
        };
    }, [
        addModal,
        redirect
    ]);
    (0, $acw62.useEffect)(function() {
        var listener = function(event) {
            if (event.detail.reason === "request_too_large") addModal({
                title: "Request too large",
                content: "Unfortunately your browser made a request too large, and our server could not process it. Please try again.",
                onClick: function() {
                    window.reload();
                }
            });
            else if (event.detail.reason === "unexpected") addModal({
                title: "Unexpected error",
                content: "Unfortunately we have encountered an unexpected error. Our team has been notified. Please try again.",
                onClick: function() {
                    window.reload();
                }
            });
            else if ("auth" in event.detail.reason) {
                var requiredRole = event.detail.reason.auth;
                addModal({
                    title: "Not authorized",
                    content: $a99d016c4549cd0c$var$requiredRoleDescriptions[requiredRole],
                    onClick: function() {
                        window.reload();
                    }
                });
            } else if ("subscriptionIssues" in event.detail.reason) {
                var _a = event.detail.reason.subscriptionIssues, missingFeatures = _a.missingFeatures, productNeeded_1 = _a.productNeeded, requiredSubscriptionStatus_1 = _a.requiredSubscriptionStatus, banned = _a.banned;
                if (banned) addModal({
                    title: (0, $dtKoB.default)("Please contact our team"),
                    content: (0, $dtKoB.default)("Our team has been trying to contact you, but was unable to reach you. Please get in touch to resume usage."),
                    onClick: function() {
                        getSupport();
                    },
                    confirmText: (0, $dtKoB.default)("Contact us")
                });
                else if (missingFeatures) addModal({
                    title: (0, $dtKoB.default)("Upgrade required"),
                    content: (0, $dtKoB.default)("Your subscription does not currently have access to this feature. Please reach out to your account manager to upgrade your account.")
                });
                else if (productNeeded_1) addModal({
                    title: (0, $dtKoB.default)("Please subscribe"),
                    content: (0, $dtKoB.default)("You must have a %{product} subscription to perform this action.", {
                        product: (0, $4Q1tF.productName)(productNeeded_1[0])
                    }),
                    onClick: function() {
                        redirect([
                            "up.settings.manageTeams",
                            {
                                newProduct: productNeeded_1[0]
                            }
                        ]);
                    }
                });
                else if (requiredSubscriptionStatus_1) {
                    var teamId_1 = event.detail.reason.teamId;
                    var team_1 = teamId_1 ? teams === null || teams === void 0 ? void 0 : teams.find(function(t) {
                        return t.id === teamId_1;
                    }) : undefined;
                    addModal({
                        title: (0, $dtKoB.default)("Invalid subscription status"),
                        content: $a99d016c4549cd0c$var$subscriptionStatusDescriptions[requiredSubscriptionStatus_1],
                        onClick: function() {
                            if (requiredSubscriptionStatus_1.startsWith("active")) team_1 ? redirect([
                                "up.onboarding.purchase",
                                {
                                    teamDomain: team_1.domain
                                }
                            ]) : redirect([
                                "up.shortCuts.purchase"
                            ]);
                            else redirect([
                                "up.root",
                                {}
                            ]);
                        }
                    });
                }
            } else addModal({
                title: (0, $dtKoB.default)("Unexpected error"),
                content: (0, $dtKoB.default)("An unexpected error has occurred. Please try again later.")
            });
        };
        document.addEventListener("apierror", listener);
        return function() {
            document.removeEventListener("apierror", listener);
        };
    }, [
        addModal,
        redirect,
        teams,
        getSupport
    ]);
    return children;
}
function $a99d016c4549cd0c$export$80879e05828f7af8(reason) {
    return new CustomEvent("railserror", {
        detail: {
            reason: reason
        }
    });
}
function $a99d016c4549cd0c$export$62a314f66a2f4e30(reason) {
    return new CustomEvent("apierror", {
        detail: {
            reason: reason
        }
    });
}

});
parcelRegister("4Q1tF", function(module, exports) {

$parcel$export(module.exports, "productName", () => $385d2a2a7e014c9b$export$75a30c72c46d1150);
$parcel$export(module.exports, "licenseType", () => $385d2a2a7e014c9b$export$e0ebd11dc7319283);
$parcel$export(module.exports, "billingFrequency", () => $385d2a2a7e014c9b$export$cb50eace46f53eaa);
function $385d2a2a7e014c9b$export$75a30c72c46d1150(identifier) {
    switch(identifier){
        case "helloscreen":
            return "HelloScreen";
        case "userview":
            return "UserView";
        case "livedocument":
            return "LiveDocument";
        case "cobrowsingapi":
            return "Co-Browsing API";
    }
}
function $385d2a2a7e014c9b$export$e0ebd11dc7319283(type) {
    switch(type){
        case "concurrent":
            return "Concurrent";
        case "agent":
            return "Named agent";
        case "seat":
            return "Seat";
    }
}
function $385d2a2a7e014c9b$export$cb50eace46f53eaa(period) {
    switch(period){
        case "year":
            return "Yearly";
        case "month":
            return "Monthly";
        case "quarter":
            return "Quarterly";
        case "six_month":
            return "Every six months";
        case "two_month":
            return "Every two months";
    }
}

});

parcelRegister("5aE2v", function(module, exports) {

$parcel$export(module.exports, "useModal", () => $3c3cf1ea80bc04d2$export$33ffd74ebf07f060);
$parcel$export(module.exports, "ModalProvider", () => $3c3cf1ea80bc04d2$export$178405afcd8c5eb);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7du74 = parcelRequire("7du74");
var $3c3cf1ea80bc04d2$var$__assign = undefined && undefined.__assign || function() {
    $3c3cf1ea80bc04d2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3c3cf1ea80bc04d2$var$__assign.apply(this, arguments);
};
var $3c3cf1ea80bc04d2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3c3cf1ea80bc04d2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3c3cf1ea80bc04d2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3c3cf1ea80bc04d2$var$ModalContext = /*#__PURE__*/ (0, $acw62.createContext)({
    addModal: function(modal) {
        return false;
    },
    removeModal: function() {},
    bindModalClick: function(func) {},
    modalExists: false
});
function $3c3cf1ea80bc04d2$export$33ffd74ebf07f060() {
    return (0, $acw62.useContext)($3c3cf1ea80bc04d2$var$ModalContext);
}
function $3c3cf1ea80bc04d2$export$178405afcd8c5eb(_a) {
    var children = _a.children;
    var _b = $3c3cf1ea80bc04d2$var$__read((0, $acw62.useState)(undefined), 2), modalDetails = _b[0], setModalDetails = _b[1];
    var _c = $3c3cf1ea80bc04d2$var$__read((0, $acw62.useState)(false), 2), modalDisappearing = _c[0], setModalDisappearing = _c[1];
    var _d = $3c3cf1ea80bc04d2$var$__read((0, $acw62.useState)(), 2), loading = _d[0], setLoading = _d[1];
    var modalDetailsRef = (0, $acw62.useRef)();
    modalDetailsRef.current = modalDetails;
    var currentModalId = (0, $acw62.useRef)(0);
    var addModalWithinClick = (0, $acw62.useRef)(false);
    var removeTimeoutRef = (0, $acw62.useRef)(undefined);
    function onModalClick(option) {
        return $3c3cf1ea80bc04d2$var$__awaiter(this, void 0, void 0, function() {
            var modalId, clear;
            var _a, _b;
            return $3c3cf1ea80bc04d2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        setLoading(option ? "confirm" : "cancel");
                        modalId = currentModalId.current;
                        addModalWithinClick.current = true;
                        return [
                            4 /*yield*/ ,
                            (_b = (_a = modalDetailsRef.current) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, option)
                        ];
                    case 1:
                        clear = _c.sent();
                        addModalWithinClick.current = false;
                        setLoading(undefined);
                        if (clear === false) return [
                            2 /*return*/ 
                        ];
                        if (modalId === currentModalId.current) removeModal();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }
    var removeModal = (0, $acw62.useCallback)(function() {
        setModalDisappearing(true);
        removeTimeoutRef.current = setTimeout(function() {
            setModalDetails(undefined);
            setModalDisappearing(false);
        }, 300);
    }, []);
    var addModal = (0, $acw62.useCallback)(function(modal) {
        var _a, _b;
        if (modalDetailsRef.current && !modal.replace) return false;
        currentModalId.current++;
        if (!addModalWithinClick.current && !removeTimeoutRef.current) (_b = (_a = modalDetailsRef.current) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, false);
        setModalDisappearing(false);
        setModalDetails(modal);
        clearTimeout(removeTimeoutRef.current);
        return true;
    }, []);
    var bindModalClick = (0, $acw62.useCallback)(function(func) {
        setModalDetails(function(modal) {
            if (!modal) return modal;
            return $3c3cf1ea80bc04d2$var$__assign($3c3cf1ea80bc04d2$var$__assign({}, modal), {
                onClick: func
            });
        });
    }, []);
    var modalExists = modalDetails !== undefined;
    return (0, $ayMG0.jsxs)($3c3cf1ea80bc04d2$var$ModalContext.Provider, {
        value: {
            addModal: addModal,
            removeModal: removeModal,
            bindModalClick: bindModalClick,
            modalExists: modalExists
        },
        children: [
            modalDetails && (0, $ayMG0.jsx)((0, $7du74.default), $3c3cf1ea80bc04d2$var$__assign({}, modalDetails, {
                disappearing: modalDisappearing,
                loading: loading,
                onClick: onModalClick,
                children: modalDetails.content
            })),
            children
        ]
    });
}

});
parcelRegister("7du74", function(module, exports) {

$parcel$export(module.exports, "default", () => $54111b2063d075d4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $iGb09 = parcelRequire("iGb09");
var $lLzDP = parcelRequire("lLzDP");
var $iymfR = parcelRequire("iymfR");

var $acw62 = parcelRequire("acw62");

var $dtKoB = parcelRequire("dtKoB");

var $5aE2v = parcelRequire("5aE2v");

var $iL5oi = parcelRequire("iL5oi");
function $54111b2063d075d4$export$2e2bcd8739ae039(props) {
    var _a, _b, _c;
    var type = (_a = props.type) !== null && _a !== void 0 ? _a : "info";
    var buttonColor = type === "warning" ? "red" : type === "success" ? "green" : "black";
    var confirmText = (_b = props.confirmText) !== null && _b !== void 0 ? _b : (0, $dtKoB.default)("Ok");
    var defaultBehavior = (_c = props.defaultBehavior) !== null && _c !== void 0 ? _c : "cancel";
    var cancelButtonRef = (0, $acw62.useRef)(null);
    var confirmButtonRef = (0, $acw62.useRef)(null);
    var titleRef = (0, $acw62.useRef)(null);
    var removeModal = (0, $5aE2v.useModal)().removeModal;
    function onCancel() {
        var _a;
        (_a = props.onClick) === null || _a === void 0 || _a.call(props, false);
    }
    function onConfirm() {
        var _a;
        (_a = props.onClick) === null || _a === void 0 || _a.call(props, true);
    }
    function onClose() {
        switch(defaultBehavior){
            case "confirm":
                onConfirm();
                break;
            case "cancel":
                onCancel();
                break;
            case "none":
                removeModal();
                break;
        }
    }
    var initialFocus = defaultBehavior === "confirm" ? confirmButtonRef : defaultBehavior === "cancel" ? cancelButtonRef : titleRef;
    return (0, $ayMG0.jsx)((0, $iymfR.Transition), {
        show: !props.disappearing,
        as: (0, $acw62.Fragment),
        children: (0, $ayMG0.jsxs)((0, $lLzDP.Dialog), {
            as: "div",
            className: "z-70 relative",
            initialFocus: initialFocus,
            onClose: onClose,
            children: [
                (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                    as: (0, $acw62.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: (0, $ayMG0.jsx)("div", {
                        className: "fixed inset-0 bg-neutral-500 bg-opacity-75 transition-opacity"
                    })
                }),
                (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: (0, $ayMG0.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                            as: (0, $acw62.Fragment),
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: (0, $ayMG0.jsxs)((0, $lLzDP.DialogPanel), {
                                "data-role": "modal",
                                className: "relative w-full overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:max-w-lg\n                  dark:bg-neutral-800",
                                children: [
                                    (0, $ayMG0.jsxs)("div", {
                                        className: "space-y-2 p-5 text-center text-slate-700 dark:text-slate-100",
                                        children: [
                                            (0, $ayMG0.jsx)((0, $lLzDP.DialogTitle), {
                                                className: "text-xl font-semibold",
                                                ref: titleRef,
                                                children: props.title
                                            }),
                                            typeof props.children === "string" ? (0, $ayMG0.jsx)((0, $iGb09.Description), {
                                                children: props.children
                                            }) : props.children
                                        ]
                                    }),
                                    (0, $ayMG0.jsxs)("div", {
                                        className: "flex flex-col justify-items-stretch gap-3 bg-neutral-100 p-3 sm:flex-row-reverse dark:bg-black/60",
                                        children: [
                                            (0, $ayMG0.jsx)((0, $iL5oi.default), {
                                                color: buttonColor,
                                                className: "w-full",
                                                onClick: onConfirm,
                                                loading: props.loading === "confirm",
                                                disabled: props.loading === "cancel",
                                                ref: confirmButtonRef,
                                                children: confirmText
                                            }),
                                            props.cancelText && (0, $ayMG0.jsx)((0, $iL5oi.default), {
                                                className: "w-full",
                                                ref: cancelButtonRef,
                                                onClick: onCancel,
                                                loading: props.loading === "cancel",
                                                disabled: props.loading === "confirm",
                                                variant: buttonColor === "black" ? "secondary" : "primary",
                                                children: props.cancelText
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

});
parcelRegister("iGb09", function(module, exports) {

$parcel$export(module.exports, "useDescribedBy", () => $d994aee5798540d7$export$899851af1363628);
$parcel$export(module.exports, "useDescriptions", () => $d994aee5798540d7$export$babde88292020af7);
$parcel$export(module.exports, "Description", () => $d994aee5798540d7$export$393edc798c47379d);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $6mpbl = parcelRequire("6mpbl");

var $brAF4 = parcelRequire("brAF4");

var $ebRQH = parcelRequire("ebRQH");
"use client";
let $d994aee5798540d7$var$a = (0, $acw62.createContext)(null);
$d994aee5798540d7$var$a.displayName = "DescriptionContext";
function $d994aee5798540d7$var$f() {
    let r = (0, $acw62.useContext)($d994aee5798540d7$var$a);
    if (r === null) {
        let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(e, $d994aee5798540d7$var$f), e;
    }
    return r;
}
function $d994aee5798540d7$export$899851af1363628() {
    var r, e;
    return (e = (r = (0, $acw62.useContext)($d994aee5798540d7$var$a)) == null ? void 0 : r.value) != null ? e : void 0;
}
function $d994aee5798540d7$export$babde88292020af7() {
    let [r, e] = (0, $acw62.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(t) {
                let i = (0, $114Mg.useEvent)((n)=>(e((s)=>[
                            ...s,
                            n
                        ]), ()=>e((s)=>{
                            let o = s.slice(), p = o.indexOf(n);
                            return p !== -1 && o.splice(p, 1), o;
                        }))), l = (0, $acw62.useMemo)(()=>({
                        register: i,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    i,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d994aee5798540d7$var$a.Provider, {
                    value: l
                }, t.children);
            }, [
            e
        ])
    ];
}
let $d994aee5798540d7$var$S = "p";
function $d994aee5798540d7$var$C(r, e) {
    let d = (0, $acw62.useId)(), t = (0, $brAF4.useDisabled)(), { id: i = `headlessui-description-${d}`, ...l } = r, n = $d994aee5798540d7$var$f(), s = (0, $6mpbl.useSyncRefs)(e);
    (0, $8KgIp.useIsoMorphicEffect)(()=>n.register(i), [
        i,
        n.register
    ]);
    let o = t || !1, p = (0, $acw62.useMemo)(()=>({
            ...n.slot,
            disabled: o
        }), [
        n.slot,
        o
    ]), D = {
        ref: s,
        ...n.props,
        id: i
    };
    return (0, $ebRQH.useRender)()({
        ourProps: D,
        theirProps: l,
        slot: p,
        defaultTag: $d994aee5798540d7$var$S,
        name: n.name || "Description"
    });
}
let $d994aee5798540d7$var$_ = (0, $ebRQH.forwardRefWithAs)($d994aee5798540d7$var$C), $d994aee5798540d7$export$393edc798c47379d = Object.assign($d994aee5798540d7$var$_, {});

});
parcelRegister("brAF4", function(module, exports) {

$parcel$export(module.exports, "useDisabled", () => $854ea7886afe8ac8$export$c763bb7a184a0f11);

var $acw62 = parcelRequire("acw62");
let $854ea7886afe8ac8$var$e = (0, $acw62.createContext)(void 0);
function $854ea7886afe8ac8$export$c763bb7a184a0f11() {
    return (0, $acw62.useContext)($854ea7886afe8ac8$var$e);
}
function $854ea7886afe8ac8$export$a4d3bd77f4efe5ad({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($854ea7886afe8ac8$var$e.Provider, {
        value: t
    }, o);
}

});


parcelRegister("lLzDP", function(module, exports) {

$parcel$export(module.exports, "DialogPanel", () => $fd89a26ac969b4f3$export$46512663428d955a);
$parcel$export(module.exports, "DialogTitle", () => $fd89a26ac969b4f3$export$16f7638e4a34b909);
$parcel$export(module.exports, "Dialog", () => $fd89a26ac969b4f3$export$3ddf2d174ce01153);

var $acw62 = parcelRequire("acw62");

var $jYrXf = parcelRequire("jYrXf");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $6QXOx = parcelRequire("6QXOx");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $jbIlv = parcelRequire("jbIlv");

var $hZodg = parcelRequire("hZodg");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $5ETDl = parcelRequire("5ETDl");

var $auuNT = parcelRequire("auuNT");

var $aQyzu = parcelRequire("aQyzu");

var $6Ngq1 = parcelRequire("6Ngq1");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $4T0AR = parcelRequire("4T0AR");

var $e9NTc = parcelRequire("e9NTc");

var $iymfR = parcelRequire("iymfR");
"use client";
var $fd89a26ac969b4f3$var$Oe = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($fd89a26ac969b4f3$var$Oe || {}), $fd89a26ac969b4f3$var$he = ((t)=>(t[t.SetTitleId = 0] = "SetTitleId", t))($fd89a26ac969b4f3$var$he || {});
let $fd89a26ac969b4f3$var$Se = {
    [0] (e, t) {
        return e.titleId === t.id ? e : {
            ...e,
            titleId: t.id
        };
    }
}, $fd89a26ac969b4f3$var$k = (0, $acw62.createContext)(null);
$fd89a26ac969b4f3$var$k.displayName = "DialogContext";
function $fd89a26ac969b4f3$var$O(e) {
    let t = (0, $acw62.useContext)($fd89a26ac969b4f3$var$k);
    if (t === null) {
        let o = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $fd89a26ac969b4f3$var$O), o;
    }
    return t;
}
function $fd89a26ac969b4f3$var$Ie(e, t) {
    return (0, $6Ngq1.match)(t.type, $fd89a26ac969b4f3$var$Se, e, t);
}
let $fd89a26ac969b4f3$var$V = (0, $ebRQH.forwardRefWithAs)(function(t, o) {
    let a = (0, $acw62.useId)(), { id: l = `headlessui-dialog-${a}`, open: i, onClose: p, initialFocus: d, role: s = "dialog", autoFocus: f = !0, __demoMode: u = !1, unmount: P = !1, ...h } = t, R = (0, $acw62.useRef)(!1);
    s = function() {
        return s === "dialog" || s === "alertdialog" ? s : (R.current || (R.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
    }();
    let c = (0, $auuNT.useOpenClosed)();
    i === void 0 && c !== null && (i = (c & (0, $auuNT.State).Open) === (0, $auuNT.State).Open);
    let T = (0, $acw62.useRef)(null), S = (0, $6mpbl.useSyncRefs)(T, o), F = (0, $5IEAk.useOwnerDocument)(T), g = i ? 0 : 1, [b, q] = (0, $acw62.useReducer)($fd89a26ac969b4f3$var$Ie, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $acw62.createRef)()
    }), m = (0, $114Mg.useEvent)(()=>p(!1)), w = (0, $114Mg.useEvent)((r)=>q({
            type: 0,
            id: r
        })), D = (0, $b8md9.useServerHandoffComplete)() ? g === 0 : !1, [z, Q] = (0, $e9NTc.useNestedPortals)(), Z = {
        get current () {
            var r;
            return (r = b.panelRef.current) != null ? r : T.current;
        }
    }, v = (0, $jbIlv.useMainTreeNode)(), { resolveContainers: I } = (0, $jbIlv.useRootContainers)({
        mainTreeNode: v,
        portals: z,
        defaultContainers: [
            Z
        ]
    }), B = c !== null ? (c & (0, $auuNT.State).Closing) === (0, $auuNT.State).Closing : !1;
    (0, $keKjn.useInertOthers)(u || B ? !1 : D, {
        allowed: (0, $114Mg.useEvent)(()=>{
            var r, H;
            return [
                (H = (r = T.current) == null ? void 0 : r.closest("[data-headlessui-portal]")) != null ? H : null
            ];
        }),
        disallowed: (0, $114Mg.useEvent)(()=>{
            var r;
            return [
                (r = v == null ? void 0 : v.closest("body > *:not(#headlessui-portal-root)")) != null ? r : null
            ];
        })
    }), (0, $23pTr.useOutsideClick)(D, I, (r)=>{
        r.preventDefault(), m();
    }), (0, $jYrXf.useEscape)(D, F == null ? void 0 : F.defaultView, (r)=>{
        r.preventDefault(), r.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), m();
    }), (0, $hZodg.useScrollLock)(u || B ? !1 : D, F, I), (0, $dcp2r.useOnDisappear)(D, T, m);
    let [ee, te] = (0, $iGb09.useDescriptions)(), oe = (0, $acw62.useMemo)(()=>[
            {
                dialogState: g,
                close: m,
                setTitleId: w,
                unmount: P
            },
            b
        ], [
        g,
        b,
        m,
        w,
        P
    ]), U = (0, $acw62.useMemo)(()=>({
            open: g === 0
        }), [
        g
    ]), ne = {
        ref: S,
        id: l,
        role: s,
        tabIndex: -1,
        "aria-modal": u ? void 0 : g === 0 ? !0 : void 0,
        "aria-labelledby": b.titleId,
        "aria-describedby": ee,
        unmount: P
    }, re = !(0, $6QXOx.useIsTouchDevice)(), y = (0, $4T0AR.FocusTrapFeatures).None;
    D && !u && (y |= (0, $4T0AR.FocusTrapFeatures).RestoreFocus, y |= (0, $4T0AR.FocusTrapFeatures).TabLock, f && (y |= (0, $4T0AR.FocusTrapFeatures).AutoFocus), re && (y |= (0, $4T0AR.FocusTrapFeatures).InitialFocus));
    let le = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.ResetOpenClosedProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQyzu.ForcePortalRoot), {
        force: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$k.Provider, {
        value: oe
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.PortalGroup), {
        target: T
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aQyzu.ForcePortalRoot), {
        force: !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(te, {
        slot: U
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Q, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4T0AR.FocusTrap), {
        initialFocus: d,
        initialFocusFallback: T,
        containers: I,
        features: y
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5ETDl.CloseProvider), {
        value: m
    }, le({
        ourProps: ne,
        theirProps: h,
        slot: U,
        defaultTag: $fd89a26ac969b4f3$var$Me,
        features: $fd89a26ac969b4f3$var$Ge,
        visible: g === 0,
        name: "Dialog"
    })))))))))));
}), $fd89a26ac969b4f3$var$Me = "div", $fd89a26ac969b4f3$var$Ge = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $fd89a26ac969b4f3$var$ke(e, t) {
    let { transition: o = !1, open: a, ...l } = e, i = (0, $auuNT.useOpenClosed)(), p = e.hasOwnProperty("open") || i !== null, d = e.hasOwnProperty("onClose");
    if (!p && !d) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!p) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!d) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (!i && typeof e.open != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
    if (typeof e.onClose != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
    return (a !== void 0 || o) && !l.static ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iymfR.Transition), {
        show: a,
        transition: o,
        unmount: l.unmount
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$V, {
        ref: t,
        ...l
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jbIlv.MainTreeProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fd89a26ac969b4f3$var$V, {
        ref: t,
        open: a,
        ...l
    }));
}
let $fd89a26ac969b4f3$var$we = "div";
function $fd89a26ac969b4f3$var$Be(e, t) {
    let o = (0, $acw62.useId)(), { id: a = `headlessui-dialog-panel-${o}`, transition: l = !1, ...i } = e, [{ dialogState: p, unmount: d }, s] = $fd89a26ac969b4f3$var$O("Dialog.Panel"), f = (0, $6mpbl.useSyncRefs)(t, s.panelRef), u = (0, $acw62.useMemo)(()=>({
            open: p === 0
        }), [
        p
    ]), P = (0, $114Mg.useEvent)((S)=>{
        S.stopPropagation();
    }), h = {
        ref: f,
        id: a,
        onClick: P
    }, R = l ? (0, $iymfR.TransitionChild) : (0, $acw62.Fragment), c = l ? {
        unmount: d
    } : {}, T = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(R, {
        ...c
    }, T({
        ourProps: h,
        theirProps: i,
        slot: u,
        defaultTag: $fd89a26ac969b4f3$var$we,
        name: "Dialog.Panel"
    }));
}
let $fd89a26ac969b4f3$var$Ue = "div";
function $fd89a26ac969b4f3$var$He(e, t) {
    let { transition: o = !1, ...a } = e, [{ dialogState: l, unmount: i }] = $fd89a26ac969b4f3$var$O("Dialog.Backdrop"), p = (0, $acw62.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), d = {
        ref: t,
        "aria-hidden": !0
    }, s = o ? (0, $iymfR.TransitionChild) : (0, $acw62.Fragment), f = o ? {
        unmount: i
    } : {}, u = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(s, {
        ...f
    }, u({
        ourProps: d,
        theirProps: a,
        slot: p,
        defaultTag: $fd89a26ac969b4f3$var$Ue,
        name: "Dialog.Backdrop"
    }));
}
let $fd89a26ac969b4f3$var$Ne = "h2";
function $fd89a26ac969b4f3$var$We(e, t) {
    let o = (0, $acw62.useId)(), { id: a = `headlessui-dialog-title-${o}`, ...l } = e, [{ dialogState: i, setTitleId: p }] = $fd89a26ac969b4f3$var$O("Dialog.Title"), d = (0, $6mpbl.useSyncRefs)(t);
    (0, $acw62.useEffect)(()=>(p(a), ()=>p(null)), [
        a,
        p
    ]);
    let s = (0, $acw62.useMemo)(()=>({
            open: i === 0
        }), [
        i
    ]), f = {
        ref: d,
        id: a
    };
    return (0, $ebRQH.useRender)()({
        ourProps: f,
        theirProps: l,
        slot: s,
        defaultTag: $fd89a26ac969b4f3$var$Ne,
        name: "Dialog.Title"
    });
}
let $fd89a26ac969b4f3$var$$e = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$ke), $fd89a26ac969b4f3$export$46512663428d955a = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$Be), $fd89a26ac969b4f3$export$91fffd879a9415f4 = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$He), $fd89a26ac969b4f3$export$16f7638e4a34b909 = (0, $ebRQH.forwardRefWithAs)($fd89a26ac969b4f3$var$We), $fd89a26ac969b4f3$export$94e94c2ec2c954d5 = (0, $iGb09.Description), $fd89a26ac969b4f3$export$3ddf2d174ce01153 = Object.assign($fd89a26ac969b4f3$var$$e, {
    Panel: $fd89a26ac969b4f3$export$46512663428d955a,
    Title: $fd89a26ac969b4f3$export$16f7638e4a34b909,
    Description: (0, $iGb09.Description)
});

});
parcelRegister("jYrXf", function(module, exports) {

$parcel$export(module.exports, "useEscape", () => $e8a94e1c7fcf4260$export$3875fddb67014c13);

var $6AKlm = parcelRequire("6AKlm");

var $lwoRo = parcelRequire("lwoRo");

var $g6SeH = parcelRequire("g6SeH");
function $e8a94e1c7fcf4260$export$3875fddb67014c13(o, r = typeof document != "undefined" ? document.defaultView : null, t) {
    let n = (0, $g6SeH.useIsTopLayer)(o, "escape");
    (0, $lwoRo.useEventListener)(r, "keydown", (e)=>{
        n && (e.defaultPrevented || e.key === (0, $6AKlm.Keys).Escape && t(e));
    });
}

});
parcelRegister("6AKlm", function(module, exports) {

$parcel$export(module.exports, "Keys", () => $4cca0dbc68b0507a$export$4b0075e5ea5e1f26);
var $4cca0dbc68b0507a$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($4cca0dbc68b0507a$export$4b0075e5ea5e1f26 || {});

});

parcelRegister("lwoRo", function(module, exports) {

$parcel$export(module.exports, "useEventListener", () => $faafded37f338b1b$export$7080b3e976bc91ab);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $faafded37f338b1b$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $ltgxC.useLatestValue)(a);
    (0, $acw62.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}

});

parcelRegister("g6SeH", function(module, exports) {

$parcel$export(module.exports, "useIsTopLayer", () => $bba7470f70c82a20$export$5f5dd115998e0b80);

var $acw62 = parcelRequire("acw62");

var $8SQCc = parcelRequire("8SQCc");

var $7AV3X = parcelRequire("7AV3X");

var $8KgIp = parcelRequire("8KgIp");

var $gCqoX = parcelRequire("gCqoX");
let $bba7470f70c82a20$var$p = new (0, $8SQCc.DefaultMap)(()=>(0, $7AV3X.createStore)(()=>[], {
        ADD (r) {
            return this.includes(r) ? this : [
                ...this,
                r
            ];
        },
        REMOVE (r) {
            let e = this.indexOf(r);
            if (e === -1) return this;
            let t = this.slice();
            return t.splice(e, 1), t;
        }
    }));
function $bba7470f70c82a20$export$5f5dd115998e0b80(r, e) {
    let t = $bba7470f70c82a20$var$p.get(e), i = (0, $acw62.useId)(), h = (0, $gCqoX.useStore)(t);
    if ((0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (r) return t.dispatch("ADD", i), ()=>t.dispatch("REMOVE", i);
    }, [
        t,
        r
    ]), !r) return !1;
    let s = h.indexOf(i), o = h.length;
    return s === -1 && (s = o, o += 1), s === o - 1;
}

});
parcelRegister("8SQCc", function(module, exports) {

$parcel$export(module.exports, "DefaultMap", () => $677c2e1e5f56d429$export$674cd7dcb504ac5c);
class $677c2e1e5f56d429$export$674cd7dcb504ac5c extends Map {
    constructor(t){
        super();
        this.factory = t;
    }
    get(t) {
        let e = super.get(t);
        return e === void 0 && (e = this.factory(t), this.set(t, e)), e;
    }
}

});

parcelRegister("7AV3X", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $587828ac89f0168d$export$f51a9068ac82ea43);
function $587828ac89f0168d$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}

});

parcelRegister("gCqoX", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $c194acc02d991b55$export$6ccbb43953eebf8);

var $acw62 = parcelRequire("acw62");
function $c194acc02d991b55$export$6ccbb43953eebf8(t) {
    return (0, $acw62.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}

});



parcelRegister("keKjn", function(module, exports) {

$parcel$export(module.exports, "useInertOthers", () => $ebb909f7f690e57e$export$af489fa7e5283cc3);

var $1COYr = parcelRequire("1COYr");

var $gxwGc = parcelRequire("gxwGc");

var $g6SeH = parcelRequire("g6SeH");

var $8KgIp = parcelRequire("8KgIp");
let $ebb909f7f690e57e$var$f = new Map, $ebb909f7f690e57e$var$u = new Map;
function $ebb909f7f690e57e$var$h(t) {
    var e;
    let r = (e = $ebb909f7f690e57e$var$u.get(t)) != null ? e : 0;
    return $ebb909f7f690e57e$var$u.set(t, r + 1), r !== 0 ? ()=>$ebb909f7f690e57e$var$m(t) : ($ebb909f7f690e57e$var$f.set(t, {
        "aria-hidden": t.getAttribute("aria-hidden"),
        inert: t.inert
    }), t.setAttribute("aria-hidden", "true"), t.inert = !0, ()=>$ebb909f7f690e57e$var$m(t));
}
function $ebb909f7f690e57e$var$m(t) {
    var i;
    let r = (i = $ebb909f7f690e57e$var$u.get(t)) != null ? i : 1;
    if (r === 1 ? $ebb909f7f690e57e$var$u.delete(t) : $ebb909f7f690e57e$var$u.set(t, r - 1), r !== 1) return;
    let e = $ebb909f7f690e57e$var$f.get(t);
    e && (e["aria-hidden"] === null ? t.removeAttribute("aria-hidden") : t.setAttribute("aria-hidden", e["aria-hidden"]), t.inert = e.inert, $ebb909f7f690e57e$var$f.delete(t));
}
function $ebb909f7f690e57e$export$af489fa7e5283cc3(t, { allowed: r, disallowed: e } = {}) {
    let i = (0, $g6SeH.useIsTopLayer)(t, "inert-others");
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var d, c;
        if (!i) return;
        let a = (0, $1COYr.disposables)();
        for (let n of (d = e == null ? void 0 : e()) != null ? d : [])n && a.add($ebb909f7f690e57e$var$h(n));
        let s = (c = r == null ? void 0 : r()) != null ? c : [];
        for (let n of s){
            if (!n) continue;
            let l = (0, $gxwGc.getOwnerDocument)(n);
            if (!l) continue;
            let o = n.parentElement;
            for(; o && o !== l.body;){
                for (let p of o.children)s.some((E)=>p.contains(E)) || a.add($ebb909f7f690e57e$var$h(p));
                o = o.parentElement;
            }
        }
        return a.dispose;
    }, [
        i,
        r,
        e
    ]);
}

});
parcelRegister("gxwGc", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $c0a913ecfa4bf5e5$export$b204af158042fbac);

var $Iy8e1 = parcelRequire("Iy8e1");
function $c0a913ecfa4bf5e5$export$b204af158042fbac(r) {
    return (0, $Iy8e1.env).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

});


parcelRegister("6QXOx", function(module, exports) {

$parcel$export(module.exports, "useIsTouchDevice", () => $4fd5ff3f074a68f3$export$2706b359107dd58d);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $4fd5ff3f074a68f3$export$2706b359107dd58d() {
    var t;
    let [e] = (0, $acw62.useState)(()=>typeof window != "undefined" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [o, c] = (0, $acw62.useState)((t = e == null ? void 0 : e.matches) != null ? t : !1);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        function n(r) {
            c(r.matches);
        }
        return e.addEventListener("change", n), ()=>e.removeEventListener("change", n);
    }, [
        e
    ]), o;
}

});

parcelRegister("dcp2r", function(module, exports) {

$parcel$export(module.exports, "useOnDisappear", () => $99bfd16f3cd33a1b$export$b41b9097915aa006);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");

var $ltgxC = parcelRequire("ltgxC");
function $99bfd16f3cd33a1b$export$b41b9097915aa006(s, n, l) {
    let i = (0, $ltgxC.useLatestValue)((t)=>{
        let e = t.getBoundingClientRect();
        e.x === 0 && e.y === 0 && e.width === 0 && e.height === 0 && l();
    });
    (0, $acw62.useEffect)(()=>{
        if (!s) return;
        let t = n === null ? null : n instanceof HTMLElement ? n : n.current;
        if (!t) return;
        let e = (0, $1COYr.disposables)();
        if (typeof ResizeObserver != "undefined") {
            let r = new ResizeObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        if (typeof IntersectionObserver != "undefined") {
            let r = new IntersectionObserver(()=>i.current(t));
            r.observe(t), e.add(()=>r.disconnect());
        }
        return ()=>e.dispose();
    }, [
        n,
        i,
        s
    ]);
}

});

parcelRegister("23pTr", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", () => $17eff26b89e4b024$export$71b2224f1ce5e08e);

var $acw62 = parcelRequire("acw62");

var $hsQxB = parcelRequire("hsQxB");

var $8UjaS = parcelRequire("8UjaS");

var $fA3F6 = parcelRequire("fA3F6");

var $g6SeH = parcelRequire("g6SeH");

var $ltgxC = parcelRequire("ltgxC");

var $5vI4D = parcelRequire("5vI4D");
const $17eff26b89e4b024$var$E = 30;
function $17eff26b89e4b024$export$71b2224f1ce5e08e(p, f, C) {
    let u = (0, $g6SeH.useIsTopLayer)(p, "outside-click"), m = (0, $ltgxC.useLatestValue)(C), s = (0, $acw62.useCallback)(function(e, n) {
        if (e.defaultPrevented) return;
        let r = n(e);
        if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
        let h = function l(o) {
            return typeof o == "function" ? l(o()) : Array.isArray(o) || o instanceof Set ? o : [
                o
            ];
        }(f);
        for (let l of h)if (l !== null && (l.contains(r) || e.composed && e.composedPath().includes(l))) return;
        return !(0, $hsQxB.isFocusableElement)(r, (0, $hsQxB.FocusableMode).Loose) && r.tabIndex !== -1 && e.preventDefault(), m.current(e, r);
    }, [
        m,
        f
    ]), i = (0, $acw62.useRef)(null);
    (0, $fA3F6.useDocumentEvent)(u, "pointerdown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "mousedown", (t)=>{
        var e, n;
        i.current = ((n = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : n[0]) || t.target;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "click", (t)=>{
        (0, $8UjaS.isMobile)() || i.current && (s(t, ()=>i.current), i.current = null);
    }, !0);
    let a = (0, $acw62.useRef)({
        x: 0,
        y: 0
    });
    (0, $fA3F6.useDocumentEvent)(u, "touchstart", (t)=>{
        a.current.x = t.touches[0].clientX, a.current.y = t.touches[0].clientY;
    }, !0), (0, $fA3F6.useDocumentEvent)(u, "touchend", (t)=>{
        let e = {
            x: t.changedTouches[0].clientX,
            y: t.changedTouches[0].clientY
        };
        if (!(Math.abs(e.x - a.current.x) >= $17eff26b89e4b024$var$E || Math.abs(e.y - a.current.y) >= $17eff26b89e4b024$var$E)) return s(t, ()=>t.target instanceof HTMLElement ? t.target : null);
    }, !0), (0, $5vI4D.useWindowEvent)(u, "blur", (t)=>s(t, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

});
parcelRegister("hsQxB", function(module, exports) {

$parcel$export(module.exports, "focusableSelector", () => $cb6dceb64e6c0606$export$acea64b1933eb668);
$parcel$export(module.exports, "Focus", () => $cb6dceb64e6c0606$export$807a7eae502106e7);
$parcel$export(module.exports, "FocusResult", () => $cb6dceb64e6c0606$export$abf286375dfa6dbd);
$parcel$export(module.exports, "FocusableMode", () => $cb6dceb64e6c0606$export$27112a34f2f8402d);
$parcel$export(module.exports, "isFocusableElement", () => $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5);
$parcel$export(module.exports, "restoreFocusIfNecessary", () => $cb6dceb64e6c0606$export$46388676ec35ab85);
$parcel$export(module.exports, "focusElement", () => $cb6dceb64e6c0606$export$5fed9cc43865dc7e);
$parcel$export(module.exports, "sortByDomNode", () => $cb6dceb64e6c0606$export$20305e96f91bf103);
$parcel$export(module.exports, "focusFrom", () => $cb6dceb64e6c0606$export$7fb6c844b485e870);
$parcel$export(module.exports, "focusIn", () => $cb6dceb64e6c0606$export$82e1f4f412218a1d);

var $1COYr = parcelRequire("1COYr");

var $6Ngq1 = parcelRequire("6Ngq1");

var $gxwGc = parcelRequire("gxwGc");
let $cb6dceb64e6c0606$export$acea64b1933eb668 = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(","), $cb6dceb64e6c0606$var$p = [
    "[data-autofocus]"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $cb6dceb64e6c0606$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n[n.AutoFocus = 64] = "AutoFocus", n))($cb6dceb64e6c0606$export$807a7eae502106e7 || {}), $cb6dceb64e6c0606$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($cb6dceb64e6c0606$export$abf286375dfa6dbd || {}), $cb6dceb64e6c0606$var$y = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($cb6dceb64e6c0606$var$y || {});
function $cb6dceb64e6c0606$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$export$acea64b1933eb668)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function $cb6dceb64e6c0606$export$89622d0e8d475962(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$var$p)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $cb6dceb64e6c0606$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($cb6dceb64e6c0606$export$27112a34f2f8402d || {});
function $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $gxwGc.getOwnerDocument)(e)) == null ? void 0 : t.body) ? !1 : (0, $6Ngq1.match)(r, {
        [0] () {
            return e.matches($cb6dceb64e6c0606$export$acea64b1933eb668);
        },
        [1] () {
            let u = e;
            for(; u !== null;){
                if (u.matches($cb6dceb64e6c0606$export$acea64b1933eb668)) return !0;
                u = u.parentElement;
            }
            return !1;
        }
    });
}
function $cb6dceb64e6c0606$export$46388676ec35ab85(e) {
    let r = (0, $gxwGc.getOwnerDocument)(e);
    (0, $1COYr.disposables)().nextFrame(()=>{
        r && !$cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e);
    });
}
var $cb6dceb64e6c0606$var$H = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($cb6dceb64e6c0606$var$H || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $cb6dceb64e6c0606$var$w = [
    "textarea",
    "input"
].join(",");
function $cb6dceb64e6c0606$var$O(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $cb6dceb64e6c0606$var$w)) != null ? t : !1;
}
function $cb6dceb64e6c0606$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, u)=>{
        let o = r(t), c = r(u);
        if (o === null || c === null) return 0;
        let l = o.compareDocumentPosition(c);
        return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $cb6dceb64e6c0606$export$7fb6c844b485e870(e, r) {
    return $cb6dceb64e6c0606$export$82e1f4f412218a1d($cb6dceb64e6c0606$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $cb6dceb64e6c0606$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: u = null, skipElements: o = [] } = {}) {
    let c = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, l = Array.isArray(e) ? t ? $cb6dceb64e6c0606$export$20305e96f91bf103(e) : e : r & 64 ? $cb6dceb64e6c0606$export$89622d0e8d475962(e) : $cb6dceb64e6c0606$export$433aaa1f216cf32d(e);
    o.length > 0 && l.length > 1 && (l = l.filter((s)=>!o.some((a)=>a != null && "current" in a ? (a == null ? void 0 : a.current) === s : a === s))), u = u != null ? u : c.activeElement;
    let n = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, l.indexOf(u)) - 1;
        if (r & 4) return Math.max(0, l.indexOf(u)) + 1;
        if (r & 8) return l.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), M = r & 32 ? {
        preventScroll: !0
    } : {}, m = 0, d = l.length, i;
    do {
        if (m >= d || m + d <= 0) return 0;
        let s = x + m;
        if (r & 16) s = (s + d) % d;
        else {
            if (s < 0) return 3;
            if (s >= d) return 1;
        }
        i = l[s], i == null || i.focus(M), m += n;
    }while (i !== c.activeElement);
    return r & 6 && $cb6dceb64e6c0606$var$O(i) && i.select(), 2;
}

});

parcelRegister("8UjaS", function(module, exports) {

$parcel$export(module.exports, "isIOS", () => $67c26d51fee0b51a$export$fedb369cb70207f1);
$parcel$export(module.exports, "isMobile", () => $67c26d51fee0b51a$export$d0a8044dce8ff2fc);
function $67c26d51fee0b51a$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $67c26d51fee0b51a$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $67c26d51fee0b51a$export$d0a8044dce8ff2fc() {
    return $67c26d51fee0b51a$export$fedb369cb70207f1() || $67c26d51fee0b51a$export$a11b0059900ceec8();
}

});

parcelRegister("fA3F6", function(module, exports) {

$parcel$export(module.exports, "useDocumentEvent", () => $b57d0f015e93db3a$export$55d2b5df396a097b);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $b57d0f015e93db3a$export$55d2b5df396a097b(t, e, o, n) {
    let u = (0, $ltgxC.useLatestValue)(o);
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        function r(m) {
            u.current(m);
        }
        return document.addEventListener(e, r, n), ()=>document.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}

});

parcelRegister("5vI4D", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", () => $40320926a37dc1cc$export$ee579bb285b8d4aa);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $40320926a37dc1cc$export$ee579bb285b8d4aa(t, e, o, n) {
    let i = (0, $ltgxC.useLatestValue)(o);
    (0, $acw62.useEffect)(()=>{
        if (!t) return;
        function r(d) {
            i.current(d);
        }
        return window.addEventListener(e, r, n), ()=>window.removeEventListener(e, r, n);
    }, [
        t,
        e,
        n
    ]);
}

});


parcelRegister("5IEAk", function(module, exports) {

$parcel$export(module.exports, "useOwnerDocument", () => $42a08b28a285ca8e$export$dd9fbcea3de0ae36);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");
function $42a08b28a285ca8e$export$dd9fbcea3de0ae36(...e) {
    return (0, $acw62.useMemo)(()=>(0, $gxwGc.getOwnerDocument)(...e), [
        ...e
    ]);
}

});

parcelRegister("jbIlv", function(module, exports) {

$parcel$export(module.exports, "useRootContainers", () => $df81719180936f93$export$445f2d1a3d9b1b9f);
$parcel$export(module.exports, "MainTreeProvider", () => $df81719180936f93$export$61c2c570df73dc80);
$parcel$export(module.exports, "useMainTreeNode", () => $df81719180936f93$export$64db24433d7f4942);

var $acw62 = parcelRequire("acw62");

var $k9Al5 = parcelRequire("k9Al5");

var $gxwGc = parcelRequire("gxwGc");

var $114Mg = parcelRequire("114Mg");

var $5IEAk = parcelRequire("5IEAk");
function $df81719180936f93$export$445f2d1a3d9b1b9f({ defaultContainers: l = [], portals: n, mainTreeNode: o } = {}) {
    let r = (0, $5IEAk.useOwnerDocument)(o), u = (0, $114Mg.useEvent)(()=>{
        var i, c;
        let t = [];
        for (let e of l)e !== null && (e instanceof HTMLElement ? t.push(e) : "current" in e && e.current instanceof HTMLElement && t.push(e.current));
        if (n != null && n.current) for (let e of n.current)t.push(e);
        for (let e of (i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : [])e !== document.body && e !== document.head && e instanceof HTMLElement && e.id !== "headlessui-portal-root" && (o && (e.contains(o) || e.contains((c = o == null ? void 0 : o.getRootNode()) == null ? void 0 : c.host)) || t.some((m)=>e.contains(m)) || t.push(e));
        return t;
    });
    return {
        resolveContainers: u,
        contains: (0, $114Mg.useEvent)((t)=>u().some((i)=>i.contains(t)))
    };
}
let $df81719180936f93$var$a = (0, $acw62.createContext)(null);
function $df81719180936f93$export$61c2c570df73dc80({ children: l, node: n }) {
    let [o, r] = (0, $acw62.useState)(null), u = $df81719180936f93$export$64db24433d7f4942(n != null ? n : o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($df81719180936f93$var$a.Provider, {
        value: u
    }, l, u === null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        ref: (t)=>{
            var i, c;
            if (t) {
                for (let e of (c = (i = (0, $gxwGc.getOwnerDocument)(t)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? c : [])if (e !== document.body && e !== document.head && e instanceof HTMLElement && e != null && e.contains(t)) {
                    r(e);
                    break;
                }
            }
        }
    }));
}
function $df81719180936f93$export$64db24433d7f4942(l = null) {
    var n;
    return (n = (0, $acw62.useContext)($df81719180936f93$var$a)) != null ? n : l;
}

});
parcelRegister("k9Al5", function(module, exports) {

$parcel$export(module.exports, "HiddenFeatures", () => $eac0d614a77ee96b$export$4e7f8864c6a16d8a);
$parcel$export(module.exports, "Hidden", () => $eac0d614a77ee96b$export$8dc98ba7eadeaa56);

var $ebRQH = parcelRequire("ebRQH");
let $eac0d614a77ee96b$var$a = "span";
var $eac0d614a77ee96b$export$4e7f8864c6a16d8a = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($eac0d614a77ee96b$export$4e7f8864c6a16d8a || {});
function $eac0d614a77ee96b$var$l(t, r) {
    var n;
    let { features: d = 1, ...e } = t, o = {
        ref: r,
        "aria-hidden": (d & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        hidden: (d & 4) === 4 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(d & 4) === 4 && (d & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $ebRQH.useRender)()({
        ourProps: o,
        theirProps: e,
        slot: {},
        defaultTag: $eac0d614a77ee96b$var$a,
        name: "Hidden"
    });
}
let $eac0d614a77ee96b$export$8dc98ba7eadeaa56 = (0, $ebRQH.forwardRefWithAs)($eac0d614a77ee96b$var$l);

});


parcelRegister("hZodg", function(module, exports) {

$parcel$export(module.exports, "useScrollLock", () => $d18aea5eab300f7b$export$e47ba1b900da5d3b);

var $cfajG = parcelRequire("cfajG");

var $g6SeH = parcelRequire("g6SeH");
function $d18aea5eab300f7b$export$e47ba1b900da5d3b(e, c, n = ()=>[
        document.body
    ]) {
    let r = (0, $g6SeH.useIsTopLayer)(e, "scroll-lock");
    (0, $cfajG.useDocumentOverflowLockedEffect)(r, c, (t)=>{
        var o;
        return {
            containers: [
                ...(o = t.containers) != null ? o : [],
                n
            ]
        };
    });
}

});
parcelRegister("cfajG", function(module, exports) {

$parcel$export(module.exports, "useDocumentOverflowLockedEffect", () => $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0);

var $gCqoX = parcelRequire("gCqoX");

var $8KgIp = parcelRequire("8KgIp");

var $270j5 = parcelRequire("270j5");
function $8e9ee35f9b752cd8$export$bb0ae4a42bcd9e0(r, e, n = ()=>({
        containers: []
    })) {
    let f = (0, $gCqoX.useStore)((0, $270j5.overflows)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!(!e || !r)) return (0, $270j5.overflows).dispatch("PUSH", e, n), ()=>(0, $270j5.overflows).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}

});
parcelRegister("270j5", function(module, exports) {

$parcel$export(module.exports, "overflows", () => $189c7921f80dd74a$export$a4161f418919b5aa);

var $1COYr = parcelRequire("1COYr");

var $7AV3X = parcelRequire("7AV3X");

var $g695P = parcelRequire("g695P");

var $g4l2L = parcelRequire("g4l2L");

var $imLcn = parcelRequire("imLcn");
function $189c7921f80dd74a$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $189c7921f80dd74a$export$a4161f418919b5aa = (0, $7AV3X.createStore)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $1COYr.disposables)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $189c7921f80dd74a$var$m(t)
        }, c = [
            (0, $g4l2L.handleIOSLocking)(),
            (0, $g695P.adjustScrollbarPadding)(),
            (0, $imLcn.preventScroll)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$189c7921f80dd74a$export$a4161f418919b5aa.subscribe(()=>{
    let e = $189c7921f80dd74a$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $189c7921f80dd74a$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});

});
parcelRegister("g695P", function(module, exports) {

$parcel$export(module.exports, "adjustScrollbarPadding", () => $bb844292a519e22f$export$110627fb35ef9205);
function $bb844292a519e22f$export$110627fb35ef9205() {
    let r;
    return {
        before ({ doc: e }) {
            var l;
            let o = e.documentElement, t = (l = e.defaultView) != null ? l : window;
            r = Math.max(0, t.innerWidth - o.clientWidth);
        },
        after ({ doc: e, d: o }) {
            let t = e.documentElement, l = Math.max(0, t.clientWidth - t.offsetWidth), n = Math.max(0, r - l);
            o.style(t, "paddingRight", `${n}px`);
        }
    };
}

});

parcelRegister("g4l2L", function(module, exports) {

$parcel$export(module.exports, "handleIOSLocking", () => $bb2d57db10996691$export$e3a523dfabf27286);

var $1COYr = parcelRequire("1COYr");

var $8UjaS = parcelRequire("8UjaS");
function $bb2d57db10996691$export$e3a523dfabf27286() {
    return (0, $8UjaS.isIOS)() ? {
        before ({ doc: r, d: n, meta: c }) {
            function o(a) {
                return c.containers.flatMap((l)=>l()).some((l)=>l.contains(a));
            }
            n.microTask(()=>{
                var s;
                if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
                    let t = (0, $1COYr.disposables)();
                    t.style(r.documentElement, "scrollBehavior", "auto"), n.add(()=>n.microTask(()=>t.dispose()));
                }
                let a = (s = window.scrollY) != null ? s : window.pageYOffset, l = null;
                n.addEventListener(r, "click", (t)=>{
                    if (t.target instanceof HTMLElement) try {
                        let e = t.target.closest("a");
                        if (!e) return;
                        let { hash: f } = new URL(e.href), i = r.querySelector(f);
                        i && !o(i) && (l = i);
                    } catch  {}
                }, !0), n.addEventListener(r, "touchstart", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && o(e.parentElement);)e = e.parentElement;
                            n.style(e, "overscrollBehavior", "contain");
                        } else n.style(t.target, "touchAction", "none");
                    }
                }), n.addEventListener(r, "touchmove", (t)=>{
                    if (t.target instanceof HTMLElement) {
                        if (t.target.tagName === "INPUT") return;
                        if (o(t.target)) {
                            let e = t.target;
                            for(; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);)e = e.parentElement;
                            e.dataset.headlessuiPortal === "" && t.preventDefault();
                        } else t.preventDefault();
                    }
                }, {
                    passive: !1
                }), n.add(()=>{
                    var e;
                    let t = (e = window.scrollY) != null ? e : window.pageYOffset;
                    a !== t && window.scrollTo(0, a), l && l.isConnected && (l.scrollIntoView({
                        block: "nearest"
                    }), l = null);
                });
            });
        }
    } : {};
}

});

parcelRegister("imLcn", function(module, exports) {

$parcel$export(module.exports, "preventScroll", () => $d5eee4b72f55118b$export$d8b6ff28805e84e9);
function $d5eee4b72f55118b$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

});




parcelRegister("5ETDl", function(module, exports) {

$parcel$export(module.exports, "CloseProvider", () => $41ebd7de5602bb69$export$dd2a80b78bebbe1d);

var $acw62 = parcelRequire("acw62");
"use client";
let $41ebd7de5602bb69$var$e = (0, $acw62.createContext)(()=>{});
function $41ebd7de5602bb69$export$4e99330e6f37bca2() {
    return (0, $acw62.useContext)($41ebd7de5602bb69$var$e);
}
function $41ebd7de5602bb69$export$dd2a80b78bebbe1d({ value: t, children: o }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41ebd7de5602bb69$var$e.Provider, {
        value: t
    }, o);
}

});

parcelRegister("aQyzu", function(module, exports) {

$parcel$export(module.exports, "usePortalRoot", () => $7e5993dca17d6628$export$6ecd3efa4eebe261);
$parcel$export(module.exports, "ForcePortalRoot", () => $7e5993dca17d6628$export$8f2af6644e3a3c93);

var $acw62 = parcelRequire("acw62");
let $7e5993dca17d6628$var$e = (0, $acw62.createContext)(!1);
function $7e5993dca17d6628$export$6ecd3efa4eebe261() {
    return (0, $acw62.useContext)($7e5993dca17d6628$var$e);
}
function $7e5993dca17d6628$export$8f2af6644e3a3c93(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7e5993dca17d6628$var$e.Provider, {
        value: o.force
    }, o.children);
}

});

parcelRegister("4T0AR", function(module, exports) {

$parcel$export(module.exports, "FocusTrapFeatures", () => $38ecc25572962dee$export$a5e9a012c73650bd);
$parcel$export(module.exports, "FocusTrap", () => $38ecc25572962dee$export$34eba2437817a67b);

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $lwoRo = parcelRequire("lwoRo");

var $brBI7 = parcelRequire("brBI7");

var $g6SeH = parcelRequire("g6SeH");

var $3XIoH = parcelRequire("3XIoH");

var $5IEAk = parcelRequire("5IEAk");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $3nJyP = parcelRequire("3nJyP");

var $lEQT2 = parcelRequire("lEQT2");

var $k9Al5 = parcelRequire("k9Al5");

var $2C9FE = parcelRequire("2C9FE");

var $hsQxB = parcelRequire("hsQxB");

var $6Ngq1 = parcelRequire("6Ngq1");

var $eJKgu = parcelRequire("eJKgu");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $38ecc25572962dee$var$U(o) {
    if (!o) return new Set;
    if (typeof o == "function") return new Set(o());
    let e = new Set;
    for (let t of o.current)t.current instanceof HTMLElement && e.add(t.current);
    return e;
}
let $38ecc25572962dee$var$Z = "div";
var $38ecc25572962dee$export$a5e9a012c73650bd = ((n)=>(n[n.None = 0] = "None", n[n.InitialFocus = 1] = "InitialFocus", n[n.TabLock = 2] = "TabLock", n[n.FocusLock = 4] = "FocusLock", n[n.RestoreFocus = 8] = "RestoreFocus", n[n.AutoFocus = 16] = "AutoFocus", n))($38ecc25572962dee$export$a5e9a012c73650bd || {});
function $38ecc25572962dee$var$$(o, e) {
    let t = (0, $acw62.useRef)(null), r = (0, $6mpbl.useSyncRefs)(t, e), { initialFocus: s, initialFocusFallback: a, containers: n, features: u = 15, ...f } = o;
    (0, $b8md9.useServerHandoffComplete)() || (u = 0);
    let l = (0, $5IEAk.useOwnerDocument)(t);
    $38ecc25572962dee$var$ee(u, {
        ownerDocument: l
    });
    let i = $38ecc25572962dee$var$te(u, {
        ownerDocument: l,
        container: t,
        initialFocus: s,
        initialFocusFallback: a
    });
    $38ecc25572962dee$var$re(u, {
        ownerDocument: l,
        container: t,
        containers: n,
        previousActiveElement: i
    });
    let R = (0, $3nJyP.useTabDirection)(), g = (0, $114Mg.useEvent)((c)=>{
        let m = t.current;
        if (!m) return;
        ((G)=>G())(()=>{
            (0, $6Ngq1.match)(R.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>{
                    (0, $hsQxB.focusIn)(m, (0, $hsQxB.Focus).First, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                },
                [(0, $3nJyP.Direction).Backwards]: ()=>{
                    (0, $hsQxB.focusIn)(m, (0, $hsQxB.Focus).Last, {
                        skipElements: [
                            c.relatedTarget,
                            a
                        ]
                    });
                }
            });
        });
    }), v = (0, $g6SeH.useIsTopLayer)(!!(u & 2), "focus-trap#tab-lock"), N = (0, $5Ai9V.useDisposables)(), F = (0, $acw62.useRef)(!1), k = {
        ref: r,
        onKeyDown (c) {
            c.key == "Tab" && (F.current = !0, N.requestAnimationFrame(()=>{
                F.current = !1;
            }));
        },
        onBlur (c) {
            if (!(u & 4)) return;
            let m = $38ecc25572962dee$var$U(n);
            t.current instanceof HTMLElement && m.add(t.current);
            let d = c.relatedTarget;
            d instanceof HTMLElement && d.dataset.headlessuiFocusGuard !== "true" && ($38ecc25572962dee$var$I(m, d) || (F.current ? (0, $hsQxB.focusIn)(t.current, (0, $6Ngq1.match)(R.current, {
                [(0, $3nJyP.Direction).Forwards]: ()=>(0, $hsQxB.Focus).Next,
                [(0, $3nJyP.Direction).Backwards]: ()=>(0, $hsQxB.Focus).Previous
            }) | (0, $hsQxB.Focus).WrapAround, {
                relativeTo: c.target
            }) : c.target instanceof HTMLElement && (0, $hsQxB.focusElement)(c.target)));
        }
    }, B = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, v && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $k9Al5.HiddenFeatures).Focusable
    }), B({
        ourProps: k,
        theirProps: f,
        defaultTag: $38ecc25572962dee$var$Z,
        name: "FocusTrap"
    }), v && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: g,
        features: (0, $k9Al5.HiddenFeatures).Focusable
    }));
}
let $38ecc25572962dee$var$D = (0, $ebRQH.forwardRefWithAs)($38ecc25572962dee$var$$), $38ecc25572962dee$export$34eba2437817a67b = Object.assign($38ecc25572962dee$var$D, {
    features: $38ecc25572962dee$export$a5e9a012c73650bd
});
function $38ecc25572962dee$var$w(o = !0) {
    let e = (0, $acw62.useRef)((0, $2C9FE.history).slice());
    return (0, $lEQT2.useWatch)(([t], [r])=>{
        r === !0 && t === !1 && (0, $eJKgu.microTask)(()=>{
            e.current.splice(0);
        }), r === !1 && t === !0 && (e.current = (0, $2C9FE.history).slice());
    }, [
        o,
        (0, $2C9FE.history),
        e
    ]), (0, $114Mg.useEvent)(()=>{
        var t;
        return (t = e.current.find((r)=>r != null && r.isConnected)) != null ? t : null;
    });
}
function $38ecc25572962dee$var$ee(o, { ownerDocument: e }) {
    let t = !!(o & 8), r = $38ecc25572962dee$var$w(t);
    (0, $lEQT2.useWatch)(()=>{
        t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && (0, $hsQxB.focusElement)(r());
    }, [
        t
    ]), (0, $3XIoH.useOnUnmount)(()=>{
        t && (0, $hsQxB.focusElement)(r());
    });
}
function $38ecc25572962dee$var$te(o, { ownerDocument: e, container: t, initialFocus: r, initialFocusFallback: s }) {
    let a = (0, $acw62.useRef)(null), n = (0, $g6SeH.useIsTopLayer)(!!(o & 1), "focus-trap#initial-focus"), u = (0, $brBI7.useIsMounted)();
    return (0, $lEQT2.useWatch)(()=>{
        if (o === 0) return;
        if (!n) {
            s != null && s.current && (0, $hsQxB.focusElement)(s.current);
            return;
        }
        let f = t.current;
        f && (0, $eJKgu.microTask)(()=>{
            if (!u.current) return;
            let l = e == null ? void 0 : e.activeElement;
            if (r != null && r.current) {
                if ((r == null ? void 0 : r.current) === l) {
                    a.current = l;
                    return;
                }
            } else if (f.contains(l)) {
                a.current = l;
                return;
            }
            if (r != null && r.current) (0, $hsQxB.focusElement)(r.current);
            else {
                if (o & 16) {
                    if ((0, $hsQxB.focusIn)(f, (0, $hsQxB.Focus).First | (0, $hsQxB.Focus).AutoFocus) !== (0, $hsQxB.FocusResult).Error) return;
                } else if ((0, $hsQxB.focusIn)(f, (0, $hsQxB.Focus).First) !== (0, $hsQxB.FocusResult).Error) return;
                if (s != null && s.current && ((0, $hsQxB.focusElement)(s.current), (e == null ? void 0 : e.activeElement) === s.current)) return;
                console.warn("There are no focusable elements inside the <FocusTrap />");
            }
            a.current = e == null ? void 0 : e.activeElement;
        });
    }, [
        s,
        n,
        o
    ]), a;
}
function $38ecc25572962dee$var$re(o, { ownerDocument: e, container: t, containers: r, previousActiveElement: s }) {
    let a = (0, $brBI7.useIsMounted)(), n = !!(o & 4);
    (0, $lwoRo.useEventListener)(e == null ? void 0 : e.defaultView, "focus", (u)=>{
        if (!n || !a.current) return;
        let f = $38ecc25572962dee$var$U(r);
        t.current instanceof HTMLElement && f.add(t.current);
        let l = s.current;
        if (!l) return;
        let i = u.target;
        i && i instanceof HTMLElement ? $38ecc25572962dee$var$I(f, i) ? (s.current = i, (0, $hsQxB.focusElement)(i)) : (u.preventDefault(), u.stopPropagation(), (0, $hsQxB.focusElement)(l)) : (0, $hsQxB.focusElement)(s.current);
    }, !0);
}
function $38ecc25572962dee$var$I(o, e) {
    for (let t of o)if (t.contains(e)) return !0;
    return !1;
}

});
parcelRegister("3XIoH", function(module, exports) {

$parcel$export(module.exports, "useOnUnmount", () => $2e29522f6fc857e9$export$cd059ee7fd0e9f3d);

var $acw62 = parcelRequire("acw62");

var $eJKgu = parcelRequire("eJKgu");

var $114Mg = parcelRequire("114Mg");
function $2e29522f6fc857e9$export$cd059ee7fd0e9f3d(t) {
    let r = (0, $114Mg.useEvent)(t), e = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>(e.current = !1, ()=>{
            e.current = !0, (0, $eJKgu.microTask)(()=>{
                e.current && r();
            });
        }), [
        r
    ]);
}

});

parcelRegister("3nJyP", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $2766dc79ae4166c9$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "useTabDirection", () => $2766dc79ae4166c9$export$19b797546aece48f);

var $acw62 = parcelRequire("acw62");

var $5vI4D = parcelRequire("5vI4D");
var $2766dc79ae4166c9$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($2766dc79ae4166c9$export$cacd6541cfeeb6c1 || {});
function $2766dc79ae4166c9$export$19b797546aece48f() {
    let e = (0, $acw62.useRef)(0);
    return (0, $5vI4D.useWindowEvent)(!0, "keydown", (r)=>{
        r.key === "Tab" && (e.current = r.shiftKey ? 1 : 0);
    }, !0), e;
}

});

parcelRegister("lEQT2", function(module, exports) {

$parcel$export(module.exports, "useWatch", () => $fc465b9f88c2456a$export$3c773aa2b84f29e0);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $fc465b9f88c2456a$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $acw62.useRef)([]), r = (0, $114Mg.useEvent)(u);
    (0, $acw62.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [a, l] of t.entries())if (e.current[a] !== l) {
            let n = r(t, o);
            return e.current = t, n;
        }
    }, [
        r,
        ...t
    ]);
}

});

parcelRegister("2C9FE", function(module, exports) {

$parcel$export(module.exports, "history", () => $1e76a1cad0cb58a8$export$55abd4691b317664);

var $ixVas = parcelRequire("ixVas");

var $hsQxB = parcelRequire("hsQxB");
let $1e76a1cad0cb58a8$export$55abd4691b317664 = [];
(0, $ixVas.onDocumentReady)(()=>{
    function e(t) {
        if (!(t.target instanceof HTMLElement) || t.target === document.body || $1e76a1cad0cb58a8$export$55abd4691b317664[0] === t.target) return;
        let n = t.target;
        n = n.closest((0, $hsQxB.focusableSelector)), $1e76a1cad0cb58a8$export$55abd4691b317664.unshift(n != null ? n : t.target), $1e76a1cad0cb58a8$export$55abd4691b317664 = $1e76a1cad0cb58a8$export$55abd4691b317664.filter((o)=>o != null && o.isConnected), $1e76a1cad0cb58a8$export$55abd4691b317664.splice(10);
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});

});
parcelRegister("ixVas", function(module, exports) {

$parcel$export(module.exports, "onDocumentReady", () => $d807a76564ed2203$export$a6a2315df743a26b);
function $d807a76564ed2203$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

});



parcelRegister("e9NTc", function(module, exports) {

$parcel$export(module.exports, "useNestedPortals", () => $a4e89ae9835d0556$export$26b8c35244a70b37);
$parcel$export(module.exports, "PortalGroup", () => $a4e89ae9835d0556$export$84c667e5e4409848);
$parcel$export(module.exports, "Portal", () => $a4e89ae9835d0556$export$602eac185826482c);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $114Mg = parcelRequire("114Mg");

var $8KgIp = parcelRequire("8KgIp");

var $3XIoH = parcelRequire("3XIoH");

var $5IEAk = parcelRequire("5IEAk");

var $b8md9 = parcelRequire("b8md9");

var $6mpbl = parcelRequire("6mpbl");

var $aQyzu = parcelRequire("aQyzu");

var $Iy8e1 = parcelRequire("Iy8e1");

var $ebRQH = parcelRequire("ebRQH");
"use client";
function $a4e89ae9835d0556$var$N(u) {
    let r = (0, $aQyzu.usePortalRoot)(), n = (0, $acw62.useContext)($a4e89ae9835d0556$var$v), e = (0, $5IEAk.useOwnerDocument)(u), [o, l] = (0, $acw62.useState)(()=>{
        var t;
        if (!r && n !== null) return (t = n.current) != null ? t : null;
        if ((0, $Iy8e1.env).isServer) return null;
        let p = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (p) return p;
        if (e === null) return null;
        let a = e.createElement("div");
        return a.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(a);
    });
    return (0, $acw62.useEffect)(()=>{
        o !== null && (e != null && e.body.contains(o) || e == null || e.body.appendChild(o));
    }, [
        o,
        e
    ]), (0, $acw62.useEffect)(()=>{
        r || n !== null && l(n.current);
    }, [
        n,
        l,
        r
    ]), o;
}
let $a4e89ae9835d0556$var$M = (0, $acw62.Fragment), $a4e89ae9835d0556$var$S = (0, $ebRQH.forwardRefWithAs)(function(r, n) {
    let e = r, o = (0, $acw62.useRef)(null), l = (0, $6mpbl.useSyncRefs)((0, $6mpbl.optionalRef)((i)=>{
        o.current = i;
    }), n), p = (0, $5IEAk.useOwnerDocument)(o), a = $a4e89ae9835d0556$var$N(o), [t] = (0, $acw62.useState)(()=>{
        var i;
        return (0, $Iy8e1.env).isServer ? null : (i = p == null ? void 0 : p.createElement("div")) != null ? i : null;
    }), s = (0, $acw62.useContext)($a4e89ae9835d0556$var$y), b = (0, $b8md9.useServerHandoffComplete)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        !a || !t || a.contains(t) || (t.setAttribute("data-headlessui-portal", ""), a.appendChild(t));
    }, [
        a,
        t
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (t && s) return s.register(t);
    }, [
        s,
        t
    ]), (0, $3XIoH.useOnUnmount)(()=>{
        var i;
        !a || !t || (t instanceof Node && a.contains(t) && a.removeChild(t), a.childNodes.length <= 0 && ((i = a.parentElement) == null || i.removeChild(a)));
    });
    let H = (0, $ebRQH.useRender)();
    return b ? !a || !t ? null : (0, $1u0KT.createPortal)(H({
        ourProps: {
            ref: l
        },
        theirProps: e,
        slot: {},
        defaultTag: $a4e89ae9835d0556$var$M,
        name: "Portal"
    }), t) : null;
});
function $a4e89ae9835d0556$var$j(u, r) {
    let n = (0, $6mpbl.useSyncRefs)(r), { enabled: e = !0, ...o } = u, l = (0, $ebRQH.useRender)();
    return e ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$S, {
        ...o,
        ref: n
    }) : l({
        ourProps: {
            ref: n
        },
        theirProps: o,
        slot: {},
        defaultTag: $a4e89ae9835d0556$var$M,
        name: "Portal"
    });
}
let $a4e89ae9835d0556$var$W = (0, $acw62.Fragment), $a4e89ae9835d0556$var$v = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$var$I(u, r) {
    let { target: n, ...e } = u, l = {
        ref: (0, $6mpbl.useSyncRefs)(r)
    }, p = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$v.Provider, {
        value: n
    }, p({
        ourProps: l,
        theirProps: e,
        defaultTag: $a4e89ae9835d0556$var$W,
        name: "Popover.Group"
    }));
}
let $a4e89ae9835d0556$var$y = (0, $acw62.createContext)(null);
function $a4e89ae9835d0556$export$26b8c35244a70b37() {
    let u = (0, $acw62.useContext)($a4e89ae9835d0556$var$y), r = (0, $acw62.useRef)([]), n = (0, $114Mg.useEvent)((l)=>(r.current.push(l), u && u.register(l), ()=>e(l))), e = (0, $114Mg.useEvent)((l)=>{
        let p = r.current.indexOf(l);
        p !== -1 && r.current.splice(p, 1), u && u.unregister(l);
    }), o = (0, $acw62.useMemo)(()=>({
            register: n,
            unregister: e,
            portals: r
        }), [
        n,
        e,
        r
    ]);
    return [
        r,
        (0, $acw62.useMemo)(()=>function({ children: p }) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a4e89ae9835d0556$var$y.Provider, {
                    value: o
                }, p);
            }, [
            o
        ])
    ];
}
let $a4e89ae9835d0556$var$J = (0, $ebRQH.forwardRefWithAs)($a4e89ae9835d0556$var$j), $a4e89ae9835d0556$export$84c667e5e4409848 = (0, $ebRQH.forwardRefWithAs)($a4e89ae9835d0556$var$I), $a4e89ae9835d0556$export$602eac185826482c = Object.assign($a4e89ae9835d0556$var$J, {
    Group: $a4e89ae9835d0556$export$84c667e5e4409848
});

});


parcelRegister("iL5oi", function(module, exports) {

$parcel$export(module.exports, "buttonClassName", () => $da80cc4bef9fc724$export$20bce677d7c5d811);
$parcel$export(module.exports, "default", () => $da80cc4bef9fc724$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3ktwa = parcelRequire("3ktwa");

var $iZHPA = parcelRequire("iZHPA");

var $01O3F = parcelRequire("01O3F");

var $kG3Fh = parcelRequire("kG3Fh");

var $jFdmN = parcelRequire("jFdmN");
var $da80cc4bef9fc724$var$__assign = undefined && undefined.__assign || function() {
    $da80cc4bef9fc724$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $da80cc4bef9fc724$var$__assign.apply(this, arguments);
};
var $da80cc4bef9fc724$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $da80cc4bef9fc724$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $da80cc4bef9fc724$var$hoverShadow = "hover:shadow-lg";
var $da80cc4bef9fc724$var$hoverScale = "hover:scale-[--max-scale] active:scale-[--min-scale]";
function $da80cc4bef9fc724$export$20bce677d7c5d811(props) {
    var _a, _b;
    var variant = (_a = props.variant) !== null && _a !== void 0 ? _a : "primary";
    var color = (_b = props.color) !== null && _b !== void 0 ? _b : "black";
    var background, border, textColor;
    switch("".concat(variant, "-").concat(color)){
        case "primary-black":
            background = "bg-black dark:bg-white ".concat($da80cc4bef9fc724$var$hoverShadow, " ").concat($da80cc4bef9fc724$var$hoverScale);
            textColor = "text-white dark:text-black";
            break;
        case "action-black":
            background = "bg-white dark:bg-gray-700 hover:bg-gray-50 hover:dark:bg-gray-600";
            border = "shadow-sm border border-gray-300 dark:border-none";
            textColor = "text-gray-700 dark:text-gray-200";
            break;
        case "secondary-black":
            background = "bg-gray-200 dark:bg-white/70 ".concat($da80cc4bef9fc724$var$hoverShadow, " ").concat($da80cc4bef9fc724$var$hoverScale);
            border = "shadow-sm";
            textColor = "text-black/70";
            break;
        case "text-black":
            background = $da80cc4bef9fc724$var$hoverScale;
            textColor = "text-black dark:text-white";
            break;
        case "primary-red":
            background = "bg-red-500 hover:bg-red-600 ".concat($da80cc4bef9fc724$var$hoverShadow, " ").concat($da80cc4bef9fc724$var$hoverScale);
            textColor = "text-white";
            break;
        case "action-red":
            background = "bg-white dark:bg-gray-700 hover:bg-gray-50 hover:dark:bg-gray-600";
            border = "shadow-sm border border-gray-300 dark:border-none";
            textColor = "text-red-700 dark:text-red-500";
            break;
        case "secondary-red":
            background = "bg-red-100 ".concat($da80cc4bef9fc724$var$hoverShadow, " ").concat($da80cc4bef9fc724$var$hoverScale);
            textColor = "text-red-700";
            break;
        case "text-red":
            background = $da80cc4bef9fc724$var$hoverScale;
            textColor = "text-red-500";
            break;
        case "primary-green":
            background = "bg-green-500 hover:bg-green-600 ".concat($da80cc4bef9fc724$var$hoverShadow, " ").concat($da80cc4bef9fc724$var$hoverScale);
            textColor = "text-white";
            break;
        case "action-green":
            background = "bg-white dark:bg-gray-700 hover:bg-gray-50 hover:dark:bg-gray-600";
            border = "shadow-sm border border-gray-300 dark:border-none";
            textColor = "text-green-700 dark:text-green-300";
            break;
        case "secondary-green":
            background = "bg-green-100 ".concat($da80cc4bef9fc724$var$hoverShadow, " ").concat($da80cc4bef9fc724$var$hoverScale);
            textColor = "text-green-700";
            break;
        case "text-green":
            background = $da80cc4bef9fc724$var$hoverScale;
            textColor = "text-green-700 dark:text-green-400";
            break;
    }
    return (0, $01O3F.classNames)("inline-flex relative text-center justify-center items-center gap-3 text-xs font-semibold tracking-widest\n    whitespace-nowrap cursor-pointer !no-underline", "uppercase transition-all duration-200 ease-in-out", background, border, textColor, props.loading && "cursor-default opacity-60 [&>span]:text-transparent [&>svg:not([data-loader])]:text-transparent pointer-events-none", !props.loading && "disabled:cursor-not-allowed disabled:opacity-50 disabled:pointer-events-none", props.size === "xs" && "px-1 py-0.5 rounded [&>svg]:-mx-0.5 [&>svg]:w-3 [&>svg]:h-3 [&>svg]:-my-3", props.size === "sm" && "px-2 py-1.5 rounded [&>svg]:-mx-1 [&>svg]:w-4 [&>svg]:h-4 [&>svg]:-my-4", props.size === "md" && "px-4 py-2 rounded-md [&>svg]:-mx-1 [&>svg]:w-5 [&>svg]:h-5 [&>svg]:-my-5", props.size === "lg" && "px-6 py-3.5 rounded-full [&>svg]:-mx-2 [&>svg]:w-6 [&>svg]:h-6 [&>svg]:-my-6", props.className);
}
var $da80cc4bef9fc724$var$Button = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_a, ref) {
    var _b;
    var disabled = _a.disabled, loading = _a.loading, type = _a.type, variant = _a.variant, children = _a.children, size = _a.size, className = _a.className, color = _a.color, progressPercent = _a.progressPercent, props = $da80cc4bef9fc724$var$__rest(_a, [
        "disabled",
        "loading",
        "type",
        "variant",
        "children",
        "size",
        "className",
        "color",
        "progressPercent"
    ]);
    disabled !== null && disabled !== void 0 ? disabled : disabled = false;
    loading !== null && loading !== void 0 ? loading : loading = false;
    size !== null && size !== void 0 ? size : size = "md";
    variant !== null && variant !== void 0 ? variant : variant = "primary";
    type !== null && type !== void 0 ? type : type = "button";
    var _c = $da80cc4bef9fc724$var$__read((0, $3ktwa.useMeasure)((_b = className === null || className === void 0 ? void 0 : className.includes("w-full")) !== null && _b !== void 0 ? _b : false), 2), measure = _c[0], measureRef = _c[1];
    var innerRef = (0, $iZHPA.default)(ref, measureRef);
    (0, $acw62.useEffect)(function() {
        var _a, _b, _c, _d;
        if (measure) {
            // Limit it to a 3px per side scale
            (_a = innerRef.current) === null || _a === void 0 || _a.style.setProperty("--max-scale", ((measure.width + 6) / measure.width).toString());
            (_b = innerRef.current) === null || _b === void 0 || _b.style.setProperty("--min-scale", ((measure.width - 6) / measure.width).toString());
        } else {
            (_c = innerRef.current) === null || _c === void 0 || _c.style.setProperty("--max-scale", "1.05");
            (_d = innerRef.current) === null || _d === void 0 || _d.style.setProperty("--min-scale", "0.95");
        }
    }, [
        measure,
        innerRef
    ]);
    (0, $acw62.useEffect)(function() {
        var _a;
        if (!loading && ((_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.form)) (0, $kG3Fh.scrollErrorIntoView)(innerRef.current.form);
    }, [
        loading,
        innerRef
    ]);
    return (0, $ayMG0.jsxs)("button", $da80cc4bef9fc724$var$__assign({
        type: type,
        ref: innerRef,
        className: $da80cc4bef9fc724$export$20bce677d7c5d811({
            loading: loading,
            size: size,
            variant: variant,
            className: className,
            color: color
        }),
        disabled: disabled || loading
    }, props, {
        children: [
            typeof progressPercent === "number" && (0, $ayMG0.jsx)("div", {
                className: "absolute left-0 h-0.5 bottom-0 transition-all bg-current",
                style: {
                    width: "".concat(Math.min(progressPercent, 1) * 100, "%")
                }
            }),
            loading && (0, $ayMG0.jsx)((0, $jFdmN.default), {
                color: "currentColor"
            }),
            (0, $01O3F.wrapText)(children !== null && children !== void 0 ? children : "Submit")
        ]
    }));
});
var $da80cc4bef9fc724$export$2e2bcd8739ae039 = $da80cc4bef9fc724$var$Button;

});
parcelRegister("3ktwa", function(module, exports) {

$parcel$export(module.exports, "useMeasure", () => $26ca22fa8c8a7a99$export$e295b0c537d32d7d);

var $acw62 = parcelRequire("acw62");

var $jG4ls = parcelRequire("jG4ls");

var $iuNkO = parcelRequire("iuNkO");

var $gIa7d = parcelRequire("gIa7d");
function $26ca22fa8c8a7a99$export$e295b0c537d32d7d(enabled = true) {
    const [element, setElement] = (0, $acw62.useState)(null);
    const elementRef = (0, $jG4ls.useHookableRef)(null, (v)=>{
        setElement(v);
        return v;
    });
    const [measures, setMeasures] = (0, $acw62.useState)();
    const [observerHandler] = (0, $iuNkO.useRafCallback)((entry)=>{
        setMeasures({
            width: entry.contentRect.width,
            height: entry.contentRect.height
        });
    });
    (0, $gIa7d.useResizeObserver)(element, observerHandler, enabled);
    return [
        measures,
        elementRef
    ];
}

});
parcelRegister("jG4ls", function(module, exports) {

$parcel$export(module.exports, "useHookableRef", () => $e5354f6b7343f0e1$export$dfc920b3a256ac30);

var $acw62 = parcelRequire("acw62");

var $eut6O = parcelRequire("eut6O");
function $e5354f6b7343f0e1$export$dfc920b3a256ac30(initialValue, onSet, onGet) {
    const onSetRef = (0, $eut6O.useSyncedRef)(onSet);
    const onGetRef = (0, $eut6O.useSyncedRef)(onGet);
    return (0, $acw62.useMemo)(()=>{
        let v = initialValue;
        return {
            get current () {
                return onGetRef.current === undefined ? v : onGetRef.current(v);
            },
            set current (value){
                v = onSetRef.current === undefined ? value : onSetRef.current(value);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});
parcelRegister("eut6O", function(module, exports) {

$parcel$export(module.exports, "useSyncedRef", () => $a8ca727003bd794a$export$ab7c8fab0bc555b6);

var $acw62 = parcelRequire("acw62");
function $a8ca727003bd794a$export$ab7c8fab0bc555b6(value) {
    const ref = (0, $acw62.useRef)(value);
    ref.current = value;
    return (0, $acw62.useMemo)(()=>Object.freeze({
            get current () {
                return ref.current;
            }
        }), []);
}

});


parcelRegister("iuNkO", function(module, exports) {

$parcel$export(module.exports, "useRafCallback", () => $d7714c2f2b50c114$export$79465d637252833b);

var $acw62 = parcelRequire("acw62");

var $eut6O = parcelRequire("eut6O");

var $dqQVQ = parcelRequire("dqQVQ");

var $5T31O = parcelRequire("5T31O");
function $d7714c2f2b50c114$export$79465d637252833b(cb) {
    const cbRef = (0, $eut6O.useSyncedRef)(cb);
    const frame = (0, $acw62.useRef)(0);
    const cancel = (0, $acw62.useCallback)(()=>{
        if (!(0, $5T31O.isBrowser)) return;
        if (frame.current) {
            cancelAnimationFrame(frame.current);
            frame.current = 0;
        }
    }, []);
    (0, $dqQVQ.useUnmountEffect)(cancel);
    return [
        (0, $acw62.useMemo)(()=>{
            const wrapped = (...args)=>{
                if (!(0, $5T31O.isBrowser)) return;
                cancel();
                frame.current = requestAnimationFrame(()=>{
                    cbRef.current(...args);
                    frame.current = 0;
                });
            };
            Object.defineProperties(wrapped, {
                length: {
                    value: cb.length
                },
                name: {
                    value: `${cb.name || "anonymous"}__raf`
                }
            });
            return wrapped;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []),
        cancel
    ];
}

});
parcelRegister("dqQVQ", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", () => $9c76c33c145f2d60$export$f3a192d0cbd30b96);

var $acw62 = parcelRequire("acw62");

var $eut6O = parcelRequire("eut6O");
function $9c76c33c145f2d60$export$f3a192d0cbd30b96(effect) {
    const effectRef = (0, $eut6O.useSyncedRef)(effect);
    (0, $acw62.useEffect)(()=>()=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            effectRef.current();
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
}

});

parcelRegister("5T31O", function(module, exports) {

$parcel$export(module.exports, "noop", () => $011b2b19574c9a0c$export$8793edee2d425525);
$parcel$export(module.exports, "isBrowser", () => $011b2b19574c9a0c$export$4e09c449d6c407f7);
const $011b2b19574c9a0c$export$8793edee2d425525 = ()=>{};
const $011b2b19574c9a0c$export$4e09c449d6c407f7 = typeof globalThis !== "undefined" && typeof navigator !== "undefined" && typeof document !== "undefined";
const $011b2b19574c9a0c$export$bbcfc742c65abdc2 = (previous, next)=>previous === next;
const $011b2b19574c9a0c$export$756d8210573f3cd1 = (conditions)=>conditions.every(Boolean);
const $011b2b19574c9a0c$export$861c6d3c5a798b6c = (conditions)=>conditions.some(Boolean);

});


parcelRegister("gIa7d", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $c2a89a1c88d63534$export$683480f191c0e3ea);

var $acw62 = parcelRequire("acw62");

var $eut6O = parcelRequire("eut6O");

var $5T31O = parcelRequire("5T31O");
let $c2a89a1c88d63534$var$observerSingleton;
function $c2a89a1c88d63534$var$getResizeObserver() {
    if (!(0, $5T31O.isBrowser)) return undefined;
    if ($c2a89a1c88d63534$var$observerSingleton) return $c2a89a1c88d63534$var$observerSingleton;
    const callbacks = new Map();
    const observer = new ResizeObserver((entries)=>{
        for (const entry of entries){
            const cbs = callbacks.get(entry.target);
            if (cbs === undefined || cbs.size === 0) continue;
            for (const cb of cbs)setTimeout(()=>{
                cb(entry);
            }, 0);
        }
    });
    $c2a89a1c88d63534$var$observerSingleton = {
        observer: observer,
        subscribe (target, callback) {
            let cbs = callbacks.get(target);
            if (!cbs) {
                // If target has no observers yet - register it
                cbs = new Set();
                callbacks.set(target, cbs);
                observer.observe(target);
            }
            // As Set is duplicate-safe - simply add callback on each call
            cbs.add(callback);
        },
        unsubscribe (target, callback) {
            const cbs = callbacks.get(target);
            // Else branch should never occur in case of normal execution
            // because callbacks map is hidden in closure - it is impossible to
            // simulate situation with non-existent `cbs` Set
            if (cbs) {
                // Remove current observer
                cbs.delete(callback);
                if (cbs.size === 0) {
                    // If no observers left unregister target completely
                    callbacks.delete(target);
                    observer.unobserve(target);
                }
            }
        }
    };
    return $c2a89a1c88d63534$var$observerSingleton;
}
function $c2a89a1c88d63534$export$683480f191c0e3ea(target, callback, enabled = true) {
    const ro = enabled && $c2a89a1c88d63534$var$getResizeObserver();
    const cb = (0, $eut6O.useSyncedRef)(callback);
    const tgt = target && "current" in target ? target.current : target;
    (0, $acw62.useEffect)(()=>{
        // This secondary target resolve required for case when we receive ref object, which, most
        // likely, contains null during render stage, but already populated with element during
        // effect stage.
        const tgt = target && "current" in target ? target.current : target;
        if (!ro || !tgt) return;
        // As unsubscription in internals of our ResizeObserver abstraction can
        // happen a bit later than effect cleanup invocation - we need a marker,
        // that this handler should not be invoked anymore
        let subscribed = true;
        const handler = (...args)=>{
            // It is reinsurance for the highly asynchronous invocations, almost
            // impossible to achieve in tests, thus excluding from LOC
            if (subscribed) cb.current(...args);
        };
        ro.subscribe(tgt, handler);
        return ()=>{
            subscribed = false;
            ro.unsubscribe(tgt, handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tgt,
        ro
    ]);
}

});


parcelRegister("iZHPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd3fec71bfb500c3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $dd3fec71bfb500c3$export$2e2bcd8739ae039() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    var targetRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        refs.forEach(function(ref) {
            if (!ref) return;
            if (typeof ref === "function") ref(targetRef.current);
            else ref.current = targetRef.current;
        });
    }, [
        refs
    ]);
    return targetRef;
}

});

parcelRegister("kG3Fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0da929eee15eed6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "scrollErrorIntoView", () => $f0da929eee15eed6$export$d373afc9574e0ca8);

var $ayMG0 = parcelRequire("ayMG0");

var $jfXvU = parcelRequire("jfXvU");

var $01O3F = parcelRequire("01O3F");

var $31jJ6 = parcelRequire("31jJ6");
function $f0da929eee15eed6$export$2e2bcd8739ae039(_a) {
    var label = _a.label, error = _a.error, explanation = _a.explanation, children = _a.children, className = _a.className, hiddenLabel = _a.hiddenLabel, testId = _a.testId;
    hiddenLabel !== null && hiddenLabel !== void 0 ? hiddenLabel : hiddenLabel = false;
    return (0, $ayMG0.jsxs)("label", {
        className: (0, $01O3F.classNames)("flex flex-col w-full mb-6 space-y-1.5", error && "group has-error", className),
        "data-testid": testId,
        children: [
            (0, $ayMG0.jsx)("div", {
                className: (0, $01O3F.classNames)("text-sm font-semibold text-gray-600 dark:text-gray-300", hiddenLabel && "hidden sm:block invisible"),
                children: label
            }),
            children,
            typeof explanation !== "undefined" && !error && (0, $ayMG0.jsx)("p", {
                className: "underlined-links text-sm text-gray-400 dark:text-gray-500",
                children: typeof explanation === "string" ? (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                    components: {
                        code: (0, $ayMG0.jsx)((0, $31jJ6.Code), {})
                    },
                    children: explanation
                }) : explanation
            }),
            error && (0, $ayMG0.jsx)("p", {
                className: "text-sm text-red-500",
                "data-role": "error_message",
                children: error
            })
        ]
    });
}
function $f0da929eee15eed6$export$ed1bfb0d26b42ebb(_a) {
    var error = _a.error, explanation = _a.explanation, children = _a.children, className = _a.className;
    return (0, $ayMG0.jsxs)("div", {
        className: (0, $01O3F.classNames)("flex flex-col w-full space-y-1.5", error && "group has-error", className),
        children: [
            children,
            typeof explanation !== "undefined" && !error && (0, $ayMG0.jsx)("p", {
                className: "underlined-links text-sm text-gray-400 dark:text-gray-500",
                children: typeof explanation === "string" ? (0, $ayMG0.jsx)((0, $jfXvU.Trans), {
                    components: {
                        code: (0, $ayMG0.jsx)((0, $31jJ6.Code), {})
                    },
                    children: explanation
                }) : explanation
            }),
            error && (0, $ayMG0.jsx)("p", {
                className: "text-sm text-red-500",
                "data-role": "error_message",
                children: error
            })
        ]
    });
}
function $f0da929eee15eed6$export$d373afc9574e0ca8(scope) {
    if (scope === void 0) scope = document;
    var error = scope.querySelector("[data-role=error_message]");
    if (error) error.scrollIntoView({
        behavior: "smooth",
        block: "center"
    });
}

});
parcelRegister("jfXvU", function(module, exports) {

$parcel$export(module.exports, "Trans", () => $e04d9533328ca578$export$8d6a9236f2e3f2ce);

var $gZU1N = parcelRequire("gZU1N");

var $41YNz = parcelRequire("41YNz");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $915hL = parcelRequire("915hL");

var $x4LLZ = parcelRequire("x4LLZ");

var $hPEPQ = parcelRequire("hPEPQ");
var $e04d9533328ca578$var$_excluded = [
    "format"
], $e04d9533328ca578$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $e04d9533328ca578$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e04d9533328ca578$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e04d9533328ca578$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e04d9533328ca578$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e04d9533328ca578$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $e04d9533328ca578$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $e04d9533328ca578$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $acw62.isValidElement)(child);
    });
}
function $e04d9533328ca578$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $e04d9533328ca578$var$mergeProps(source, target) {
    var newTarget = $e04d9533328ca578$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $e04d9533328ca578$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $e04d9533328ca578$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $acw62.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $e04d9533328ca578$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $hPEPQ.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === "object") {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(child, $e04d9533328ca578$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $hPEPQ.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $hPEPQ.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $e04d9533328ca578$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $e04d9533328ca578$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($e04d9533328ca578$var$hasChildren(child)) getData($e04d9533328ca578$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === "object" && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $915hL.default).parse("<0>".concat(targetString, "</0>"));
    var opts = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $e04d9533328ca578$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $e04d9533328ca578$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $e04d9533328ca578$var$getAsArray(reactNode);
        var astNodes = $e04d9533328ca578$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $e04d9533328ca578$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $acw62.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $e04d9533328ca578$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($e04d9533328ca578$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $acw62.cloneElement)(child, $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $e04d9533328ca578$var$getAsArray(children || []));
    return $e04d9533328ca578$var$getChildren(result[0]);
}
function $e04d9533328ca578$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, $e04d9533328ca578$var$_excluded2);
    var _ref2 = (0, $acw62.useContext)((0, $x4LLZ.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $x4LLZ.getI18n)();
    if (!i18n) {
        (0, $hPEPQ.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, (0, $x4LLZ.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $e04d9533328ca578$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread($e04d9533328ca578$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $e04d9533328ca578$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("915hL", function(module, exports) {

$parcel$export(module.exports, "default", () => $69084eaa2e6a0d50$export$2e2bcd8739ae039);

var $iWvxr = parcelRequire("iWvxr");
var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($iWvxr)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;

});
parcelRegister("iWvxr", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRegister("hPEPQ", function(module, exports) {

$parcel$export(module.exports, "warn", () => $cfb6e0167e0b350d$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "warnOnce", () => $cfb6e0167e0b350d$export$5b28268982f175ba);
function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d.apply(void 0, args);
}
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    });
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});


parcelRegister("31jJ6", function(module, exports) {

$parcel$export(module.exports, "Code", () => $2330c45fa2fbc570$export$52f0f02147b12c03);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iZHPA = parcelRequire("iZHPA");

var $01O3F = parcelRequire("01O3F");
var $2330c45fa2fbc570$export$52f0f02147b12c03 = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_a, ref) {
    var children = _a.children, _b = _a.selectAll, selectAll = _b === void 0 ? true : _b, className = _a.className;
    var innerRef = (0, $iZHPA.default)(ref);
    function onClick() {
        if (innerRef.current) {
            var selection = window.getSelection();
            if (selection) {
                var range = document.createRange();
                range.selectNodeContents(innerRef.current);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    }
    return (0, $ayMG0.jsx)("code", {
        ref: innerRef,
        onClick: onClick,
        className: (0, $01O3F.classNames)("bg-gray-200 rounded-sm outline outline-1 outline-gray-200 dark:bg-gray-700 dark:outline-gray-700 px-1", className),
        children: children
    });
});

});


parcelRegister("jFdmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50c37000a12e3cb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $01O3F = parcelRequire("01O3F");

var $bsRud = parcelRequire("bsRud");
function $e50c37000a12e3cb$export$2e2bcd8739ae039(_a) {
    var size = _a.size, color = _a.color;
    size !== null && size !== void 0 ? size : size = 5;
    return (0, $ayMG0.jsx)((0, $bsRud.default), {
        children: (0, $ayMG0.jsxs)("svg", {
            className: (0, $01O3F.classNames)("w-".concat(size, " h-").concat(size), "animate-spin", color ? color : "text-black dark:text-white"),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "data-role": "loader",
            children: [
                (0, $ayMG0.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                }),
                (0, $ayMG0.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
            ]
        })
    });
}

});




parcelRegister("hNovL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4a06b3c7dd94e8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $cf4a06b3c7dd94e8$export$2e2bcd8739ae039() {
    var getSupport = (0, $acw62.useCallback)(function() {
        if (typeof window.Intercom === "function") return window.Intercom("showNewMessage");
        window.open("mailto:support@upscope.com");
    }, []);
    return {
        getSupport: getSupport
    };
}

});

parcelRegister("7xuAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $57d356d5d3381745$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Redirect", () => $57d356d5d3381745$export$2d8d895a0a0f636e);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $hmJ39 = parcelRequire("hmJ39");

var $iCMjC = parcelRequire("iCMjC");
var $57d356d5d3381745$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $57d356d5d3381745$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $57d356d5d3381745$export$2e2bcd8739ae039() {
    var navigate = (0, $aphAM.useNavigate)();
    var user = (0, $iCMjC.useAuthentication)().user;
    var redirect = (0, $acw62.useCallback)(function(to) {
        var destination = typeof to === "string" ? to : (0, $hmJ39.path).apply(void 0, $57d356d5d3381745$var$__spreadArray([], $57d356d5d3381745$var$__read(to), false));
        var needsServerResponse = typeof to === "string" || Object.keys((0, $hmJ39.serverResponsePaths)).includes(to[0]);
        console.log("Redirecting to", to);
        // Target will be a path if it is on the same domain, otherwise it will be a URL
        if (destination.startsWith("/") && !needsServerResponse) return navigate(destination);
        if (destination.startsWith(location.origin) || typeof to === "string" || !destination.startsWith("http") || to[0].startsWith("up.") || !user) {
            location.href = destination;
            return;
        }
        location.href = (0, $hmJ39.path)("up.auth.loginRedirect", {
            redirectUrl: destination
        });
    }, [
        navigate,
        user
    ]);
    return redirect;
}
function $57d356d5d3381745$export$2d8d895a0a0f636e(_a) {
    var to = _a.to;
    var redirect = $57d356d5d3381745$export$2e2bcd8739ae039();
    (0, $acw62.useEffect)(function() {
        redirect(to);
    }, [
        to,
        redirect
    ]);
    return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
}

});
parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $040dbb9c344a508d$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $aphAM.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2vsP7.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2vsP7.UNSAFE_invariant)(false);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2vsP7.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $2vsP7.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $aphAM.useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2vsP7.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2vsP7.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2vsP7.matchPath)(path.pathname, nextPath) != null || (0, $2vsP7.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $1d34d5c4a288b213$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $1d34d5c4a288b213$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $1d34d5c4a288b213$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $1d34d5c4a288b213$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $1d34d5c4a288b213$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $1d34d5c4a288b213$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.19.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$480182c6abbb2ff6(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false);
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $1d34d5c4a288b213$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref6) {
    let { matches: matches } = _ref6;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $7939e29d663dd3ed$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useOutletContext", () => $7939e29d663dd3ed$export$4138103a3ae699cc);
$parcel$export(module.exports, "useOutlet", () => $7939e29d663dd3ed$export$a3be3530d8e40d0b);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $7939e29d663dd3ed$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $7939e29d663dd3ed$export$b273b3273281a049);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Outlet", () => $7939e29d663dd3ed$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.26.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, (0, $2vsP7.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $2vsP7.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $2vsP7.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $2vsP7.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2vsP7.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("hmJ39", function(module, exports) {

$parcel$export(module.exports, "serverResponsePaths", () => $ca476fb97608ce0d$export$cc57941318c595ed);
$parcel$export(module.exports, "path", () => $ca476fb97608ce0d$export$bb654e07daaf8c3a);
$parcel$export(module.exports, "getRouteOrigin", () => $ca476fb97608ce0d$export$15d6f2a5111c5634);
$parcel$export(module.exports, "getRouteBaseHostname", () => $ca476fb97608ce0d$export$a94ad189d3d42327);
$parcel$export(module.exports, "getRoot", () => $ca476fb97608ce0d$export$31e4419873013369);
$parcel$export(module.exports, "cleanRedirectPath", () => $ca476fb97608ce0d$export$27c132606dcf9711);
$parcel$export(module.exports, "isTrustedOrigin", () => $ca476fb97608ce0d$export$bbf90bf88cf3cef8);
$parcel$export(module.exports, "productPrefixes", () => $ca476fb97608ce0d$export$f3336dfadaab17e6);

var $3Ukkm = parcelRequire("3Ukkm");
var $ca476fb97608ce0d$var$__assign = undefined && undefined.__assign || function() {
    $ca476fb97608ce0d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ca476fb97608ce0d$var$__assign.apply(this, arguments);
};
var $ca476fb97608ce0d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $ca476fb97608ce0d$var$decamelize = (0, (/*@__PURE__*/$parcel$interopDefault($3Ukkm))).decamelize;
var $ca476fb97608ce0d$export$595447059867920 = {
    "up.auth.signUp": function(p) {
        return "/auth/sign_up" + $ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({
            inviteToken: p.inviteToken,
            product: p.product,
            integration: p.integration
        }, p.utmParams));
    },
    "up.auth.login": function(p) {
        var _a, _b;
        return "/auth/login" + $ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({
            redirectUrl: (_a = p.redirectUrl) !== null && _a !== void 0 ? _a : p.returnHere ? location.href : null,
            product: p.product,
            email: (_b = p.email) !== null && _b !== void 0 ? _b : null
        }, p.loginToken ? {
            loginToken: p.loginToken
        } : {}));
    },
    "up.auth.join": function(p) {
        return "/join/".concat(p.teamUniqueIdentifier, "-").concat(p.teamDomain);
    },
    "up.auth.mfa.enable": "/auth/mfa/setup",
    "up.auth.invites.show": function(p) {
        return "/auth/invites/".concat(p.inviteToken);
    },
    "up.notifications.confirmation": "/email_notification",
    "up.shortCuts.purchase": "/purchase",
    "up.shortCuts.install": "/install",
    "up.onboarding": function(p) {
        return "/welcome/".concat(p.teamDomain);
    },
    "up.onboarding.questions": function(p) {
        return "/welcome/".concat(p.teamDomain, "/questions");
    },
    "up.onboarding.bookCall": function(p) {
        return "/welcome/".concat(p.teamDomain, "/book_call");
    },
    "up.onboarding.inviteTeam": function(p) {
        return "/welcome/".concat(p.teamDomain, "/invite_team");
    },
    "up.onboarding.purchase": function(p) {
        return "/welcome/".concat(p.teamDomain, "/purchase");
    },
    "up.onboarding.installCobrowsing": function(p) {
        return "/welcome/".concat(p.teamDomain, "/install-").concat(p.teamUniqueIdentifier);
    },
    "hs.extension.view": function(p) {
        return "/".concat(p.sessionCode);
    },
    "hs.extension.welcome": "/extension/welcome",
    "hs.extension.uninstall": function(p) {
        return "/extension/uninstall" + $ca476fb97608ce0d$var$query({
            installationUuid: p.installationUuid
        });
    },
    "hs.visitorsList": function(p) {
        return "".concat(p.isEmbedded ? "/embed" : "", "/").concat(p.searchTerm === ":searchTerm" ? "s/:searchTerm" : typeof p.searchTerm !== "undefined" ? "s/".concat(encodeURIComponent(p.searchTerm)) : "").concat($ca476fb97608ce0d$var$query({
            fromProduct: p.fromProduct
        }));
    },
    "hs.cobrowse": function(p) {
        if (p.onPremiseTeamUniqueIdentifier) return "/onprem_redirect/".concat(p.onPremiseTeamUniqueIdentifier) + $ca476fb97608ce0d$var$query({
            metadataToken: p.metadataToken,
            source: p.source,
            id: p.visitorId,
            fromProduct: p.fromProduct
        });
        return "".concat(p.isEmbedded ? "/embed" : "", "/w/").concat(p.visitorId) + $ca476fb97608ce0d$var$query({
            metadataToken: p.metadataToken,
            source: p.source,
            fromProduct: p.fromProduct
        });
    },
    "uv.visitorsList": function(p) {
        return "".concat(p.isEmbedded ? "/embed" : "", "/").concat(p.searchTerm === ":searchTerm" ? "s/:searchTerm" : typeof p.searchTerm !== "undefined" ? "s/".concat(encodeURIComponent(p.searchTerm)) : "").concat($ca476fb97608ce0d$var$query({
            fromProduct: p.fromProduct
        }));
    },
    "uv.cobrowse": function(p) {
        if (p.onPremiseTeamUniqueIdentifier) return "/onprem_redirect/".concat(p.onPremiseTeamUniqueIdentifier) + $ca476fb97608ce0d$var$query({
            metadataToken: p.metadataToken,
            source: p.source,
            id: p.visitorId,
            fromProduct: p.fromProduct
        });
        return "".concat(p.isEmbedded ? "/embed" : "", "/w/").concat(p.visitorId) + $ca476fb97608ce0d$var$query({
            metadataToken: p.metadataToken,
            source: p.source,
            fromProduct: p.fromProduct
        });
    },
    "co.cobrowse": function(p) {
        return "/w/".concat(p.visitorId).concat($ca476fb97608ce0d$var$query({
            fromProduct: p.fromProduct
        }));
    },
    "up.settings.authTokens.new": "/auth/tokens/new",
    "up.settings.personal": "/settings",
    "up.settings.manageTeams": function(p) {
        return "/manage_teams" + $ca476fb97608ce0d$var$query(p);
    },
    "up.settings.general": function(p) {
        return "/settings/teams/".concat(p.teamDomain).concat(p.section ? "/".concat(p.section) : "");
    },
    "up.settings.quickEnable": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/quick_enable/").concat(p.setting);
    },
    "co.root": function(p) {
        return "/".concat($ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({}, p.utmParams)));
    },
    "hs.root": function(p) {
        return "/".concat($ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({}, p.utmParams)));
    },
    "up.root": function(p) {
        return "/".concat($ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({}, p.utmParams)));
    },
    "ld.root": function(p) {
        return "/".concat($ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({}, p.utmParams)));
    },
    "uv.root": function(p) {
        return "/".concat($ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({}, p.utmParams)));
    },
    "up.reporting.usage": function(p) {
        var _a, _b;
        return "/usage/".concat(p.teamDomain).concat($ca476fb97608ce0d$var$query({
            from: (_a = p.from) === null || _a === void 0 ? void 0 : _a.toString(),
            to: (_b = p.to) === null || _b === void 0 ? void 0 : _b.toString()
        }));
    },
    "up.visitorData": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/visitor-data");
    },
    "up.members": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/members");
    },
    "up.members.invites": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/members/invites");
    },
    "co.dashboard": function(p) {
        return "/dashboard/".concat(p.teamDomain);
    },
    "co.dashboard.restKeys": function(p) {
        return "/dashboard/".concat(p.teamDomain, "/rest_keys");
    },
    "co.dashboard.requestHistory": function(p) {
        return "/dashboard/".concat(p.teamDomain, "/history");
    },
    "co.dashboard.webhookHistory": function(p) {
        return "/dashboard/".concat(p.teamDomain, "/webhooks");
    },
    "hq.root": "/",
    "hq.accounts.index": function(p) {
        return "/accounts".concat($ca476fb97608ce0d$var$query({
            tags: p.tag
        }));
    },
    "hq.accounts.show": function(p) {
        return "/accounts/".concat(p.companyId);
    },
    "hq.accounts.show.team": function(p) {
        return "/accounts/".concat(p.companyId, "/teams/").concat(p.teamId);
    },
    "hq.accounts.show.emails": function(p) {
        return "/accounts/".concat(p.companyId, "/emails");
    },
    "hq.accounts.show.contacts": function(p) {
        return "/accounts/".concat(p.companyId, "/contacts");
    },
    "hq.accounts.show.companyDocuments": function(p) {
        return "/accounts/".concat(p.companyId, "/company_documents");
    },
    "hq.accounts.show.members": function(p) {
        return "/accounts/".concat(p.companyId, "/teams/").concat(p.teamId, "/members");
    },
    "hq.accounts.show.usage": function(p) {
        return "/accounts/".concat(p.companyId, "/teams/").concat(p.teamId, "/usage");
    },
    "hq.accounts.show.activityLog": function(p) {
        return "/accounts/".concat(p.companyId, "/activity_log");
    },
    "hq.accounts.show.charges": function(p) {
        return "/accounts/".concat(p.companyId, "/charges/").concat(p.teamId);
    },
    "hq.customerSuccess.index": "/cs",
    "hq.customerSuccess.list": function(p) {
        return "/cs/".concat(p.stage);
    },
    "hq.globalActivityLog": function(p) {
        return "/activity_log".concat($ca476fb97608ce0d$var$query({
            userId: p.userId
        }));
    },
    "hq.sales.index": "/sales",
    "hq.sales.tasks": "/sales/tasks",
    "hq.sales.leads": "/sales/leads",
    "hq.sales.activities": "/sales/activities",
    "hq.aiChanges": "/ai_changes",
    "hq.sales.opportunities.index": "/sales/opportunities",
    "hq.sales.opportunities.show": function(p) {
        return "/sales/opportunities/".concat(p.opportunityId);
    },
    "hq.users.show": function(p) {
        return "/users/".concat(p.userId);
    },
    "hq.quotes.transfer.new": function(p) {
        return "/quotes/".concat(p.quotePublicKey, "/transfer");
    },
    "hq.quotes.show": function(p) {
        return "/quotes/".concat(p.quotePublicKey);
    },
    "hq.quotes.index": "/quotes",
    "hq.debug.show": function(p) {
        return "/debug/".concat(p.visitorId);
    },
    "hq.emailRedirect": "/emailredirect",
    "ld.templates.index": function(p) {
        return "/templates/".concat(p.teamDomain);
    },
    "ld.leads.index": function(p) {
        return "/leads/".concat(p.teamDomain);
    },
    "ld.templates.show": function(p) {
        return "/templates/".concat(p.teamDomain, "/").concat(p.templateId);
    },
    "ld.templates.create": function(p) {
        return "/templates/".concat(p.teamDomain, "/new");
    },
    "ld.links.list": function(p) {
        return "/links/".concat(p.teamDomain);
    },
    "ld.links.create": function(p) {
        return "/links/".concat(p.teamDomain, "/new");
    },
    "ld.links.show": function(p) {
        return "/".concat(p.linkSlug).concat(p.section ? "/".concat(p.section) : "").concat($ca476fb97608ce0d$var$query({
            document: p.documentId,
            page: p.pageNumber
        }));
    },
    "up.settings.team": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/members");
    },
    "up.settings.billing": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/billing");
    },
    "up.settings.billing.upgrade": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/billing/upgrade").concat($ca476fb97608ce0d$var$query({
            feature: p.feature
        }));
    },
    "up.settings.billing.sessionCredit": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/billing/session-credit");
    },
    "up.settings.billing.subaccounts": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/billing/subaccounts");
    },
    "up.settings.billing.history": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/billing/history");
    },
    "up.activity.activityLog": function(p) {
        return "/activity_log/".concat(p.teamDomain).concat($ca476fb97608ce0d$var$query({
            userId: p.userId
        }));
    },
    "up.history": function(p) {
        return "/usage/".concat(p.teamDomain, "/sessions").concat(p.sessionId ? "/".concat(p.sessionId) : "");
    },
    "up.integrations": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations");
    },
    "up.integrations.intercom.connect": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/intercom");
    },
    "up.integrations.googleOauth2": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/google_oauth2");
    },
    "up.integrations.livechat": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/livechat");
    },
    "up.integrations.twilioFlex": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/twilio_flex/").concat(p.integrationId);
    },
    "up.integrations.freshchat": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/freshchat/").concat(p.integrationId);
    },
    "up.integrations.front": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/front").concat(p.integrationId ? "/".concat(p.integrationId) : "");
    },
    "up.integrations.salesforce": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/salesforce");
    },
    "up.integrations.salesforceSandbox": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/salesforce?sandbox=true");
    },
    "up.integrations.zapier": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/zapier/").concat(p.integrationId);
    },
    "up.integrations.zendesk": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/add/zendesk/").concat(p.integrationId);
    },
    "up.integrations.intercom.settings": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/intercom/").concat(p.integrationId, "/settings");
    },
    "up.integrations.salesforce.settings": function(p) {
        return "/settings/teams/".concat(p.teamDomain, "/integrations/salesforce/").concat(p.integrationId, "/settings");
    },
    "up.quotes.show": function(p) {
        return "/quote/".concat(p.quotePublicKey).concat($ca476fb97608ce0d$var$query({
            orderForm: p.orderForm
        }));
    },
    "up.invoice.showFailed": function(p) {
        return "/invoice/".concat(p.invoiceId, "/failed");
    }
};
var $ca476fb97608ce0d$export$cc57941318c595ed = {
    "up.auth.loginRedirect": function(p) {
        var _a;
        return "/api/auth/redirect" + $ca476fb97608ce0d$var$query({
            redirectUrl: (_a = p.redirectUrl) !== null && _a !== void 0 ? _a : location.href
        });
    },
    "up.auth.saml.redirect": function(p) {
        var _a;
        return "/auth/saml/".concat(p.teamUniqueIdentifier, "/authenticate").concat($ca476fb97608ce0d$var$query({
            redirectUrl: (_a = p.redirectUrl) !== null && _a !== void 0 ? _a : p.returnHere ? location.href : null
        }));
    },
    "up.oauth.signUp": function(p) {
        return "/auth/sign_up/with/".concat(p.provider) + "".concat($ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign($ca476fb97608ce0d$var$__assign({}, p.utmParams), {
            ignoreTakenDomain: p.ignoreTakenDomain,
            product: p.product,
            integration: p.integration
        })));
    },
    "up.oauth.intercom.connect": function(p) {
        return "/auth/with/intercom" + "".concat($ca476fb97608ce0d$var$query({
            intent: "connect",
            team: p.team,
            redirectUrl: p.redirectUrl
        }));
    },
    "up.oauth.google.connect": function(p) {
        return "/auth/with/google_oauth2" + "".concat($ca476fb97608ce0d$var$query({
            intent: "connect",
            team: p.team,
            redirectUrl: p.redirectUrl
        }));
    },
    "up.oauth.salesforce.connect": function(p) {
        return "/auth/with/".concat(p.sandbox ? "salesforcesandbox" : "salesforce") + "".concat($ca476fb97608ce0d$var$query({
            intent: "connect",
            team: p.team,
            redirectUrl: p.redirectUrl
        }));
    },
    "web.legal": "/legal",
    "hs.extensionRedirect": function(p) {
        return "/extension".concat($ca476fb97608ce0d$var$query($ca476fb97608ce0d$var$__assign({}, p.utmParams)));
    },
    "web.security": "/security",
    "co.restDocs": "/docs/rest-api",
    "up.reporting.usage.download": function(p) {
        return "/usage/".concat(p.teamDomain, "/download").concat($ca476fb97608ce0d$var$query({
            from: p.from.toString(),
            to: p.to.toString()
        }));
    }
};
var $ca476fb97608ce0d$var$allPaths = $ca476fb97608ce0d$var$__assign($ca476fb97608ce0d$var$__assign({}, $ca476fb97608ce0d$export$595447059867920), $ca476fb97608ce0d$export$cc57941318c595ed);
function $ca476fb97608ce0d$export$bb654e07daaf8c3a() {
    var pathData = [];
    for(var _i = 0; _i < arguments.length; _i++)pathData[_i] = arguments[_i];
    var _a = $ca476fb97608ce0d$var$__read(pathData), pathName = _a[0], args = _a.slice(1);
    var path;
    path = typeof $ca476fb97608ce0d$var$allPaths[pathName] === "string" ? $ca476fb97608ce0d$var$allPaths[pathName] : $ca476fb97608ce0d$var$allPaths[pathName].apply(null, args);
    var origin = $ca476fb97608ce0d$export$15d6f2a5111c5634(pathName);
    if (origin !== location.origin) {
        path = "".concat(origin).concat(path);
        if (new URL(path).pathname === "/") path += path.includes("?") ? "&authenticated=true" : "?authenticated=true";
    }
    return path;
}
function $ca476fb97608ce0d$export$15d6f2a5111c5634(routeKey) {
    var protocol = location.protocol;
    return "".concat(protocol, "//").concat($ca476fb97608ce0d$export$a94ad189d3d42327(routeKey));
}
function $ca476fb97608ce0d$export$a94ad189d3d42327(routeKey) {
    var tld = location.hostname.split(".").pop();
    if (routeKey.startsWith("web.")) return "upscope.".concat(tld === "io" ? "com" : tld);
    if (routeKey.startsWith("up.")) return "app.upscope.".concat(tld === "com" ? "io" : tld);
    if (routeKey.startsWith("hq.")) return "hq.upscope.".concat(tld === "com" ? "io" : tld);
    if (routeKey.startsWith("uv.")) return "userview.".concat(tld === "io" ? "com" : tld);
    if (routeKey.startsWith("ld.")) return "livedocument.".concat(tld === "io" ? "com" : tld);
    if (routeKey.startsWith("hs.")) return "helloscreen.".concat(tld === "io" ? "com" : tld);
    if (routeKey.startsWith("co.")) return "cobrowsingapi.".concat(tld === "io" ? "com" : tld);
    throw new Error("Unknown path prefix");
}
function $ca476fb97608ce0d$export$31e4419873013369(service) {
    return $ca476fb97608ce0d$export$15d6f2a5111c5634("".concat(service, ".root")) + "/";
}
function $ca476fb97608ce0d$export$27c132606dcf9711(url) {
    if (url.startsWith("/")) return $ca476fb97608ce0d$export$31e4419873013369("up").slice(0, -1) + url;
    if (url.startsWith($ca476fb97608ce0d$export$31e4419873013369("up")) || url.startsWith($ca476fb97608ce0d$export$31e4419873013369("uv")) || url.startsWith($ca476fb97608ce0d$export$31e4419873013369("hs")) || url.startsWith($ca476fb97608ce0d$export$31e4419873013369("hq")) || url.startsWith($ca476fb97608ce0d$export$31e4419873013369("ld")) || url.startsWith($ca476fb97608ce0d$export$31e4419873013369("co"))) return $ca476fb97608ce0d$export$bb654e07daaf8c3a("up.auth.loginRedirect", {
        redirectUrl: url
    });
    return $ca476fb97608ce0d$export$31e4419873013369("up");
}
function $ca476fb97608ce0d$export$bbf90bf88cf3cef8(origin) {
    var originRoot = origin + "/";
    return originRoot === $ca476fb97608ce0d$export$31e4419873013369("up") || originRoot === $ca476fb97608ce0d$export$31e4419873013369("uv") || originRoot === $ca476fb97608ce0d$export$31e4419873013369("hs") || originRoot === $ca476fb97608ce0d$export$31e4419873013369("hq") || originRoot === $ca476fb97608ce0d$export$31e4419873013369("ld") || originRoot === $ca476fb97608ce0d$export$31e4419873013369("co");
}
function $ca476fb97608ce0d$var$query(object) {
    var params = Object.entries(object).filter(function(_a) {
        var _b = $ca476fb97608ce0d$var$__read(_a, 2), key = _b[0], value = _b[1];
        return value !== null && value !== undefined;
    });
    if (params.length === 0) return "";
    return "?" + params.map(function(_a) {
        var _b = $ca476fb97608ce0d$var$__read(_a, 2), key = _b[0], value = _b[1];
        return "".concat($ca476fb97608ce0d$var$decamelize(key), "=").concat(encodeURIComponent(value));
    }).join("&");
}
var $ca476fb97608ce0d$export$f3336dfadaab17e6 = {
    helloscreen: "hs",
    userview: "uv",
    cobrowsingapi: "co",
    livedocument: "ld"
};

});
parcelRegister("3Ukkm", function(module, exports) {
// =========
// = humps =
// =========
// Underscore-to-camelCase converter (and vice versa)
// for strings and object keys
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
(function(global) {
    var _processKeys = function(convert, obj, options) {
        if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) return obj;
        var output, i = 0, l = 0;
        if (_isArray(obj)) {
            output = [];
            for(l = obj.length; i < l; i++)output.push(_processKeys(convert, obj[i], options));
        } else {
            output = {};
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
        return output;
    };
    // String conversion methods
    var separateWords = function(string, options) {
        options = options || {};
        var separator = options.separator || "_";
        var split = options.split || /(?=[A-Z])/;
        return string.split(split).join(separator);
    };
    var camelize = function(string) {
        if (_isNumerical(string)) return string;
        string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
            return chr ? chr.toUpperCase() : "";
        });
        // Ensure 1st char is always lowercase
        return string.substr(0, 1).toLowerCase() + string.substr(1);
    };
    var pascalize = function(string) {
        var camelized = camelize(string);
        // Ensure 1st char is always uppercase
        return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
    };
    var decamelize = function(string, options) {
        return separateWords(string, options).toLowerCase();
    };
    // Utilities
    // Taken from Underscore.js
    var toString = Object.prototype.toString;
    var _isFunction = function(obj) {
        return typeof obj === "function";
    };
    var _isObject = function(obj) {
        return obj === Object(obj);
    };
    var _isArray = function(obj) {
        return toString.call(obj) == "[object Array]";
    };
    var _isDate = function(obj) {
        return toString.call(obj) == "[object Date]";
    };
    var _isRegExp = function(obj) {
        return toString.call(obj) == "[object RegExp]";
    };
    var _isBoolean = function(obj) {
        return toString.call(obj) == "[object Boolean]";
    };
    // Performant way to determine if obj coerces to a number
    var _isNumerical = function(obj) {
        obj = obj - 0;
        return obj === obj;
    };
    // Sets up function which handles processing keys
    // allowing the convert function to be modified by a callback
    var _processor = function(convert, options) {
        var callback = options && "process" in options ? options.process : options;
        if (typeof callback !== "function") return convert;
        return function(string, options) {
            return callback(string, convert, options);
        };
    };
    var humps = {
        camelize: camelize,
        decamelize: decamelize,
        pascalize: pascalize,
        depascalize: decamelize,
        camelizeKeys: function(object, options) {
            return _processKeys(_processor(camelize, options), object);
        },
        decamelizeKeys: function(object, options) {
            return _processKeys(_processor(decamelize, options), object, options);
        },
        pascalizeKeys: function(object, options) {
            return _processKeys(_processor(pascalize, options), object);
        },
        depascalizeKeys: function() {
            return this.decamelizeKeys.apply(this, arguments);
        }
    };
    if (typeof define === "function" && define.amd) define(humps);
    else if (0, module.exports) module.exports = humps;
    else global.humps = humps;
})(module.exports);

});




parcelRegister("aRPX9", function(module, exports) {

$parcel$export(module.exports, "apiEndpoints", () => $7e972767fe283787$export$13c8cd43cddc209e);
$parcel$export(module.exports, "apiResponses", () => $7e972767fe283787$export$3d4f0eaec0f183f8);

var $7PUSW = parcelRequire("7PUSW");

var $gX1L4 = parcelRequire("gX1L4");

var $5S0bn = parcelRequire("5S0bn");

var $gsKrY = parcelRequire("gsKrY");

var $1O6bo = parcelRequire("1O6bo");

var $dF56t = parcelRequire("dF56t");

var $19wxB = parcelRequire("19wxB");
var $7e972767fe283787$var$__assign = undefined && undefined.__assign || function() {
    $7e972767fe283787$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7e972767fe283787$var$__assign.apply(this, arguments);
};
var $7e972767fe283787$export$13c8cd43cddc209e = $7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign({}, (0, $7PUSW.authEndpoints)), (0, $gX1L4.cobrowsingApiEndpoints)), (0, $5S0bn.helloScreenEndpoints)), (0, $19wxB.userViewEndpoints)), (0, $gsKrY.hqEndpoints)), (0, $1O6bo.onboardingEndpoints)), (0, $dF56t.settingsEndpoints));
var $7e972767fe283787$export$b7812f84c42840cc = $7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign({}, (0, $7PUSW.authRequests)), (0, $gX1L4.cobrowsingApiRequests)), (0, $5S0bn.helloScreenRequests)), (0, $19wxB.userViewRequests)), (0, $gsKrY.hqRequests)), (0, $1O6bo.onboardingRequests)), (0, $dF56t.settingsRequests));
var $7e972767fe283787$export$3d4f0eaec0f183f8 = $7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign($7e972767fe283787$var$__assign({}, (0, $7PUSW.authResponses)), (0, $gX1L4.cobrowsingApiResponses)), (0, $5S0bn.helloScreenResponses)), (0, $19wxB.userViewResponses)), (0, $gsKrY.hqResponses)), (0, $1O6bo.onboardingResponses)), (0, $dF56t.settingsResponses));

});
parcelRegister("7PUSW", function(module, exports) {

$parcel$export(module.exports, "authEndpoints", () => $5b496c0d272a66d2$export$cc566ccefa1c456f);
$parcel$export(module.exports, "authRequests", () => $5b496c0d272a66d2$export$f2da1839e231ce78);
$parcel$export(module.exports, "authResponses", () => $5b496c0d272a66d2$export$50acba3739d77ad9);

var $2zDt6 = parcelRequire("2zDt6");

var $lIQh8 = parcelRequire("lIQh8");

var $lbXII = parcelRequire("lbXII");

var $9JXBn = parcelRequire("9JXBn");

var $210qL = parcelRequire("210qL");

var $JRp7q = parcelRequire("JRp7q");
var $5b496c0d272a66d2$export$cc566ccefa1c456f = {
    "auth.join.setup": function(p) {
        return [
            "up",
            "get",
            "/join/".concat(p.teamUniqueIdentifier, "-").concat(p.teamDomain, "/status")
        ];
    },
    "auth.join.askInvite": function(p) {
        return [
            "up",
            "post",
            "/ask_to_join/".concat(p.teamUniqueIdentifier, "-").concat(p.teamDomain)
        ];
    },
    "auth.join.byEmail": function(p) {
        return [
            "up",
            "post",
            "/join/".concat(p.teamUniqueIdentifier, "-").concat(p.teamDomain, "/by_email")
        ];
    },
    "auth.logIn.create": function() {
        return [
            "up",
            "post",
            "/auth/login"
        ];
    },
    "auth.invite.accept": function(p) {
        return [
            "up",
            "post",
            "/auth/invites/".concat(p.inviteToken, "/accept")
        ];
    },
    "auth.invite.reject": function(p) {
        return [
            "up",
            "post",
            "/auth/invites/".concat(p.inviteToken, "/reject")
        ];
    },
    "auth.mfa.setup": function() {
        return [
            "up",
            "get",
            "/auth/mfa/setup/qr"
        ];
    },
    "auth.mfa.enable": function() {
        return [
            "up",
            "post",
            "/auth/mfa/setup"
        ];
    },
    "auth.accessTokens.create": function() {
        return [
            "up",
            "post",
            "/auth/tokens"
        ];
    },
    "up.teams.create": function() {
        return [
            "*",
            "post",
            "/settings/teams"
        ];
    },
    "auth.token.confirm": function(p) {
        return [
            "*",
            "post",
            "/t/".concat(p.token)
        ];
    },
    "auth.token.delete": function(p) {
        return [
            "*",
            "delete",
            "/t/".concat(p.token)
        ];
    }
};
var $5b496c0d272a66d2$export$f2da1839e231ce78 = {
    "auth.join.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        teamUniqueIdentifier: (0, $2zDt6.z).string()
    }),
    "auth.join.byEmail": (0, $2zDt6.z).object({
        emailUsername: (0, $2zDt6.z).string(),
        teamDomain: (0, $2zDt6.z).string(),
        teamUniqueIdentifier: (0, $2zDt6.z).string()
    }),
    "auth.join.askInvite": (0, $2zDt6.z).object({
        user: (0, $210qL.User).pick({
            name: true,
            email: true
        }),
        teamDomain: (0, $2zDt6.z).string(),
        teamUniqueIdentifier: (0, $2zDt6.z).string()
    }),
    "auth.logIn.create": (0, $2zDt6.z).union([
        (0, $2zDt6.z).object({
            email: (0, $210qL.User).shape.email,
            redirectUrl: (0, $2zDt6.z).string().optional(),
            noPassword: (0, $2zDt6.z).literal(true).optional(),
            password: (0, $2zDt6.z).string().optional(),
            mfaCode: (0, $2zDt6.z).string().optional()
        }),
        (0, $2zDt6.z).object({
            loginToken: (0, $2zDt6.z).string(),
            redirectUrl: (0, $2zDt6.z).string().optional(),
            mfaCode: (0, $2zDt6.z).string().optional()
        })
    ]),
    "auth.invite.accept": (0, $2zDt6.z).object({
        inviteToken: (0, $2zDt6.z).string()
    }),
    "auth.invite.reject": (0, $2zDt6.z).object({
        inviteToken: (0, $2zDt6.z).string()
    }),
    "auth.mfa.setup": (0, $2zDt6.z).undefined(),
    "auth.mfa.enable": (0, $2zDt6.z).object({
        code: (0, $2zDt6.z).string()
    }),
    "auth.accessTokens.create": (0, $2zDt6.z).undefined(),
    "up.teams.create": (0, $2zDt6.z).object({
        team: (0, $2zDt6.z).object({
            subIdentifier: (0, $2zDt6.z).string(),
            product: (0, $lIQh8.Product),
            billingOwnerId: (0, $2zDt6.z).custom().optional()
        })
    }),
    "auth.token.confirm": (0, $2zDt6.z).object({
        token: (0, $2zDt6.z).string()
    }),
    "auth.token.delete": (0, $2zDt6.z).object({
        token: (0, $2zDt6.z).string()
    })
};
var $5b496c0d272a66d2$export$50acba3739d77ad9 = {
    "auth.join.setup": (0, $2zDt6.z).union([
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("already_a_member")
        }),
        (0, $JRp7q.SuccessResponse).extend({
            product: (0, $lIQh8.Product).nullable(),
            inviteRequired: (0, $2zDt6.z).boolean(),
            samlLink: (0, $lbXII.Url).nullable(),
            joinByEmailDomain: (0, $2zDt6.z).string().nullable(),
            joinBySso: (0, $2zDt6.z).object({
                name: (0, $2zDt6.z).string(),
                link: (0, $lbXII.Url)
            }).array()
        }).strict()
    ]),
    "auth.join.byEmail": (0, $2zDt6.z).union([
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).enum([
                "missing_email",
                "existing_user",
                "invite_required",
                "invalid_email"
            ])
        }),
        (0, $JRp7q.SuccessResponse)
    ]),
    "auth.join.askInvite": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("record_not_found")
    })),
    "auth.logIn.create": (0, $2zDt6.z).union([
        (0, $JRp7q.SuccessResponse).extend({
            authStatus: (0, $2zDt6.z).enum([
                "authenticated",
                "check_email"
            ])
        }),
        (0, $JRp7q.SuccessResponse).extend({
            authStatus: (0, $2zDt6.z).literal("login_link"),
            loginLink: (0, $lbXII.Url)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("login_error"),
            authStatus: (0, $2zDt6.z).enum([
                "invalid_email",
                "invalid_token",
                "invalid_password",
                "password_required",
                "invalid_mfa_code",
                "mfa_code_required"
            ])
        })
    ]),
    "auth.invite.accept": (0, $JRp7q.SuccessResponse),
    "auth.invite.reject": (0, $JRp7q.SuccessResponse),
    "auth.mfa.setup": (0, $JRp7q.SuccessResponse).extend({
        qrUrl: (0, $2zDt6.z).string(),
        force: (0, $2zDt6.z).boolean()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("already_enabled")
    })),
    "auth.mfa.enable": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("invalid_code")
    })),
    "auth.accessTokens.create": (0, $JRp7q.SuccessResponse).extend({
        code: (0, $2zDt6.z).string()
    }),
    "up.teams.create": (0, $JRp7q.SuccessResponse).extend({
        team: (0, $9JXBn.TeamBaseData)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).enum([
            "domain_already_in_use",
            "invalid_billing_owner"
        ])
    })),
    "auth.token.confirm": (0, $JRp7q.SuccessResponse).extend({
        redirect: (0, $2zDt6.z).boolean(),
        redirectTo: (0, $2zDt6.z).custom().optional()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).enum([
            "wrong_link",
            "already_logged_in",
            "not_found"
        ]).nullable()
    })),
    "auth.token.delete": (0, $JRp7q.SuccessResponse)
};

});
parcelRegister("2zDt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "z", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
var $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($9ee9c7b494d01fc9$export$7debb50ef11d5e0b || ($9ee9c7b494d01fc9$export$7debb50ef11d5e0b = {}));
var $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 || ($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 = {}));
const $9ee9c7b494d01fc9$export$5716da67bfaa244d = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $9ee9c7b494d01fc9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined;
        case "string":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan : $9ee9c7b494d01fc9$export$5716da67bfaa244d.number;
        case "boolean":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean;
        case "function":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.function;
        case "bigint":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.array;
            if (data === null) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.date;
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.object;
        default:
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.unknown;
    }
};
const $9ee9c7b494d01fc9$export$5ba560653e4a1035 = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $9ee9c7b494d01fc9$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $9ee9c7b494d01fc9$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $9ee9c7b494d01fc9$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$9ee9c7b494d01fc9$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues);
    return error;
};
const $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $9ee9c7b494d01fc9$var$overrideErrorMap = $9ee9c7b494d01fc9$export$341b0b6e0a6f5099;
function $9ee9c7b494d01fc9$export$1097a8289cfd22d7(map) {
    $9ee9c7b494d01fc9$var$overrideErrorMap = map;
}
function $9ee9c7b494d01fc9$export$32f27c719778d4c4() {
    return $9ee9c7b494d01fc9$var$overrideErrorMap;
}
const $9ee9c7b494d01fc9$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $9ee9c7b494d01fc9$export$1526d2e05f74572 = [];
function $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $9ee9c7b494d01fc9$export$32f27c719778d4c4();
    const issue = $9ee9c7b494d01fc9$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 ? undefined : $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $9ee9c7b494d01fc9$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $9ee9c7b494d01fc9$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $9ee9c7b494d01fc9$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $9ee9c7b494d01fc9$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $9ee9c7b494d01fc9$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $9ee9c7b494d01fc9$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $9ee9c7b494d01fc9$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9ee9c7b494d01fc9$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $9ee9c7b494d01fc9$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($9ee9c7b494d01fc9$var$errorUtil || ($9ee9c7b494d01fc9$var$errorUtil = {}));
var $9ee9c7b494d01fc9$var$_ZodEnum_cache, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache;
class $9ee9c7b494d01fc9$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $9ee9c7b494d01fc9$var$handleResult = (ctx, result)=>{
    if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $9ee9c7b494d01fc9$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $9ee9c7b494d01fc9$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $9ee9c7b494d01fc9$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $9ee9c7b494d01fc9$export$66b0c798a395271f({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $9ee9c7b494d01fc9$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $9ee9c7b494d01fc9$var$cuid2Regex = /^[0-9a-z]+$/;
const $9ee9c7b494d01fc9$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $9ee9c7b494d01fc9$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $9ee9c7b494d01fc9$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $9ee9c7b494d01fc9$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $9ee9c7b494d01fc9$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $9ee9c7b494d01fc9$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $9ee9c7b494d01fc9$var$emojiRegex;
// faster, simpler, safer
const $9ee9c7b494d01fc9$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $9ee9c7b494d01fc9$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $9ee9c7b494d01fc9$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $9ee9c7b494d01fc9$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $9ee9c7b494d01fc9$var$dateRegex = new RegExp(`^${$9ee9c7b494d01fc9$var$dateRegexSource}$`);
function $9ee9c7b494d01fc9$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $9ee9c7b494d01fc9$var$timeRegex(args) {
    return new RegExp(`^${$9ee9c7b494d01fc9$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $9ee9c7b494d01fc9$export$a4b563879add27a(args) {
    let regex = `${$9ee9c7b494d01fc9$var$dateRegexSource}T${$9ee9c7b494d01fc9$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $9ee9c7b494d01fc9$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $9ee9c7b494d01fc9$export$1230eb29b8d3b502 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$9ee9c7b494d01fc9$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$9ee9c7b494d01fc9$var$emojiRegex) $9ee9c7b494d01fc9$var$emojiRegex = new RegExp($9ee9c7b494d01fc9$var$_emojiRegex, "u");
                if (!$9ee9c7b494d01fc9$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$9ee9c7b494d01fc9$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$9ee9c7b494d01fc9$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$9ee9c7b494d01fc9$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$9ee9c7b494d01fc9$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$9ee9c7b494d01fc9$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $9ee9c7b494d01fc9$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $9ee9c7b494d01fc9$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $9ee9c7b494d01fc9$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$9ee9c7b494d01fc9$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$9ee9c7b494d01fc9$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$9ee9c7b494d01fc9$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $9ee9c7b494d01fc9$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $9ee9c7b494d01fc9$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $9ee9c7b494d01fc9$export$5b070a55c0c43e09 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($9ee9c7b494d01fc9$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$67d741fd70ff98f4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$723d146f80596191 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$723d146f80596191.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$723d146f80596191({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e974be33bdc55521 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$9ee9c7b494d01fc9$export$e974be33bdc55521.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDate,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bcc3b40f6b638044 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$bcc3b40f6b638044.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$bcc3b40f6b638044({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSymbol,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$4e780e961c30340d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$4e780e961c30340d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$4e780e961c30340d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUndefined,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a96281f914484f2d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$a96281f914484f2d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$a96281f914484f2d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNull,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodAny,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$ef3b1bb1630977ae extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$ef3b1bb1630977ae({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnknown,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
}
$9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNever,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7d39f5df85f21031 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$7d39f5df85f21031.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$7d39f5df85f21031({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodVoid,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7acfc3e64785411 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big : $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$7acfc3e64785411.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodArray,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$deepPartialify(schema) {
    if (schema instanceof $9ee9c7b494d01fc9$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(fieldSchema));
        }
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $9ee9c7b494d01fc9$export$7acfc3e64785411) return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        ...schema._def,
        type: $9ee9c7b494d01fc9$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3) return $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$9ee9c7b494d01fc9$var$deepPartialify(item)));
    else return schema;
}
class $9ee9c7b494d01fc9$export$736315c5b55efbad extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $9ee9c7b494d01fc9$var$errorUtil.errToObj;
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $9ee9c7b494d01fc9$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $9ee9c7b494d01fc9$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $9ee9c7b494d01fc9$var$createZodEnum($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$9ee9c7b494d01fc9$export$736315c5b55efbad.create = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a8b236cb5070a311 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(result.ctx.common.issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$9ee9c7b494d01fc9$export$a8b236cb5070a311.create = (types, params)=>{
    return new $9ee9c7b494d01fc9$export$a8b236cb5070a311({
        options: types,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnion,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $9ee9c7b494d01fc9$var$getDiscriminator = (type)=>{
    if (type instanceof $9ee9c7b494d01fc9$export$378d0cfce37406e6) return $9ee9c7b494d01fc9$var$getDiscriminator(type.schema);
    else if (type instanceof $9ee9c7b494d01fc9$export$a60af00cc0ce2582) return $9ee9c7b494d01fc9$var$getDiscriminator(type.innerType());
    else if (type instanceof $9ee9c7b494d01fc9$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $9ee9c7b494d01fc9$export$bb19b37874861e7e) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $9ee9c7b494d01fc9$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return [
        undefined,
        ...$9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return [
        null,
        ...$9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$66b0c798a395271f) return $9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap());
    else if (type instanceof $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a) return $9ee9c7b494d01fc9$var$getDiscriminator(type.unwrap());
    else if (type instanceof $9ee9c7b494d01fc9$export$75a44ec6249ac76b) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $9ee9c7b494d01fc9$export$5ef2424805ac76a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $9ee9c7b494d01fc9$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $9ee9c7b494d01fc9$export$5ef2424805ac76a3({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
function $9ee9c7b494d01fc9$var$mergeValues(a, b) {
    const aType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(a);
    const bType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
        const bKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $9ee9c7b494d01fc9$export$c02deaf0bb5203d4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($9ee9c7b494d01fc9$export$afa861e3c5730743(parsedLeft) || $9ee9c7b494d01fc9$export$afa861e3c5730743(parsedRight)) return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            const merged = $9ee9c7b494d01fc9$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            }
            if ($9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedLeft) || $9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $9ee9c7b494d01fc9$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodIntersection,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a2acc09968cb4b7f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $9ee9c7b494d01fc9$export$19342e026b58ebb7) return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(third)
        });
        return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(second)
        });
    }
}
class $9ee9c7b494d01fc9$export$163b6a2b712d9542 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.map) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$9ee9c7b494d01fc9$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodMap,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$977057706f816712 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.set) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$977057706f816712.create = (valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSet,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$d4602ba55673f53c extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.function) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $9ee9c7b494d01fc9$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            args: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(items).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            args: args ? args : $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create([]).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create()),
            returns: returns || $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create(),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodFunction,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
class $9ee9c7b494d01fc9$export$378d0cfce37406e6 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$9ee9c7b494d01fc9$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $9ee9c7b494d01fc9$export$378d0cfce37406e6({
        getter: getter,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLazy,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7e44096782a165d3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$9ee9c7b494d01fc9$export$7e44096782a165d3.create = (value, params)=>{
    return new $9ee9c7b494d01fc9$export$7e44096782a165d3({
        value: value,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLiteral,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$createZodEnum(values, params) {
    return new $9ee9c7b494d01fc9$export$d325d1f0e1c20179({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
}
class $9ee9c7b494d01fc9$export$d325d1f0e1c20179 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $9ee9c7b494d01fc9$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, "f")) $9ee9c7b494d01fc9$var$__classPrivateFieldSet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$9ee9c7b494d01fc9$var$_ZodEnum_cache = new WeakMap();
$9ee9c7b494d01fc9$export$d325d1f0e1c20179.create = $9ee9c7b494d01fc9$var$createZodEnum;
class $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string && ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, "f")) $9ee9c7b494d01fc9$var$__classPrivateFieldSet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, new Set($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$9ee9c7b494d01fc9$var$__classPrivateFieldGet(this, $9ee9c7b494d01fc9$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$9ee9c7b494d01fc9$var$_ZodNativeEnum_cache = new WeakMap();
$9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNativeEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$3f196b0127d6e50a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$9ee9c7b494d01fc9$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$3f196b0127d6e50a({
        type: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPromise,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a60af00cc0ce2582 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $9ee9c7b494d01fc9$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aa56fec1e9d629b8 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodOptional,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aaac0b8b429cef5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNullable,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bb19b37874861e7e extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$bb19b37874861e7e.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$75a44ec6249ac76b extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$26ccfa0145e8511f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$9ee9c7b494d01fc9$export$26ccfa0145e8511f.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$26ccfa0145e8511f({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNaN,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $9ee9c7b494d01fc9$export$66b0c798a395271f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $9ee9c7b494d01fc9$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodReadonly,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create();
}
const $9ee9c7b494d01fc9$export$1ee8ee30835eab8b = {
    object: $9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate
};
var $9ee9c7b494d01fc9$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($9ee9c7b494d01fc9$export$558106ce543bd011 || ($9ee9c7b494d01fc9$export$558106ce543bd011 = {}));
const $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$9ee9c7b494d01fc9$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $9ee9c7b494d01fc9$export$22b082955e083ec3 = $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create;
const $9ee9c7b494d01fc9$export$98e628dec113755e = $9ee9c7b494d01fc9$export$5b070a55c0c43e09.create;
const $9ee9c7b494d01fc9$export$9e06de0973666692 = $9ee9c7b494d01fc9$export$26ccfa0145e8511f.create;
const $9ee9c7b494d01fc9$export$a0f65b52274bcc00 = $9ee9c7b494d01fc9$export$67d741fd70ff98f4.create;
const $9ee9c7b494d01fc9$export$4a21f16c33752377 = $9ee9c7b494d01fc9$export$723d146f80596191.create;
const $9ee9c7b494d01fc9$export$324d90190a8b822a = $9ee9c7b494d01fc9$export$e974be33bdc55521.create;
const $9ee9c7b494d01fc9$export$8f701197936bc2a6 = $9ee9c7b494d01fc9$export$bcc3b40f6b638044.create;
const $9ee9c7b494d01fc9$export$1db45310990710a5 = $9ee9c7b494d01fc9$export$4e780e961c30340d.create;
const $9ee9c7b494d01fc9$export$7b1b591b262c240 = $9ee9c7b494d01fc9$export$a96281f914484f2d.create;
const $9ee9c7b494d01fc9$export$4154a199d7d90455 = $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create;
const $9ee9c7b494d01fc9$export$19282c40b967aec6 = $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create;
const $9ee9c7b494d01fc9$export$b3e22bcfd64c1022 = $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create;
const $9ee9c7b494d01fc9$export$490e536ee7389aeb = $9ee9c7b494d01fc9$export$7d39f5df85f21031.create;
const $9ee9c7b494d01fc9$export$2f23118c22fb2630 = $9ee9c7b494d01fc9$export$7acfc3e64785411.create;
const $9ee9c7b494d01fc9$export$be5493f9613cbbe = $9ee9c7b494d01fc9$export$736315c5b55efbad.create;
const $9ee9c7b494d01fc9$export$8fb0df5f40d0b477 = $9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate;
const $9ee9c7b494d01fc9$export$971dd5b0dfd021b6 = $9ee9c7b494d01fc9$export$a8b236cb5070a311.create;
const $9ee9c7b494d01fc9$export$4b888e40c4ee26dd = $9ee9c7b494d01fc9$export$5ef2424805ac76a3.create;
const $9ee9c7b494d01fc9$export$bc86dfbf7795668c = $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create;
const $9ee9c7b494d01fc9$export$65e3907585753458 = $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create;
const $9ee9c7b494d01fc9$export$e5185e241753e543 = $9ee9c7b494d01fc9$export$a2acc09968cb4b7f.create;
const $9ee9c7b494d01fc9$export$871de8747c9eaa88 = $9ee9c7b494d01fc9$export$163b6a2b712d9542.create;
const $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be = $9ee9c7b494d01fc9$export$977057706f816712.create;
const $9ee9c7b494d01fc9$export$44e51c8aac7c2deb = $9ee9c7b494d01fc9$export$d4602ba55673f53c.create;
const $9ee9c7b494d01fc9$export$488013bae63b21da = $9ee9c7b494d01fc9$export$378d0cfce37406e6.create;
const $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0 = $9ee9c7b494d01fc9$export$7e44096782a165d3.create;
const $9ee9c7b494d01fc9$export$78a99c8d44d72635 = $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create;
const $9ee9c7b494d01fc9$export$6fe7eca19ebe5199 = $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create;
const $9ee9c7b494d01fc9$export$c957ef27a0ebfd4 = $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create;
const $9ee9c7b494d01fc9$export$dc573d8a6576cdb3 = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.create;
const $9ee9c7b494d01fc9$export$516e28dec6a4b6d4 = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create;
const $9ee9c7b494d01fc9$export$133fc36489ac9add = $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create;
const $9ee9c7b494d01fc9$export$fc37fe19dfda43ee = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess;
const $9ee9c7b494d01fc9$export$43f28b24e1eb8181 = $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create;
const $9ee9c7b494d01fc9$export$3b3d07727c5b702c = ()=>$9ee9c7b494d01fc9$export$22b082955e083ec3().optional();
const $9ee9c7b494d01fc9$export$eb150471a61fced6 = ()=>$9ee9c7b494d01fc9$export$98e628dec113755e().optional();
const $9ee9c7b494d01fc9$export$269251733cdcbbf1 = ()=>$9ee9c7b494d01fc9$export$4a21f16c33752377().optional();
const $9ee9c7b494d01fc9$export$8c14e57e778d3873 = {
    string: (arg)=>$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$9ee9c7b494d01fc9$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$9ee9c7b494d01fc9$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $9ee9c7b494d01fc9$export$96c94437c95d7862 = $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
var $9ee9c7b494d01fc9$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $9ee9c7b494d01fc9$export$341b0b6e0a6f5099,
    setErrorMap: $9ee9c7b494d01fc9$export$1097a8289cfd22d7,
    getErrorMap: $9ee9c7b494d01fc9$export$32f27c719778d4c4,
    makeIssue: $9ee9c7b494d01fc9$export$244a85fde9c419ed,
    EMPTY_PATH: $9ee9c7b494d01fc9$export$1526d2e05f74572,
    addIssueToContext: $9ee9c7b494d01fc9$export$db7caee60e5d514d,
    ParseStatus: $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f,
    INVALID: $9ee9c7b494d01fc9$export$9a105a556e65c2c0,
    DIRTY: $9ee9c7b494d01fc9$export$325a211da9693fcf,
    OK: $9ee9c7b494d01fc9$export$c6813a8d51f77eaf,
    isAborted: $9ee9c7b494d01fc9$export$afa861e3c5730743,
    isDirty: $9ee9c7b494d01fc9$export$910b6cdd390341b3,
    isValid: $9ee9c7b494d01fc9$export$1ea939691cdc45b8,
    isAsync: $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e,
    get util () {
        return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $9ee9c7b494d01fc9$export$5716da67bfaa244d,
    getParsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a,
    ZodType: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    datetimeRegex: $9ee9c7b494d01fc9$export$a4b563879add27a,
    ZodString: $9ee9c7b494d01fc9$export$1230eb29b8d3b502,
    ZodNumber: $9ee9c7b494d01fc9$export$5b070a55c0c43e09,
    ZodBigInt: $9ee9c7b494d01fc9$export$67d741fd70ff98f4,
    ZodBoolean: $9ee9c7b494d01fc9$export$723d146f80596191,
    ZodDate: $9ee9c7b494d01fc9$export$e974be33bdc55521,
    ZodSymbol: $9ee9c7b494d01fc9$export$bcc3b40f6b638044,
    ZodUndefined: $9ee9c7b494d01fc9$export$4e780e961c30340d,
    ZodNull: $9ee9c7b494d01fc9$export$a96281f914484f2d,
    ZodAny: $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb,
    ZodUnknown: $9ee9c7b494d01fc9$export$ef3b1bb1630977ae,
    ZodNever: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5,
    ZodVoid: $9ee9c7b494d01fc9$export$7d39f5df85f21031,
    ZodArray: $9ee9c7b494d01fc9$export$7acfc3e64785411,
    ZodObject: $9ee9c7b494d01fc9$export$736315c5b55efbad,
    ZodUnion: $9ee9c7b494d01fc9$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $9ee9c7b494d01fc9$export$5ef2424805ac76a3,
    ZodIntersection: $9ee9c7b494d01fc9$export$c02deaf0bb5203d4,
    ZodTuple: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3,
    ZodRecord: $9ee9c7b494d01fc9$export$a2acc09968cb4b7f,
    ZodMap: $9ee9c7b494d01fc9$export$163b6a2b712d9542,
    ZodSet: $9ee9c7b494d01fc9$export$977057706f816712,
    ZodFunction: $9ee9c7b494d01fc9$export$d4602ba55673f53c,
    ZodLazy: $9ee9c7b494d01fc9$export$378d0cfce37406e6,
    ZodLiteral: $9ee9c7b494d01fc9$export$7e44096782a165d3,
    ZodEnum: $9ee9c7b494d01fc9$export$d325d1f0e1c20179,
    ZodNativeEnum: $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56,
    ZodPromise: $9ee9c7b494d01fc9$export$3f196b0127d6e50a,
    ZodEffects: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodTransformer: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodOptional: $9ee9c7b494d01fc9$export$aa56fec1e9d629b8,
    ZodNullable: $9ee9c7b494d01fc9$export$aaac0b8b429cef5,
    ZodDefault: $9ee9c7b494d01fc9$export$bb19b37874861e7e,
    ZodCatch: $9ee9c7b494d01fc9$export$75a44ec6249ac76b,
    ZodNaN: $9ee9c7b494d01fc9$export$26ccfa0145e8511f,
    BRAND: $9ee9c7b494d01fc9$export$cf2deea74cde46b4,
    ZodBranded: $9ee9c7b494d01fc9$export$66b0c798a395271f,
    ZodPipeline: $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da,
    ZodReadonly: $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a,
    custom: $9ee9c7b494d01fc9$export$4c00f665f0d4b443,
    Schema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodSchema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    late: $9ee9c7b494d01fc9$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $9ee9c7b494d01fc9$export$558106ce543bd011;
    },
    coerce: $9ee9c7b494d01fc9$export$8c14e57e778d3873,
    any: $9ee9c7b494d01fc9$export$4154a199d7d90455,
    array: $9ee9c7b494d01fc9$export$2f23118c22fb2630,
    bigint: $9ee9c7b494d01fc9$export$a0f65b52274bcc00,
    boolean: $9ee9c7b494d01fc9$export$4a21f16c33752377,
    date: $9ee9c7b494d01fc9$export$324d90190a8b822a,
    discriminatedUnion: $9ee9c7b494d01fc9$export$4b888e40c4ee26dd,
    effect: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    "enum": $9ee9c7b494d01fc9$export$78a99c8d44d72635,
    "function": $9ee9c7b494d01fc9$export$44e51c8aac7c2deb,
    "instanceof": $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5,
    intersection: $9ee9c7b494d01fc9$export$bc86dfbf7795668c,
    lazy: $9ee9c7b494d01fc9$export$488013bae63b21da,
    literal: $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0,
    map: $9ee9c7b494d01fc9$export$871de8747c9eaa88,
    nan: $9ee9c7b494d01fc9$export$9e06de0973666692,
    nativeEnum: $9ee9c7b494d01fc9$export$6fe7eca19ebe5199,
    never: $9ee9c7b494d01fc9$export$b3e22bcfd64c1022,
    "null": $9ee9c7b494d01fc9$export$7b1b591b262c240,
    nullable: $9ee9c7b494d01fc9$export$133fc36489ac9add,
    number: $9ee9c7b494d01fc9$export$98e628dec113755e,
    object: $9ee9c7b494d01fc9$export$be5493f9613cbbe,
    oboolean: $9ee9c7b494d01fc9$export$269251733cdcbbf1,
    onumber: $9ee9c7b494d01fc9$export$eb150471a61fced6,
    optional: $9ee9c7b494d01fc9$export$516e28dec6a4b6d4,
    ostring: $9ee9c7b494d01fc9$export$3b3d07727c5b702c,
    pipeline: $9ee9c7b494d01fc9$export$43f28b24e1eb8181,
    preprocess: $9ee9c7b494d01fc9$export$fc37fe19dfda43ee,
    promise: $9ee9c7b494d01fc9$export$c957ef27a0ebfd4,
    record: $9ee9c7b494d01fc9$export$e5185e241753e543,
    set: $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be,
    strictObject: $9ee9c7b494d01fc9$export$8fb0df5f40d0b477,
    string: $9ee9c7b494d01fc9$export$22b082955e083ec3,
    symbol: $9ee9c7b494d01fc9$export$8f701197936bc2a6,
    transformer: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    tuple: $9ee9c7b494d01fc9$export$65e3907585753458,
    "undefined": $9ee9c7b494d01fc9$export$1db45310990710a5,
    union: $9ee9c7b494d01fc9$export$971dd5b0dfd021b6,
    unknown: $9ee9c7b494d01fc9$export$19282c40b967aec6,
    "void": $9ee9c7b494d01fc9$export$490e536ee7389aeb,
    NEVER: $9ee9c7b494d01fc9$export$96c94437c95d7862,
    ZodIssueCode: $9ee9c7b494d01fc9$export$5ba560653e4a1035,
    quotelessJson: $9ee9c7b494d01fc9$export$913eddeaf297cfea,
    ZodError: $9ee9c7b494d01fc9$export$f98dac4b251ab333
});

});

parcelRegister("lIQh8", function(module, exports) {

$parcel$export(module.exports, "Product", () => $fd0641dbd4dc0649$export$264ad599d7cef668);

var $2zDt6 = parcelRequire("2zDt6");
var $fd0641dbd4dc0649$export$264ad599d7cef668 = (0, $2zDt6.z).enum([
    "helloscreen",
    "cobrowsingapi",
    "userview",
    "livedocument"
]);

});

parcelRegister("lbXII", function(module, exports) {

$parcel$export(module.exports, "Url", () => $f6d8f33cc34fb6ea$export$59d795186a5d3f58);

var $2zDt6 = parcelRequire("2zDt6");
var $f6d8f33cc34fb6ea$export$59d795186a5d3f58 = (0, $2zDt6.z).union([
    (0, $2zDt6.z).string().startsWith("https://"),
    (0, $2zDt6.z).string().startsWith("http://")
]);

});

parcelRegister("9JXBn", function(module, exports) {

$parcel$export(module.exports, "Team", () => $71768cb662e3a945$export$3e5d0af8e738b082);
$parcel$export(module.exports, "TeamBaseData", () => $71768cb662e3a945$export$4393a2dbad098773);
$parcel$export(module.exports, "TeamBillingInfoData", () => $71768cb662e3a945$export$b1076635842ecbd7);

var $2zDt6 = parcelRequire("2zDt6");

var $358CX = parcelRequire("358CX");

var $iUj1w = parcelRequire("iUj1w");

var $4gUyz = parcelRequire("4gUyz");

var $tzjy8 = parcelRequire("tzjy8");

var $l0osQ = parcelRequire("l0osQ");

var $4Y9rk = parcelRequire("4Y9rk");

var $4cd6R = parcelRequire("4cd6R");

var $lIQh8 = parcelRequire("lIQh8");

var $3rRoQ = parcelRequire("3rRoQ");

var $gCU2M = parcelRequire("gCU2M");

var $7MlKx = parcelRequire("7MlKx");

var $210qL = parcelRequire("210qL");
var $71768cb662e3a945$export$3e5d0af8e738b082 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).custom(),
    createdAt: (0, $2zDt6.z).coerce.date(),
    deletable: (0, $2zDt6.z).boolean(),
    domain: (0, $2zDt6.z).string(),
    emailDomain: (0, $2zDt6.z).string().nullable(),
    apiKey: (0, $2zDt6.z).string(),
    uniqueIdentifier: (0, $2zDt6.z).string(),
    paying: (0, $2zDt6.z).boolean(),
    trialEndsOn: (0, $358CX.zDay).nullable(),
    trialConvertsAutomatically: (0, $2zDt6.z).boolean().nullable(),
    beta: (0, $2zDt6.z).boolean(),
    baa: (0, $2zDt6.z).boolean(),
    companyId: (0, $2zDt6.z).custom(),
    nextPlanLicenses: (0, $2zDt6.z).number().nullable(),
    onboardingCompleted: (0, $2zDt6.z).boolean(),
    products: (0, $2zDt6.z).array((0, $lIQh8.Product)),
    signupProduct: (0, $lIQh8.Product).nullable(),
    usageTrendData: (0, $3rRoQ.UsageTrendData).nullable(),
    usageTrend: (0, $3rRoQ.UsageTrend).nullable(),
    yearlyValue: (0, $2zDt6.z).number(),
    activeLicenses: (0, $2zDt6.z).number(),
    licensesNeeded: (0, $2zDt6.z).number(),
    autoAdjustLicenses: (0, $2zDt6.z).enum([
        "off",
        "increase",
        "increase_and_decrease",
        "not_allowed",
        "bill_monthly"
    ]),
    onTrial: (0, $2zDt6.z).boolean(),
    trialStartedOn: (0, $358CX.zDay).nullable(),
    cancelling: (0, $2zDt6.z).boolean(),
    plan: (0, $7MlKx.Plan).nullable(),
    planDetails: (0, $2zDt6.z).custom().nullable(),
    nextPlan: (0, $7MlKx.Plan).nullable(),
    nextPlanDetails: (0, $2zDt6.z).custom().nullable(),
    nextPlanActivatesOn: (0, $358CX.zDay).nullable(),
    sessionTimeCreditSecondsLeft: (0, $2zDt6.z).number().nullable(),
    contractAutoRenews: (0, $2zDt6.z).boolean().nullable(),
    contractTerminatesOn: (0, $358CX.zDay).nullable(),
    banReason: (0, $2zDt6.z).enum([
        "delinquent",
        "security",
        "other"
    ]).nullable(),
    onPremise: (0, $2zDt6.z).boolean(),
    taxExempt: (0, $2zDt6.z).boolean(),
    onPremiseRequireServerValidation: (0, $2zDt6.z).boolean(),
    onPremiseAllowedDomains: (0, $2zDt6.z).array((0, $2zDt6.z).string()).nullable(),
    newMembersGracePeriodDays: (0, $2zDt6.z).number(),
    canMakePlanChanges: (0, $2zDt6.z).boolean(),
    billingPausedUntil: (0, $2zDt6.z).coerce.date().nullable(),
    billingPeriodEndsOn: (0, $358CX.zDay).nullable(),
    freeAccount: (0, $2zDt6.z).boolean(),
    invoiceName: (0, $2zDt6.z).string().nullable(),
    invoiceAddress: (0, $2zDt6.z).string().nullable(),
    invoiceCountry: (0, $4gUyz.CountryCode).nullable(),
    country: (0, $4gUyz.CountryCode).nullable(),
    invoiceEmail: (0, $2zDt6.z).string().nullable(),
    invoiceZip: (0, $2zDt6.z).string().nullable(),
    invoiceState: (0, $gCU2M.UsStateCode).nullable(),
    vatNumber: (0, $2zDt6.z).string().nullable(),
    invoiceDaysUntilDue: (0, $2zDt6.z).number(),
    banned: (0, $2zDt6.z).boolean(),
    trialProduct: (0, $lIQh8.Product).nullable(),
    membersCount: (0, $2zDt6.z).number(),
    subscriptionPaused: (0, $2zDt6.z).boolean(),
    subscribedAt: (0, $2zDt6.z).coerce.date().nullable(),
    subscriptionEndsAt: (0, $2zDt6.z).coerce.date().nullable(),
    taxRate: (0, $2zDt6.z).number(),
    lastCustomerSuccessCheckupAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastCustomerSuccessCheckupRating: (0, $tzjy8.CustomerSuccessRating).nullable(),
    currentCustomerSuccessStage: (0, $l0osQ.CustomerSuccessStage),
    currency: (0, $2zDt6.z).enum([
        "usd",
        "gbp",
        "eur"
    ]).nullable(),
    customerSuccessStageChangeableTo: (0, $2zDt6.z).array((0, $l0osQ.CustomerSuccessStage)),
    customerSuccessCheckupDue: (0, $2zDt6.z).boolean(),
    customerSuccessCheckupSnoozedUntil: (0, $2zDt6.z).coerce.date().nullable(),
    csUsageTrendData: (0, $3rRoQ.UsageTrendData).nullable(),
    customerSuccessManager: (0, $210qL.UserBaseData).nullable(),
    csInstallationStatus: (0, $4Y9rk.InstallationStatus),
    installationStatus: (0, $4Y9rk.InstallationStatus),
    lastRequestAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastUsedAt: (0, $2zDt6.z).coerce.date().nullable(),
    isInstalled: (0, $2zDt6.z).boolean(),
    stillInstalled: (0, $2zDt6.z).boolean(),
    isInstalledLive: (0, $2zDt6.z).boolean(),
    unsubscribedAt: (0, $2zDt6.z).coerce.date().nullable(),
    billingOnboardingCompleted: (0, $2zDt6.z).boolean(),
    nextBillingPoint: (0, $358CX.zDay).nullable(),
    settingSessionTimeCreditAutoTopUpEnabled: (0, $2zDt6.z).boolean(),
    settingSessionTimeCreditAutoTopUpTrigger: (0, $2zDt6.z).number(),
    settingSessionTimeCreditAutoTopUpMultiplier: (0, $2zDt6.z).number(),
    paymentSourceData: (0, $4cd6R.PaymentSourceData).nullable(),
    billingOwner: (0, $2zDt6.z).object({
        id: (0, $2zDt6.z).string(),
        domain: (0, $2zDt6.z).string(),
        uniqueIdentifier: (0, $2zDt6.z).string(),
        type: (0, $2zDt6.z).literal("team")
    }).nullable(),
    billingSubaccounts: (0, $2zDt6.z).array((0, $2zDt6.z).object({
        id: (0, $2zDt6.z).string(),
        domain: (0, $2zDt6.z).string(),
        uniqueIdentifier: (0, $2zDt6.z).string(),
        type: (0, $2zDt6.z).literal("team")
    })),
    owner: (0, $210qL.User).pick({
        id: true,
        email: true,
        name: true,
        type: true
    }),
    ownerId: (0, $2zDt6.z).custom(),
    type: (0, $2zDt6.z).literal("team")
});
var $71768cb662e3a945$export$4393a2dbad098773 = $71768cb662e3a945$export$3e5d0af8e738b082.pick({
    id: true,
    domain: true,
    uniqueIdentifier: true,
    companyId: true
});
var $71768cb662e3a945$export$5d12e34d4980a6be = $71768cb662e3a945$export$4393a2dbad098773.merge($71768cb662e3a945$export$3e5d0af8e738b082.pick({
    customerSuccessManager: true,
    createdAt: true,
    activeLicenses: true,
    nextPlanLicenses: true,
    apiKey: true,
    licensesNeeded: true,
    autoAdjustLicenses: true,
    onTrial: true,
    trialEndsOn: true,
    currency: true,
    trialStartedOn: true,
    trialConvertsAutomatically: true,
    cancelling: true,
    plan: true,
    planDetails: true,
    nextPlan: true,
    nextPlanDetails: true,
    nextPlanActivatesOn: true,
    sessionTimeCreditSecondsLeft: true,
    contractAutoRenews: true,
    contractTerminatesOn: true,
    beta: true,
    baa: true,
    banReason: true,
    onPremise: true,
    onPremiseRequireServerValidation: true,
    onPremiseAllowedDomains: true,
    products: true,
    taxExempt: true,
    newMembersGracePeriodDays: true,
    canMakePlanChanges: true,
    billingPausedUntil: true,
    billingPeriodEndsOn: true,
    country: true,
    freeAccount: true,
    invoiceName: true,
    invoiceAddress: true,
    invoiceZip: true,
    invoiceState: true,
    taxRate: true,
    invoiceCountry: true,
    currentCustomerSuccessStage: true,
    customerSuccessStageChangeableTo: true,
    invoiceEmail: true,
    vatNumber: true,
    invoiceDaysUntilDue: true,
    subscriptionPaused: true,
    subscribedAt: true,
    subscriptionEndsAt: true,
    paymentSourceData: true,
    paying: true,
    billingOwner: true,
    billingSubaccounts: true,
    owner: true,
    installationStatus: true,
    nextBillingPoint: true,
    deletable: true
}));
var $71768cb662e3a945$export$b96ee3229e91d526 = $71768cb662e3a945$export$4393a2dbad098773.merge($71768cb662e3a945$export$3e5d0af8e738b082.pick({
    lastCustomerSuccessCheckupAt: true,
    lastCustomerSuccessCheckupRating: true,
    currentCustomerSuccessStage: true,
    customerSuccessCheckupDue: true,
    customerSuccessCheckupSnoozedUntil: true,
    customerSuccessStageChangeableTo: true,
    csUsageTrendData: true,
    customerSuccessManager: true,
    lastUsedAt: true,
    lastRequestAt: true,
    usageTrend: true,
    emailDomain: true,
    products: true,
    csInstallationStatus: true,
    onTrial: true,
    subscriptionEndsAt: true,
    unsubscribedAt: true,
    subscribedAt: true
})).merge((0, $2zDt6.z).object({
    company: (0, $2zDt6.z).object({
        id: (0, $2zDt6.z).string(),
        type: (0, $2zDt6.z).literal("company"),
        username: (0, $2zDt6.z).string(),
        yearlyValue: (0, $2zDt6.z).number(),
        lastHeardFromAt: (0, $2zDt6.z).coerce.date().nullable(),
        lastContactedAt: (0, $2zDt6.z).coerce.date().nullable(),
        lastHeardFromChannel: (0, $iUj1w.ContactChannel).nullable(),
        lastContactedChannel: (0, $iUj1w.ContactChannel).nullable(),
        selfService: (0, $2zDt6.z).boolean().nullable()
    })
}));
var $71768cb662e3a945$export$b1076635842ecbd7 = $71768cb662e3a945$export$4393a2dbad098773.merge($71768cb662e3a945$export$3e5d0af8e738b082.pick({
    products: true,
    activeLicenses: true,
    autoAdjustLicenses: true,
    licensesNeeded: true,
    plan: true,
    freeAccount: true,
    billingPausedUntil: true,
    sessionTimeCreditSecondsLeft: true,
    canMakePlanChanges: true,
    cancelling: true,
    contractAutoRenews: true,
    contractTerminatesOn: true,
    nextPlanActivatesOn: true,
    nextPlan: true,
    onTrial: true,
    subscriptionEndsAt: true,
    trialConvertsAutomatically: true,
    trialEndsOn: true,
    trialProduct: true,
    subscriptionPaused: true,
    trialStartedOn: true,
    paymentSourceData: true,
    billingOnboardingCompleted: true,
    invoiceAddress: true,
    invoiceCountry: true,
    invoiceEmail: true,
    invoiceName: true,
    invoiceZip: true,
    invoiceState: true,
    vatNumber: true,
    billingOwner: true,
    settingSessionTimeCreditAutoTopUpEnabled: true,
    settingSessionTimeCreditAutoTopUpTrigger: true,
    settingSessionTimeCreditAutoTopUpMultiplier: true,
    taxRate: true
}));

});
parcelRegister("358CX", function(module, exports) {

$parcel$export(module.exports, "zDay", () => $23e887f49c5bc29b$export$1433736428215083);

var $2zDt6 = parcelRequire("2zDt6");

var $gz8iO = parcelRequire("gz8iO");
var $23e887f49c5bc29b$export$1433736428215083 = (0, $2zDt6.z).custom(function(data) {
    return typeof data === "string" && /^\d+-\d+-\d+$/.test(data);
}).transform(function(date) {
    return new (0, $gz8iO.default)(date);
});

});
parcelRegister("gz8iO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f65ae61a752b28$export$2e2bcd8739ae039);

var $8RAYl = parcelRequire("8RAYl");

var $4gTQh = parcelRequire("4gTQh");
var $c0f65ae61a752b28$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $c0f65ae61a752b28$var$Day = /** @class */ function() {
    function Day(date) {
        if (date === void 0) date = new Date();
        if (typeof date === "string") {
            var _a = $c0f65ae61a752b28$var$__read(date.split("-").map(Number), 3), year = _a[0], month = _a[1], day = _a[2];
            this.year = year;
            this.month = month;
            this.day = day;
        } else if (date instanceof Day) {
            this.year = date.year;
            this.month = date.month;
            this.day = date.day;
        } else {
            this.year = date.getFullYear();
            this.month = date.getMonth() + 1;
            this.day = date.getDate();
        }
    }
    Day.prototype.getTime = function() {
        return this.beginningOfDay().getTime();
    };
    Day.prototype.isBefore = function(date) {
        return this.getTime() < date.getTime();
    };
    Day.prototype.toLocaleDateString = function(locales, options) {
        var _a;
        return this.beginningOfDay().toLocaleDateString((_a = locales !== null && locales !== void 0 ? locales : (0, $8RAYl.default).languages[0]) !== null && _a !== void 0 ? _a : "en-US", options);
    };
    Day.prototype.isAfter = function(date) {
        return this.getTime() > date.getTime();
    };
    Day.prototype.isSameDay = function(date) {
        return this.toString() === date.toString();
    };
    Day.prototype.add = function(count, unit) {
        var _a;
        return new Day((0, $4gTQh.relativeDate)((_a = {}, _a[unit] = count, _a), this.beginningOfDay()));
    };
    Day.prototype.subtract = function(count, unit) {
        return this.add(-count, unit);
    };
    Day.prototype.toString = function() {
        var month = String(this.month);
        if (month.length === 1) month = "0".concat(month);
        var day = String(this.day);
        if (day.length === 1) day = "0".concat(day);
        return "".concat(this.year, "-").concat(month, "-").concat(day);
    };
    Day.prototype.toJSON = function() {
        return this.toString();
    };
    Day.prototype.beginningOfDay = function() {
        return new Date(this.year, this.month - 1, this.day);
    };
    Day.prototype.endOfDay = function() {
        return new Date(this.year, this.month - 1, this.day, 23, 59, 59, 999);
    };
    Day.prototype.utcEndOfDay = function() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day, 23, 59, 59, 999));
    };
    Day.prototype.utcBeginningOfDay = function() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day));
    };
    /**
     * Returns the end of the day in global time.
     * The end of the day is defined as midnight in UTC−12:00.
     *
     * @returns {Date} A Date object representing the end of the day.
     */ Day.prototype.globalEndOfDay = function() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day) + 136800000 - 1);
    };
    /**
     * Returns the start of the day in global time.
     * The start of the day is defined as 12am in UTC+14:00.
     *
     * @returns {Date} A Date object representing the start of the day.
     */ Day.prototype.globalBeginningOfDay = function() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day) - 43200000);
    };
    Day.prototype.at = function(hour, minute, second) {
        if (second === void 0) second = 0;
        return new Date(this.year, this.month - 1, this.day, hour, minute, second);
    };
    Day.prototype.atTimezone = function(timeZone, hour, minute, second) {
        if (second === void 0) second = 0;
        var date = new Date(Date.UTC(this.year, this.month - 1, this.day, hour, minute, second));
        var utcDate = new Date(date.toLocaleString("en-US", {
            timeZone: "UTC"
        }));
        var tzDate = new Date(date.toLocaleString("en-US", {
            timeZone: timeZone
        }));
        var offset = utcDate.getTime() - tzDate.getTime();
        date.setTime(date.getTime() + offset);
        return date;
    };
    Day.prototype.beginningOfMonth = function() {
        return new Date(this.year, this.month - 1, 1);
    };
    Day.prototype.endOfMonth = function() {
        return new Date(this.year, this.month, 1);
    };
    Day.prototype.beginningOfYear = function() {
        return new Date(this.year, 0, 1);
    };
    Day.prototype.endOfYear = function() {
        return new Date(this.year + 1, 0, 1);
    };
    Day.prototype.beginningOfWeek = function() {
        var date = this.beginningOfDay();
        date.setDate(date.getDate() - date.getDay() + 1);
        return date;
    };
    Day.prototype.endOfWeek = function() {
        var date = this.endOfDay();
        date.setDate(date.getDate() + (7 - date.getDay()));
        return date;
    };
    Day.prototype.beginningOfQuarter = function() {
        var date = this.beginningOfMonth();
        var monthsToSubtract = date.getMonth() % 3;
        return (0, $4gTQh.relativeDate)({
            months: -monthsToSubtract
        }, date);
    };
    Day.prototype.endOfQuarter = function() {
        var date = this.beginningOfMonth();
        var monthsToAdd = 3 - date.getMonth() % 3;
        return (0, $4gTQh.relativeDate)({
            months: monthsToAdd
        }, date);
    };
    Day.prototype.daysTo = function(date) {
        return Math.floor((date.getTime() - this.getTime()) / 86400000);
    };
    Day.prototype.valueOf = function() {
        return this.getTime();
    };
    return Day;
}();
var $c0f65ae61a752b28$export$2e2bcd8739ae039 = $c0f65ae61a752b28$var$Day;

});
parcelRegister("4gTQh", function(module, exports) {

$parcel$export(module.exports, "relativeDate", () => $31c3f9298067042a$export$6270e84457db9b38);

var $gz8iO = parcelRequire("gz8iO");
var $31c3f9298067042a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $31c3f9298067042a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $31c3f9298067042a$export$6270e84457db9b38(_a, reference) {
    var ms = _a.ms, seconds = _a.seconds, minutes = _a.minutes, hours = _a.hours, days = _a.days, weeks = _a.weeks, months = _a.months, years = _a.years;
    var date = reference ? new Date(reference.getTime()) : new Date();
    if (typeof ms !== "undefined" && ms) date.setMilliseconds(date.getMilliseconds() + ms);
    if (typeof seconds !== "undefined" && seconds) date.setSeconds(date.getSeconds() + seconds);
    if (typeof minutes !== "undefined" && minutes) date.setMinutes(date.getMinutes() + minutes);
    if (typeof hours !== "undefined" && hours) date.setHours(date.getHours() + hours);
    if (typeof days !== "undefined" && days) date.setDate(date.getDate() + days);
    if (typeof weeks !== "undefined" && weeks) date.setDate(date.getDate() + weeks * 7);
    var currentDay = date.getDate();
    var targetYear = date.getFullYear();
    var targetMonth = date.getMonth();
    var hasYearChange = typeof years !== "undefined" && years !== 0;
    var hasMonthChange = typeof months !== "undefined" && months !== 0;
    var newDate = date;
    if (hasYearChange || hasMonthChange) {
        var totalMonths = targetMonth + (hasMonthChange ? months : 0);
        targetYear += hasYearChange ? years : 0;
        targetYear += Math.floor(totalMonths / 12);
        targetMonth = (totalMonths % 12 + 12) % 12;
        var lastDay = new Date(targetYear, targetMonth + 1, 0).getDate();
        var clampedDay = Math.min(currentDay, lastDay);
        newDate = new Date(Date.UTC(targetYear, targetMonth, clampedDay, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    }
    return newDate;
}
function $31c3f9298067042a$export$32751e76a652577f(_a) {
    var seconds = _a.seconds, minutes = _a.minutes, hours = _a.hours, days = _a.days;
    return 1000 * $31c3f9298067042a$export$9921e99a2a676152({
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days
    });
}
function $31c3f9298067042a$export$9921e99a2a676152(_a) {
    var seconds = _a.seconds, minutes = _a.minutes, hours = _a.hours, days = _a.days;
    var duration = 0;
    if (typeof seconds !== "undefined" && seconds) duration += seconds;
    if (typeof minutes !== "undefined" && minutes) duration += minutes * 60;
    if (typeof hours !== "undefined" && hours) duration += hours * 3600;
    if (typeof days !== "undefined" && days) duration += days * 86400;
    return duration;
}
function $31c3f9298067042a$export$5c333a116e949cdd() {
    var dates = [];
    for(var _i = 0; _i < arguments.length; _i++)dates[_i] = arguments[_i];
    return new Date(Math.min.apply(Math, $31c3f9298067042a$var$__spreadArray([], $31c3f9298067042a$var$__read(dates.filter(Boolean).map(function(date) {
        return date.getTime();
    })), false)));
}
function $31c3f9298067042a$export$a75f2bff57811055() {
    var dates = [];
    for(var _i = 0; _i < arguments.length; _i++)dates[_i] = arguments[_i];
    return new Date(Math.max.apply(Math, $31c3f9298067042a$var$__spreadArray([], $31c3f9298067042a$var$__read(dates.filter(Boolean).map(function(date) {
        return date.getTime();
    })), false)));
}
function $31c3f9298067042a$export$c02e9654c307b054() {
    var days = [];
    for(var _i = 0; _i < arguments.length; _i++)days[_i] = arguments[_i];
    return days.filter(Boolean).sort(function(a, b) {
        return a.getTime() - b.getTime();
    })[0];
}
function $31c3f9298067042a$export$7804b4a879f532ac() {
    var days = [];
    for(var _i = 0; _i < arguments.length; _i++)days[_i] = arguments[_i];
    return days.filter(Boolean).sort(function(a, b) {
        return b.getTime() - a.getTime();
    })[0];
}
function $31c3f9298067042a$export$8d5a9e2f1006f3c3(timeZone, hour, minute) {
    var clock = timeZone ? new (0, $gz8iO.default)().atTimezone(timeZone, hour, minute) : new (0, $gz8iO.default)().at(hour, minute);
    return clock < new Date() ? $31c3f9298067042a$export$6270e84457db9b38({
        days: 1
    }, clock) : clock;
}

});



parcelRegister("iUj1w", function(module, exports) {

$parcel$export(module.exports, "ContactChannel", () => $038d5bb862cbd8b6$export$63fc7fc040f0bfe4);

var $2zDt6 = parcelRequire("2zDt6");
var $038d5bb862cbd8b6$export$63fc7fc040f0bfe4 = (0, $2zDt6.z).enum([
    "email",
    "slack",
    "intercom"
]);

});

parcelRegister("4gUyz", function(module, exports) {

$parcel$export(module.exports, "CountryCode", () => $31c486fbdba68342$export$34a98f1791d1800e);

var $2zDt6 = parcelRequire("2zDt6");

var $cdyK4 = parcelRequire("cdyK4");
var $31c486fbdba68342$export$34a98f1791d1800e = (0, $2zDt6.z).enum(Object.keys((0, $cdyK4.default)));

});
parcelRegister("cdyK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e51a5f81c96478a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "vatCountries", () => $8e51a5f81c96478a$export$90664f0ad791cf56);
var $8e51a5f81c96478a$var$countries = {
    AD: "Andorra",
    AE: "United Arab Emirates",
    AF: "Afghanistan",
    AG: "Antigua And Barbuda",
    AI: "Anguilla",
    AL: "Albania",
    AM: "Armenia",
    AO: "Angola",
    AQ: "Antarctica",
    AR: "Argentina",
    AS: "American Samoa",
    AT: "Austria",
    AU: "Australia",
    AW: "Aruba",
    AX: "Aland Islands",
    AZ: "Azerbaijan",
    BA: "Bosnia And Herzegovina",
    BB: "Barbados",
    BD: "Bangladesh",
    BE: "Belgium",
    BF: "Burkina Faso",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "Saint Barthelemy",
    BM: "Bermuda",
    BN: "Brunei Darussalam",
    BO: "Bolivia",
    BR: "Brazil",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Bouvet Island",
    BW: "Botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocos Islands",
    CD: "Congo",
    CF: "Central African Republic",
    CG: "Congo",
    CH: "Switzerland",
    CI: "Cote D'Ivoire",
    CK: "Cook Islands",
    CL: "Chile",
    CM: "Cameroon",
    CN: "China",
    CO: "Colombia",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cape Verde",
    CX: "Christmas Island",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DE: "Germany",
    DJ: "Djibouti",
    DK: "Denmark",
    DM: "Dominica",
    DO: "Dominican Republic",
    DZ: "Algeria",
    EC: "Ecuador",
    EE: "Estonia",
    EG: "Egypt",
    EH: "Western Sahara",
    ER: "Eritrea",
    ES: "Spain",
    ET: "Ethiopia",
    FI: "Finland",
    FJ: "Fiji",
    FK: "Falkland Islands",
    FM: "Micronesia",
    FO: "Faroe Islands",
    FR: "France",
    GA: "Gabon",
    GB: "United Kingdom",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Greenland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "Equatorial Guinea",
    GR: "Greece",
    GS: "South Georgia And Sandwich Isl.",
    GT: "Guatemala",
    GU: "Guam",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hong Kong",
    HM: "Heard Island & Mcdonald Islands",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IM: "Isle Of Man",
    IN: "India",
    IO: "British Indian Ocean Territory",
    IQ: "Iraq",
    IR: "Iran",
    IS: "Iceland",
    IT: "Italy",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenya",
    KG: "Kyrgyzstan",
    KH: "Cambodia",
    KI: "Kiribati",
    KM: "Comoros",
    KN: "Saint Kitts And Nevis",
    KR: "Korea",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Lao People's Democratic Republic",
    LB: "Lebanon",
    LC: "Saint Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Lithuania",
    LU: "Luxembourg",
    LV: "Latvia",
    LY: "Libyan Arab Jamahiriya",
    MA: "Morocco",
    MC: "Monaco",
    MD: "Moldova",
    ME: "Montenegro",
    MF: "Saint Martin",
    MG: "Madagascar",
    MH: "Marshall Islands",
    MK: "Macedonia",
    ML: "Mali",
    MM: "Myanmar",
    MN: "Mongolia",
    MO: "Macao",
    MP: "Northern Mariana Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Malaysia",
    MZ: "Mozambique",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Netherlands",
    NO: "Norway",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "New Zealand",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "Papua New Guinea",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Poland",
    PM: "Saint Pierre And Miquelon",
    PN: "Pitcairn",
    PR: "Puerto Rico",
    PS: "Palestine",
    PT: "Portugal",
    PW: "Palau",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RS: "Serbia",
    RU: "Russian Federation",
    RW: "Rwanda",
    SA: "Saudi Arabia",
    SB: "Solomon Islands",
    SC: "Seychelles",
    SD: "Sudan",
    SE: "Sweden",
    SG: "Singapore",
    SH: "Saint Helena",
    SI: "Slovenia",
    SJ: "Svalbard And Jan Mayen",
    SK: "Slovakia",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    ST: "Sao Tome And Principe",
    SV: "El Salvador",
    SY: "Syrian Arab Republic",
    SZ: "Eswatini",
    TC: "Turks And Caicos Islands",
    TD: "Chad",
    TF: "French Southern Territories",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tajikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    TM: "Turkmenistan",
    TN: "Tunisia",
    TO: "Tonga",
    TR: "Turkey",
    TT: "Trinidad And Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tanzania",
    UA: "Ukraine",
    UG: "Uganda",
    UM: "United States Outlying Islands",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VA: "Holy See",
    VC: "Saint Vincent And Grenadines",
    VE: "Venezuela",
    VG: "British Virgin Islands",
    VI: "U.S. Virgin Islands",
    VN: "Viet Nam",
    VU: "Vanuatu",
    WF: "Wallis And Futuna",
    WS: "Samoa",
    YE: "Yemen",
    YT: "Mayotte",
    ZA: "South Africa",
    ZM: "Zambia",
    ZW: "Zimbabwe"
};
var $8e51a5f81c96478a$export$2e2bcd8739ae039 = $8e51a5f81c96478a$var$countries;
var $8e51a5f81c96478a$export$90664f0ad791cf56 = [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GR",
    "HU",
    "IE",
    "IT",
    "LV",
    "LT",
    "LU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE",
    "GB"
];

});


parcelRegister("tzjy8", function(module, exports) {

$parcel$export(module.exports, "CustomerSuccessRating", () => $058e1a3c6546c351$export$5ac6c2a69d54d38a);

var $2zDt6 = parcelRequire("2zDt6");
var $058e1a3c6546c351$export$5ac6c2a69d54d38a = (0, $2zDt6.z).union([
    (0, $2zDt6.z).literal(1),
    (0, $2zDt6.z).literal(2),
    (0, $2zDt6.z).literal(3),
    (0, $2zDt6.z).literal(4),
    (0, $2zDt6.z).literal(5)
]);

});

parcelRegister("l0osQ", function(module, exports) {

$parcel$export(module.exports, "CustomerSuccessStage", () => $f4ac9327b25fd29d$export$47ac5ea14223a0ee);

var $2zDt6 = parcelRequire("2zDt6");
var $f4ac9327b25fd29d$export$47ac5ea14223a0ee = (0, $2zDt6.z).enum([
    "onboarding",
    "adoption",
    "growth",
    "retention",
    "renewal",
    "losing",
    "lost",
    "ignored"
]);

});

parcelRegister("4Y9rk", function(module, exports) {

$parcel$export(module.exports, "InstallationStatus", () => $39e4168d3b4144d4$export$12df9a10caaba640);

var $2zDt6 = parcelRequire("2zDt6");
var $39e4168d3b4144d4$export$12df9a10caaba640 = (0, $2zDt6.z).enum([
    "on_premise",
    "installed_live",
    "installing",
    "tried_installing",
    "never_installed"
]);

});

parcelRegister("4cd6R", function(module, exports) {

$parcel$export(module.exports, "PaymentSourceData", () => $30e273be0ed7c1ff$export$626c7dc7feb30758);

var $2zDt6 = parcelRequire("2zDt6");

var $4gUyz = parcelRequire("4gUyz");
var $30e273be0ed7c1ff$export$626c7dc7feb30758 = (0, $2zDt6.z).object({
    ready: (0, $2zDt6.z).boolean(),
    type: (0, $2zDt6.z).union([
        (0, $2zDt6.z).literal("card"),
        (0, $2zDt6.z).literal("bank_account")
    ]),
    ending: (0, $2zDt6.z).string().nullable(),
    brand: (0, $2zDt6.z).string().nullable(),
    country: (0, $4gUyz.CountryCode).nullable(),
    expiresAt: (0, $2zDt6.z).coerce.date(),
    active: (0, $2zDt6.z).boolean(),
    expired: (0, $2zDt6.z).boolean(),
    expiring: (0, $2zDt6.z).boolean()
});

});

parcelRegister("3rRoQ", function(module, exports) {

$parcel$export(module.exports, "UsageTrendData", () => $282d50cf605e24d8$export$75ca96982d0977de);
$parcel$export(module.exports, "UsageTrend", () => $282d50cf605e24d8$export$85213838eb277d8e);

var $2zDt6 = parcelRequire("2zDt6");
var $282d50cf605e24d8$export$75ca96982d0977de = (0, $2zDt6.z).object({
    currentUsageSeconds: (0, $2zDt6.z).number(),
    previousUsageSeconds: (0, $2zDt6.z).number(),
    currentAgentRatingAverage: (0, $2zDt6.z).number().nullable(),
    previousAgentRatingAverage: (0, $2zDt6.z).number().nullable(),
    currentAgentRatingCount: (0, $2zDt6.z).number(),
    previousAgentRatingCount: (0, $2zDt6.z).number(),
    usageWeeks: (0, $2zDt6.z).number().array(),
    totalLicenses: (0, $2zDt6.z).number(),
    licensesNeeded: (0, $2zDt6.z).number()
});
var $282d50cf605e24d8$export$85213838eb277d8e = (0, $2zDt6.z).enum([
    "decrease",
    "moderateDecrease",
    "unchanged",
    "moderateIncrease",
    "increase"
]);

});

parcelRegister("gCU2M", function(module, exports) {

$parcel$export(module.exports, "UsStateCode", () => $c1abab1610185457$export$777974e2e9702526);

var $2zDt6 = parcelRequire("2zDt6");

var $dFUxM = parcelRequire("dFUxM");
var $c1abab1610185457$export$777974e2e9702526 = (0, $2zDt6.default).enum((0, $dFUxM.default).map(function(_a) {
    var code = _a.code;
    return code;
}));

});
parcelRegister("dFUxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f4af72306261d76$export$2e2bcd8739ae039);
var $9f4af72306261d76$var$usStates = [
    {
        code: "AL",
        state: "Alabama"
    },
    {
        code: "AK",
        state: "Alaska"
    },
    {
        code: "AZ",
        state: "Arizona"
    },
    {
        code: "AR",
        state: "Arkansas"
    },
    {
        code: "CA",
        state: "California"
    },
    {
        code: "CO",
        state: "Colorado"
    },
    {
        code: "CT",
        state: "Connecticut"
    },
    {
        code: "DE",
        state: "Delaware"
    },
    {
        code: "FL",
        state: "Florida"
    },
    {
        code: "GA",
        state: "Georgia"
    },
    {
        code: "HI",
        state: "Hawaii"
    },
    {
        code: "ID",
        state: "Idaho"
    },
    {
        code: "IL",
        state: "Illinois"
    },
    {
        code: "IN",
        state: "Indiana"
    },
    {
        code: "IA",
        state: "Iowa"
    },
    {
        code: "KS",
        state: "Kansas"
    },
    {
        code: "KY",
        state: "Kentucky"
    },
    {
        code: "LA",
        state: "Louisiana"
    },
    {
        code: "ME",
        state: "Maine"
    },
    {
        code: "MD",
        state: "Maryland"
    },
    {
        code: "MA",
        state: "Massachusetts"
    },
    {
        code: "MI",
        state: "Michigan"
    },
    {
        code: "MN",
        state: "Minnesota"
    },
    {
        code: "MS",
        state: "Mississippi"
    },
    {
        code: "MO",
        state: "Missouri"
    },
    {
        code: "MT",
        state: "Montana"
    },
    {
        code: "NE",
        state: "Nebraska"
    },
    {
        code: "NV",
        state: "Nevada"
    },
    {
        code: "NH",
        state: "New Hampshire"
    },
    {
        code: "NJ",
        state: "New Jersey"
    },
    {
        code: "NM",
        state: "New Mexico"
    },
    {
        code: "NY",
        state: "New York"
    },
    {
        code: "NC",
        state: "North Carolina"
    },
    {
        code: "ND",
        state: "North Dakota"
    },
    {
        code: "OH",
        state: "Ohio"
    },
    {
        code: "OK",
        state: "Oklahoma"
    },
    {
        code: "OR",
        state: "Oregon"
    },
    {
        code: "PA",
        state: "Pennsylvania"
    },
    {
        code: "RI",
        state: "Rhode Island"
    },
    {
        code: "SC",
        state: "South Carolina"
    },
    {
        code: "SD",
        state: "South Dakota"
    },
    {
        code: "TN",
        state: "Tennessee"
    },
    {
        code: "TX",
        state: "Texas"
    },
    {
        code: "UT",
        state: "Utah"
    },
    {
        code: "VT",
        state: "Vermont"
    },
    {
        code: "VA",
        state: "Virginia"
    },
    {
        code: "WA",
        state: "Washington"
    },
    {
        code: "WV",
        state: "West Virginia"
    },
    {
        code: "WI",
        state: "Wisconsin"
    },
    {
        code: "WY",
        state: "Wyoming"
    },
    {
        code: "DC",
        state: "District of Columbia"
    },
    {
        code: "AS",
        state: "American Samoa"
    },
    {
        code: "GU",
        state: "Guam"
    },
    {
        code: "MP",
        state: "Northern Mariana Islands"
    },
    {
        code: "PR",
        state: "Puerto Rico"
    },
    {
        code: "UM",
        state: "United States Minor Outlying Islands"
    },
    {
        code: "VI",
        state: "Virgin Islands, U.S.Outlying area"
    }
];
var $9f4af72306261d76$export$2e2bcd8739ae039 = $9f4af72306261d76$var$usStates;

});


parcelRegister("7MlKx", function(module, exports) {

$parcel$export(module.exports, "PlanPeriod", () => $5a9de32353f019a4$export$67372694db0d56c3);
$parcel$export(module.exports, "PlanLicenseType", () => $5a9de32353f019a4$export$e41adbc47615c89b);
$parcel$export(module.exports, "Plan", () => $5a9de32353f019a4$export$814cc77def5a44df);
$parcel$export(module.exports, "planMonthsInPeriod", () => $5a9de32353f019a4$export$8bb7d6d2bcf8299b);

var $2zDt6 = parcelRequire("2zDt6");

var $j6Pkg = parcelRequire("j6Pkg");

var $lIQh8 = parcelRequire("lIQh8");
var $5a9de32353f019a4$export$67372694db0d56c3 = (0, $2zDt6.z).enum([
    "month",
    "year",
    "quarter",
    "six_month",
    "two_month"
]);
var $5a9de32353f019a4$export$e41adbc47615c89b = (0, $2zDt6.z).enum([
    "agent",
    "seat",
    "concurrent"
]);
var $5a9de32353f019a4$var$basePlanSchema = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string().optional(),
    period: $5a9de32353f019a4$export$67372694db0d56c3,
    name: (0, $2zDt6.z).string(),
    monthlyPricePerLicense: (0, $2zDt6.z).number(),
    price: (0, $2zDt6.z).number(),
    monthlyPrice: (0, $2zDt6.z).number(),
    features: (0, $2zDt6.z).array((0, $j6Pkg.Feature)),
    products: (0, $2zDt6.z).array((0, $lIQh8.Product)),
    formattedMonthlyPrice: (0, $2zDt6.z).string(),
    yearlySaving: (0, $2zDt6.z).number().nullable(),
    formattedYearlySaving: (0, $2zDt6.z).string().nullable(),
    currency: (0, $2zDt6.z).enum([
        "gbp",
        "usd",
        "eur"
    ]),
    current: (0, $2zDt6.z).boolean(),
    perLicense: (0, $2zDt6.z).boolean(),
    invoiced: (0, $2zDt6.z).boolean(),
    sessionTimeCreditHours: (0, $2zDt6.z).number().nullable(),
    sessionTimeCreditHoursMonthly: (0, $2zDt6.z).number().nullable(),
    topupAmount: (0, $2zDt6.z).number().nullable(),
    topupHours: (0, $2zDt6.z).number().nullable(),
    sessionTimeCredit: (0, $2zDt6.z).boolean(),
    minLicenses: (0, $2zDt6.z).number(),
    maxLicenses: (0, $2zDt6.z).number(),
    licenses: (0, $2zDt6.z).number(),
    licenseType: $5a9de32353f019a4$export$e41adbc47615c89b,
    formattedPrice: (0, $2zDt6.z).string(),
    formattedMinPrice: (0, $2zDt6.z).string(),
    formattedPricePerLicense: (0, $2zDt6.z).string(),
    formattedMonthlyPricePerLicense: (0, $2zDt6.z).string(),
    formattedBillingFrequency: (0, $2zDt6.z).string(),
    formattedPeriod: (0, $2zDt6.z).string(),
    formattedPriceDescription: (0, $2zDt6.z).string(),
    formattedTopupPrice: (0, $2zDt6.z).string().nullable(),
    type: (0, $2zDt6.z).literal("plan")
});
var $5a9de32353f019a4$export$814cc77def5a44df = $5a9de32353f019a4$var$basePlanSchema.extend({
    yearly: (0, $2zDt6.z).lazy(function() {
        return $5a9de32353f019a4$export$814cc77def5a44df.nullable();
    })
});
function $5a9de32353f019a4$export$8bb7d6d2bcf8299b(period) {
    switch(period){
        case "year":
            return 12;
        case "month":
            return 1;
        case "quarter":
            return 3;
        case "six_month":
            return 6;
        case "two_month":
            return 2;
    }
}

});
parcelRegister("j6Pkg", function(module, exports) {

$parcel$export(module.exports, "Feature", () => $de96641a2048c232$export$6e91cf7616333d5);

var $2zDt6 = parcelRequire("2zDt6");
var $de96641a2048c232$export$6e91cf7616333d5 = (0, $2zDt6.z).enum([
    "cobrowse_whitelabel",
    "cobrowse_dev_console",
    "sso",
    "reporting",
    "activity_log",
    "cobrowse_multi_agent",
    "user_roles",
    "cobrowse_remote_control",
    "cobrowse_audio_calls",
    "cobrowse_agent_request_button",
    "cobrowse_dev_console_control",
    "cobrowse_session_history",
    "zapier_integration",
    "salesforce_integration",
    "intercom_session_summary",
    "cobrowse_agent_redirect",
    "cobrowse_agent_notes",
    "cobrowse_session_recording",
    "cobrowse_browsing_history",
    "cobrowse_browsing_history_automatic_screenshots",
    "cobrowse_user_full_screen",
    "cobrowse_agent_share_screen",
    "cobrowse_visitor_session_feedback",
    "cobrowse",
    "cobrowse_rest_api",
    "userview_screen_tv",
    "helloscreen_extension",
    "helloscreen_extension_full_screen",
    "helloscreen_extension_request_viewer_screen",
    "helloscreen_extension_multi_viewer",
    "helloscreen_extension_url_whitelist",
    "helloscreen_document_share",
    "helloscreen_document_share_templates",
    "helloscreen_presentation_sharing",
    "livedocument_templates",
    "cobrowse_session_history_own"
]);
var $de96641a2048c232$var$check = true;

});


parcelRegister("210qL", function(module, exports) {

$parcel$export(module.exports, "User", () => $177c024a2136f696$export$1f44aaf2ec115b54);
$parcel$export(module.exports, "UserBaseData", () => $177c024a2136f696$export$4ef75464d690c281);
$parcel$export(module.exports, "UserTeamManagementData", () => $177c024a2136f696$export$9e992aef50ac2fe0);

var $2zDt6 = parcelRequire("2zDt6");

var $2BD3c = parcelRequire("2BD3c");
var $177c024a2136f696$export$1f44aaf2ec115b54 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).custom(),
    fromOauth: (0, $2zDt6.z).boolean(),
    name: (0, $2zDt6.z).string(),
    email: (0, $2zDt6.z).string(),
    emailDomain: (0, $2zDt6.z).string(),
    phoneNumber: (0, $2zDt6.z).string().nullable(),
    username: (0, $2zDt6.z).string(),
    subscribedToEmails: (0, $2zDt6.z).boolean(),
    language: (0, $2zDt6.z).string().nullable(),
    settingLivedocumentViewNotification: (0, $2zDt6.z).enum([
        "daily_aggregate_summary",
        "daily_summary",
        "new_viewers",
        "new_views",
        "never"
    ]),
    type: (0, $2zDt6.z).literal("user"),
    isAdmin: (0, $2zDt6.z).boolean(),
    intercomHashedEmail: (0, $2zDt6.z).string().nullable(),
    intercomId: (0, $2zDt6.z).string().nullable(),
    password: (0, $2zDt6.z).boolean(),
    passwordEnableNeeded: (0, $2zDt6.z).boolean(),
    mfaEnabled: (0, $2zDt6.z).boolean(),
    deletedAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastRequestAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastUsedLicenseAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastAttemptedCobrowsingSessionAt: (0, $2zDt6.z).coerce.date().nullable(),
    cobrowsingSessionsCount: (0, $2zDt6.z).number(),
    sourceIntegrationName: (0, $2zDt6.z).string().nullable(),
    seated: (0, $2zDt6.z).boolean(),
    adminRoles: (0, $2BD3c.AdminRole).array(),
    metadata: (0, $2zDt6.z).object({
        leftG2ReviewAt: (0, $2zDt6.z).string().optional(),
        confettiUnlocked: (0, $2zDt6.z).boolean().optional(),
        intercomUserId: (0, $2zDt6.z).string().optional()
    })
});
var $177c024a2136f696$export$4ef75464d690c281 = $177c024a2136f696$export$1f44aaf2ec115b54.pick({
    name: true,
    email: true,
    type: true,
    id: true,
    deletedAt: true
});
var $177c024a2136f696$export$9e992aef50ac2fe0 = $177c024a2136f696$export$4ef75464d690c281.merge($177c024a2136f696$export$1f44aaf2ec115b54.pick({
    lastRequestAt: true,
    lastUsedLicenseAt: true,
    lastAttemptedCobrowsingSessionAt: true,
    cobrowsingSessionsCount: true,
    sourceIntegrationName: true,
    password: true,
    mfaEnabled: true,
    seated: true
}));

});
parcelRegister("2BD3c", function(module, exports) {

$parcel$export(module.exports, "AdminRole", () => $1e5d54160495eabf$export$29ae8a301dbdf057);

var $2zDt6 = parcelRequire("2zDt6");
var $1e5d54160495eabf$export$29ae8a301dbdf057 = (0, $2zDt6.z).enum([
    "devops",
    "accounts_view",
    "accounts_write",
    "sales_lead_target",
    "impersonate",
    "superuser",
    "sales_view",
    "sales_write",
    "sales_manager",
    "sales_exec",
    "customer_success",
    "product_helloscreen",
    "product_userview",
    "product_cobrowsingapi",
    "product_livedocument"
]);
var $1e5d54160495eabf$export$628d173b9b7a0833 = (0, $2zDt6.z).enum([
    "devops",
    "accountsView",
    "accountsWrite",
    "impersonate",
    "superuser",
    "salesView",
    "salesWrite",
    "salesManager",
    "salesExec",
    "customerSuccess",
    "salesLeadTarget",
    "productHelloscreen",
    "productUserview",
    "productCobrowsingapi",
    "productLivedocument"
]);

});



parcelRegister("JRp7q", function(module, exports) {

$parcel$export(module.exports, "SuccessResponse", () => $089da108a9dbe56d$export$ed01511bbd0f04a1);
$parcel$export(module.exports, "ErrorResponse", () => $089da108a9dbe56d$export$acf1a680051f5031);
$parcel$export(module.exports, "SubscriptionLimitResponse", () => $089da108a9dbe56d$export$bce939551d8445ed);
$parcel$export(module.exports, "Pagy", () => $089da108a9dbe56d$export$598775fd3eb3c6c6);

var $2zDt6 = parcelRequire("2zDt6");
var $089da108a9dbe56d$export$ed01511bbd0f04a1 = (0, $2zDt6.z).object({
    status: (0, $2zDt6.z).literal("ok"),
    success: (0, $2zDt6.z).literal(true)
});
var $089da108a9dbe56d$export$acf1a680051f5031 = (0, $2zDt6.z).object({
    status: (0, $2zDt6.z).literal("error"),
    success: (0, $2zDt6.z).literal(false)
});
var $089da108a9dbe56d$export$bbb758df855f2805 = (0, $2zDt6.z).union([
    $089da108a9dbe56d$export$ed01511bbd0f04a1,
    $089da108a9dbe56d$export$acf1a680051f5031
]);
var $089da108a9dbe56d$export$bce939551d8445ed = (0, $2zDt6.z).union([
    $089da108a9dbe56d$export$acf1a680051f5031.extend({
        error: (0, $2zDt6.z).literal("subscription_limit:too_many_monthly_agents")
    }),
    $089da108a9dbe56d$export$acf1a680051f5031.extend({
        error: (0, $2zDt6.z).literal("subscription_limit:too_many_seats_used")
    }),
    $089da108a9dbe56d$export$acf1a680051f5031.extend({
        error: (0, $2zDt6.z).literal("subscription_limit:cobrowse_multi_agent_not_available")
    }),
    $089da108a9dbe56d$export$acf1a680051f5031.extend({
        error: (0, $2zDt6.z).literal("subscription_limit:no_session_time_credit_left")
    }),
    $089da108a9dbe56d$export$acf1a680051f5031.extend({
        error: (0, $2zDt6.z).literal("subscription_limit:too_many_sessions")
    }),
    $089da108a9dbe56d$export$acf1a680051f5031.extend({
        error: (0, $2zDt6.z).literal("team:no_subscription")
    })
]);
var $089da108a9dbe56d$export$598775fd3eb3c6c6 = (0, $2zDt6.z).object({
    page: (0, $2zDt6.z).number(),
    items: (0, $2zDt6.z).number(),
    count: (0, $2zDt6.z).number(),
    pages: (0, $2zDt6.z).number()
});

});


parcelRegister("gX1L4", function(module, exports) {

$parcel$export(module.exports, "cobrowsingApiEndpoints", () => $c573852827dff5e6$export$c714b6303cdda389);
$parcel$export(module.exports, "cobrowsingApiRequests", () => $c573852827dff5e6$export$8533b3ee6cb5c389);
$parcel$export(module.exports, "cobrowsingApiResponses", () => $c573852827dff5e6$export$c2623183e6bbb31a);

var $2zDt6 = parcelRequire("2zDt6");

var $ha2ef = parcelRequire("ha2ef");

var $5vRIf = parcelRequire("5vRIf");

var $94XPD = parcelRequire("94XPD");

var $JRp7q = parcelRequire("JRp7q");
var $c573852827dff5e6$export$c714b6303cdda389 = {
    "co.keys.index": function(p) {
        return [
            "co",
            "get",
            "/dashboard/".concat(p.teamDomain, "/rest_keys/index")
        ];
    },
    "co.keys.create": function(p) {
        return [
            "co",
            "post",
            "/dashboard/".concat(p.teamDomain, "/rest_keys")
        ];
    },
    "co.keys.delete": function(p) {
        return [
            "co",
            "delete",
            "/dashboard/".concat(p.teamDomain, "/rest_keys/").concat(p.keyId)
        ];
    },
    "co.history.index": function(p) {
        return [
            "co",
            "get",
            "/dashboard/".concat(p.teamDomain, "/history/index")
        ];
    },
    "co.webhooks.index": function(p) {
        return [
            "co",
            "get",
            "/dashboard/".concat(p.teamDomain, "/webhooks/index")
        ];
    },
    "co.cobrowse.notes.show": function() {
        return [
            "co",
            "get",
            "/session/notes"
        ];
    },
    "co.cobrowse.notes.update": function() {
        return [
            "co",
            "put",
            "/session/notes"
        ];
    }
};
var $c573852827dff5e6$export$8533b3ee6cb5c389 = {
    "co.keys.create": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        restKey: (0, $2zDt6.z).object({
            name: (0, $2zDt6.z).string()
        })
    }),
    "co.keys.delete": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        keyId: (0, $2zDt6.z).string()
    }),
    "co.keys.index": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "co.history.index": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        page: (0, $2zDt6.z).number().optional().nullable(),
        maxId: (0, $2zDt6.z).string().optional().nullable()
    }),
    "co.webhooks.index": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        page: (0, $2zDt6.z).number().optional().nullable(),
        maxId: (0, $2zDt6.z).string().optional().nullable()
    }),
    "co.cobrowse.notes.show": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string()
    }),
    "co.cobrowse.notes.update": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string(),
        notes: (0, $2zDt6.z).string().nullable()
    })
};
var $c573852827dff5e6$export$c2623183e6bbb31a = {
    "co.keys.create": (0, $JRp7q.SuccessResponse).extend({
        restKey: (0, $94XPD.RestKey)
    }),
    "co.keys.delete": (0, $JRp7q.SuccessResponse),
    "co.keys.index": (0, $JRp7q.SuccessResponse).extend({
        restKeys: (0, $94XPD.RestKey).array()
    }),
    "co.history.index": (0, $JRp7q.SuccessResponse).extend({
        apiLogs: (0, $ha2ef.ApiLog).array(),
        pagy: (0, $JRp7q.Pagy)
    }),
    "co.webhooks.index": (0, $JRp7q.SuccessResponse).extend({
        sessionWebhookLogs: (0, $5vRIf.CobrowsingSessionWebhookLog).array(),
        pagy: (0, $JRp7q.Pagy)
    }),
    "co.cobrowse.notes.show": (0, $JRp7q.SuccessResponse).extend({
        notes: (0, $2zDt6.z).string().nullable()
    }),
    "co.cobrowse.notes.update": (0, $JRp7q.SuccessResponse).extend({
        notes: (0, $2zDt6.z).string().nullable()
    })
};

});
parcelRegister("ha2ef", function(module, exports) {

$parcel$export(module.exports, "ApiLog", () => $c7e5196a5e756d5a$export$5d4f2e84c3eeaf74);

var $2zDt6 = parcelRequire("2zDt6");
var $c7e5196a5e756d5a$export$5d4f2e84c3eeaf74 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    createdAt: (0, $2zDt6.z).coerce.date(),
    ip: (0, $2zDt6.z).string(),
    statusCode: (0, $2zDt6.z).number(),
    requestMethod: (0, $2zDt6.z).enum([
        "GET",
        "POST",
        "PUT",
        "DELETE"
    ]),
    url: (0, $2zDt6.z).string(),
    request: (0, $2zDt6.z).string(),
    response: (0, $2zDt6.z).string(),
    type: (0, $2zDt6.z).literal("api_log")
});

});

parcelRegister("5vRIf", function(module, exports) {

$parcel$export(module.exports, "CobrowsingSessionWebhookLog", () => $40398333532712f6$export$ef304f7f7c2b42da);

var $2zDt6 = parcelRequire("2zDt6");
var $40398333532712f6$export$ef304f7f7c2b42da = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    webhookUrl: (0, $2zDt6.z).string(),
    status: (0, $2zDt6.z).string(),
    statusCode: (0, $2zDt6.z).number(),
    timedOut: (0, $2zDt6.z).boolean(),
    createdAt: (0, $2zDt6.z).coerce.date(),
    willRetryAt: (0, $2zDt6.z).coerce.date().nullable(),
    session: (0, $2zDt6.z).object({
        id: (0, $2zDt6.z).string(),
        type: (0, $2zDt6.z).literal("cobrowsing_session")
    })
});

});

parcelRegister("94XPD", function(module, exports) {

$parcel$export(module.exports, "RestKey", () => $69c2e61d4392f90c$export$7ab82c1009f5ed75);

var $2zDt6 = parcelRequire("2zDt6");
var $69c2e61d4392f90c$export$7ab82c1009f5ed75 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    name: (0, $2zDt6.z).string(),
    secretApiKey: (0, $2zDt6.z).string(),
    lastIp: (0, $2zDt6.z).string().nullable(),
    lastUsedAt: (0, $2zDt6.z).coerce.date().nullable(),
    type: (0, $2zDt6.z).literal("rest_key")
});

});


parcelRegister("5S0bn", function(module, exports) {

$parcel$export(module.exports, "helloScreenEndpoints", () => $446223264d9e34a9$export$e05796626e9d394e);
$parcel$export(module.exports, "helloScreenRequests", () => $446223264d9e34a9$export$39c5f8d5b3d64f9c);
$parcel$export(module.exports, "helloScreenResponses", () => $446223264d9e34a9$export$24f083145877bd72);

var $2zDt6 = parcelRequire("2zDt6");

var $lbXII = parcelRequire("lbXII");

var $6nNCC = parcelRequire("6nNCC");

var $JRp7q = parcelRequire("JRp7q");
var $446223264d9e34a9$export$e05796626e9d394e = {
    "hs.publicLink.join": function() {
        return [
            "hs",
            "post",
            "/helloscreen_public_link"
        ];
    },
    "hs.authToken.exchange": function() {
        return [
            "hs",
            "post",
            "/embed/auth"
        ];
    },
    "hs.visitorsList.token": function() {
        return [
            "hs",
            "get",
            "/list_token"
        ];
    },
    "hs.stats": function() {
        return [
            "hs",
            "get",
            "/stats"
        ];
    },
    "hs.cobrowse.token": function(p) {
        return [
            "hs",
            "post",
            "/w/".concat(p.visitorId, "/token")
        ];
    },
    "hs.cobrowse.feedback": function(p) {
        return [
            "hs",
            "post",
            "/agent_feedback/".concat(p.sessionId)
        ];
    },
    "hs.cobrowse.onPrem.token": function(p) {
        return [
            "hs",
            "post",
            "/onprem_redirect/".concat(p.teamUniqueIdentifier, "/token")
        ];
    },
    "hs.cobrowse.notes.show": function() {
        return [
            "hs",
            "get",
            "/notes"
        ];
    },
    "hs.cobrowse.notes.update": function() {
        return [
            "hs",
            "put",
            "/notes"
        ];
    }
};
var $446223264d9e34a9$export$39c5f8d5b3d64f9c = {
    "hs.publicLink.join": (0, $2zDt6.z).object({
        accessCode: (0, $2zDt6.z).string(),
        subdomain: (0, $2zDt6.z).string()
    }),
    "hs.authToken.exchange": (0, $2zDt6.z).object({
        code: (0, $2zDt6.z).string()
    }),
    "hs.visitorsList.token": (0, $2zDt6.z).undefined(),
    "hs.stats": (0, $2zDt6.z).object({
        astronautMessage: (0, $2zDt6.z).boolean()
    }),
    "hs.cobrowse.token": (0, $2zDt6.z).object({
        visitorId: (0, $2zDt6.z).string(),
        adminOverride: (0, $2zDt6.z).boolean().optional().nullable(),
        confirm: (0, $2zDt6.z).boolean().optional().nullable(),
        source: (0, $2zDt6.z).string().optional().nullable(),
        metadataToken: (0, $2zDt6.z).string().optional().nullable()
    }),
    "hs.cobrowse.feedback": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string(),
        feedback: (0, $2zDt6.z).string().optional(),
        rating: (0, $2zDt6.z).number()
    }),
    "hs.cobrowse.onPrem.token": (0, $2zDt6.z).object({
        teamUniqueIdentifier: (0, $2zDt6.z).string(),
        visitorId: (0, $2zDt6.z).string(),
        confirm: (0, $2zDt6.z).boolean().optional().nullable(),
        metadataToken: (0, $2zDt6.z).string().optional().nullable()
    }),
    "hs.cobrowse.notes.show": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string()
    }),
    "hs.cobrowse.notes.update": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string(),
        notes: (0, $2zDt6.z).string().nullable()
    })
};
var $446223264d9e34a9$export$24f083145877bd72 = {
    "hs.publicLink.join": (0, $JRp7q.SuccessResponse).extend({
        token: (0, $2zDt6.z).string(),
        region: (0, $2zDt6.z).string(),
        shortId: (0, $2zDt6.z).string()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("invalid_access_code")
    })).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("invalid_subdomain")
    })),
    "hs.authToken.exchange": (0, $JRp7q.SuccessResponse).extend({
        token: (0, $2zDt6.z).string()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("invalid_code")
    })),
    "hs.visitorsList.token": (0, $JRp7q.SuccessResponse).extend({
        token: (0, $2zDt6.z).string(),
        endpoints: (0, $2zDt6.z).string().array(),
        lookupCodeNeeded: (0, $2zDt6.z).boolean(),
        requestAgentButtonEnabled: (0, $2zDt6.z).boolean(),
        onPremise: (0, $2zDt6.z).boolean(),
        onPremiseIdentifier: (0, $2zDt6.z).string().optional().nullable()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("no_teams")
    })),
    "hs.stats": (0, $JRp7q.SuccessResponse).extend({
        stats: (0, $2zDt6.z).object({
            online: (0, $2zDt6.z).number().nullable(),
            totalSessions: (0, $2zDt6.z).number(),
            mySessions: (0, $2zDt6.z).number()
        }),
        astronautMessage: (0, $2zDt6.z).string().nullable().optional()
    }),
    "hs.cobrowse.token": (0, $JRp7q.SuccessResponse).extend({
        askForRating: (0, $2zDt6.z).boolean(),
        confettiEnabled: (0, $2zDt6.z).boolean(),
        sessionId: (0, $2zDt6.z).string().nullable(),
        token: (0, $2zDt6.z).string(),
        region: (0, $2zDt6.z).string(),
        shortId: (0, $2zDt6.z).string(),
        notesEnabled: (0, $2zDt6.z).boolean(),
        teamId: (0, $2zDt6.z).custom()
    }).or((0, $2zDt6.z).union([
        (0, $JRp7q.SuccessResponse).extend({
            alternativeVisitorId: (0, $2zDt6.z).string(),
            teamId: (0, $2zDt6.z).custom()
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("connection_error")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("record_not_found")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("visitor:not_supported")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("visitor:not_online")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("auth:admin:override_needed"),
            visitor: (0, $6nNCC.VisitorModel)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("auth:login"),
            loginUrl: (0, $lbXII.Url)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("confirmation_needed"),
            visitor: (0, $6nNCC.VisitorModel),
            teamId: (0, $2zDt6.z).custom()
        })
    ]).or((0, $JRp7q.SubscriptionLimitResponse))),
    "hs.cobrowse.feedback": (0, $JRp7q.SuccessResponse),
    "hs.cobrowse.onPrem.token": (0, $JRp7q.SuccessResponse).extend({
        redirectUrl: (0, $lbXII.Url),
        sessionId: (0, $2zDt6.z).string()
    }).or((0, $2zDt6.z).union([
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("record_not_found")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("auth:login"),
            loginUrl: (0, $lbXII.Url)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("team:onpremise_not_supported")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("confirmation_needed")
        })
    ]).or((0, $JRp7q.SubscriptionLimitResponse))),
    "hs.cobrowse.notes.show": (0, $JRp7q.SuccessResponse).extend({
        notes: (0, $2zDt6.z).string().nullable()
    }),
    "hs.cobrowse.notes.update": (0, $JRp7q.SuccessResponse).extend({
        notes: (0, $2zDt6.z).string().nullable()
    })
};

});
parcelRegister("6nNCC", function(module, exports) {

$parcel$export(module.exports, "VisitorModel", () => $4a5b61f331e14f5f$export$8e87dbe624a271cd);

var $2zDt6 = parcelRequire("2zDt6");

var $58EmH = parcelRequire("58EmH");

var $lbXII = parcelRequire("lbXII");
var $4a5b61f331e14f5f$export$8e87dbe624a271cd = (0, $2zDt6.z).object({
    shortId: (0, $2zDt6.z).string(),
    watchLink: (0, $lbXII.Url),
    apiKey: (0, $2zDt6.z).string(),
    email: (0, $2zDt6.z).string().nullable(),
    name: (0, $2zDt6.z).string().nullable(),
    nickname: (0, $2zDt6.z).string(),
    ipAddress: (0, $2zDt6.z).string(),
    jsConfiguration: (0, $2zDt6.z).boolean(),
    locationCity: (0, $2zDt6.z).string().nullable(),
    locationCountry: (0, $2zDt6.z).string().nullable(),
    locationCountryName: (0, $2zDt6.z).string().nullable(),
    lastUrl: (0, $2zDt6.z).string().nullable(),
    deviceType: (0, $2zDt6.z).string().nullable(),
    deviceName: (0, $2zDt6.z).string().nullable(),
    browserName: (0, $2zDt6.z).string().nullable(),
    integration: (0, $2zDt6.z).string().nullable(),
    lastSeenAt: (0, $2zDt6.z).coerce.date(),
    isOnline: (0, $2zDt6.z).boolean(),
    addedAt: (0, $2zDt6.z).coerce.date(),
    isInSession: (0, $2zDt6.z).boolean(),
    identities: (0, $2zDt6.z).array((0, $2zDt6.z).string()),
    tags: (0, $2zDt6.z).array((0, $2zDt6.z).string()),
    uniqueId: (0, $2zDt6.z).string().nullable(),
    lookupCode: (0, $2zDt6.z).string().nullable(),
    callName: (0, $2zDt6.z).string().nullable(),
    isSupported: (0, $2zDt6.z).boolean(),
    isWaitingForCall: (0, $2zDt6.z).boolean(),
    sessions: (0, $2zDt6.z).array((0, $2zDt6.z).record((0, $2zDt6.z).any())).optional(),
    history: (0, $2zDt6.z).array((0, $58EmH.PageView)).optional(),
    type: (0, $2zDt6.z).literal("visitor"),
    sdk: (0, $2zDt6.z).enum([
        "web",
        "ios",
        "android"
    ])
});

});
parcelRegister("58EmH", function(module, exports) {

$parcel$export(module.exports, "PageView", () => $3bdd02c52c540932$export$12c0fdede1c6bc6c);

var $2zDt6 = parcelRequire("2zDt6");
var $3bdd02c52c540932$export$12c0fdede1c6bc6c = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string()
});

});



parcelRegister("gsKrY", function(module, exports) {

$parcel$export(module.exports, "hqEndpoints", () => $bfc34aeb5537e1a3$export$2168dfba235edbba);
$parcel$export(module.exports, "hqRequests", () => $bfc34aeb5537e1a3$export$d31ba09d45a2fe6b);
$parcel$export(module.exports, "hqResponses", () => $bfc34aeb5537e1a3$export$f263f55edff7e21b);

var $2zDt6 = parcelRequire("2zDt6");

var $jYplN = parcelRequire("jYplN");

var $01O3F = parcelRequire("01O3F");

var $358CX = parcelRequire("358CX");

var $isBZy = parcelRequire("isBZy");

var $7GbXT = parcelRequire("7GbXT");

var $lIQh8 = parcelRequire("lIQh8");

var $dEcVM = parcelRequire("dEcVM");

var $ammTY = parcelRequire("ammTY");

var $2AhOQ = parcelRequire("2AhOQ");

var $gmYLw = parcelRequire("gmYLw");

var $9JXBn = parcelRequire("9JXBn");

var $gwJge = parcelRequire("gwJge");

var $JRp7q = parcelRequire("JRp7q");
var $bfc34aeb5537e1a3$export$2168dfba235edbba = {
    "hq.accounts.relatedObjects.index": function(p) {
        return [
            "hq",
            "get",
            "/accounts/".concat(p.companyId, "/related")
        ];
    },
    "hq.teams.usage": function(p) {
        return [
            "hq",
            "get",
            "/accounts/".concat(p.companyId, "/teams/").concat(p.teamId, "/usage/data")
        ];
    },
    "hq.sales.tasks.index": function() {
        return [
            "hq",
            "get",
            "/sales/tasks/index"
        ];
    },
    "hq.sales.tasks.count": function() {
        return [
            "hq",
            "get",
            "/sales/tasks/count"
        ];
    },
    "hq.sales.tasks.create": function() {
        return [
            "hq",
            "post",
            "/sales/tasks"
        ];
    },
    "hq.sales.tasks.update": function(p) {
        return [
            "hq",
            "put",
            "/sales/tasks/".concat(p.taskId)
        ];
    },
    "hq.admins.emails.index": function(p) {
        return [
            "hq",
            "get",
            "/admins/".concat(p.userId, "/emails/index")
        ];
    },
    "hq.admins.activities.counts": function(p) {
        return [
            "hq",
            "get",
            "/admins/".concat(p.userId, "/activities/counts")
        ];
    },
    "hq.teams.merge": function(p) {
        return [
            "hq",
            "post",
            "/teams/".concat(p.teamId, "/merge")
        ];
    },
    "hq.teams.resetBilling": function(p) {
        return [
            "hq",
            "delete",
            "/teams/".concat(p.teamId, "/reset_billing")
        ];
    },
    "hq.teams.forceSync": function(p) {
        return [
            "hq",
            "post",
            "/teams/".concat(p.teamId, "/force_sync")
        ];
    },
    "hq.teams.update.onpremise": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/onpremise")
        ];
    },
    "hq.teams.cancelSubscription": function(p) {
        return [
            "hq",
            "delete",
            "/teams/".concat(p.teamId, "/subscription")
        ];
    },
    "hq.teams.resumeSubscription": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/subscription/on")
        ];
    },
    "hq.teams.adjustLicenses": function(p) {
        return [
            "hq",
            "post",
            "/teams/".concat(p.teamId, "/adjust_licenses")
        ];
    },
    "hq.teams.update.licenses": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/licenses")
        ];
    },
    "hq.teams.update.delegateBilling": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/delegate_billing")
        ];
    },
    "hq.teams.changePlan": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/change_plan")
        ];
    },
    "hq.teams.cancelPlanChange": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/cancel_plan_change")
        ];
    },
    "hq.teams.changeTrial": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/change_trial")
        ];
    },
    "hq.teams.changeContract": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/change_contract")
        ];
    },
    "hq.teams.billingHistory": function(p) {
        return [
            "hq",
            "get",
            "/teams/".concat(p.teamId, "/billing_history")
        ];
    },
    "hq.teams.pendingCharges": function(p) {
        return [
            "hq",
            "get",
            "/teams/".concat(p.teamId, "/invoice/pending")
        ];
    },
    "hq.teams.addToInvoice": function(p) {
        return [
            "hq",
            "post",
            "/teams/".concat(p.teamId, "/invoice/items")
        ];
    },
    "hq.teams.pendingCharge.delete": function(p) {
        return [
            "hq",
            "delete",
            "/teams/".concat(p.teamId, "/invoice/pending/").concat(p.itemId)
        ];
    },
    "hq.teams.invoice": function(p) {
        return [
            "hq",
            "post",
            "/teams/".concat(p.teamId, "/invoice")
        ];
    },
    "hq.teams.refundCharge": function(p) {
        return [
            "hq",
            "post",
            "/teams/".concat(p.teamId, "/charges/").concat(p.chargeId)
        ];
    },
    "hq.teams.update.owner": function(p) {
        return [
            "hq",
            "put",
            "/teams/".concat(p.teamId, "/change_owner")
        ];
    }
};
var $bfc34aeb5537e1a3$export$d31ba09d45a2fe6b = {
    "hq.accounts.relatedObjects.index": (0, $2zDt6.z).object({
        companyId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.usage": (0, $2zDt6.z).object({
        companyId: (0, $2zDt6.z).custom(),
        teamId: (0, $2zDt6.z).custom(),
        from: (0, $2zDt6.z).coerce.date(),
        to: (0, $2zDt6.z).coerce.date()
    }),
    "hq.sales.tasks.index": (0, $2zDt6.z).object({
        companyId: (0, $2zDt6.z).custom().optional(),
        opportunityId: (0, $2zDt6.z).string().optional(),
        assignedToId: (0, $2zDt6.z).string().optional(),
        createdById: (0, $2zDt6.z).string().optional()
    }),
    "hq.sales.tasks.count": (0, $2zDt6.z).undefined(),
    "hq.sales.tasks.create": (0, $2zDt6.z).object({
        task: (0, $gmYLw.SalesTask).pick({
            dueDate: true,
            name: true,
            description: true,
            priority: true,
            status: true,
            snoozedUntil: true
        }).merge((0, $2zDt6.z).object({
            assignedToId: (0, $2zDt6.z).string(),
            companyId: (0, $2zDt6.z).custom(),
            salesOpportunityId: (0, $2zDt6.z).string().optional()
        })).partial()
    }),
    "hq.sales.tasks.update": (0, $2zDt6.z).object({
        taskId: (0, $2zDt6.z).string(),
        task: (0, $gmYLw.SalesTask).pick({
            dueDate: true,
            name: true,
            description: true,
            priority: true,
            status: true,
            snoozedUntil: true
        }).merge((0, $2zDt6.z).object({
            assignedToId: (0, $2zDt6.z).string(),
            companyId: (0, $2zDt6.z).custom(),
            opportunityId: (0, $2zDt6.z).string()
        })).partial()
    }),
    "hq.admins.emails.index": (0, $2zDt6.z).object({
        userId: (0, $2zDt6.z).string(),
        page: (0, $2zDt6.z).number().optional().nullable()
    }),
    "hq.admins.activities.counts": (0, $2zDt6.z).object({
        userId: (0, $2zDt6.z).string()
    }),
    "hq.teams.merge": (0, $2zDt6.z).object({
        teamToDelete: (0, $2zDt6.z).string(),
        mainTeamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.resetBilling": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.forceSync": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.update.onpremise": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        onPremise: (0, $2zDt6.z).boolean(),
        onPremiseRequireServerValidation: (0, $2zDt6.z).boolean(),
        onPremiseAllowedDomains: (0, $2zDt6.z).string().nullable()
    }),
    "hq.teams.cancelSubscription": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        now: (0, $2zDt6.z).literal(true).optional()
    }),
    "hq.teams.resumeSubscription": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.adjustLicenses": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.update.licenses": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        activeLicenses: (0, $2zDt6.z).number(),
        autoAdjustLicenses: (0, $9JXBn.Team).shape.autoAdjustLicenses,
        newMembersGracePeriodDays: (0, $2zDt6.z).number().min(0).max(31)
    }),
    "hq.teams.update.vat": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        vatNumber: (0, $2zDt6.z).string().optional().nullable()
    }),
    "hq.teams.update.delegateBilling": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        billingOwner: (0, $2zDt6.z).string().nullable()
    }),
    "hq.teams.changePlan": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        plan: (0, $2zDt6.z).custom(),
        applyOn: (0, $358CX.zDay).nullable(),
        licenses: (0, $2zDt6.z).number().optional()
    }),
    "hq.teams.cancelPlanChange": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.changeTrial": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        trial: (0, $2zDt6.z).object({
            status: (0, $2zDt6.z).literal("continue"),
            endsOn: (0, $358CX.zDay),
            product: (0, $lIQh8.Product).optional()
        }).or((0, $2zDt6.z).object({
            status: (0, $2zDt6.z).enum([
                "convert",
                "terminate"
            ])
        }))
    }),
    "hq.teams.changeContract": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        canMakePlanChanges: (0, $2zDt6.z).boolean(),
        contractTerminatesOn: (0, $358CX.zDay).nullable(),
        contractAutoRenews: (0, $2zDt6.z).boolean().nullable()
    }),
    "hq.teams.billingHistory": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.pendingCharges": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom()
    }),
    "hq.teams.addToInvoice": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        currency: (0, $2zDt6.z).enum([
            "usd",
            "eur",
            "gbp"
        ]),
        amount: (0, $2zDt6.z).number(),
        description: (0, $2zDt6.z).string()
    }),
    "hq.teams.pendingCharge.delete": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        itemId: (0, $2zDt6.z).string()
    }),
    "hq.teams.invoice": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        dueAfter: (0, $358CX.zDay).optional()
    }),
    "hq.teams.refundCharge": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        chargeId: (0, $2zDt6.z).string(),
        amount: (0, $2zDt6.z).number()
    }),
    "hq.teams.update.owner": (0, $2zDt6.z).object({
        teamId: (0, $2zDt6.z).custom(),
        newOwnerId: (0, $2zDt6.z).string()
    })
};
var $bfc34aeb5537e1a3$export$f263f55edff7e21b = {
    "hq.accounts.relatedObjects.index": (0, $JRp7q.SuccessResponse).extend({
        invoices: (0, $7GbXT.Invoice).array(),
        quotes: (0, $dEcVM.QuoteAdminSearchData).array(),
        opportunities: (0, $2AhOQ.SalesOpportunityAdminSearchData).array()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("record_not_found")
    })),
    "hq.teams.usage": (0, $JRp7q.SuccessResponse).extend({
        usage: (0, $ammTY.CobrowsingTeamUsage),
        previousUsage: (0, $ammTY.CobrowsingTeamUsage)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("record_not_found")
    })),
    "hq.sales.tasks.index": (0, $JRp7q.SuccessResponse).extend({
        tasks: (0, $gmYLw.SalesTask).array()
    }),
    "hq.sales.tasks.count": (0, $JRp7q.SuccessResponse).extend({
        total: (0, $2zDt6.z).number(),
        due: (0, $2zDt6.z).number()
    }),
    "hq.sales.tasks.create": (0, $JRp7q.SuccessResponse).extend({
        task: (0, $gmYLw.SalesTask)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        taskErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            name: (0, $2zDt6.z).string(),
            description: (0, $2zDt6.z).string(),
            dueDate: (0, $2zDt6.z).string(),
            snoozedUntil: (0, $2zDt6.z).string(),
            company: (0, $2zDt6.z).string(),
            assignedTo: (0, $2zDt6.z).string()
        }))
    })),
    "hq.sales.tasks.update": (0, $JRp7q.SuccessResponse).extend({
        task: (0, $gmYLw.SalesTask)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        taskErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            name: (0, $2zDt6.z).string(),
            description: (0, $2zDt6.z).string(),
            dueDate: (0, $2zDt6.z).string(),
            snoozedUntil: (0, $2zDt6.z).string(),
            company: (0, $2zDt6.z).string(),
            assignedTo: (0, $2zDt6.z).string()
        }))
    })),
    "hq.admins.emails.index": (0, $JRp7q.SuccessResponse).extend({
        emails: (0, $gwJge.TrackedEmail).array(),
        pagy: (0, $JRp7q.Pagy)
    }),
    "hq.admins.activities.counts": (0, $JRp7q.SuccessResponse).extend({
        quarterEmailCount: (0, $2zDt6.z).number(),
        quarterActivityCount: (0, $2zDt6.z).record((0, $2zDt6.z).enum((0, $jYplN.activityTypeKeys)), (0, $2zDt6.z).number()),
        weekEmailCount: (0, $2zDt6.z).number(),
        weekActivityCount: (0, $2zDt6.z).record((0, $2zDt6.z).enum((0, $jYplN.activityTypeKeys)), (0, $2zDt6.z).number())
    }),
    "hq.teams.merge": (0, $JRp7q.SuccessResponse),
    "hq.teams.resetBilling": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("already_customer")
    })),
    "hq.teams.forceSync": (0, $JRp7q.SuccessResponse),
    "hq.teams.update.onpremise": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            onPremiseAllowedDomains: (0, $2zDt6.z).string()
        }))
    })),
    "hq.teams.cancelSubscription": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("team_not_subscribed")
    })),
    "hq.teams.resumeSubscription": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("team_not_cancelling")
    })),
    "hq.teams.adjustLicenses": (0, $JRp7q.SuccessResponse),
    "hq.teams.update.licenses": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            activeLicenses: (0, $2zDt6.z).string()
        }))
    })),
    "hq.teams.update.vat": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            vatNumber: (0, $2zDt6.z).string()
        }))
    })),
    "hq.teams.update.delegateBilling": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            billingOwner: (0, $2zDt6.z).string()
        }))
    })),
    "hq.teams.changePlan": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("missing_invoice_details")
    })),
    "hq.teams.cancelPlanChange": (0, $JRp7q.SuccessResponse),
    "hq.teams.changeTrial": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("team_paying")
    })),
    "hq.teams.changeContract": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            canMakePlanChanges: (0, $2zDt6.z).string(),
            contractTerminatesOn: (0, $2zDt6.z).string()
        }))
    })),
    "hq.teams.billingHistory": (0, $JRp7q.SuccessResponse).extend({
        charges: (0, $isBZy.Charge).array(),
        invoices: (0, $7GbXT.Invoice).array()
    }),
    "hq.teams.pendingCharges": (0, $JRp7q.SuccessResponse).extend({
        lineItems: (0, $2zDt6.z).object({
            id: (0, $2zDt6.z).string(),
            amount: (0, $2zDt6.z).number(),
            currency: (0, $2zDt6.z).enum([
                "usd",
                "eur",
                "gbp"
            ]),
            description: (0, $2zDt6.z).string()
        }).array()
    }),
    "hq.teams.addToInvoice": (0, $JRp7q.SuccessResponse),
    "hq.teams.pendingCharge.delete": (0, $JRp7q.SuccessResponse),
    "hq.teams.invoice": (0, $JRp7q.SuccessResponse),
    "hq.teams.refundCharge": (0, $JRp7q.SuccessResponse),
    "hq.teams.update.owner": (0, $JRp7q.SuccessResponse)
};

});
parcelRegister("jYplN", function(module, exports) {

$parcel$export(module.exports, "salesActivityTypeLabel", () => $e8a7490379e16656$export$51cac1be3ae452e3);
$parcel$export(module.exports, "salesActivityTypeVerb", () => $e8a7490379e16656$export$3f8cdcd35c6dd16e);
$parcel$export(module.exports, "salesActivityCreationAllowed", () => $e8a7490379e16656$export$51b0a4a66c392600);
$parcel$export(module.exports, "activityTypeKeys", () => $e8a7490379e16656$export$e59027191879afde);
function $e8a7490379e16656$export$51cac1be3ae452e3(type) {
    switch(type){
        case "call":
            return "Call";
        case "email":
            return "Email";
        case "meeting":
            return "Meeting";
        case "stage_change":
            return "Stage Change";
        case "social_message_sent":
            return "Social media message sent";
        case "social_message_received":
            return "Social media message received";
        case "note":
            return "Note";
        case "attempted_call":
            return "Attempted call";
    }
}
function $e8a7490379e16656$export$3f8cdcd35c6dd16e(type) {
    switch(type){
        case "stage_change":
        case "note":
        case "attempted_call":
        case "social_message_sent":
        case "social_message_received":
            return "by";
        case "call":
        case "email":
            return "from";
        case "meeting":
            return "with";
    }
}
function $e8a7490379e16656$export$51b0a4a66c392600(type) {
    switch(type){
        case "stage_change":
            return false;
        case "note":
        case "call":
        case "email":
        case "meeting":
        case "social_message_sent":
        case "social_message_received":
        case "attempted_call":
            return true;
    }
}
var $e8a7490379e16656$export$e59027191879afde = [
    "call",
    "email",
    "meeting",
    "stageChange",
    "note",
    "socialMessageSent",
    "socialMessageReceived",
    "attemptedCall"
];
var $e8a7490379e16656$var$check = true;

});

parcelRegister("isBZy", function(module, exports) {

$parcel$export(module.exports, "Charge", () => $0377e041bae32348$export$91b92057a2a9e47);
$parcel$export(module.exports, "chargeStatusLabel", () => $0377e041bae32348$export$ba4d84b25cd0fcb);

var $2zDt6 = parcelRequire("2zDt6");

var $lbXII = parcelRequire("lbXII");
var $0377e041bae32348$export$91b92057a2a9e47 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    show: (0, $2zDt6.z).boolean(),
    succeeded: (0, $2zDt6.z).boolean(),
    failed: (0, $2zDt6.z).boolean(),
    date: (0, $2zDt6.z).coerce.date(),
    amountFormatted: (0, $2zDt6.z).string(),
    // TODO: Should disputed be nullable?
    disputed: (0, $2zDt6.z).boolean().nullable(),
    pending: (0, $2zDt6.z).boolean(),
    refunded: (0, $2zDt6.z).boolean(),
    amountRefunded: (0, $2zDt6.z).number(),
    invoiceUrl: (0, $lbXII.Url).nullable(),
    type: (0, $2zDt6.z).literal("charge"),
    amountRefundable: (0, $2zDt6.z).number(),
    currency: (0, $2zDt6.z).enum([
        "usd",
        "gbp",
        "eur"
    ])
});
function $0377e041bae32348$export$ba4d84b25cd0fcb(charge) {
    if (charge.succeeded) return "Succeeded";
    if (charge.failed) return "Failed";
    if (charge.disputed) return "Disputed";
    if (charge.refunded) return "Refunded";
    if (charge.pending) return "Pending";
    return "Unknown";
}

});

parcelRegister("7GbXT", function(module, exports) {

$parcel$export(module.exports, "Invoice", () => $5975bca842119d58$export$ba5f874f962e090e);
$parcel$export(module.exports, "invoiceStatusLabel", () => $5975bca842119d58$export$aac12510deb23789);

var $2zDt6 = parcelRequire("2zDt6");

var $lbXII = parcelRequire("lbXII");
var $5975bca842119d58$export$ba5f874f962e090e = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    amountFormatted: (0, $2zDt6.z).string(),
    paid: (0, $2zDt6.z).boolean(),
    voided: (0, $2zDt6.z).boolean(),
    overdue: (0, $2zDt6.z).boolean(),
    date: (0, $2zDt6.z).coerce.date(),
    dueDate: (0, $2zDt6.z).coerce.date().nullable(),
    invoiced: (0, $2zDt6.z).boolean(),
    url: (0, $lbXII.Url).nullable(),
    type: (0, $2zDt6.z).literal("invoice")
});
function $5975bca842119d58$export$aac12510deb23789(invoice) {
    if (invoice.paid) return "Paid";
    if (invoice.voided) return "Voided";
    if (invoice.overdue) return "Overdue";
}

});

parcelRegister("dEcVM", function(module, exports) {

$parcel$export(module.exports, "QuoteAdminSearchData", () => $9ef90a95f2b52e4a$export$e1191984fa4197fa);

var $2zDt6 = parcelRequire("2zDt6");

var $j4t0q = parcelRequire("j4t0q");
var $9ef90a95f2b52e4a$export$82b8d343c504672 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    publicKey: (0, $2zDt6.z).string(),
    status: (0, $2zDt6.z).enum([
        "draft",
        "published",
        "awaiting_signature",
        "signed",
        "trial",
        "trial_canceled",
        "completed",
        "deleted",
        "paid"
    ]),
    signerName: (0, $2zDt6.z).string(),
    signerEmail: (0, $2zDt6.z).string(),
    company: (0, $j4t0q.Company).pick({
        id: true,
        type: true,
        name: true
    }),
    expired: (0, $2zDt6.z).boolean(),
    type: (0, $2zDt6.z).literal("quote")
});
var $9ef90a95f2b52e4a$export$e1191984fa4197fa = $9ef90a95f2b52e4a$export$82b8d343c504672.pick({
    id: true,
    publicKey: true,
    company: true,
    status: true,
    signerEmail: true,
    signerName: true,
    expired: true,
    type: true
});

});
parcelRegister("j4t0q", function(module, exports) {

$parcel$export(module.exports, "Company", () => $de24e3fc2e77d13a$export$17f7382901150e2d);
$parcel$export(module.exports, "CompanyBaseData", () => $de24e3fc2e77d13a$export$4be5f39b8ac3a8e8);

var $2zDt6 = parcelRequire("2zDt6");

var $358CX = parcelRequire("358CX");

var $iUj1w = parcelRequire("iUj1w");

var $tzjy8 = parcelRequire("tzjy8");

var $lIQh8 = parcelRequire("lIQh8");

var $3rRoQ = parcelRequire("3rRoQ");

var $7MlKx = parcelRequire("7MlKx");

var $9JXBn = parcelRequire("9JXBn");

var $210qL = parcelRequire("210qL");
var $de24e3fc2e77d13a$export$17f7382901150e2d = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).custom(),
    activeLicenses: (0, $2zDt6.z).number(),
    billingEmail: (0, $2zDt6.z).string().nullable(),
    contractAutoRenews: (0, $2zDt6.z).boolean().nullable(),
    contractTerminatesOn: (0, $2zDt6.z).coerce.date().nullable(),
    domains: (0, $2zDt6.z).array((0, $2zDt6.z).string()),
    isCancelling: (0, $2zDt6.z).boolean(),
    isOnTrial: (0, $2zDt6.z).boolean(),
    isInstalled: (0, $2zDt6.z).boolean(),
    yearlyValue: (0, $2zDt6.z).number(),
    products: (0, $lIQh8.Product).array(),
    name: (0, $2zDt6.z).string(),
    notes: (0, $2zDt6.z).string(),
    phoneNumber: (0, $2zDt6.z).string().nullable(),
    primaryDomain: (0, $2zDt6.z).string().nullable(),
    subscribedAt: (0, $2zDt6.z).coerce.date().nullable(),
    trialConvertsAutomatically: (0, $2zDt6.z).boolean().nullable(),
    trialEndsAt: (0, $2zDt6.z).coerce.date().nullable(),
    trialStartedAt: (0, $2zDt6.z).coerce.date().nullable(),
    unsubscribedAt: (0, $2zDt6.z).coerce.date().nullable(),
    usageTrend: (0, $3rRoQ.UsageTrend),
    usageTrendData: (0, $3rRoQ.UsageTrendData),
    licenseType: (0, $7MlKx.PlanLicenseType).nullable(),
    planPeriod: (0, $7MlKx.PlanPeriod).nullable(),
    nextInvoiceAt: (0, $2zDt6.z).coerce.date().nullable(),
    subscriptionEndsAt: (0, $2zDt6.z).coerce.date().nullable(),
    licensesNeeded: (0, $2zDt6.z).number(),
    planIsTimeLimited: (0, $2zDt6.z).boolean(),
    monthlySessionTimeCreditHours: (0, $2zDt6.z).number().nullable(),
    teams: (0, $9JXBn.Team).pick({
        id: true,
        domain: true,
        yearlyValue: true,
        usageTrendData: true,
        membersCount: true,
        lastCustomerSuccessCheckupAt: true,
        lastCustomerSuccessCheckupRating: true,
        currentCustomerSuccessStage: true,
        installationStatus: true,
        type: true
    }).array(),
    primaryTeam: (0, $9JXBn.Team).pick({
        id: true,
        type: true
    }).nullable(),
    lastCustomerSuccessCheckupRating: (0, $tzjy8.CustomerSuccessRating).nullable(),
    lastHeardFromAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastHeardFromChannel: (0, $iUj1w.ContactChannel).nullable(),
    lastContactedAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastContactedChannel: (0, $iUj1w.ContactChannel).nullable(),
    slackChannelId: (0, $2zDt6.z).string().nullable(),
    slackChannelName: (0, $2zDt6.z).string().nullable(),
    lastSeenOn: (0, $2zDt6.z).coerce.date().nullable(),
    type: (0, $2zDt6.z).literal("company"),
    hqTags: (0, $2zDt6.z).array((0, $2zDt6.z).custom())
});
var $de24e3fc2e77d13a$export$4be5f39b8ac3a8e8 = $de24e3fc2e77d13a$export$17f7382901150e2d.pick({
    id: true,
    name: true,
    domains: true
});
var $de24e3fc2e77d13a$export$78beb1bb1e54ca7f = $de24e3fc2e77d13a$export$4be5f39b8ac3a8e8.merge((0, $2zDt6.z).object({
    inLeadListSince: (0, $358CX.zDay).nullable(),
    leadAssignedTo: (0, $210qL.UserBaseData).nullable(),
    leadListDetails: (0, $2zDt6.z).custom()
}));
var $de24e3fc2e77d13a$export$1d2d73eaac54443d = $de24e3fc2e77d13a$export$4be5f39b8ac3a8e8.merge($de24e3fc2e77d13a$export$17f7382901150e2d.pick({
    activeLicenses: true,
    billingEmail: true,
    contractAutoRenews: true,
    contractTerminatesOn: true,
    isCancelling: true,
    isOnTrial: true,
    yearlyValue: true,
    products: true,
    notes: true,
    phoneNumber: true,
    primaryDomain: true,
    subscribedAt: true,
    trialConvertsAutomatically: true,
    trialEndsAt: true,
    trialStartedAt: true,
    unsubscribedAt: true,
    usageTrend: true,
    isInstalled: true,
    usageTrendData: true,
    licensesNeeded: true,
    licenseType: true,
    teams: true,
    primaryTeam: true,
    planPeriod: true,
    subscriptionEndsAt: true,
    lastCustomerSuccessCheckupRating: true,
    nextInvoiceAt: true,
    planIsTimeLimited: true,
    monthlySessionTimeCreditHours: true,
    slackChannelId: true,
    slackChannelName: true,
    lastHeardFromAt: true,
    lastHeardFromChannel: true,
    lastContactedAt: true,
    lastContactedChannel: true,
    lastSeenOn: true,
    hqTags: true
}));

});


parcelRegister("ammTY", function(module, exports) {

$parcel$export(module.exports, "CobrowsingTeamUsage", () => $78adb9445244e4fb$export$1975cd3c2411a81a);

var $2zDt6 = parcelRequire("2zDt6");

var $210qL = parcelRequire("210qL");
var $78adb9445244e4fb$export$280b4e225522db08 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    name: (0, $2zDt6.z).string().nullable(),
    externalId: (0, $2zDt6.z).string(),
    agentNickname: (0, $2zDt6.z).string().nullable(),
    onPremise: (0, $2zDt6.z).boolean(),
    firstSeenAt: (0, $2zDt6.z).coerce.date(),
    lastSeenAt: (0, $2zDt6.z).coerce.date(),
    deletedAt: (0, $2zDt6.z).null(),
    type: (0, $2zDt6.z).literal("external_agent")
});
var $78adb9445244e4fb$export$cbfb52ddcd4bbcea = (0, $2zDt6.z).object({
    agent: (0, $2zDt6.z).union([
        (0, $210qL.UserBaseData),
        $78adb9445244e4fb$export$280b4e225522db08.pick({
            externalId: true,
            name: true,
            onPremise: true,
            id: true,
            deletedAt: true,
            type: true
        })
    ]),
    totalSeconds: (0, $2zDt6.z).number(),
    totalMinutes: (0, $2zDt6.z).number(),
    totalAudioMinutes: (0, $2zDt6.z).number(),
    formattedTime: (0, $2zDt6.z).string(),
    formattedAudioTime: (0, $2zDt6.z).string(),
    screensharesCount: (0, $2zDt6.z).number(),
    usersCount: (0, $2zDt6.z).number(),
    historyViewsCount: (0, $2zDt6.z).number(),
    userAgentRatingAverage: (0, $2zDt6.z).number()
});
var $78adb9445244e4fb$export$1975cd3c2411a81a = (0, $2zDt6.z).object({
    agentsCount: (0, $2zDt6.z).number(),
    agentsUsages: (0, $2zDt6.z).array($78adb9445244e4fb$export$cbfb52ddcd4bbcea).nullable(),
    formattedAudioTime: (0, $2zDt6.z).string(),
    formattedTime: (0, $2zDt6.z).string(),
    formattedTimePerSession: (0, $2zDt6.z).string(),
    from: (0, $2zDt6.z).coerce.date(),
    screensharesCount: (0, $2zDt6.z).number(),
    to: (0, $2zDt6.z).coerce.date(),
    totalAudioMinutes: (0, $2zDt6.z).number(),
    totalAudioSeconds: (0, $2zDt6.z).number(),
    totalMinutes: (0, $2zDt6.z).number(),
    totalSeconds: (0, $2zDt6.z).number(),
    usersCount: (0, $2zDt6.z).number(),
    agentsRatingAverage: (0, $2zDt6.z).number()
});

});

parcelRegister("2AhOQ", function(module, exports) {

$parcel$export(module.exports, "SalesOpportunity", () => $1e1cc40fa83cf24f$export$8fae355d824fa11d);
$parcel$export(module.exports, "SalesOpportunityAdminSearchData", () => $1e1cc40fa83cf24f$export$87e492b2908ce8a7);

var $2zDt6 = parcelRequire("2zDt6");

var $j4t0q = parcelRequire("j4t0q");

var $kFVat = parcelRequire("kFVat");

var $kHmfr = parcelRequire("kHmfr");

var $9JXBn = parcelRequire("9JXBn");

var $210qL = parcelRequire("210qL");
var $1e1cc40fa83cf24f$export$8fae355d824fa11d = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).custom(),
    company: (0, $j4t0q.CompanyBaseData),
    team: (0, $9JXBn.TeamBaseData).nullable(),
    salesExec: (0, $210qL.UserBaseData).nullable(),
    source: (0, $210qL.UserBaseData).nullable(),
    primaryContact: (0, $kFVat.Contact).nullable(),
    health: (0, $kHmfr.SalesRating).nullable(),
    ranking: (0, $2zDt6.z).number(),
    name: (0, $2zDt6.z).string(),
    description: (0, $2zDt6.z).string().nullable(),
    notes: (0, $2zDt6.z).string().nullable(),
    opportunityType: (0, $2zDt6.z).enum([
        "new_business",
        "renewal",
        "expansion",
        "upsale"
    ]),
    stage: (0, $2zDt6.z).enum([
        "new",
        "demo_booked",
        "discovery",
        "trial",
        "closed_won",
        "closed_lost",
        "disqualified"
    ]),
    value: (0, $2zDt6.z).number(),
    expectedCloseDate: (0, $2zDt6.z).coerce.date(),
    actualCloseDate: (0, $2zDt6.z).coerce.date().nullable(),
    lastInteraction: (0, $2zDt6.z).coerce.date().nullable(),
    lastTouchpoint: (0, $2zDt6.z).coerce.date().nullable(),
    tasksDue: (0, $2zDt6.z).boolean(),
    followUpNeeded: (0, $2zDt6.z).boolean(),
    open: (0, $2zDt6.z).boolean(),
    snoozedUntil: (0, $2zDt6.z).coerce.date().nullable(),
    healthExpired: (0, $2zDt6.z).boolean(),
    questions: (0, $2zDt6.z).array((0, $2zDt6.z).object({
        question: (0, $2zDt6.z).string(),
        answer: (0, $2zDt6.z).string().nullable()
    })),
    createdAt: (0, $2zDt6.z).coerce.date(),
    type: (0, $2zDt6.z).literal("sales_opportunity")
});
var $1e1cc40fa83cf24f$export$87e492b2908ce8a7 = $1e1cc40fa83cf24f$export$8fae355d824fa11d.pick({
    id: true,
    type: true,
    name: true,
    company: true,
    description: true,
    opportunityType: true,
    open: true,
    stage: true
});

});
parcelRegister("kFVat", function(module, exports) {

$parcel$export(module.exports, "Contact", () => $f0d3fb564dae3b52$export$836a6ea60fb78f25);

var $2zDt6 = parcelRequire("2zDt6");

var $210qL = parcelRequire("210qL");

var $j4t0q = parcelRequire("j4t0q");
var $f0d3fb564dae3b52$export$836a6ea60fb78f25 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    name: (0, $2zDt6.z).string().nullable(),
    email: (0, $2zDt6.z).string(),
    phoneNumber: (0, $2zDt6.z).string().nullable(),
    role: (0, $2zDt6.z).enum([
        "technical",
        "manager",
        "procurement",
        "security",
        "consultant"
    ]).nullable(),
    lastContactedAt: (0, $2zDt6.z).coerce.date().nullable(),
    lastHeardFromAt: (0, $2zDt6.z).coerce.date().nullable(),
    comment: (0, $2zDt6.z).string().nullable(),
    user: (0, $210qL.User).pick({
        id: true,
        type: true
    }).nullable(),
    company: (0, $j4t0q.Company).pick({
        id: true,
        type: true
    }).nullable()
});

});

parcelRegister("kHmfr", function(module, exports) {

$parcel$export(module.exports, "SalesRating", () => $f11914d19325e485$export$48a99ec1f35bb89d);

var $2zDt6 = parcelRequire("2zDt6");
var $f11914d19325e485$export$48a99ec1f35bb89d = (0, $2zDt6.z).union([
    (0, $2zDt6.z).literal(1),
    (0, $2zDt6.z).literal(2),
    (0, $2zDt6.z).literal(3),
    (0, $2zDt6.z).literal(4),
    (0, $2zDt6.z).literal(5)
]);

});


parcelRegister("gmYLw", function(module, exports) {

$parcel$export(module.exports, "SalesTask", () => $beadd6286b23cb1c$export$d2d704d807f4917d);
$parcel$export(module.exports, "taskPriorityLabel", () => $beadd6286b23cb1c$export$45dae656d9c1eb4c);
$parcel$export(module.exports, "taskStatusLabel", () => $beadd6286b23cb1c$export$3859216957f8d75);

var $2zDt6 = parcelRequire("2zDt6");

var $j4t0q = parcelRequire("j4t0q");

var $210qL = parcelRequire("210qL");
var $beadd6286b23cb1c$export$d2d704d807f4917d = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    company: (0, $j4t0q.CompanyBaseData),
    createdAt: (0, $2zDt6.z).coerce.date(),
    createdBy: (0, $210qL.UserBaseData).nullable(),
    assignedTo: (0, $210qL.UserBaseData).nullable(),
    name: (0, $2zDt6.z).string(),
    description: (0, $2zDt6.z).string().nullable(),
    priority: (0, $2zDt6.z).enum([
        "low",
        "medium",
        "high"
    ]),
    status: (0, $2zDt6.z).enum([
        "open",
        "in_progress",
        "done",
        "canceled"
    ]),
    dueDate: (0, $2zDt6.z).custom().nullable(),
    snoozedUntil: (0, $2zDt6.z).custom().nullable(),
    completedAt: (0, $2zDt6.z).coerce.date().nullable(),
    canceledAt: (0, $2zDt6.z).coerce.date().nullable(),
    type: (0, $2zDt6.z).literal("sales_task")
});
function $beadd6286b23cb1c$export$45dae656d9c1eb4c(priority) {
    switch(priority){
        case "low":
            return "Low";
        case "medium":
            return "Medium";
        case "high":
            return "High";
    }
}
function $beadd6286b23cb1c$export$3859216957f8d75(status) {
    switch(status){
        case "open":
            return "To do";
        case "in_progress":
            return "In Progress";
        case "done":
            return "Done";
        case "canceled":
            return "Canceled";
    }
}

});

parcelRegister("gwJge", function(module, exports) {

$parcel$export(module.exports, "TrackedEmail", () => $c082be57f7c777bd$export$c8b49ea1bcf7ea72);

var $2zDt6 = parcelRequire("2zDt6");

var $210qL = parcelRequire("210qL");
var $c082be57f7c777bd$export$c8b49ea1bcf7ea72 = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).string(),
    senderName: (0, $2zDt6.z).string(),
    senderEmail: (0, $2zDt6.z).string(),
    recipients: (0, $2zDt6.z).object({
        name: (0, $2zDt6.z).string().nullable(),
        email: (0, $2zDt6.z).string()
    }).array(),
    ccRecipients: (0, $2zDt6.z).object({
        name: (0, $2zDt6.z).string().nullable(),
        email: (0, $2zDt6.z).string()
    }).array(),
    subject: (0, $2zDt6.z).string(),
    body: (0, $2zDt6.z).string(),
    sentAt: (0, $2zDt6.z).coerce.date(),
    hasAttachments: (0, $2zDt6.z).boolean(),
    userFrom: (0, $210qL.User).pick({
        id: true,
        isAdmin: true,
        type: true
    }).nullable(),
    userTo: (0, $210qL.User).pick({
        id: true,
        isAdmin: true,
        type: true
    }).nullable()
});

});


parcelRegister("1O6bo", function(module, exports) {

$parcel$export(module.exports, "onboardingEndpoints", () => $150f41b32462cb42$export$48e4b46b31a09ba3);
$parcel$export(module.exports, "onboardingRequests", () => $150f41b32462cb42$export$21e361b4b2873012);
$parcel$export(module.exports, "onboardingResponses", () => $150f41b32462cb42$export$91feee9a5af9a410);

var $2zDt6 = parcelRequire("2zDt6");

var $4gUyz = parcelRequire("4gUyz");

var $4cd6R = parcelRequire("4cd6R");

var $lIQh8 = parcelRequire("lIQh8");

var $e4acA = parcelRequire("e4acA");

var $7MlKx = parcelRequire("7MlKx");

var $9JXBn = parcelRequire("9JXBn");

var $JRp7q = parcelRequire("JRp7q");
var $150f41b32462cb42$export$48e4b46b31a09ba3 = {
    "onboarding.bookCall.done": function(p) {
        return [
            "up",
            "post",
            "/welcome/".concat(p.teamDomain, "/book_call")
        ];
    },
    "onboarding.members.invite": function(p) {
        return [
            "up",
            "post",
            "/welcome/".concat(p.teamDomain, "/invite_team")
        ];
    },
    "onboarding.startTrial": function(p) {
        return [
            "up",
            "post",
            "/welcome/".concat(p.teamDomain, "/start_trial")
        ];
    },
    "onboarding.purchase.plans": function(p) {
        return [
            "up",
            "get",
            "/welcome/".concat(p.teamDomain, "/purchase/plans")
        ];
    },
    "onboarding.purchase.card.token": function(p) {
        return [
            "up",
            "get",
            "/welcome/".concat(p.teamDomain, "/purchase/card/token")
        ];
    },
    "onboarding.purchase.card.add": function(p) {
        return [
            "up",
            "post",
            "/welcome/".concat(p.teamDomain, "/purchase/card")
        ];
    },
    "onboarding.purchase.billing.update": function(p) {
        return [
            "up",
            "post",
            "/welcome/".concat(p.teamDomain, "/purchase/billing")
        ];
    },
    "onboarding.purchase.plans.show": function(p) {
        return [
            "up",
            "get",
            "/welcome/".concat(p.teamDomain, "/purchase/plans/").concat(p.planId)
        ];
    },
    "onboarding.purchase.plans.subscribe": function(p) {
        return [
            "up",
            "post",
            "/welcome/".concat(p.teamDomain, "/purchase/plans/").concat(p.planId)
        ];
    }
};
var $150f41b32462cb42$export$21e361b4b2873012 = {
    "onboarding.bookCall.done": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "onboarding.members.invite": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        email: (0, $2zDt6.z).string()
    }),
    "onboarding.startTrial": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        product: (0, $lIQh8.Product)
    }),
    "onboarding.purchase.plans": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "onboarding.purchase.card.token": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "onboarding.purchase.card.add": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        intentTokenId: (0, $2zDt6.z).string()
    }),
    "onboarding.purchase.billing.update": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        vatNumber: (0, $2zDt6.z).string().optional().nullable(),
        invoiceName: (0, $2zDt6.z).string().optional().nullable(),
        invoiceAddress: (0, $2zDt6.z).string().optional().nullable(),
        invoiceCountry: (0, $4gUyz.CountryCode).nullable(),
        invoiceZip: (0, $2zDt6.z).string().optional().nullable(),
        invoiceState: (0, $2zDt6.z).string().optional().nullable(),
        invoiceEmail: (0, $2zDt6.z).string().optional().nullable()
    }),
    "onboarding.purchase.plans.show": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        planId: (0, $2zDt6.z).string().optional(),
        licenses: (0, $2zDt6.z).number().optional().nullable(),
        period: (0, $7MlKx.PlanPeriod).optional().nullable()
    }),
    "onboarding.purchase.plans.subscribe": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        planId: (0, $2zDt6.z).string().optional(),
        licenses: (0, $2zDt6.z).number(),
        autoAdjustLicenses: (0, $2zDt6.z).custom(),
        period: (0, $7MlKx.PlanPeriod)
    })
};
var $150f41b32462cb42$export$91feee9a5af9a410 = {
    "onboarding.bookCall.done": (0, $JRp7q.SuccessResponse),
    "onboarding.members.invite": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        inviteErrors: (0, $2zDt6.z).object({
            email: (0, $2zDt6.z).string()
        })
    })),
    "onboarding.startTrial": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("no_trial_available")
    })),
    "onboarding.purchase.plans": (0, $2zDt6.z).union([
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("subaccount"),
            billingOwner: (0, $9JXBn.TeamBaseData)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("no_changes_allowed")
        }),
        (0, $JRp7q.SuccessResponse).extend({
            plans: (0, $7MlKx.Plan).array(),
            onTrial: (0, $2zDt6.z).boolean(),
            trialEndDate: (0, $2zDt6.z).coerce.date().nullable(),
            initialLicenseCount: (0, $2zDt6.z).number(),
            currency: (0, $2zDt6.z).enum([
                "usd",
                "gbp",
                "eur"
            ])
        })
    ]),
    "onboarding.purchase.card.token": (0, $JRp7q.SuccessResponse).extend({
        intentToken: (0, $2zDt6.z).object({
            id: (0, $2zDt6.z).string(),
            clientSecret: (0, $2zDt6.z).string()
        }),
        stripePublicKey: (0, $2zDt6.z).string()
    }),
    "onboarding.purchase.card.add": (0, $JRp7q.SuccessResponse).extend({
        paymentSource: (0, $4cd6R.PaymentSourceData),
        taxInfo: (0, $e4acA.TaxInfo)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("stripe_error"),
        stripeError: (0, $2zDt6.z).string()
    })),
    "onboarding.purchase.billing.update": (0, $JRp7q.SuccessResponse).extend({
        taxInfo: (0, $e4acA.TaxInfo)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $2zDt6.z).record($150f41b32462cb42$export$21e361b4b2873012["onboarding.purchase.billing.update"].keyof(), (0, $2zDt6.z).string())
    })),
    "onboarding.purchase.plans.show": (0, $JRp7q.SuccessResponse).extend({
        plan: (0, $7MlKx.Plan),
        taxInfo: (0, $e4acA.TaxInfo)
    }),
    "onboarding.purchase.plans.subscribe": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("stripe_error"),
        stripeError: (0, $2zDt6.z).string()
    }))
};

});
parcelRegister("e4acA", function(module, exports) {

$parcel$export(module.exports, "TaxInfo", () => $a3d95a567fd168e1$export$30879ff8b5a6c7b9);

var $2zDt6 = parcelRequire("2zDt6");

var $4gUyz = parcelRequire("4gUyz");
var $a3d95a567fd168e1$export$30879ff8b5a6c7b9 = (0, $2zDt6.z).object({
    vatNumber: (0, $2zDt6.z).string().optional().nullable(),
    vatName: (0, $2zDt6.z).string().optional().nullable(),
    vatAddress: (0, $2zDt6.z).string().optional().nullable(),
    vatCountry: (0, $4gUyz.CountryCode).optional().nullable(),
    country: (0, $4gUyz.CountryCode).optional().nullable(),
    taxRate: (0, $2zDt6.z).number(),
    taxType: (0, $2zDt6.z).enum([
        "vat",
        "sales"
    ])
});

});


parcelRegister("dF56t", function(module, exports) {

$parcel$export(module.exports, "settingsEndpoints", () => $9f231021bc31738a$export$94a4928cd7b4e83a);
$parcel$export(module.exports, "settingsRequests", () => $9f231021bc31738a$export$ce6630c02852c92b);
$parcel$export(module.exports, "settingsResponses", () => $9f231021bc31738a$export$f1268b58338a9612);

var $2zDt6 = parcelRequire("2zDt6");

var $01O3F = parcelRequire("01O3F");

var $isBZy = parcelRequire("isBZy");
parcelRequire("2cFN9");
var $e4fCO = parcelRequire("e4fCO");
var $c8ifE = parcelRequire("c8ifE");
var $bs0Gy = parcelRequire("bs0Gy");
var $lYoSC = parcelRequire("lYoSC");
var $9vDau = parcelRequire("9vDau");

var $7GbXT = parcelRequire("7GbXT");

var $4gUyz = parcelRequire("4gUyz");

var $j6Pkg = parcelRequire("j6Pkg");

var $4cd6R = parcelRequire("4cd6R");

var $lIQh8 = parcelRequire("lIQh8");

var $lbXII = parcelRequire("lbXII");

var $gCU2M = parcelRequire("gCU2M");

var $ammTY = parcelRequire("ammTY");

var $9JXBn = parcelRequire("9JXBn");

var $5a0dB = parcelRequire("5a0dB");

var $210qL = parcelRequire("210qL");

var $6nNCC = parcelRequire("6nNCC");

var $JRp7q = parcelRequire("JRp7q");
var $9f231021bc31738a$export$94a4928cd7b4e83a = {
    "up.settings.personal.setup": function() {
        return [
            "up",
            "get",
            "/settings/personal/setup"
        ];
    },
    "up.settings.personal.update": function() {
        return [
            "up",
            "put",
            "/settings/personal"
        ];
    },
    "up.settings.personal.password.update": function() {
        return [
            "up",
            "put",
            "/settings/personal/password"
        ];
    },
    "up.settings.personal.mfa.disable": function() {
        return [
            "up",
            "delete",
            "/settings/personal/mfa"
        ];
    },
    "up.settings.general.setup": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/setup")
        ];
    },
    "up.settings.general.update": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain)
        ];
    },
    "up.reporting.usage": function(p) {
        return [
            "up",
            "get",
            "/usage/".concat(p.teamDomain, "/index")
        ];
    },
    "up.visitorData.index": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/visitor-data/index")
        ];
    },
    "up.visitorData.delete": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/visitor-data/").concat(p.visitorId)
        ];
    },
    "up.members.index": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/members/index")
        ];
    },
    "up.members.invite.index": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/members/invites/index")
        ];
    },
    "up.members.delete": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/members/").concat(p.memberId)
        ];
    },
    "up.members.resetPassword": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/members/").concat(p.memberId, "/password")
        ];
    },
    "up.members.resetMfa": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/members/").concat(p.memberId, "/mfa")
        ];
    },
    "up.members.logout": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/members/").concat(p.memberId, "/session")
        ];
    },
    "up.members.invite": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/members/invites")
        ];
    },
    "up.members.invite.resend": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/members/invites/").concat(p.inviteId, "/resend")
        ];
    },
    "up.members.invite.revoke": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/members/invites/").concat(p.inviteId)
        ];
    },
    "up.members.permissions.update": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/members/").concat(p.memberId)
        ];
    },
    "up.members.invite.permissions.update": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/members/invites/").concat(p.inviteId)
        ];
    },
    "up.members.transferOwnership": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/members/").concat(p.memberId, "/transfer")
        ];
    },
    "up.billing.history.details": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/billing/history/details")
        ];
    },
    "up.billing.data": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/billing/data")
        ];
    },
    "up.billing.link": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/billing/link")
        ];
    },
    "up.billing.unlink": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/billing/link")
        ];
    },
    "up.billing.card.intent": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/billing/card/token")
        ];
    },
    "up.billing.card.update": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/billing/card")
        ];
    },
    "up.billing.licenses.update": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/billing/licenses")
        ];
    },
    "up.billing.subscription.cancel": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/billing/subscription")
        ];
    },
    "up.billing.subscription.resume": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/billing/subscription/on")
        ];
    },
    "up.billing.update": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/billing/details")
        ];
    },
    "up.billing.sessionCredit.buy": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/billing/session-credit/buy")
        ];
    },
    "up.billing.sessionCredit.settings.update": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/billing/session-credit/settings")
        ];
    },
    "up.settings.integrations.intercom.ssoOff": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/intercom/").concat(p.integrationId, "/sso/off")
        ];
    },
    "up.settings.integrations.intercom.customize": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/integrations/intercom/").concat(p.integrationId, "/settings")
        ];
    },
    "up.settings.integrations.intercom.ssoOn": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/intercom/").concat(p.integrationId, "/sso/on")
        ];
    },
    "up.settings.integrations.intercom.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/intercom/").concat(p.integrationId)
        ];
    },
    "up.settings.integrations.google.ssoOff": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/google_oauth2/").concat(p.integrationId, "/sso/off")
        ];
    },
    "up.settings.integrations.google.ssoOn": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/google_oauth2/").concat(p.integrationId, "/sso/on")
        ];
    },
    "up.settings.integrations.google.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/google_oauth2/").concat(p.integrationId)
        ];
    },
    "up.settings.integrations.salesforce.setup": function(p) {
        return [
            "up",
            "get",
            "/settings/teams/".concat(p.teamDomain, "/integrations/add/salesforce").concat(p.sandbox ? "?sandbox=true" : "")
        ];
    },
    "up.settings.integrations.salesforce.ssoOff": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/salesforce/").concat(p.integrationId, "/sso/off")
        ];
    },
    "up.settings.integrations.salesforce.ssoOn": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/salesforce/").concat(p.integrationId, "/sso/on")
        ];
    },
    "up.settings.integrations.salesforce.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/salesforce/").concat(p.integrationId)
        ];
    },
    "up.settings.integrations.salesforce.customize": function(p) {
        return [
            "up",
            "put",
            "/settings/teams/".concat(p.teamDomain, "/integrations/salesforce/").concat(p.integrationId, "/settings")
        ];
    },
    "up.settings.integrations.zapier.setup": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/add/zapier")
        ];
    },
    "up.settings.integrations.zapier.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/zapier/").concat(p.integrationId)
        ];
    },
    "up.settings.integrations.zendesk.setup": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/add/zendesk")
        ];
    },
    "up.settings.integrations.zendesk.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/zendesk/").concat(p.integrationId)
        ];
    },
    "up.settings.integrations.freshchat.setup": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/add/freshchat")
        ];
    },
    "up.settings.integrations.freshchat.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/freshchat/").concat(p.integrationId)
        ];
    },
    "up.settings.integrations.twilioFlex.setup": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/add/twilio_flex")
        ];
    },
    "up.settings.integrations.twilioFlex.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/twilio_flex/").concat(p.integrationId)
        ];
    },
    "up.settings.integrations.front.setup": function(p) {
        return [
            "up",
            "post",
            "/settings/teams/".concat(p.teamDomain, "/integrations/add/front")
        ];
    },
    "up.settings.integrations.front.remove": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/integrations/front/").concat(p.integrationId)
        ];
    },
    "up.quotes.sign": function(p) {
        return [
            "up",
            "post",
            "/quote/".concat(p.quotePublicKey, "/sign")
        ];
    },
    "up.invoice.failed": function(p) {
        return [
            "up",
            "get",
            "/invoice/".concat(p.invoiceId, "/failed/data")
        ];
    },
    "up.invoice.reportPaid": function(p) {
        return [
            "up",
            "post",
            "/invoice/".concat(p.invoiceId, "/failed/paid")
        ];
    },
    "up.settings.teams.delete": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/delete_team")
        ];
    },
    "up.settings.teams.leave": function(p) {
        return [
            "up",
            "delete",
            "/settings/teams/".concat(p.teamDomain, "/leave")
        ];
    }
};
var $9f231021bc31738a$export$ce6630c02852c92b = {
    "up.settings.personal.setup": (0, $2zDt6.z).undefined(),
    "up.settings.personal.update": (0, $2zDt6.z).object({
        user: (0, $210qL.User).pick({
            name: true,
            email: true,
            phoneNumber: true,
            subscribedToEmails: true,
            username: true,
            settingLivedocumentViewNotification: true,
            language: true
        }).partial()
    }),
    "up.settings.personal.password.update": (0, $2zDt6.z).object({
        user: (0, $2zDt6.z).object({
            password: (0, $2zDt6.z).string()
        })
    }),
    "up.settings.personal.mfa.disable": (0, $2zDt6.z).undefined(),
    "up.settings.general.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.settings.general.update": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        team: (0, $2zDt6.z).object({
            settings: (0, $2zDt6.z).object({
                settings: (0, $2zDt6.z).custom().optional(),
                onPremise: (0, $2zDt6.z).custom().optional()
            })
        })
    }),
    "up.reporting.usage": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        from: (0, $2zDt6.z).coerce.date(),
        to: (0, $2zDt6.z).coerce.date()
    }),
    "up.visitorData.index": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        search: (0, $2zDt6.z).string()
    }),
    "up.visitorData.delete": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        visitorId: (0, $2zDt6.z).string()
    }),
    "up.members.index": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        page: (0, $2zDt6.z).number().optional().nullable(),
        search: (0, $2zDt6.z).string().optional().nullable()
    }),
    "up.members.invite.index": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        page: (0, $2zDt6.z).number().optional().nullable()
    }),
    "up.members.delete": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        memberId: (0, $2zDt6.z).string()
    }),
    "up.members.resetPassword": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        memberId: (0, $2zDt6.z).string()
    }),
    "up.members.resetMfa": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        memberId: (0, $2zDt6.z).string()
    }),
    "up.members.logout": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        memberId: (0, $2zDt6.z).string()
    }),
    "up.members.invite": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        email: (0, $2zDt6.z).string()
    }),
    "up.members.invite.resend": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        inviteId: (0, $2zDt6.z).string()
    }),
    "up.members.transferOwnership": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        memberId: (0, $2zDt6.z).string()
    }),
    "up.members.invite.revoke": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        inviteId: (0, $2zDt6.z).string()
    }),
    "up.members.permissions.update": (0, $2zDt6.z).object({
        permissions: (0, $2zDt6.z).object({
            canAccessVisitorsList: (0, $2zDt6.z).boolean().optional(),
            canScreenshare: (0, $2zDt6.z).boolean().optional(),
            canAccessSettings: (0, $2zDt6.z).boolean().optional(),
            canManageUsers: (0, $2zDt6.z).boolean().optional(),
            canManageBilling: (0, $2zDt6.z).boolean().optional(),
            canAccessActivityLog: (0, $2zDt6.z).boolean().optional(),
            canUseConsole: (0, $2zDt6.z).boolean().optional(),
            canDeleteVisitorData: (0, $2zDt6.z).boolean().optional(),
            canViewReporting: (0, $2zDt6.z).boolean().optional(),
            canPurchase: (0, $2zDt6.z).boolean().optional()
        }),
        teamDomain: (0, $2zDt6.z).string(),
        memberId: (0, $2zDt6.z).string()
    }),
    "up.members.invite.permissions.update": (0, $2zDt6.z).object({
        permissions: (0, $2zDt6.z).object({
            canAccessVisitorsList: (0, $2zDt6.z).boolean().optional(),
            canScreenshare: (0, $2zDt6.z).boolean().optional(),
            canAccessSettings: (0, $2zDt6.z).boolean().optional(),
            canManageUsers: (0, $2zDt6.z).boolean().optional(),
            canManageBilling: (0, $2zDt6.z).boolean().optional(),
            canAccessActivityLog: (0, $2zDt6.z).boolean().optional(),
            canUseConsole: (0, $2zDt6.z).boolean().optional(),
            canDeleteVisitorData: (0, $2zDt6.z).boolean().optional(),
            canViewReporting: (0, $2zDt6.z).boolean().optional(),
            canPurchase: (0, $2zDt6.z).boolean().optional()
        }),
        teamDomain: (0, $2zDt6.z).string(),
        inviteId: (0, $2zDt6.z).string()
    }),
    "up.billing.history.details": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        page: (0, $2zDt6.z).number().optional().nullable()
    }),
    "up.billing.data": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.billing.link": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        subaccountId: (0, $2zDt6.z).string()
    }),
    "up.billing.unlink": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        subaccountId: (0, $2zDt6.z).string()
    }),
    "up.billing.card.intent": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.billing.card.update": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        intentTokenId: (0, $2zDt6.z).string()
    }),
    "up.billing.licenses.update": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        activeLicenses: (0, $2zDt6.z).number(),
        autoAdjustLicenses: (0, $2zDt6.z).custom().optional()
    }),
    "up.billing.subscription.cancel": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        cancelReason: (0, $2zDt6.z).string(),
        cancelDetails: (0, $2zDt6.z).string().optional()
    }),
    "up.billing.subscription.resume": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.billing.update": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        vatNumber: (0, $2zDt6.z).string().optional().nullable(),
        invoiceName: (0, $2zDt6.z).string().optional().nullable(),
        invoiceAddress: (0, $2zDt6.z).string().optional().nullable(),
        invoiceCountry: (0, $4gUyz.CountryCode).nullable(),
        invoiceZip: (0, $2zDt6.z).string().optional().nullable(),
        invoiceState: (0, $gCU2M.UsStateCode).optional().nullable(),
        invoiceEmail: (0, $2zDt6.z).string().optional().nullable()
    }),
    "up.billing.sessionCredit.buy": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        hours: (0, $2zDt6.z).number()
    }),
    "up.billing.sessionCredit.settings.update": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        team: (0, $9JXBn.TeamBillingInfoData).pick({
            settingSessionTimeCreditAutoTopUpEnabled: true,
            settingSessionTimeCreditAutoTopUpTrigger: true,
            settingSessionTimeCreditAutoTopUpMultiplier: true
        })
    }),
    "up.settings.integrations.intercom.ssoOff": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.intercom.ssoOn": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.intercom.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.intercom.customize": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string(),
        intercomIntegration: (0, $2zDt6.z).object({
            settingPromptTitle: (0, $2zDt6.z).string(),
            settingPromptMessage: (0, $2zDt6.z).string(),
            settingPromptAcceptText: (0, $2zDt6.z).string(),
            settingPromptRefuseText: (0, $2zDt6.z).string(),
            settingPromptExplanation: (0, $2zDt6.z).string(),
            settingStartMessage: (0, $2zDt6.z).string(),
            settingAddSessionSummaryToIntercom: (0, $2zDt6.z).boolean().default(true)
        }).partial()
    }),
    "up.settings.integrations.google.ssoOff": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.google.ssoOn": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.google.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.salesforce.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        sandbox: (0, $2zDt6.z).boolean().optional()
    }),
    "up.settings.integrations.salesforce.customize": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string(),
        salesforceIntegration: (0, $2zDt6.z).object({
            settingFieldMapping: (0, $2zDt6.z).string(),
            settingCreateCallFromSession: (0, $2zDt6.z).boolean().default(false)
        }).partial()
    }),
    "up.settings.integrations.salesforce.ssoOff": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.salesforce.ssoOn": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.salesforce.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.zapier.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.zapier.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.zendesk.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.zendesk.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.freshchat.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.freshchat.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.front.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        apiKey: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.front.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.twilioFlex.setup": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.settings.integrations.twilioFlex.remove": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string(),
        integrationId: (0, $2zDt6.z).string()
    }),
    "up.quotes.sign": (0, $2zDt6.z).object({
        quotePublicKey: (0, $2zDt6.z).string(),
        signature: (0, $2zDt6.z).string(),
        signatureToken: (0, $2zDt6.z).string()
    }),
    "up.invoice.failed": (0, $2zDt6.z).object({
        invoiceId: (0, $2zDt6.z).string()
    }),
    "up.invoice.reportPaid": (0, $2zDt6.z).object({
        invoiceId: (0, $2zDt6.z).string(),
        updateCardTokenId: (0, $2zDt6.z).string().optional()
    }),
    "up.settings.teams.delete": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    }),
    "up.settings.teams.leave": (0, $2zDt6.z).object({
        teamDomain: (0, $2zDt6.z).string()
    })
};
var $9f231021bc31738a$export$f1268b58338a9612 = {
    "up.settings.personal.setup": (0, $JRp7q.SuccessResponse).extend({
        user: (0, $210qL.User).pick({
            name: true,
            email: true,
            phoneNumber: true,
            subscribedToEmails: true,
            username: true,
            settingLivedocumentViewNotification: true,
            language: true,
            passwordEnableNeeded: true,
            password: true,
            mfaEnabled: true
        }),
        sessions: (0, $2zDt6.z).object({
            id: (0, $2zDt6.z).string(),
            device: (0, $2zDt6.z).string(),
            lastSeenAt: (0, $2zDt6.z).coerce.date().nullable()
        }).array(),
        currentSessionId: (0, $2zDt6.z).string(),
        allowPassword: (0, $2zDt6.z).boolean()
    }),
    "up.settings.personal.update": (0, $JRp7q.SuccessResponse).extend({
        checkEmail: (0, $2zDt6.z).boolean()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        userErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            name: (0, $2zDt6.z).string(),
            email: (0, $2zDt6.z).string(),
            phoneNumber: (0, $2zDt6.z).string(),
            username: (0, $2zDt6.z).string()
        }))
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("admin_cannot_change_email")
    }))),
    "up.settings.personal.password.update": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        userErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            password: (0, $2zDt6.z).string()
        }))
    })),
    "up.settings.personal.mfa.disable": (0, $JRp7q.SuccessResponse),
    "up.settings.general.setup": (0, $JRp7q.SuccessResponse).extend({
        settings: (0, $2zDt6.z).object({
            settings: (0, $2zDt6.z).custom(),
            onPremiseSettings: (0, $2zDt6.z).custom().nullable()
        }),
        features: (0, $j6Pkg.Feature).array(),
        products: (0, $lIQh8.Product).array(),
        beta: (0, $2zDt6.z).boolean()
    }),
    "up.settings.general.update": (0, $JRp7q.SuccessResponse).extend({
        settings: (0, $2zDt6.z).object({
            settings: (0, $2zDt6.z).custom(),
            onPremiseSettings: (0, $2zDt6.z).custom().nullable()
        })
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        validationErrors: (0, $2zDt6.z).record((0, $2zDt6.z).string(), (0, $2zDt6.z).string())
    })),
    "up.reporting.usage": (0, $JRp7q.SuccessResponse).extend({
        usage: (0, $ammTY.CobrowsingTeamUsage),
        previousUsage: (0, $ammTY.CobrowsingTeamUsage)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("record_not_found")
    })),
    "up.visitorData.index": (0, $JRp7q.SuccessResponse).extend({
        visitors: (0, $6nNCC.VisitorModel).array()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("server_unavailable")
    })),
    "up.visitorData.delete": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).enum([
            "server_unavailable",
            "visitor_not_deletable"
        ])
    })),
    "up.members.index": (0, $JRp7q.SuccessResponse).extend({
        pagy: (0, $JRp7q.Pagy),
        memberships: (0, $5a0dB.TeamMembershipTeamManagementData).array(),
        currentUserMembership: (0, $5a0dB.TeamMembershipTeamManagementData)
    }),
    "up.members.invite.index": (0, $JRp7q.SuccessResponse).extend({
        pagy: (0, $JRp7q.Pagy),
        invites: (0, $5a0dB.Invite).array(),
        currentUserMembership: (0, $5a0dB.TeamMembershipTeamManagementData),
        signupOptions: (0, $2zDt6.z).object({
            link: (0, $lbXII.Url),
            options: (0, $2zDt6.z).object({
                saml: (0, $2zDt6.z).boolean(),
                email: (0, $2zDt6.z).string().nullable(),
                sso: (0, $2zDt6.z).boolean()
            })
        })
    }),
    "up.members.permissions.update": (0, $JRp7q.SuccessResponse),
    "up.members.invite.permissions.update": (0, $JRp7q.SuccessResponse),
    "up.members.logout": (0, $JRp7q.SuccessResponse),
    "up.members.delete": (0, $JRp7q.SuccessResponse),
    "up.members.resetPassword": (0, $JRp7q.SuccessResponse),
    "up.members.resetMfa": (0, $JRp7q.SuccessResponse),
    "up.members.invite.resend": (0, $JRp7q.SuccessResponse).extend({
        invite: (0, $5a0dB.Invite),
        removeId: (0, $2zDt6.z).string()
    }),
    "up.members.invite.revoke": (0, $JRp7q.SuccessResponse),
    "up.members.transferOwnership": (0, $JRp7q.SuccessResponse),
    "up.members.invite": (0, $JRp7q.SuccessResponse).extend({
        invite: (0, $5a0dB.Invite)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        inviteErrors: (0, $2zDt6.z).object({
            email: (0, $2zDt6.z).string()
        })
    })),
    "up.billing.history.details": (0, $JRp7q.SuccessResponse).extend({
        teamInvoices: (0, $7GbXT.Invoice).array(),
        teamCharges: (0, $isBZy.Charge).omit({
            amountRefundable: true
        }).array()
    }),
    "up.billing.data": (0, $JRp7q.SuccessResponse).extend({
        team: (0, $9JXBn.TeamBillingInfoData),
        subaccounts: (0, $9JXBn.TeamBillingInfoData).array(),
        possibleBillingOwners: (0, $9JXBn.TeamBillingInfoData).array()
    }),
    "up.billing.link": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $2zDt6.z).object({
            billingOwner: (0, $2zDt6.z).string()
        })
    })),
    "up.billing.unlink": (0, $JRp7q.SuccessResponse),
    "up.billing.card.intent": (0, $JRp7q.SuccessResponse).extend({
        intentToken: (0, $2zDt6.z).object({
            id: (0, $2zDt6.z).string(),
            clientSecret: (0, $2zDt6.z).string(),
            publicKey: (0, $2zDt6.z).string()
        })
    }),
    "up.billing.card.update": (0, $JRp7q.SuccessResponse).extend({
        source: (0, $4cd6R.PaymentSourceData)
    }),
    "up.billing.licenses.update": (0, $JRp7q.SuccessResponse).extend({
        team: (0, $9JXBn.TeamBillingInfoData)
    }),
    "up.billing.subscription.cancel": (0, $JRp7q.SuccessResponse).extend({
        team: (0, $9JXBn.TeamBillingInfoData)
    }),
    "up.billing.subscription.resume": (0, $JRp7q.SuccessResponse).extend({
        team: (0, $9JXBn.TeamBillingInfoData)
    }),
    "up.billing.update": (0, $JRp7q.SuccessResponse).extend({
        invoiceDetails: (0, $2zDt6.z).object({
            invoiceAddress: (0, $2zDt6.z).string().nullable(),
            invoiceCountry: (0, $2zDt6.z).string().nullable(),
            invoiceEmail: (0, $2zDt6.z).string().nullable(),
            invoiceName: (0, $2zDt6.z).string().nullable(),
            invoiceZip: (0, $2zDt6.z).string().nullable(),
            invoiceState: (0, $2zDt6.z).string().nullable(),
            vatNumber: (0, $2zDt6.z).string().nullable()
        })
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        teamErrors: (0, $2zDt6.z).record($9f231021bc31738a$export$ce6630c02852c92b["up.billing.update"].keyof(), (0, $2zDt6.z).string())
    })),
    "up.billing.sessionCredit.buy": (0, $JRp7q.SuccessResponse).extend({
        team: (0, $9JXBn.TeamBillingInfoData)
    }),
    "up.billing.sessionCredit.settings.update": (0, $JRp7q.SuccessResponse).extend({
        team: (0, $9JXBn.TeamBillingInfoData)
    }),
    "up.settings.integrations.intercom.ssoOff": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.intercom.ssoOn": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.intercom.customize": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.intercom.remove": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.google.ssoOff": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.google.ssoOn": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.google.remove": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.salesforce.setup": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.salesforce.ssoOff": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.salesforce.ssoOn": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.salesforce.remove": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.salesforce.customize": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        integrationErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            settingFieldMapping: (0, $2zDt6.z).string()
        }))
    })),
    "up.settings.integrations.zapier.setup": (0, $JRp7q.SuccessResponse).extend({
        integration: (0, $lYoSC.ZapierIntegration)
    }),
    "up.settings.integrations.zapier.remove": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.zendesk.setup": (0, $JRp7q.SuccessResponse).extend({
        integration: (0, $9vDau.ZendeskIntegration)
    }),
    "up.settings.integrations.zendesk.remove": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.freshchat.setup": (0, $JRp7q.SuccessResponse).extend({
        integration: (0, $e4fCO.FreshchatIntegration)
    }),
    "up.settings.integrations.freshchat.remove": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.front.setup": (0, $JRp7q.SuccessResponse).extend({
        integration: (0, $c8ifE.FrontIntegration)
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("validation_error"),
        integrationErrors: (0, $01O3F.zNoEmptyObject)((0, $2zDt6.z).object({
            apiKey: (0, $2zDt6.z).string()
        }))
    })),
    "up.settings.integrations.front.remove": (0, $JRp7q.SuccessResponse),
    "up.settings.integrations.twilioFlex.setup": (0, $JRp7q.SuccessResponse).extend({
        integration: (0, $bs0Gy.TwilioFlexIntegration)
    }),
    "up.settings.integrations.twilioFlex.remove": (0, $JRp7q.SuccessResponse),
    "up.quotes.sign": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("signature_error"),
        signatureError: (0, $2zDt6.z).string()
    })),
    "up.invoice.failed": (0, $JRp7q.SuccessResponse).extend({
        existingPaymentSource: (0, $4cd6R.PaymentSourceData).nullable(),
        invoice: (0, $7GbXT.Invoice),
        intentToken: (0, $2zDt6.z).object({
            id: (0, $2zDt6.z).string(),
            clientSecret: (0, $2zDt6.z).string(),
            publicKey: (0, $2zDt6.z).string()
        })
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("invoice_not_found")
    })).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("invoice_paid")
    })),
    "up.invoice.reportPaid": (0, $JRp7q.SuccessResponse),
    "up.settings.teams.delete": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("cannot_delete_team")
    })),
    "up.settings.teams.leave": (0, $JRp7q.SuccessResponse).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("user_is_owner")
    }))
};

});
parcelRegister("2cFN9", function(module, exports) {

$parcel$export(module.exports, "FreshchatIntegration", () => (parcelRequire("e4fCO")).FreshchatIntegration);
$parcel$export(module.exports, "FrontIntegration", () => (parcelRequire("c8ifE")).FrontIntegration);
$parcel$export(module.exports, "TwilioFlexIntegration", () => (parcelRequire("bs0Gy")).TwilioFlexIntegration);
$parcel$export(module.exports, "ZapierIntegration", () => (parcelRequire("lYoSC")).ZapierIntegration);
$parcel$export(module.exports, "ZendeskIntegration", () => (parcelRequire("9vDau")).ZendeskIntegration);

var $e4fCO = parcelRequire("e4fCO");

var $c8ifE = parcelRequire("c8ifE");

var $bs0Gy = parcelRequire("bs0Gy");

var $lYoSC = parcelRequire("lYoSC");

var $9vDau = parcelRequire("9vDau");

});
parcelRegister("e4fCO", function(module, exports) {

$parcel$export(module.exports, "FreshchatIntegration", () => $a3dd8f34efb8963b$export$709599196b16d04d);

var $2zDt6 = parcelRequire("2zDt6");
var $a3dd8f34efb8963b$export$709599196b16d04d = (0, $2zDt6.default).object({
    id: (0, $2zDt6.default).custom(),
    createdAt: (0, $2zDt6.default).coerce.date(),
    integrationType: (0, $2zDt6.default).literal("freshchat"),
    isUsed: (0, $2zDt6.default).boolean(),
    lastUsedAt: (0, $2zDt6.default).coerce.date(),
    name: (0, $2zDt6.default).string(),
    teamId: (0, $2zDt6.default).custom(),
    type: (0, $2zDt6.default).literal("freshchat_integration")
});

});

parcelRegister("c8ifE", function(module, exports) {

$parcel$export(module.exports, "FrontIntegration", () => $8d5463c54b1a3c4d$export$b6550ae80b542cd0);

var $2zDt6 = parcelRequire("2zDt6");
var $8d5463c54b1a3c4d$export$b6550ae80b542cd0 = (0, $2zDt6.default).object({
    id: (0, $2zDt6.default).custom(),
    createdAt: (0, $2zDt6.default).coerce.date(),
    integrationType: (0, $2zDt6.default).literal("front"),
    apiKey: (0, $2zDt6.default).string(),
    isUsed: (0, $2zDt6.default).boolean(),
    lastUsedAt: (0, $2zDt6.default).coerce.date(),
    name: (0, $2zDt6.default).string(),
    teamId: (0, $2zDt6.default).custom(),
    type: (0, $2zDt6.default).literal("front_integration")
});

});

parcelRegister("bs0Gy", function(module, exports) {

$parcel$export(module.exports, "TwilioFlexIntegration", () => $8562d753583855e6$export$991c36b4d71849eb);

var $2zDt6 = parcelRequire("2zDt6");
var $8562d753583855e6$export$991c36b4d71849eb = (0, $2zDt6.default).object({
    id: (0, $2zDt6.default).custom(),
    createdAt: (0, $2zDt6.default).coerce.date(),
    integrationType: (0, $2zDt6.default).literal("twilio_flex"),
    isUsed: (0, $2zDt6.default).boolean(),
    lastUsedAt: (0, $2zDt6.default).coerce.date(),
    name: (0, $2zDt6.default).string(),
    teamId: (0, $2zDt6.default).custom(),
    type: (0, $2zDt6.default).literal("twilio_flex_integration")
});

});

parcelRegister("lYoSC", function(module, exports) {

$parcel$export(module.exports, "ZapierIntegration", () => $fff280315f179e04$export$e2044da4b8859dd1);

var $2zDt6 = parcelRequire("2zDt6");
var $fff280315f179e04$export$e2044da4b8859dd1 = (0, $2zDt6.default).object({
    id: (0, $2zDt6.default).custom(),
    createdAt: (0, $2zDt6.default).coerce.date(),
    integrationType: (0, $2zDt6.default).literal("zapier"),
    isUsed: (0, $2zDt6.default).boolean(),
    lastUsedAt: (0, $2zDt6.default).coerce.date(),
    name: (0, $2zDt6.default).string(),
    teamId: (0, $2zDt6.default).custom(),
    type: (0, $2zDt6.default).literal("zapier_integration")
});

});

parcelRegister("9vDau", function(module, exports) {

$parcel$export(module.exports, "ZendeskIntegration", () => $6ec56445a8cd53d9$export$c5d1d491520a11ad);

var $2zDt6 = parcelRequire("2zDt6");
var $6ec56445a8cd53d9$export$c5d1d491520a11ad = (0, $2zDt6.default).object({
    id: (0, $2zDt6.default).custom(),
    createdAt: (0, $2zDt6.default).coerce.date(),
    integrationType: (0, $2zDt6.default).literal("zendesk"),
    isUsed: (0, $2zDt6.default).boolean(),
    lastUsedAt: (0, $2zDt6.default).coerce.date(),
    name: (0, $2zDt6.default).string(),
    teamId: (0, $2zDt6.default).custom(),
    type: (0, $2zDt6.default).literal("zendesk_integration")
});

});


parcelRegister("5a0dB", function(module, exports) {

$parcel$export(module.exports, "Invite", () => $3c1e0e4665977b19$export$5faba96a460ce625);
$parcel$export(module.exports, "TeamMembershipTeamManagementData", () => $3c1e0e4665977b19$export$43277872e37fd2aa);

var $2zDt6 = parcelRequire("2zDt6");

var $9JXBn = parcelRequire("9JXBn");

var $210qL = parcelRequire("210qL");
var $3c1e0e4665977b19$export$bdcd6983b20d4a9b = (0, $2zDt6.z).object({
    id: (0, $2zDt6.z).custom(),
    isOwner: (0, $2zDt6.z).boolean(),
    inGracePeriod: (0, $2zDt6.z).boolean(),
    createdAt: (0, $2zDt6.z).coerce.date(),
    isOverLimit: (0, $2zDt6.z).boolean(),
    license: (0, $2zDt6.z).boolean(),
    role: (0, $2zDt6.z).enum([
        "owner",
        "administrator",
        "user"
    ]),
    permissions: (0, $2zDt6.z).object({
        canUse: (0, $2zDt6.z).boolean(),
        canManageContent: (0, $2zDt6.z).boolean(),
        canViewReporting: (0, $2zDt6.z).boolean(),
        canManageUsers: (0, $2zDt6.z).boolean(),
        canManageBilling: (0, $2zDt6.z).boolean(),
        canAccessSettings: (0, $2zDt6.z).boolean(),
        canPurchase: (0, $2zDt6.z).boolean()
    }),
    team: (0, $9JXBn.Team).pick({
        id: true,
        domain: true,
        uniqueIdentifier: true,
        type: true
    }),
    type: (0, $2zDt6.z).literal("team_membership")
});
var $3c1e0e4665977b19$export$5faba96a460ce625 = (0, $2zDt6.z).object({
    email: (0, $2zDt6.z).string().email(),
    emailBounced: (0, $2zDt6.z).boolean(),
    expired: (0, $2zDt6.z).boolean(),
    id: (0, $2zDt6.z).string(),
    permissions: (0, $2zDt6.z).object({
        canUse: (0, $2zDt6.z).boolean(),
        canManageContent: (0, $2zDt6.z).boolean(),
        canViewReporting: (0, $2zDt6.z).boolean(),
        canManageUsers: (0, $2zDt6.z).boolean(),
        canManageBilling: (0, $2zDt6.z).boolean(),
        canAccessSettings: (0, $2zDt6.z).boolean()
    }),
    sentAt: (0, $2zDt6.z).coerce.date(),
    type: (0, $2zDt6.z).literal("invite")
});
var $3c1e0e4665977b19$export$43277872e37fd2aa = $3c1e0e4665977b19$export$bdcd6983b20d4a9b.pick({
    id: true,
    createdAt: true,
    inGracePeriod: true,
    isOverLimit: true,
    isOwner: true,
    license: true,
    permissions: true,
    team: true,
    role: true,
    type: true
}).merge((0, $2zDt6.z).object({
    user: (0, $210qL.UserTeamManagementData)
}));

});


parcelRegister("19wxB", function(module, exports) {

$parcel$export(module.exports, "userViewEndpoints", () => $0d6fdfa7f4aa732b$export$b0ce3b2635ed6c84);
$parcel$export(module.exports, "userViewRequests", () => $0d6fdfa7f4aa732b$export$f6a4007b5149a36a);
$parcel$export(module.exports, "userViewResponses", () => $0d6fdfa7f4aa732b$export$dbb32e36a8ed14ec);

var $2zDt6 = parcelRequire("2zDt6");

var $lbXII = parcelRequire("lbXII");

var $6nNCC = parcelRequire("6nNCC");

var $JRp7q = parcelRequire("JRp7q");
var $0d6fdfa7f4aa732b$export$b0ce3b2635ed6c84 = {
    "uv.authToken.exchange": function() {
        return [
            "uv",
            "post",
            "/embed/auth"
        ];
    },
    "uv.visitorsList.token": function() {
        return [
            "uv",
            "get",
            "/list_token"
        ];
    },
    "uv.stats": function() {
        return [
            "uv",
            "get",
            "/stats"
        ];
    },
    "uv.cobrowse.token": function(p) {
        return [
            "uv",
            "post",
            "/w/".concat(p.visitorId, "/token")
        ];
    },
    "uv.cobrowse.feedback": function(p) {
        return [
            "uv",
            "post",
            "/agent_feedback/".concat(p.sessionId)
        ];
    },
    "uv.cobrowse.onPrem.token": function(p) {
        return [
            "uv",
            "post",
            "/onprem_redirect/".concat(p.teamUniqueIdentifier, "/token")
        ];
    },
    "uv.cobrowse.notes.show": function() {
        return [
            "uv",
            "get",
            "/notes"
        ];
    },
    "uv.cobrowse.notes.update": function() {
        return [
            "uv",
            "put",
            "/notes"
        ];
    }
};
var $0d6fdfa7f4aa732b$export$f6a4007b5149a36a = {
    "uv.authToken.exchange": (0, $2zDt6.z).object({
        code: (0, $2zDt6.z).string()
    }),
    "uv.visitorsList.token": (0, $2zDt6.z).undefined(),
    "uv.stats": (0, $2zDt6.z).object({
        astronautMessage: (0, $2zDt6.z).boolean()
    }),
    "uv.cobrowse.token": (0, $2zDt6.z).object({
        visitorId: (0, $2zDt6.z).string(),
        adminOverride: (0, $2zDt6.z).boolean().optional().nullable(),
        confirm: (0, $2zDt6.z).boolean().optional().nullable(),
        source: (0, $2zDt6.z).string().optional().nullable(),
        metadataToken: (0, $2zDt6.z).string().optional().nullable()
    }),
    "uv.cobrowse.feedback": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string(),
        feedback: (0, $2zDt6.z).string().optional(),
        rating: (0, $2zDt6.z).number()
    }),
    "uv.cobrowse.onPrem.token": (0, $2zDt6.z).object({
        teamUniqueIdentifier: (0, $2zDt6.z).string(),
        visitorId: (0, $2zDt6.z).string(),
        confirm: (0, $2zDt6.z).boolean().optional().nullable(),
        metadataToken: (0, $2zDt6.z).string().optional().nullable()
    }),
    "uv.cobrowse.notes.show": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string()
    }),
    "uv.cobrowse.notes.update": (0, $2zDt6.z).object({
        sessionId: (0, $2zDt6.z).string(),
        notes: (0, $2zDt6.z).string().nullable()
    })
};
var $0d6fdfa7f4aa732b$export$dbb32e36a8ed14ec = {
    "uv.authToken.exchange": (0, $JRp7q.SuccessResponse).extend({
        token: (0, $2zDt6.z).string()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("invalid_code")
    })),
    "uv.visitorsList.token": (0, $JRp7q.SuccessResponse).extend({
        token: (0, $2zDt6.z).string(),
        endpoints: (0, $2zDt6.z).string().array(),
        lookupCodeNeeded: (0, $2zDt6.z).boolean(),
        requestAgentButtonEnabled: (0, $2zDt6.z).boolean(),
        onPremise: (0, $2zDt6.z).boolean(),
        onPremiseIdentifier: (0, $2zDt6.z).string().optional().nullable()
    }).or((0, $JRp7q.ErrorResponse).extend({
        error: (0, $2zDt6.z).literal("no_teams")
    })),
    "uv.stats": (0, $JRp7q.SuccessResponse).extend({
        stats: (0, $2zDt6.z).object({
            online: (0, $2zDt6.z).number().nullable(),
            totalSessions: (0, $2zDt6.z).number(),
            mySessions: (0, $2zDt6.z).number()
        }),
        astronautMessage: (0, $2zDt6.z).string().nullable().optional()
    }),
    "uv.cobrowse.token": (0, $JRp7q.SuccessResponse).extend({
        askForRating: (0, $2zDt6.z).boolean(),
        confettiEnabled: (0, $2zDt6.z).boolean(),
        sessionId: (0, $2zDt6.z).string().nullable(),
        token: (0, $2zDt6.z).string(),
        region: (0, $2zDt6.z).string(),
        shortId: (0, $2zDt6.z).string(),
        notesEnabled: (0, $2zDt6.z).boolean(),
        teamId: (0, $2zDt6.z).custom()
    }).or((0, $2zDt6.z).union([
        (0, $JRp7q.SuccessResponse).extend({
            alternativeVisitorId: (0, $2zDt6.z).string(),
            teamId: (0, $2zDt6.z).custom()
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("connection_error")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("record_not_found")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("visitor:not_supported")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("visitor:not_online")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("auth:admin:override_needed"),
            visitor: (0, $6nNCC.VisitorModel)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("auth:login"),
            loginUrl: (0, $lbXII.Url)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("confirmation_needed"),
            visitor: (0, $6nNCC.VisitorModel),
            teamId: (0, $2zDt6.z).custom()
        })
    ]).or((0, $JRp7q.SubscriptionLimitResponse))),
    "uv.cobrowse.feedback": (0, $JRp7q.SuccessResponse),
    "uv.cobrowse.onPrem.token": (0, $JRp7q.SuccessResponse).extend({
        redirectUrl: (0, $lbXII.Url),
        sessionId: (0, $2zDt6.z).string()
    }).or((0, $2zDt6.z).union([
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("record_not_found")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("auth:login"),
            loginUrl: (0, $lbXII.Url)
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("team:onpremise_not_supported")
        }),
        (0, $JRp7q.ErrorResponse).extend({
            error: (0, $2zDt6.z).literal("confirmation_needed")
        })
    ]).or((0, $JRp7q.SubscriptionLimitResponse))),
    "uv.cobrowse.notes.show": (0, $JRp7q.SuccessResponse).extend({
        notes: (0, $2zDt6.z).string().nullable()
    }),
    "uv.cobrowse.notes.update": (0, $JRp7q.SuccessResponse).extend({
        notes: (0, $2zDt6.z).string().nullable()
    })
};

});



parcelRegister("9HNzc", function(module, exports) {

$parcel$export(module.exports, "default", () => $710e941b93754d6e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCachedState", () => $710e941b93754d6e$export$14afb9e4c16377d3);

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");
var $710e941b93754d6e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $710e941b93754d6e$export$2e2bcd8739ae039(object) {
    var cacheRef = (0, $acw62.useRef)(object);
    var cached = (0, $acw62.useMemo)(function() {
        if (!(0, $f1q41.isEqual)(cacheRef.current, object)) cacheRef.current = object;
        return cacheRef.current;
    }, [
        object
    ]);
    return cached;
}
function $710e941b93754d6e$export$14afb9e4c16377d3(object) {
    var _a = $710e941b93754d6e$var$__read((0, $acw62.useState)(object), 2), state = _a[0], setState = _a[1];
    var cached = $710e941b93754d6e$export$2e2bcd8739ae039(state);
    return [
        cached,
        setState
    ];
}

});
parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});


parcelRegister("fbNBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ee5b9e70808c52$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $b0ee5b9e70808c52$export$2e2bcd8739ae039() {
    (0, $acw62.useEffect)(function() {
        window.postMessage({
            action: "extension.auth.update"
        });
    }, []);
    return null;
}

});

parcelRegister("lID51", function(module, exports) {

$parcel$export(module.exports, "useGoogleTagManager", () => $fcfc057e81c1a344$export$ed058e39f3682d4b);

var $acw62 = parcelRequire("acw62");
function $fcfc057e81c1a344$export$ed058e39f3682d4b(_a) {
    var enable = _a.enable, userId = _a.userId, baa = _a.baa;
    var authLoaded = typeof userId !== "undefined";
    (0, $acw62.useEffect)(function() {
        window.userId = userId;
        window.baa = baa;
        window.gtmContext = "app";
    }, [
        userId,
        baa
    ]);
    (0, $acw62.useEffect)(function() {
        if (authLoaded && enable) $fcfc057e81c1a344$var$addGoogleTagManager();
    }, [
        authLoaded,
        enable
    ]);
}
function $fcfc057e81c1a344$var$addGoogleTagManager() {
    var w = window;
    w["dataLayer"] = w["dataLayer"] || []; // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    w["dataLayer"].push({
        "gtm.start": new Date().getTime(),
        "event": "gtm.js"
    });
    var f = document.getElementsByTagName("script")[0], j = document.createElement("script"), dl = "";
    j.async = true;
    j.src = "//www.googletagmanager.com/gtm.js?id=GTM-W33PJXB5" + dl;
    f.parentNode.insertBefore(j, f);
}

});

parcelRegister("3gpVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2606f936fbf26ebb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $2606f936fbf26ebb$export$2e2bcd8739ae039(_a) {
    var enable = _a.enable, name = _a.name, email = _a.email, hashedEmail = _a.hashedEmail;
    (0, $acw62.useEffect)(function() {
        if (!enable || false) return;
        window.intercomSettings = {
            app_id: "jjuq5mvv",
            email: email !== null && email !== void 0 ? email : null,
            name: name !== null && name !== void 0 ? name : null,
            user_hash: hashedEmail !== null && hashedEmail !== void 0 ? hashedEmail : null,
            hide_default_launcher: true
        };
        $2606f936fbf26ebb$var$addIntercom();
    }, [
        hashedEmail,
        email,
        name,
        enable
    ]);
}
function $2606f936fbf26ebb$var$addIntercom() {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        var d_1 = document;
        var i_1 = function() {
            i_1.c(arguments);
        };
        i_1.q = [];
        i_1.c = function(args) {
            i_1.q.push(args);
        };
        w.Intercom = i_1;
        var l = function() {
            var s = d_1.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/jjuq5mvv";
            var x = d_1.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
        };
        if (d_1.readyState === "complete") l();
        else if (typeof w.attachEvent === "function") w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
}

});


parcelRegister("82f7M", function(module, exports) {

$parcel$export(module.exports, "useWindowSize", () => $5d9a3e063333b971$export$42c02f33970a2afa);

var $acw62 = parcelRequire("acw62");

var $2DvvU = parcelRequire("2DvvU");

var $kSgCT = parcelRequire("kSgCT");

var $516jn = parcelRequire("516jn");

var $5T31O = parcelRequire("5T31O");
const $5d9a3e063333b971$var$listeners = new Set();
const $5d9a3e063333b971$var$callAllListeners = ()=>{
    for (const l of $5d9a3e063333b971$var$listeners)l({
        width: window.innerWidth,
        height: window.innerHeight
    });
};
function $5d9a3e063333b971$export$42c02f33970a2afa(stateHook = (0, $516jn.useRafState), measureOnMount) {
    const isFirstMount = (0, $2DvvU.useFirstMountState)();
    const [size, setSize] = stateHook({
        width: isFirstMount && (0, $5T31O.isBrowser) && !measureOnMount ? window.innerWidth : 0,
        height: isFirstMount && (0, $5T31O.isBrowser) && !measureOnMount ? window.innerHeight : 0
    });
    (0, $kSgCT.useMountEffect)(()=>{
        if (measureOnMount) setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    });
    (0, $acw62.useEffect)(()=>{
        if ($5d9a3e063333b971$var$listeners.size === 0) window.addEventListener("resize", $5d9a3e063333b971$var$callAllListeners, {
            passive: true
        });
        $5d9a3e063333b971$var$listeners.add(setSize);
        return ()=>{
            $5d9a3e063333b971$var$listeners.delete(setSize);
            if ($5d9a3e063333b971$var$listeners.size === 0) window.removeEventListener("resize", $5d9a3e063333b971$var$callAllListeners);
        };
    }, [
        setSize
    ]);
    return size;
}

});
parcelRegister("2DvvU", function(module, exports) {

$parcel$export(module.exports, "useFirstMountState", () => $1eb7ab3da57c816f$export$ddbfea47304c9e3);

var $acw62 = parcelRequire("acw62");
function $1eb7ab3da57c816f$export$ddbfea47304c9e3() {
    const isFirstMount = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        isFirstMount.current = false;
    }, []);
    return isFirstMount.current;
}

});

parcelRegister("kSgCT", function(module, exports) {

$parcel$export(module.exports, "useMountEffect", () => $f325bf6ba87e815d$export$51c44cea289ac0f6);

var $acw62 = parcelRequire("acw62");
function $f325bf6ba87e815d$export$51c44cea289ac0f6(effect) {
    (0, $acw62.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});

parcelRegister("516jn", function(module, exports) {

$parcel$export(module.exports, "useRafState", () => $3a71f1159b478e6a$export$4d5d35ff55b6d811);

var $acw62 = parcelRequire("acw62");

var $iuNkO = parcelRequire("iuNkO");

var $dqQVQ = parcelRequire("dqQVQ");
function $3a71f1159b478e6a$export$4d5d35ff55b6d811(initialState) {
    // eslint-disable-next-line react/hook-use-state
    const [state, innerSetState] = (0, $acw62.useState)(initialState);
    const [setState, cancelRaf] = (0, $iuNkO.useRafCallback)(innerSetState);
    (0, $dqQVQ.useUnmountEffect)(cancelRaf);
    return [
        state,
        setState
    ];
}

});


parcelRegister("hW7sX", function(module, exports) {

$parcel$export(module.exports, "useApiData", () => $d0eda51063c892ab$export$ae32bc417f2657d3);
$parcel$export(module.exports, "useApi", () => $d0eda51063c892ab$export$eb2799109db70ffd);

var $kQ0sT = parcelRequire("kQ0sT");

var $acw62 = parcelRequire("acw62");

var $gU1vo = parcelRequire("gU1vo");

var $ebuIP = parcelRequire("ebuIP");

var $9HNzc = parcelRequire("9HNzc");
var $d0eda51063c892ab$var$__assign = undefined && undefined.__assign || function() {
    $d0eda51063c892ab$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d0eda51063c892ab$var$__assign.apply(this, arguments);
};
var $d0eda51063c892ab$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d0eda51063c892ab$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d0eda51063c892ab$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d0eda51063c892ab$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $d0eda51063c892ab$var$promises = new Map();
function $d0eda51063c892ab$export$ae32bc417f2657d3(endpoint, data, options) {
    var _a;
    // Ensure the apiEndpoint doesn't change
    var apiEndpoint = (0, $acw62.useRef)(endpoint);
    if (apiEndpoint.current !== endpoint) throw new Error("apiEndpoint cannot change (changed from " + apiEndpoint.current + " to " + endpoint + ")");
    var _b = (0, $ebuIP.useApiCache)(), getCache = _b.getCache, setCache = _b.setCache, forgetCache = _b.forgetCache;
    var _c = $d0eda51063c892ab$var$__read((0, $9HNzc.useCachedState)(null), 2), response = _c[0], setResponse = _c[1];
    var _d = $d0eda51063c892ab$var$__read((0, $acw62.useState)(false), 2), everLoaded = _d[0], setEverLoaded = _d[1];
    var _e = $d0eda51063c892ab$var$__read((0, $acw62.useState)(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var settersCache = (0, $acw62.useRef)(new Map());
    var cachedData = (0, $9HNzc.default)(data);
    var isLoadingRef = (0, $acw62.useRef)(isLoading);
    isLoadingRef.current = isLoading;
    var responseRef = (0, $acw62.useRef)(response);
    responseRef.current = response;
    var optionsRef = (0, $acw62.useRef)(options);
    optionsRef.current = options;
    var enabled = (_a = options === null || options === void 0 ? void 0 : options.enable) !== null && _a !== void 0 ? _a : true;
    var storeCache = (0, $acw62.useCallback)(function(endpoint, data, response) {
        if (response.success) setCache(endpoint, data, response);
    }, [
        setCache
    ]);
    var refresh = (0, $acw62.useCallback)(function(clear) {
        var _a;
        if (clear) {
            setResponse(null);
            setEverLoaded(false);
        } else if (isLoadingRef.current) return; // Ignore refresh if a request is already happening
        setIsLoading(true);
        var promiseKey = JSON.stringify({
            endpoint: endpoint,
            data: cachedData
        });
        var promise = (_a = $d0eda51063c892ab$var$promises.get(promiseKey)) !== null && _a !== void 0 ? _a : (0, $gU1vo.default)(endpoint, cachedData);
        var requestedData = cachedData;
        $d0eda51063c892ab$var$promises.set(promiseKey, promise);
        promise.then(function(response) {
            var _a;
            $d0eda51063c892ab$var$promises.delete(promiseKey);
            storeCache(endpoint, cachedData, response);
            if (cachedData !== requestedData) return; // This response is no longer relevant
            if (response.success) {
                setResponse(response); // as Successful<ApiResponses[T]>;
                setIsLoading(false);
                setEverLoaded(true);
            } else if ((_a = optionsRef.current) === null || _a === void 0 ? void 0 : _a.onError) optionsRef.current.onError(response); // as Unsuccessful<ApiResponses[T]>;
            else {
                var error = "useApiData has returned an error in ".concat(endpoint, " (").concat(response.error, ") but there is no onError handler registered");
                $kQ0sT.captureException(new Error(error));
            }
        });
    }, [
        cachedData,
        endpoint,
        storeCache,
        setResponse
    ]);
    (0, $acw62.useEffect)(function() {
        if (!enabled) return;
        var _a = $d0eda51063c892ab$var$__read(getCache(endpoint, cachedData), 2), isFresh = _a[0], response = _a[1];
        if (response) {
            if (!isFresh) refresh();
            setResponse(response);
            setIsLoading(false);
            setEverLoaded(true);
        } else refresh(true);
    }, [
        endpoint,
        cachedData,
        getCache,
        refresh,
        enabled,
        setResponse
    ]);
    (0, $acw62.useEffect)(function() {
        if (enabled && everLoaded && !getCache(endpoint, data)[0]) refresh();
    }, [
        everLoaded,
        endpoint,
        refresh,
        getCache,
        data,
        enabled
    ]);
    var makeSetter = (0, $acw62.useCallback)(function(key, forget) {
        // Generate a unique identifier for the cache key
        var forgetKey = forget ? forget.join(",") : "";
        var cacheKey = "".concat(String(key), "-").concat(forgetKey);
        // Check if the setter function for this cacheKey is already cached
        if (settersCache.current.has(cacheKey)) return settersCache.current.get(cacheKey);
        // Create a new setter function
        var newSetter = function(func) {
            var e_1, _a;
            var response = responseRef.current;
            if (response === null || response === void 0 ? void 0 : response.success) {
                response[key] = func(response[key]);
                setResponse(response);
                storeCache(endpoint, cachedData, response);
            }
            if (forget) try {
                for(var forget_1 = $d0eda51063c892ab$var$__values(forget), forget_1_1 = forget_1.next(); !forget_1_1.done; forget_1_1 = forget_1.next()){
                    var key_1 = forget_1_1.value;
                    forgetCache(key_1);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (forget_1_1 && !forget_1_1.done && (_a = forget_1.return)) _a.call(forget_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        };
        // Cache and return the new setter function
        settersCache.current.set(cacheKey, newSetter);
        return newSetter;
    }, [
        endpoint,
        forgetCache,
        storeCache,
        cachedData,
        setResponse
    ]);
    return $d0eda51063c892ab$var$__assign($d0eda51063c892ab$var$__assign({}, response), {
        isLoading: !everLoaded,
        isRefreshing: isLoading,
        refresh: refresh,
        makeSetter: makeSetter
    });
}
function $d0eda51063c892ab$export$eb2799109db70ffd(endpoint, defaultData, invalidates) {
    var _this = this;
    var _a = $d0eda51063c892ab$var$__read((0, $acw62.useState)(false), 2), isLoading = _a[0], setIsLoading = _a[1];
    var _b = (0, $ebuIP.useApiCache)(), invalidateCache = _b.invalidateCache, forgetCache = _b.forgetCache;
    // Ensure the apiEndpoint doesn't change
    var apiEndpoint = (0, $acw62.useRef)(endpoint);
    if (apiEndpoint.current !== endpoint) throw new Error("apiEndpoint cannot change");
    var cachedDefaultData = (0, $9HNzc.default)(defaultData);
    var cachedInvalidates = (0, $9HNzc.default)(invalidates);
    var call = (0, $acw62.useCallback)(function(data) {
        return $d0eda51063c892ab$var$__awaiter(_this, void 0, Promise, function() {
            var responseAt_1;
            return $d0eda51063c892ab$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $gU1vo.default)(endpoint, $d0eda51063c892ab$var$__assign($d0eda51063c892ab$var$__assign({}, cachedDefaultData), data))
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        responseAt_1 = new Date();
                        setTimeout(function() {
                            return setIsLoading(false);
                        }, 0); // In case we update state in the same tick
                        setTimeout(function() {
                            invalidateCache(responseAt_1, Object.entries($d0eda51063c892ab$var$__assign($d0eda51063c892ab$var$__assign({}, cachedDefaultData), data)).filter(function(_a) {
                                var _b = $d0eda51063c892ab$var$__read(_a, 2), key = _b[0], value = _b[1];
                                return key.endsWith("Id");
                            }).map(function(_a) {
                                var _b = $d0eda51063c892ab$var$__read(_a, 2), key = _b[0], value = _b[1];
                                return value;
                            }));
                            cachedInvalidates === null || cachedInvalidates === void 0 || cachedInvalidates.forEach(function(key) {
                                return forgetCache(key);
                            });
                        }, 100);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        cachedDefaultData,
        endpoint,
        invalidateCache,
        forgetCache,
        cachedInvalidates
    ]);
    return {
        isLoading: isLoading,
        call: call
    };
}

});


//# sourceMappingURL=index.3c26e150.js.map
